(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/config.ts":
/*!***********************!*\
  !*** ./src/config.ts ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CLOSE_SOCKET_TIMEOUT_DURATION: () => (/* binding */ CLOSE_SOCKET_TIMEOUT_DURATION),
/* harmony export */   CONF: () => (/* binding */ CONF),
/* harmony export */   KEEPALIVE_WORKER_INTERVAL: () => (/* binding */ KEEPALIVE_WORKER_INTERVAL),
/* harmony export */   LEGACY_METHOD_NAME: () => (/* binding */ LEGACY_METHOD_NAME),
/* harmony export */   LEGACY_PING_API_URL: () => (/* binding */ LEGACY_PING_API_URL),
/* harmony export */   METHOD_NAME: () => (/* binding */ METHOD_NAME),
/* harmony export */   NOTIFS_RESOLVE_DELAY: () => (/* binding */ NOTIFS_RESOLVE_DELAY),
/* harmony export */   PING_API_URL: () => (/* binding */ PING_API_URL),
/* harmony export */   getAuthService: () => (/* binding */ getAuthService),
/* harmony export */   setAgentxServicesConfig: () => (/* binding */ setAgentxServicesConfig),
/* harmony export */   setAuthService: () => (/* binding */ setAuthService)
/* harmony export */ });
/* eslint-disable @typescript-eslint/no-explicit-any */
/* Some of these constants must be purged after moving to websocket in webworker*/
const KEEPALIVE_WORKER_INTERVAL = 4000;
const NOTIFS_RESOLVE_DELAY = 1200;
const CLOSE_SOCKET_TIMEOUT_DURATION = 16000;
const PING_API_URL = "https://reachable.webex.com";
const LEGACY_PING_API_URL = "/health";
const METHOD_NAME = "GET";
const LEGACY_METHOD_NAME = location && location.host.includes("localhost") ? "GET" : "HEAD";
const CONF = {};
function setAgentxServicesConfig(config) {
    Object.keys(config).forEach((k) => (CONF[k] = config[k]));
}
let auth;
const getAuthService = () => auth;
const setAuthService = (authService) => {
    auth = authService;
};


/***/ }),

/***/ "./src/core/aqm-notifs.ts":
/*!********************************!*\
  !*** ./src/core/aqm-notifs.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AqmNotifs: () => (/* binding */ AqmNotifs),
/* harmony export */   extractLogDetails: () => (/* binding */ extractLogDetails)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../config */ "./src/config.ts");
/* harmony import */ var _feature_flag_names__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../feature-flag-names */ "./src/feature-flag-names.ts");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../index */ "./src/index.ts");
/* harmony import */ var _services_aqm_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../services/aqm/constants */ "./src/services/aqm/constants.ts");
/* harmony import */ var _services_constant__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../services/constant */ "./src/services/constant.ts");
/* harmony import */ var _services_service_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../services/service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _utils_structuredLog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/structuredLog */ "./src/utils/structuredLog.ts");
/* harmony import */ var _workers_workerUtil__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../workers/workerUtil */ "./src/workers/workerUtil.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./sdk */ "./src/core/sdk.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-explicit-any */










const extractLogDetails = (eventText) => {
    var _a, _b, _c, _d, _e;
    try {
        const payload = JSON.parse(eventText);
        if (payload.data && payload.data.type) {
            if (payload.data.reason && payload.data.reasonCode) {
                return [
                    `${payload === null || payload === void 0 ? void 0 : payload.type}/${(_a = payload === null || payload === void 0 ? void 0 : payload.data) === null || _a === void 0 ? void 0 : _a.type}`,
                    { reason: (_b = payload.data) === null || _b === void 0 ? void 0 : _b.reason, reasonCode: (_c = payload.data) === null || _c === void 0 ? void 0 : _c.reasonCode }
                ];
            }
            return [`${payload === null || payload === void 0 ? void 0 : payload.type}/${(_d = payload === null || payload === void 0 ? void 0 : payload.data) === null || _d === void 0 ? void 0 : _d.type}`, { interactionId: (_e = payload.data) === null || _e === void 0 ? void 0 : _e.interactionId }];
        }
        return [payload === null || payload === void 0 ? void 0 : payload.type, {}];
        // eslint-disable-next-line sonarjs/no-ignored-exceptions
    }
    catch (exceptionValue) {
        return [null, {}];
    }
};
class AqmNotifs {
    constructor() {
        var _a;
        this.url = null;
        this.webSocketStatus = {
            isSocketClosed: false,
            shouldReconnect: true,
            forceCloseWebSocketOnTimeout: false,
            isConnectionLost: false,
            connectionId: null,
            connectCounter: 0,
            isWelcomeReceived: false
        };
        this.logTrace = (eventName, message = "", _extraFields = {}) => {
            _utils_structuredLog__WEBPACK_IMPORTED_MODULE_7__.StructuredLog.trace(this.buildEventName(eventName), message, Object.assign(Object.assign({}, _extraFields), this.webSocketStatus));
        };
        this.logDebug = (eventName, message = "", _extraFields = {}) => {
            _utils_structuredLog__WEBPACK_IMPORTED_MODULE_7__.StructuredLog.debug(this.buildEventName(eventName), message, Object.assign(Object.assign({}, _extraFields), this.webSocketStatus));
        };
        this.logError = (eventName, message = "", _extraFields = {}) => {
            _utils_structuredLog__WEBPACK_IMPORTED_MODULE_7__.StructuredLog.error(this.buildEventName(eventName), message, Object.assign(Object.assign({}, _extraFields), this.webSocketStatus));
        };
        this.handleConnectionLost = (detail) => {
            this.webSocketStatus.isConnectionLost = detail.isConnectionLost;
        };
        this.dispatchEventForRTD = (isConnected) => {
            window.dispatchEvent(new CustomEvent(_services_constant__WEBPACK_IMPORTED_MODULE_5__.RtdConstants.RTD_PING_EVENT, {
                detail: isConnected,
                bubbles: true,
                composed: true
            }));
        };
        this.trackWebSocketDisconnect = (reason, isOnline) => {
            _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.track(_index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.TELEM_EVENT.WEB_SOCKET_DISCONNECT, {
                IsOnline: isOnline,
                Reason: reason,
                WebsocketConnectionId: this.webSocketStatus.connectionId,
                ConnectCounter: this.webSocketStatus.connectCounter,
                IsInWebworker: false
            }, [
                _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.SERVICE_PROVIDERS.prometheus,
                _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.SERVICE_PROVIDERS.webex_business,
                _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.SERVICE_PROVIDERS.webex_operational
            ]);
        };
        this.webSocketOnCloseHandler = (event) => __awaiter(this, void 0, void 0, function* () {
            this.webSocketStatus.isSocketClosed = true;
            this.keepaliveWorker.postMessage({ type: _services_aqm_constants__WEBPACK_IMPORTED_MODULE_4__.KeepaliveWorkerMessageType.TERMINATE });
            this.dispatchEventForRTD(false);
            const onlineStatusValue = yield (0,_services_service_utils__WEBPACK_IMPORTED_MODULE_6__.checkOnlineStatus)();
            let issueReason = `WebsSocket closed but should not reconnect | desktop online status is ${onlineStatusValue}`;
            if (this.webSocketStatus.shouldReconnect) {
                this.onSocketCloseSend();
                if (this.webSocketStatus.forceCloseWebSocketOnTimeout) {
                    issueReason = "WebSocket auto close timed out. Forcefully closed websocket.";
                }
                else {
                    this.logTrace("", `desktop online status: ${onlineStatusValue}`);
                    issueReason = !onlineStatusValue ? "network issue" : "missing keepalive from either desktop or notif service";
                }
                this.logError("socketConnectionClosed", `[WebSocketStatus] | event=socketConnectionClosed | WebSocket connection closed due to ${issueReason}`);
                this.logError("socketConnectionClosedDetails", "", {
                    code: event === null || event === void 0 ? void 0 : event.code,
                    reason: event === null || event === void 0 ? void 0 : event.reason,
                    wasClean: event === null || event === void 0 ? void 0 : event.wasClean
                });
                this.webSocketStatus.forceCloseWebSocketOnTimeout = false;
            }
            this.webSocketStatus.connectionId = null;
            this.trackWebSocketDisconnect(issueReason, onlineStatusValue);
        });
        const { send, signal } = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.withData();
        this.onMessage = signal;
        this.onMessageSend = send;
        const socketCloseSignal = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.empty();
        this.onSocketClose = socketCloseSignal.signal;
        this.onSocketCloseSend = socketCloseSignal.send;
        this.websocket = {};
        this.welcomeTimeout = parseInt((_a = _config__WEBPACK_IMPORTED_MODULE_1__.CONF.WELCOME_TIMEOUT) !== null && _a !== void 0 ? _a : 7000); //Adding a wait time of 7sec for Welcome message since CORE has max retry timeout of 6sec today.
        this.notifsWelcomeFlag = _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.featureflag.isDesktopConsumeWelcomeEnabled();
        this.isUsingReachableEndpoint = _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.featureflag.isUsingReachableEndpoint();
        this.useOptimizedConnectionChecks = _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.featureflag.isFeatureFlagEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.OPTIMIZED_CONNECTION_CHECKS);
        this.keepaliveWorker = (0,_workers_workerUtil__WEBPACK_IMPORTED_MODULE_8__.createWorker)("keepalive.worker.js", (e) => this.workerMessageHandler(e));
    }
    isSocketClosed() {
        return this.webSocketStatus.isSocketClosed;
    }
    setShouldReconnect(value) {
        this.webSocketStatus.shouldReconnect = value;
    }
    buildEventName(eventName) {
        return `Network/WebSocket/${eventName}`;
    }
    workerMessageHandler(event) {
        var _a, _b, _c, _d, _e;
        if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.type) === _services_aqm_constants__WEBPACK_IMPORTED_MODULE_4__.KeepaliveWorkerMessageType.KEEPALIVE) {
            if (this.websocket.readyState === this.websocket.OPEN) {
                this.websocket.send(JSON.stringify({ keepalive: "true" }));
            }
            _sdk__WEBPACK_IMPORTED_MODULE_9__.logger.info(`Keepalive from Desktop every 4 sec | { keepalive: 'true' } :: WS status: ${this.websocket.readyState} :: Desktop is online: ${(_b = event === null || event === void 0 ? void 0 : event.data) === null || _b === void 0 ? void 0 : _b.onlineStatus}`);
            this.dispatchEventForRTD(((_c = event === null || event === void 0 ? void 0 : event.data) === null || _c === void 0 ? void 0 : _c.onlineStatus) === undefined ? true : (_d = event === null || event === void 0 ? void 0 : event.data) === null || _d === void 0 ? void 0 : _d.onlineStatus);
        }
        // checking isConnectionLost here, so as to cover a scenario when desktop restores
        // back after socket close event is dispatched
        if (((_e = event === null || event === void 0 ? void 0 : event.data) === null || _e === void 0 ? void 0 : _e.type) === _services_aqm_constants__WEBPACK_IMPORTED_MODULE_4__.KeepaliveWorkerMessageType.REQUEST_CLOSE_SOCKET &&
            this.webSocketStatus.isConnectionLost) {
            this.webSocketStatus.forceCloseWebSocketOnTimeout = true;
            this.close(true, "WebSocket did not auto close within 16 secs");
            this.logError("webSocketTimeout", "WebSocket connection closed forcefully");
        }
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.webSocketStatus.connectCounter++;
            yield this.register();
            yield this.connect().catch(() => {
                this.logError("Connecting", "Error in connecting Websocket");
            });
            _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.aqm.connectionConfig.OnConnectionLost.listen(this.handleConnectionLost);
        });
    }
    close(shouldReconnect, reasonValue = "Unknown") {
        this.logTrace("webSocketClose");
        if (!this.webSocketStatus.isSocketClosed && this.webSocketStatus.shouldReconnect) {
            this.webSocketStatus.shouldReconnect = shouldReconnect;
            this.websocket.close();
            this.keepaliveWorker.postMessage({ type: _services_aqm_constants__WEBPACK_IMPORTED_MODULE_4__.KeepaliveWorkerMessageType.TERMINATE });
            this.logError("webSocketClose", "WebSocket connection closed manually", { reason: reasonValue });
            _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.track(_index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.TELEM_EVENT.WEB_SOCKET_CLOSE_REQUEST, {
                Reason: reasonValue,
                WebsocketConnectionId: this.webSocketStatus.connectionId,
                ConnectCounter: this.webSocketStatus.connectCounter,
                IsInWebworker: false
            }, [
                _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.SERVICE_PROVIDERS.prometheus,
                _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.SERVICE_PROVIDERS.webex_business,
                _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.SERVICE_PROVIDERS.webex_operational
            ]);
        }
    }
    register() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const canaryHeader = { "X-ORGANIZATION-ID": _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.featureflag.orgId };
            try {
                const res = yield _sdk__WEBPACK_IMPORTED_MODULE_9__.http.post(`${_config__WEBPACK_IMPORTED_MODULE_1__.CONF.NOTIF_HOST}/v1/notification/subscribe`, {
                    force: true,
                    webexCcStack: true,
                    isKeepAliveEnabled: true
                }, {
                    headers: Object.assign({}, canaryHeader)
                });
                this.url = res.data.webSocketUrl;
                this.webSocketStatus.connectionId = (_a = res.data) === null || _a === void 0 ? void 0 : _a.subscriptionId;
                this.logDebug("RegistrationSuccess", "", { url: this.url });
            }
            catch (e) {
                this.logError("", `Register API Failed: Request to RoutingNotifs websocket registration API failed: ${e}`);
            }
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            const startTime = performance.now();
            let openTime = -1;
            this.logTrace("Connecting");
            if (!this.url) {
                return undefined;
            }
            this.websocket = new WebSocket(this.url);
            return new Promise((resolve, reject) => {
                this.websocket.onopen = (event) => {
                    openTime = performance.now();
                    const openDelay = openTime - startTime;
                    _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.track(_index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.TELEM_EVENT.WEBSOCKET_OPENED, {
                        WebsocketConnectionId: this.webSocketStatus.connectionId,
                        ConnectCounter: this.webSocketStatus.connectCounter,
                        OpenDelayMs: `${openDelay}`,
                        IsInWebworker: false
                    }, [_index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.SERVICE_PROVIDERS.webex_business]);
                    this.webSocketStatus.isSocketClosed = false;
                    this.webSocketStatus.shouldReconnect = true;
                    // Upon successful websocket connection establishment, send an immediate keepalive message to the notification service.
                    // Subsequently, keepalive for every 4 seconds will handled in keepalive.worker.ts
                    this.websocket.send(JSON.stringify({ keepalive: "true" }));
                    this.logDebug("ConnectionEstablished", `WebSocket connection established and first { keepalive: 'true' } from Desktop to notifs sent: ${JSON.stringify(event)}`);
                    const isSocketClosed = this.webSocketStatus.isSocketClosed;
                    this.keepaliveWorker.postMessage({
                        type: _services_aqm_constants__WEBPACK_IMPORTED_MODULE_4__.KeepaliveWorkerMessageType.START,
                        intervalDuration: _config__WEBPACK_IMPORTED_MODULE_1__.KEEPALIVE_WORKER_INTERVAL,
                        isSocketClosed,
                        closeSocketTimeout: _config__WEBPACK_IMPORTED_MODULE_1__.CLOSE_SOCKET_TIMEOUT_DURATION,
                        networkCheckApiUrl: this.isUsingReachableEndpoint ? _config__WEBPACK_IMPORTED_MODULE_1__.PING_API_URL : _config__WEBPACK_IMPORTED_MODULE_1__.LEGACY_PING_API_URL,
                        methodName: this.isUsingReachableEndpoint ? _config__WEBPACK_IMPORTED_MODULE_1__.METHOD_NAME : _config__WEBPACK_IMPORTED_MODULE_1__.LEGACY_METHOD_NAME,
                        useOptimizedConnectionChecks: this.useOptimizedConnectionChecks
                    });
                    if (this.notifsWelcomeFlag) {
                        //If FF is on, wait 7sec for welcome msg before timeout error
                        _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.timeEvent(_index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.TELEM_EVENT.WELCOME_MESSAGE_RECEIVED);
                        setTimeout(() => {
                            if (!this.webSocketStatus.isWelcomeReceived) {
                                this.logError("", `WebSocket registration error | Welcome Message from notifs not received within expected time of ${this.welcomeTimeout} ms`);
                                reject(new Error("Welcome Message from notifs timed out"));
                                _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.track(_index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.TELEM_EVENT.WELCOME_MESSAGE_RECEIVED, {
                                    Status: _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                                    WebsocketConnectionId: this.webSocketStatus.connectionId,
                                    ConnectCounter: this.webSocketStatus.connectCounter,
                                    IsInWebworker: false
                                });
                            }
                        }, this.welcomeTimeout);
                    }
                    else {
                        setTimeout(() => {
                            this.logTrace("", `Resolving notifs registration with a delay of ${_config__WEBPACK_IMPORTED_MODULE_1__.NOTIFS_RESOLVE_DELAY} millisecs`);
                            resolve({});
                        }, _config__WEBPACK_IMPORTED_MODULE_1__.NOTIFS_RESOLVE_DELAY); //Resolving socket connection establishment is delayed by 1.2 secs until  WELCOME message is fied by CORE-4207.
                    }
                };
                this.websocket.onerror = (_event) => {
                    const errorDelay = performance.now() - startTime;
                    this.logError("ConnectionFailed", "WebSocket connection failed", { errorDelay_ms: errorDelay });
                    reject(); // and what ?
                };
                this.websocket.onclose = (event) => __awaiter(this, void 0, void 0, function* () {
                    this.webSocketOnCloseHandler(event);
                });
                this.websocket.onmessage = (e) => {
                    var _a, _b;
                    this.keepaliveWorker.postMessage({ type: _services_aqm_constants__WEBPACK_IMPORTED_MODULE_4__.KeepaliveWorkerMessageType.NOTIFY_MESSAGE_FROM_WEBSOCKET });
                    if (e.data) {
                        const [msgType, extraFields] = extractLogDetails(e.data);
                        if (msgType && msgType !== "Welcome") {
                            // Special handling below for Welcome message
                            this.logTrace(`Msg/${msgType}`, "", extraFields);
                        }
                    }
                    this.onMessageSend(e.data);
                    if (e.data && ((_a = JSON.parse(e.data)) === null || _a === void 0 ? void 0 : _a.type) === "Welcome") {
                        const welcomeReceptionDelay = performance.now() - startTime;
                        const welcomeReceptionDelaySinceOpened = openTime >= 0 ? performance.now() - openTime : -1;
                        this.logTrace("Msg/Welcome", `Welcome message received`, { delay: welcomeReceptionDelay });
                        _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.track(_index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.TELEM_EVENT.WELCOME_MESSAGE_RECEIVED, {
                            Status: _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS,
                            WebsocketConnectionId: this.webSocketStatus.connectionId,
                            ConnectCounter: this.webSocketStatus.connectCounter,
                            Delay: welcomeReceptionDelay,
                            DelaySinceOpened: welcomeReceptionDelaySinceOpened,
                            IsInWebworker: false
                        }, [_index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.telemetry.SERVICE_PROVIDERS.webex_business]);
                        if (this.notifsWelcomeFlag) {
                            this.webSocketStatus.isWelcomeReceived = true;
                            resolve({}); //if FF is on, notifs is resolved upon receiving Welcome msg
                        }
                    }
                    if (e.data && e.data !== "keepalive" && ((_b = JSON.parse(e.data)) === null || _b === void 0 ? void 0 : _b.type) === "AGENT_MULTI_LOGIN") {
                        this.close(false, "multiLogin"); // closing websocket on multiLogin.
                        this.logError("agentMultiLogin", "WebSocket connection closed by agent multiLogin");
                    }
                };
            });
        });
    }
}


/***/ }),

/***/ "./src/core/aqm-reqs.ts":
/*!******************************!*\
  !*** ./src/core/aqm-reqs.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AqmReqs: () => (/* binding */ AqmReqs),
/* harmony export */   TIMEOUT_REQ: () => (/* binding */ TIMEOUT_REQ)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var fflate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! fflate */ "fflate");
/* harmony import */ var fflate__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fflate__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! .. */ "./src/index.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../config */ "./src/config.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./sdk */ "./src/core/sdk.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





const TIMEOUT_REQ = 20000;
const TIMEOUT_EVT = TIMEOUT_REQ;
const CLIENT_NAME_HEADER = { "x-client-name": "desktop" };
const FC_DESKTOP_VIEW = "FC-DESKTOP-VIEW";
const fcDesktopView = "fcDesktopView";
class AqmReqs {
    constructor(notifs) {
        this.pendingRequests = {};
        this.pendingEvents = {};
        // pendingNotifCancelrequest is used for handling request cancel events based on another action. When a promise can be resolved using multiple events.
        // example consult and cancelCtq(end in new API)  when we cancel consult to ques we need to resolve both consul and cancel ctq promises
        // #CX-14258 : Consult to DN failing if Consult to Queue is cancelled in the first try #2344
        this.pendingNotifCancelrequest = {};
        this.identifyInteractionIsTaskObject = (event) => {
            var _a, _b, _c;
            // This method will return the callProcessingDetails are present inside the interaction object or task object
            return (_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.task) === null || _b === void 0 ? void 0 : _b.callProcessingDetails) !== null && _c !== void 0 ? _c : false;
        };
        // must be lambda
        this.onMessage = (msg) => {
            const event = JSON.parse(msg);
            this.onMessageImp(event);
        };
        notifs.onMessage.listen(this.onMessage);
        this.auth = (0,_config__WEBPACK_IMPORTED_MODULE_3__.getAuthService)();
    }
    req(c) {
        return (p, cbRes) => this.makeAPIRequest(c(p), cbRes);
    }
    reqEmpty(c) {
        return (cbRes) => this.makeAPIRequest(c(), cbRes);
    }
    evt(p) {
        const { send, signal } = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.withData();
        const k = this.bindPrint(p.bind);
        if (this.pendingEvents[k]) {
            throw new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details("Service.aqm.reqs.PendingEvent", { key: k });
        }
        this.pendingEvents[k] = {
            check: (msg) => this.bindCheck(p.bind, msg),
            handle: (msg) => send(msg)
        };
        // add listenOnceAsync
        const evt = signal;
        evt.listenOnceAsync = (listenOnceParam) => {
            return new Promise((resolve, reject) => {
                const { stopListen } = signal.listen((msg) => {
                    if ((listenOnceParam === null || listenOnceParam === void 0 ? void 0 : listenOnceParam.resolveIf) ? listenOnceParam.resolveIf(msg) : true) {
                        stopListen();
                        resolve(msg);
                    }
                });
                if ((listenOnceParam === null || listenOnceParam === void 0 ? void 0 : listenOnceParam.timeout) === "disabled") {
                    return;
                }
                const ms = listenOnceParam && listenOnceParam.timeout && listenOnceParam.timeout > 0
                    ? listenOnceParam.timeout
                    : TIMEOUT_EVT;
                setTimeout(() => {
                    const isStopped = stopListen();
                    if (isStopped) {
                        reject(new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details("Service.aqm.reqs.TimeoutEvent", { key: k }));
                    }
                }, ms);
            });
        };
        return evt;
    }
    fetchNewToken() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.auth.getNewToken();
            return (_a = data === null || data === void 0 ? void 0 : data.token) === null || _a === void 0 ? void 0 : _a.access_token;
        });
    }
    makeAPIRequest(c, cbRes) {
        return __awaiter(this, void 0, void 0, function* () {
            const isTokenValid = this.auth.isTokenValid();
            if (isTokenValid) {
                return this.createPromise(c, cbRes);
            }
            const newToken = yield this.fetchNewToken();
            return this.createPromise(c, cbRes, newToken);
        });
    }
    createPromise(c, cbRes, token) {
        return new Promise((resolve, reject) => {
            var _a, _b;
            const keySuccess = this.bindPrint(c.notifSuccess.bind);
            const keyFail = c.notifFail ? this.bindPrint(c.notifFail.bind) : null;
            const keyCancel = ((_a = c.notifCancel) === null || _a === void 0 ? void 0 : _a.bind) ? this.bindPrint(c.notifCancel.bind) : null;
            let k = "";
            if (this.pendingRequests[keySuccess]) {
                k = keySuccess;
            }
            if (keyFail && this.pendingRequests[keyFail]) {
                k += keyFail;
            }
            if (k && c.timeout !== "disabled") {
                reject(new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details("Service.aqm.reqs.Pending", {
                    key: k,
                    msg: "The request has been already created, multiple requests are not allowed."
                }));
                return;
            }
            let isClear = false;
            const clear = () => {
                delete this.pendingRequests[keySuccess];
                if (keyFail) {
                    delete this.pendingRequests[keyFail];
                }
                if (keyCancel) {
                    delete this.pendingNotifCancelrequest[keyCancel];
                }
                isClear = true;
            };
            this.pendingRequests[keySuccess] = {
                check: (msg) => this.bindCheck(c.notifSuccess.bind, msg),
                handle: (msg) => {
                    clear();
                    resolve(msg);
                }
            };
            if (keyCancel) {
                this.pendingRequests[keySuccess].alternateBind = keyCancel;
                this.pendingNotifCancelrequest[keyCancel] = {
                    check: (msg) => { var _a; return this.bindCheck((_a = c.notifCancel) === null || _a === void 0 ? void 0 : _a.bind, msg); },
                    handle: (msg) => {
                        const alternateBindKey = this.pendingNotifCancelrequest[keyCancel].alternateBind;
                        if (alternateBindKey) {
                            this.pendingRequests[alternateBindKey].handle(msg);
                        }
                    },
                    alternateBind: keySuccess
                };
            }
            if (keyFail) {
                this.pendingRequests[keyFail] = {
                    check: (msg) => this.bindCheck(c.notifFail.bind, msg),
                    handle: (msg) => {
                        clear();
                        const notifFail = c.notifFail;
                        if ("errId" in notifFail) {
                            reject(new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details(notifFail.errId, msg));
                        }
                        else {
                            reject(notifFail.err(msg));
                        }
                    }
                };
            }
            let resAxios = null;
            const canaryHeader = { "X-ORGANIZATION-ID": ___WEBPACK_IMPORTED_MODULE_2__.SERVICE.featureflag.orgId };
            const theMethod = c.method ? c.method : c.data ? "post" : "get";
            const theUrl = ((_b = c.host) !== null && _b !== void 0 ? _b : _config__WEBPACK_IMPORTED_MODULE_3__.CONF.AQM_HOST) + c.url;
            _sdk__WEBPACK_IMPORTED_MODULE_4__.http
                .request({
                url: theUrl,
                method: theMethod,
                headers: Object.assign(Object.assign(Object.assign(Object.assign({}, canaryHeader), c.headers), CLIENT_NAME_HEADER), (token ? { Authorization: `Bearer ${token}` } : {})),
                data: c.data
            })
                .then((res) => {
                resAxios = res;
                if (cbRes) {
                    cbRes(res);
                }
            })
                .catch((axiosErr) => {
                var _a, _b;
                clear();
                if ((_a = axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.config) === null || _a === void 0 ? void 0 : _a.headers) {
                    axiosErr.config.headers.Authorization = "*";
                }
                if ((_b = axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.response) === null || _b === void 0 ? void 0 : _b.headers) {
                    axiosErr.response.headers.Authorization = "*";
                }
                if (typeof c.err == "function") {
                    reject(c.err(axiosErr));
                }
                else if (typeof c.err == "string") {
                    reject(new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Message(c.err));
                }
                else {
                    reject(new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Message("Service.aqm.reqs.GenericRequestError"));
                }
            });
            if (c.timeout !== "disabled") {
                window.setTimeout(() => {
                    var _a;
                    if (isClear) {
                        return;
                    }
                    clear();
                    if ((_a = resAxios === null || resAxios === void 0 ? void 0 : resAxios.config) === null || _a === void 0 ? void 0 : _a.headers) {
                        resAxios.config.headers.Authorization = "*";
                    }
                    ___WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Network/HttpRequest/Timeout", "Request timeout", {
                        url: c.url,
                        key: keySuccess,
                        axiosResult: resAxios
                    });
                    _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error("Routing request timeout", keySuccess, resAxios, c.url);
                    reject(new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details("Service.aqm.reqs.Timeout", { key: keySuccess, resAxios: resAxios }));
                }, c.timeout && c.timeout > 0 ? c.timeout : TIMEOUT_REQ);
            }
        });
    }
    bindPrint(bind) {
        let result = "";
        for (const k in bind) {
            if (Array.isArray(bind[k])) {
                result += `${k}=[${bind[k].join(",")}],`;
            }
            else if (typeof bind[k] == "object" && bind[k] !== null) {
                result += `${k}=(${this.bindPrint(bind[k])}),`;
            }
            else {
                result += `${k}=${bind[k]},`;
            }
        }
        return result ? result.slice(0, -1) : result;
    }
    bindCheck(bind, msg) {
        for (const k in bind) {
            if (Array.isArray(bind[k])) {
                // Check if the message value matches any of the values in the array
                if (!bind[k].includes(msg[k])) {
                    return false;
                }
            }
            else if (typeof bind[k] == "object" && bind[k] !== null) {
                if (typeof msg[k] == "object" && msg[k] !== null) {
                    if (!this.bindCheck(bind[k], msg[k])) {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
            else if (!msg[k] || msg[k] !== bind[k]) {
                return false;
            }
        }
        return true;
    }
    isFlowValuesEncrypted(event) {
        var _a, _b, _c, _d, _e, _f;
        let fcDesktopViewValue;
        if (this.identifyInteractionIsTaskObject(event)) {
            fcDesktopViewValue = (_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.task) === null || _b === void 0 ? void 0 : _b.callAssociatedData[FC_DESKTOP_VIEW]) === null || _c === void 0 ? void 0 : _c.value;
        }
        else {
            fcDesktopViewValue = (_f = (_e = (_d = event === null || event === void 0 ? void 0 : event.data) === null || _d === void 0 ? void 0 : _d.interaction) === null || _e === void 0 ? void 0 : _e.callAssociatedData[FC_DESKTOP_VIEW]) === null || _f === void 0 ? void 0 : _f.value;
        }
        return (fcDesktopViewValue === null || fcDesktopViewValue === void 0 ? void 0 : fcDesktopViewValue.includes("pop-over")) || (fcDesktopViewValue === null || fcDesktopViewValue === void 0 ? void 0 : fcDesktopViewValue.includes("interaction-panel"));
    }
    isValidCADFlowValue(event) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        // event?.data?.interaction:  CAD, CPD values are under the event?.data?.interaction for call events
        // event?.data?.task :CAD, CPD values are under the event?.data?.task for monitoring call events
        if (this.identifyInteractionIsTaskObject(event)) {
            return ((_g = (((_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.task) === null || _b === void 0 ? void 0 : _b.callAssociatedData[FC_DESKTOP_VIEW]) === null || _c === void 0 ? void 0 : _c.value) &&
                ((_f = (_e = (_d = event === null || event === void 0 ? void 0 : event.data) === null || _d === void 0 ? void 0 : _d.task) === null || _e === void 0 ? void 0 : _e.callAssociatedData[FC_DESKTOP_VIEW]) === null || _f === void 0 ? void 0 : _f.value) !== "")) !== null && _g !== void 0 ? _g : false);
        }
        // Interaction details are present like event?.data?.interaction
        return ((_p = (((_k = (_j = (_h = event === null || event === void 0 ? void 0 : event.data) === null || _h === void 0 ? void 0 : _h.interaction) === null || _j === void 0 ? void 0 : _j.callAssociatedData[FC_DESKTOP_VIEW]) === null || _k === void 0 ? void 0 : _k.value) &&
            ((_o = (_m = (_l = event === null || event === void 0 ? void 0 : event.data) === null || _l === void 0 ? void 0 : _l.interaction) === null || _m === void 0 ? void 0 : _m.callAssociatedData[FC_DESKTOP_VIEW]) === null || _o === void 0 ? void 0 : _o.value) !== "")) !== null && _p !== void 0 ? _p : false);
    }
    isValidCPDFlowValue(event) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        // event?.data?.interaction:  CAD, CPD values are under the event?.data?.interaction for call events
        // event?.data?.task :CAD, CPD values are under the event?.data?.task for monitoring call events
        if (___WEBPACK_IMPORTED_MODULE_2__.SERVICE.featureflag.isDesktopCpdViewEnabled()) {
            if (this.identifyInteractionIsTaskObject(event)) {
                return (((_b = (_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.task) === null || _b === void 0 ? void 0 : _b.callProcessingDetails[fcDesktopView]) &&
                    ((_d = (_c = event === null || event === void 0 ? void 0 : event.data) === null || _c === void 0 ? void 0 : _c.task) === null || _d === void 0 ? void 0 : _d.callProcessingDetails[fcDesktopView]) !== "");
            }
            return (((_f = (_e = event === null || event === void 0 ? void 0 : event.data) === null || _e === void 0 ? void 0 : _e.interaction) === null || _f === void 0 ? void 0 : _f.callProcessingDetails[fcDesktopView]) &&
                ((_h = (_g = event === null || event === void 0 ? void 0 : event.data) === null || _g === void 0 ? void 0 : _g.interaction) === null || _h === void 0 ? void 0 : _h.callProcessingDetails[fcDesktopView]) !== "");
        }
        return false;
    }
    getDecompressedValue(encryptedValue) {
        const decryptedValue = (0,fflate__WEBPACK_IMPORTED_MODULE_1__.decompressSync)(encryptedValue);
        return (0,fflate__WEBPACK_IMPORTED_MODULE_1__.strFromU8)(decryptedValue);
    }
    /**
     * This method is a temporary workaround to handle the message from the websocket worker as it
     * does not require a lambda. Not using a lambda simplifies unit test.
     * Once we remove main thread websocket and aqm-notifs, we can rename this method OnMessage and
     * get rid of the lambda (but keep the code inside it).
     * @param message
     */
    onMessageForWebsocketWorker(message) {
        ___WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Network/AqmReq/MessageHandler", "", { message });
        this.onMessageImp(message);
    }
    onMessageImp(event) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (event["type"] === "Welcome") {
            _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("Welcome message from Notifs Websocket", event);
            return;
        }
        if (event["keepalive"]) {
            _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("Keepalive from notifs", event);
            return;
        }
        if (this.isValidCADFlowValue(event) && !this.isFlowValuesEncrypted(event)) {
            const isTaskObject = this.identifyInteractionIsTaskObject(event);
            try {
                const targetObject = isTaskObject ? (_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.task : (_b = event === null || event === void 0 ? void 0 : event.data) === null || _b === void 0 ? void 0 : _b.interaction;
                const encryptedFcValue = (_c = targetObject === null || targetObject === void 0 ? void 0 : targetObject.callAssociatedData[FC_DESKTOP_VIEW]) === null || _c === void 0 ? void 0 : _c.value;
                const encryptedValue = Buffer.from(encryptedFcValue, "base64");
                // Update the decrypted value to same object
                targetObject.callAssociatedData[FC_DESKTOP_VIEW].value = this.getDecompressedValue(encryptedValue);
                const interactionId = targetObject === null || targetObject === void 0 ? void 0 : targetObject.interactionId;
                _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info(`${FC_DESKTOP_VIEW} values decrypted successfully for Interaction ID: ${interactionId || ""}`);
            }
            catch (_l) {
                const targetObject = isTaskObject ? (_d = event === null || event === void 0 ? void 0 : event.data) === null || _d === void 0 ? void 0 : _d.task : (_e = event === null || event === void 0 ? void 0 : event.data) === null || _e === void 0 ? void 0 : _e.interaction;
                const interactionId = targetObject === null || targetObject === void 0 ? void 0 : targetObject.interactionId;
                const fcValue = ((_f = targetObject === null || targetObject === void 0 ? void 0 : targetObject.callAssociatedData[FC_DESKTOP_VIEW]) === null || _f === void 0 ? void 0 : _f.value) || "";
                _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error(`Error on decrypting ${FC_DESKTOP_VIEW} value for Interaction Id: ${interactionId}`, fcValue || "");
            }
        }
        else if (this.isValidCPDFlowValue(event)) {
            const isTaskObject = this.identifyInteractionIsTaskObject(event);
            try {
                // When WXCC_DESKTOP_VIEW_IN_CPD FF is enabled, then values will be fcDesktopView values are always compressed.
                const targetObject = isTaskObject ? (_g = event === null || event === void 0 ? void 0 : event.data) === null || _g === void 0 ? void 0 : _g.task : (_h = event === null || event === void 0 ? void 0 : event.data) === null || _h === void 0 ? void 0 : _h.interaction;
                const encryptedFcValue = targetObject === null || targetObject === void 0 ? void 0 : targetObject.callProcessingDetails[fcDesktopView];
                const encryptedValue = Buffer.from(encryptedFcValue, "base64");
                // Update the decrypted value to same object
                targetObject.callProcessingDetails[fcDesktopView] = this.getDecompressedValue(encryptedValue);
                const interactionId = targetObject === null || targetObject === void 0 ? void 0 : targetObject.interactionId;
                _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info(`${fcDesktopView} values decrypted successfully for Interaction ID: ${interactionId || ""}`);
            }
            catch (_m) {
                const targetObject = isTaskObject ? (_j = event === null || event === void 0 ? void 0 : event.data) === null || _j === void 0 ? void 0 : _j.task : (_k = event === null || event === void 0 ? void 0 : event.data) === null || _k === void 0 ? void 0 : _k.interaction;
                const interactionId = targetObject === null || targetObject === void 0 ? void 0 : targetObject.interactionId;
                const fcValue = (targetObject === null || targetObject === void 0 ? void 0 : targetObject.callProcessingDetails[fcDesktopView]) || "";
                _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error(`Error on decrypting ${fcDesktopView} value for Interaction Id: ${interactionId || ""}`, fcValue || "");
            }
        }
        let isHandled = false;
        const kReq = Object.keys(this.pendingRequests);
        for (const thisReq of kReq) {
            const req = this.pendingRequests[thisReq];
            if (req.check(event)) {
                req.handle(event);
                isHandled = true;
                break;
            }
        }
        // pendingNotifCancelrequest stores the secondary bind key, checks for the secondary bind key and handles the event
        const kReqAlt = Object.keys(this.pendingNotifCancelrequest);
        for (const thisReq of kReqAlt) {
            const req = this.pendingNotifCancelrequest[thisReq];
            if (req.check(event)) {
                req.handle(event);
                isHandled = true;
            }
        }
        const kEvt = Object.keys(this.pendingEvents);
        for (const thisEvt of kEvt) {
            const evt = this.pendingEvents[thisEvt];
            if (evt.check(event)) {
                evt.handle(event);
                isHandled = true;
                break;
            }
        }
        if (!isHandled) {
            _sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info(`event=missingEventHandler | [AqmReqs] missing routing message handler`, event);
        }
    }
}


/***/ }),

/***/ "./src/core/http-interceptors.ts":
/*!***************************************!*\
  !*** ./src/core/http-interceptors.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HttpInterceptors: () => (/* binding */ HttpInterceptors)
/* harmony export */ });
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! uuid */ "uuid");
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(uuid__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./src/index.ts");
/* harmony import */ var _services_telemetry_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/telemetry/constants */ "./src/services/telemetry/constants.ts");
/* harmony import */ var _utils_structuredLog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/structuredLog */ "./src/utils/structuredLog.ts");
/* harmony import */ var _http_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./http-utils */ "./src/core/http-utils.ts");
/* eslint-disable @typescript-eslint/no-explicit-any */





function logHttpRequest(_method, _url, _trackingId = null) {
    const getLogUrl = (url) => {
        const index = url.indexOf("?"); //  Avoid PII in url
        return index !== -1 ? url.substring(0, index) : url;
    };
    _utils_structuredLog__WEBPACK_IMPORTED_MODULE_3__.StructuredLog.trace("Network/Http/Request", "", { method: _method, url: getLogUrl(_url), trackingId: _trackingId });
}
function logHttpResponse(_startTime, _endTime, _trackingId, _status) {
    const _duration = _startTime == null ? null : _endTime - _startTime;
    _utils_structuredLog__WEBPACK_IMPORTED_MODULE_3__.StructuredLog.trace("Network/Http/Response", "", Object.assign(Object.assign(Object.assign(Object.assign({}, (_startTime == null ? {} : { startTime: _startTime })), { endTime: _endTime }), (_duration == null ? {} : { duration: _duration })), { trackingId: _trackingId, status: _status }));
}
function logHttpError(_message, _trackingId, _status, _code, _startTime, _endTime) {
    const _duration = _startTime == null ? null : _endTime - _startTime;
    _utils_structuredLog__WEBPACK_IMPORTED_MODULE_3__.StructuredLog.trace("Network/Http/Error", _message, Object.assign(Object.assign(Object.assign({ trackingId: _trackingId, status: _status, code: _code }, (_startTime === null ? {} : { startTime: _startTime })), { endTime: _endTime }), (_duration === null ? {} : { duration: _duration })));
}
var HttpInterceptors;
(function (HttpInterceptors) {
    let metricsBuffer = [];
    let errorBuffer = [];
    let metricsInterval = null;
    function initializeMetricsCollection() {
        if (!metricsInterval && metricsBuffer.length === 0) {
            metricsInterval = setTimeout(sendAggregatedMetrics, _services_telemetry_constants__WEBPACK_IMPORTED_MODULE_2__.AGGREGATION_INTERVAL);
        }
    }
    function cleanupMetricsCollection() {
        if (metricsInterval) {
            clearTimeout(metricsInterval);
            metricsInterval = null;
        }
        errorBuffer = [];
        metricsBuffer = [];
    }
    function sendAggregatedMetrics() {
        if (metricsBuffer.length > 0 || errorBuffer.length > 0) {
            ___WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.track(___WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.TELEM_EVENT.NETWORK_REQUEST_USAGE, {
                metricsSummary: getMetricsSummary(metricsBuffer),
                metrics: metricsBuffer,
                errorMetrics: errorBuffer
            }, [___WEBPACK_IMPORTED_MODULE_1__.SERVICE.telemetry.SERVICE_PROVIDERS.webex_business]);
            // clears the setTimeout
            cleanupMetricsCollection();
        }
    }
    function updateCounts(metric, packetType, isError) {
        if (packetType === _services_telemetry_constants__WEBPACK_IMPORTED_MODULE_2__.httpConstants.REQUEST) {
            if (isError) {
                metric.count_failedRequest++;
            }
            else {
                metric.count_sendRequest++;
            }
        }
        else {
            if (isError) {
                metric.count_failedResponse++;
            }
            else {
                metric.count_recvdResponse++;
            }
        }
    }
    function getMetricsSummary(metrics) {
        const summary = {
            totalSendRequest: 0,
            totalFailedRequest: 0,
            totalRecvdResponse: 0,
            totalFailedResponse: 0
        };
        metrics.forEach((metric) => {
            summary.totalSendRequest += metric.count_sendRequest;
            summary.totalFailedRequest += metric.count_failedRequest;
            summary.totalRecvdResponse += metric.count_recvdResponse;
            summary.totalFailedResponse += metric.count_failedResponse;
        });
        return summary;
    }
    function addToErrorMetricsBuffer(params) {
        const existingMetric = errorBuffer.find((metric) => {
            return (metric.host === params.host &&
                metric.endPoint === params.endPoint &&
                metric.statusCode === params.error.statusCode &&
                metric.errorCode === params.error.errorCode &&
                metric.method === params.error.method &&
                metric.errorType === params.error.errorType &&
                metric.errorMessage === params.error.errorMessage);
        });
        if (existingMetric) {
            if (existingMetric.trackingIds.length < 10) {
                // This is added to prevant a large amount of trackingIds being added to the array
                existingMetric.trackingIds.push(params.error.trackingId);
            }
            existingMetric.count_error++;
        }
        else {
            const newMetric = {
                host: params.host,
                endPoint: params.endPoint,
                statusCode: params.error.statusCode,
                errorCode: params.error.errorCode,
                method: params.error.method,
                trackingIds: [params.error.trackingId],
                count_error: 1,
                errorType: params.error.errorType,
                errorMessage: params.error.errorMessage
            };
            errorBuffer.push(newMetric);
        }
    }
    function addToMetricsBuffer(params) {
        // Initialize metrics collection to call the sendAggregatedMetrics function in 30 mins
        initializeMetricsCollection();
        // Find if the metric already exists in the buffer
        const existingMetric = metricsBuffer.find((metric) => metric.host === params.host && metric.endPoint === params.endPoint);
        // Update the counts for the metric endPoint
        if (existingMetric) {
            updateCounts(existingMetric, params.packetType, params.isError);
        }
        else {
            const newMetric = {
                host: params.host,
                endPoint: params.endPoint,
                count_sendRequest: 0,
                count_failedRequest: 0,
                count_recvdResponse: 0,
                count_failedResponse: 0
            };
            updateCounts(newMetric, params.packetType, params.isError);
            metricsBuffer.push(newMetric);
        }
    }
    // Interceptor Functions
    function requestFn(config) {
        var _a, _b, _c;
        config.metadata = { startTime: Date.now() };
        const method = (_b = (_a = config.method) === null || _a === void 0 ? void 0 : _a.toUpperCase()) !== null && _b !== void 0 ? _b : "GET";
        const url = config.url || "<None>";
        const trackingId = (_c = config.headers["TrackingID"]) !== null && _c !== void 0 ? _c : `wxcc_${(0,uuid__WEBPACK_IMPORTED_MODULE_0__.v4)()}`;
        config.headers["TrackingID"] = trackingId;
        logHttpRequest(method, url, trackingId);
        if (url !== "<None>") {
            const metricsParams = {
                host: (0,_http_utils__WEBPACK_IMPORTED_MODULE_4__.getHostName)(url),
                endPoint: (0,_http_utils__WEBPACK_IMPORTED_MODULE_4__.getEndPoint)(url),
                packetType: _services_telemetry_constants__WEBPACK_IMPORTED_MODULE_2__.httpConstants.REQUEST,
                isError: false
            };
            addToMetricsBuffer(metricsParams);
        }
        return config;
    }
    HttpInterceptors.requestFn = requestFn;
    function errorFn(error, message) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const startTime = ((_b = (_a = error.config) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.startTime) || null;
        const theTrackingId = ((_d = (_c = error.config) === null || _c === void 0 ? void 0 : _c.headers) === null || _d === void 0 ? void 0 : _d.TrackingID) || "<None>";
        const statusCode = (_f = (_e = error.response) === null || _e === void 0 ? void 0 : _e.status) !== null && _f !== void 0 ? _f : 0;
        const url = ((_g = error.config) === null || _g === void 0 ? void 0 : _g.url) || "<None>";
        const method = (_k = (_j = (_h = error.config) === null || _h === void 0 ? void 0 : _h.method) === null || _j === void 0 ? void 0 : _j.toUpperCase()) !== null && _k !== void 0 ? _k : "GET";
        const errorMessage = error.message || "<None>";
        if (url !== "<None>") {
            const metricsParams = {
                host: (0,_http_utils__WEBPACK_IMPORTED_MODULE_4__.getHostName)(url),
                endPoint: (0,_http_utils__WEBPACK_IMPORTED_MODULE_4__.getEndPoint)(url),
                packetType: message === _services_telemetry_constants__WEBPACK_IMPORTED_MODULE_2__.httpConstants.Request ? _services_telemetry_constants__WEBPACK_IMPORTED_MODULE_2__.httpConstants.REQUEST : _services_telemetry_constants__WEBPACK_IMPORTED_MODULE_2__.httpConstants.RESPONSE,
                isError: true,
                error: {
                    statusCode,
                    errorCode: error.code || "<None>",
                    method,
                    errorMessage,
                    trackingId: theTrackingId,
                    errorType: error.name || "<None>"
                }
            };
            addToMetricsBuffer(metricsParams);
            addToErrorMetricsBuffer(metricsParams);
        }
        logHttpError(message, theTrackingId, statusCode, error.errorCode, startTime, Date.now());
        return Promise.reject(error); // Reject the promise to propagate the error
    }
    HttpInterceptors.errorFn = errorFn;
    function responseFn(response) {
        var _a, _b, _c, _d, _e;
        const startTime = ((_b = (_a = response.config) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.startTime) || null;
        const trackingId = ((_d = (_c = response.config) === null || _c === void 0 ? void 0 : _c.headers) === null || _d === void 0 ? void 0 : _d.TrackingID) || "<None>";
        const url = ((_e = response.config) === null || _e === void 0 ? void 0 : _e.url) || "<None>";
        if (url !== "<None>") {
            const metricsParams = {
                host: (0,_http_utils__WEBPACK_IMPORTED_MODULE_4__.getHostName)(url),
                endPoint: (0,_http_utils__WEBPACK_IMPORTED_MODULE_4__.getEndPoint)(url),
                packetType: _services_telemetry_constants__WEBPACK_IMPORTED_MODULE_2__.httpConstants.RESPONSE,
                isError: false
            };
            addToMetricsBuffer(metricsParams);
        }
        logHttpResponse(startTime, Date.now(), trackingId, response.status);
        return response;
    }
    HttpInterceptors.responseFn = responseFn;
})(HttpInterceptors || (HttpInterceptors = {}));


/***/ }),

/***/ "./src/core/http-reqs.ts":
/*!*******************************!*\
  !*** ./src/core/http-reqs.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HttpReqs: () => (/* binding */ HttpReqs)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! .. */ "./src/index.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../config */ "./src/config.ts");
/* harmony import */ var _services_telemetry_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../services/telemetry/constants */ "./src/services/telemetry/constants.ts");
/* harmony import */ var _http_interceptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./http-interceptors */ "./src/core/http-interceptors.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./sdk */ "./src/core/sdk.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






const CLIENT_NAME_HEADER = { "x-client-name": "desktop" };
const HTTP_TIMEOUT_REQ = 10000; // default timeout req time in ms
_sdk__WEBPACK_IMPORTED_MODULE_5__.http.interceptors.request.use((config) => {
    return _http_interceptors__WEBPACK_IMPORTED_MODULE_4__.HttpInterceptors.requestFn(config);
}, (error) => {
    return _http_interceptors__WEBPACK_IMPORTED_MODULE_4__.HttpInterceptors.errorFn(error, _services_telemetry_constants__WEBPACK_IMPORTED_MODULE_3__.httpConstants.Request);
});
_sdk__WEBPACK_IMPORTED_MODULE_5__.http.interceptors.response.use((response) => {
    return _http_interceptors__WEBPACK_IMPORTED_MODULE_4__.HttpInterceptors.responseFn(response);
}, (error) => {
    return _http_interceptors__WEBPACK_IMPORTED_MODULE_4__.HttpInterceptors.errorFn(error, _services_telemetry_constants__WEBPACK_IMPORTED_MODULE_3__.httpConstants.Response);
});
class HttpReqs {
    constructor(host, removeDefaultHeader = false) {
        this.host = host;
        this.removeDefaultHeader = removeDefaultHeader;
        this.auth = (0,_config__WEBPACK_IMPORTED_MODULE_2__.getAuthService)();
    }
    req(c) {
        return (p, cbRes) => this.makeAPIRequest(c(p), cbRes);
    }
    reqEmpty(c) {
        return (cbRes) => this.makeAPIRequest(c(), cbRes);
    }
    reqEmptyWithoutAuth(c) {
        return (cbRes) => this.makeAPIRequest(c(), cbRes, false);
    }
    fetchNewToken() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.auth.getNewToken();
            return (_a = data === null || data === void 0 ? void 0 : data.token) === null || _a === void 0 ? void 0 : _a.access_token;
        });
    }
    makeAPIRequest(c, cbRes, useAuth = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (useAuth) {
                const isTokenValid = this.auth.isTokenValid();
                if (isTokenValid) {
                    return this.createPromise(c, cbRes);
                }
                const newToken = yield this.fetchNewToken();
                return this.createPromise(c, cbRes, newToken);
            }
            else {
                return this.createPromise(c, cbRes);
            }
        });
    }
    createPromise(c, cbRes, token) {
        const canaryHeader = { "X-ORGANIZATION-ID": ___WEBPACK_IMPORTED_MODULE_1__.SERVICE.featureflag.orgId };
        return new Promise((resolve, reject) => {
            var _a;
            const headerValue = this.removeDefaultHeader
                ? Object.assign({}, c.headers) : Object.assign(Object.assign(Object.assign(Object.assign({}, canaryHeader), c.headers), CLIENT_NAME_HEADER), (token ? { Authorization: `Bearer ${token}` } : {}));
            const theMethod = (_a = c.method) !== null && _a !== void 0 ? _a : (c.data ? "post" : "get");
            const theUrl = this.host + c.url;
            const req = _sdk__WEBPACK_IMPORTED_MODULE_5__.http.request({
                url: theUrl,
                method: theMethod,
                headers: headerValue,
                data: c.data,
                responseType: c.responseType
            });
            let isTimeoutRequired = true;
            /* istanbul ignore next */
            req
                .then((res) => {
                if (cbRes) {
                    cbRes(res);
                }
                resolve(res.data);
            })
                .catch((axiosErr) => {
                var _a, _b;
                ___WEBPACK_IMPORTED_MODULE_1__.StructuredLog.trace("Network/HttpRequest/Catch", "", { url: theUrl, method: theMethod });
                if ((_a = axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.config) === null || _a === void 0 ? void 0 : _a.headers) {
                    axiosErr.config.headers.Authorization = "*";
                }
                if ((_b = axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.response) === null || _b === void 0 ? void 0 : _b.headers) {
                    axiosErr.response.headers.Authorization = "*";
                }
                if (typeof c.err == "function") {
                    reject(c.err(axiosErr));
                }
                else if (typeof c.err == "string") {
                    reject(new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Message(c.err));
                }
                else {
                    reject(new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Message("Service.http.reqs.GenericRequestError"));
                }
            })
                .finally(() => {
                isTimeoutRequired = false;
            });
            if (c.timeout !== "disabled") {
                setTimeout(() => {
                    var _a;
                    if (!isTimeoutRequired) {
                        return;
                    }
                    _sdk__WEBPACK_IMPORTED_MODULE_5__.logger.error(`https request timeout for ${c.url} with errId ${c.errId}`);
                    reject(new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details("Service.http.reqs.Timeout", { key: (_a = c.errId) !== null && _a !== void 0 ? _a : c.url })); //If the errId is not available the request will be rejected with the url info
                }, c.timeout && c.timeout > 0 ? c.timeout : HTTP_TIMEOUT_REQ);
            }
        });
    }
}


/***/ }),

/***/ "./src/core/http-utils.ts":
/*!********************************!*\
  !*** ./src/core/http-utils.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getEndPoint: () => (/* binding */ getEndPoint),
/* harmony export */   getHostName: () => (/* binding */ getHostName)
/* harmony export */ });
function getHostName(url) {
    const urlParts = stripParameters(url).split("/");
    return urlParts.filter((part) => isHostname(part) || isWebApiHostname(part)).join("/");
}
function getEndPoint(url) {
    return stripParameters(url)
        .split("/")
        .filter((part) => !isIgnore(part))
        .join("/");
}
function isCallId(word) {
    const callIdRegex = /^callhalf-\d+:\d+$/;
    return callIdRegex.test(word);
}
function isIgnore(word) {
    return (isExcludedWord(word) ||
        isGuid(word) ||
        isCallId(word) ||
        isHostname(word) ||
        isWebApiHostname(word) ||
        isEmpty(word));
}
function stripParameters(url) {
    const index = url.indexOf("?");
    return index !== -1 ? url.substring(0, index) : url;
}
function isEmpty(word) {
    return word.length === 0;
}
const EXCLUDED_WORDS = new Set(["..", "https:"]);
function isExcludedWord(word) {
    return EXCLUDED_WORDS.has(word.toLowerCase());
}
function isGuid(word) {
    const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return guidRegex.test(word);
}
function isHostname(word) {
    const length = word.length;
    if (length > 4) {
        const firstDot = word.indexOf(".");
        const lastDot = word.lastIndexOf(".");
        const thereAreTwoDots = firstDot !== -1 && lastDot !== -1;
        const thereAreDifferentDots = firstDot !== lastDot;
        const thereAreDotsInsideString = firstDot !== 0 && lastDot !== length - 1;
        return thereAreTwoDots && thereAreDifferentDots && thereAreDotsInsideString;
    }
    return false;
}
function isWebApiHostname(word) {
    const length = word.length;
    if (length > 4) {
        const lastDot = word.lastIndexOf(".");
        // Check for single domain (e.g., webexapis.com)
        if (lastDot !== -1) {
            return lastDot !== 0 && lastDot !== length - 1;
        }
    }
    return false;
}


/***/ }),

/***/ "./src/core/public/performance-observer.ts":
/*!*************************************************!*\
  !*** ./src/core/public/performance-observer.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   renderPerformanceObserver: () => (/* binding */ renderPerformanceObserver)
/* harmony export */ });
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../index */ "./src/index.ts");
/* harmony import */ var _utils_structuredLog__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/structuredLog */ "./src/utils/structuredLog.ts");


const TELEMETRY_SENT = "performance-long-running-entry-telemetry-sent";
function sendPerformanceTelemetry(entryId, entry) {
    var _a, _b, _c, _d;
    const hasTelemetryBeenSent = JSON.parse((_a = sessionStorage.getItem(TELEMETRY_SENT)) !== null && _a !== void 0 ? _a : "false");
    if (hasTelemetryBeenSent) {
        return;
    }
    (_b = _index__WEBPACK_IMPORTED_MODULE_0__.SERVICE === null || _index__WEBPACK_IMPORTED_MODULE_0__.SERVICE === void 0 ? void 0 : _index__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _b === void 0 ? void 0 : _b.track(entryId, entry.toJSON(), [(_d = (_c = _index__WEBPACK_IMPORTED_MODULE_0__.SERVICE === null || _index__WEBPACK_IMPORTED_MODULE_0__.SERVICE === void 0 ? void 0 : _index__WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _c === void 0 ? void 0 : _c.SERVICE_PROVIDERS) === null || _d === void 0 ? void 0 : _d.webex_business]);
    sessionStorage.setItem(TELEMETRY_SENT, JSON.stringify(true));
}
const longRunningPerformanceObserver = (entries) => {
    entries
        .getEntries()
        .filter((entry) => entry.duration >= 1000)
        .forEach((entry) => {
        _utils_structuredLog__WEBPACK_IMPORTED_MODULE_1__.StructuredLog.warn("Performance/LongRunningEntry", "Long-running performance entry detected", entry);
        sendPerformanceTelemetry("performance-long-running-entry", entry);
    });
};
function renderPerformanceObserver() {
    const performanceObserver = new PerformanceObserver(longRunningPerformanceObserver);
    performanceObserver.observe({ type: "measure", buffered: true });
    return performanceObserver;
}


/***/ }),

/***/ "./src/core/sdk.ts":
/*!*************************!*\
  !*** ./src/core/sdk.ts ***!
  \*************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   http: () => (/* binding */ http),
/* harmony export */   logger: () => (/* binding */ logger)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);

const objKeysToBeMasked = {
    ani: true,
    dn: true,
    agent_ani: true,
    dnis: true,
    email: true,
    callAssociatedData: true,
    title: true,
    text: true,
    agentName: true,
    agentMailId: true,
    userName: true,
    emails: true,
    sipAddresses: true
};
const http = (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.createHttp)();
const logger = (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.createLogger)("agentx-services", objKeysToBeMasked);


/***/ }),

/***/ "./src/feature-flag-names.ts":
/*!***********************************!*\
  !*** ./src/feature-flag-names.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FEATURE_FLAGS: () => (/* binding */ FEATURE_FLAGS),
/* harmony export */   OBSERVE_PERFORMANCE_ENABLED: () => (/* binding */ OBSERVE_PERFORMANCE_ENABLED)
/* harmony export */ });
const OBSERVE_PERFORMANCE_ENABLED = "observe-performance-enabled";
const FEATURE_FLAGS = {
    RECORDING_TRANSCRIPTION: "wxcc-desktop-recording-transcription",
    CARE_ATTACHMENT: "care_attachment",
    WCC_DIGITAL_V3: "wcc_digital_v3",
    CARE_VIDEO_ESCALATE: "care_video_escalate",
    WCC_PCI_COMPLIANCE: "wcc_pci_compliance",
    IMI_CHAT_WIDGET: "wcc-imi-digital" /* This FF is commonly used in KAD and Portal as well to controll IMI features */,
    STEERING_DIGITS_APPEND: "steering_digits_append",
    DESKTOP_TAHOE_ENABLED: "wxcc-desktop-tahoe-enabled",
    DESKTOP_CJDS_ENABLED: "wxcc-desktop-cjds-enabled",
    SECURE_VARIABLES_ENABLED: "flow-control-secure-variables",
    CANARY_ORG: "wxcc_canary_org",
    DESKTOP_CONSUME_WELCOME: "desktop-consume-welcome",
    DESKTOP_LOGROCKET: "desktop-logrocket",
    DESKTOP_LOGROCKET_DISABLE_TEXT_MASKING: "desktop-logrocket-disable-text-masking",
    IMI_GLOBAL_VARIABLES: "global_variables_imi",
    GLOBAL_VARIABLES: "global_variables",
    DESKTOP_CONSULT_TO_ENTRY_POINT_DN: "wxcc_consult_to_entry_point_dn" /* This FF is used to control EP-DN features */,
    DESKTOP_MAX_SESSION_LIMITS: "wxcc-tm-conf-limits",
    WXCC_CALLBACK_RETRY: "wxcc_callback_retry",
    WXCC_WEBRTC: "wxcc_webrtc",
    WXCC_SUPERVISOR_WEBRTC: "wxcc-supervisor-webrtc",
    PROGRESSIVE_CAMPAIGN: "WXCC_PROGRESSIVE_DIALER",
    DESKTOP_REASON_CODE: "wxcc_reasonCode_consistency",
    DESKTOP_SIGNOUT_BY_SUPERVISOR: "desktop-signout-by-supervisor",
    DESKTOP_MAERSK_ENHANCEMENT: "desktop-maersk-CX-11355",
    WXCC_DESKTOP_VIEW_IN_CPD: "WXCC_DESKTOP_VIEW_IN_CPD",
    DESKTOP_MAERSK_ENHANCEMENT_ACQUEON: "desktop-maersk-CX-11865",
    DESKTOP_PROGRESSIVE_CAMPAIGN_N: "WxCC_progressive__N",
    ESD_POST_INTERACTION_INSIGHTS: "ESD-post-interaction-insights",
    ADDRESSBOOK_INFINITE_SCROLL: "addressbook-infinite-scroll",
    SDK_CALLING_INFO_LEVEL_LOGS: "sdk-calling-info-level-logs",
    DESKTOP_MSFT_STATE_SYNC: "desktop-msft-State-sync",
    DESKTOP_AUX_CODES_INFINITE_SCROLL: "desktop-aux-codes-infinite-scrolling",
    DESKTOP_WEBEX_STATE_SYNC: "desktop-webex-State-sync",
    DESKTOP_EMERGENCY_NOTIFICATION: "wxcc_e911",
    WEBRTC_RINGING: "CX-13578-webrtc-ringtone",
    WEBRTC_ENDCALL: "CX-13579-webrtc-endcall",
    WXCC_MULTI_PARTY_CONF: "wxcc-multi-party-conf",
    DESKTOP_ENABLE_CONF_RECORDING: "desktop-enable-conference-recording",
    WXCC_PERSIST_CALL: "wxcc_persist_call",
    AI_ASSISTANT: "ai-assistant",
    QMW_SHOW_CONSULT_RECORDINGS: "show_consult_recordings",
    RECORDINGS_DISPLAY_RICHER_METADATA: "wxcc-recordings-display-richer-metadata",
    SHOW_SIGNED_OUT_AGENTS: "show_signed_out_agents",
    AUTO_CSAT: "auto_CSAT",
    DESKTOP_WXCC_MOMENTUM_V2: "desktop_wxcc_momentum_v2",
    WXCC_ALLOW_OUTDIAL_CALL_ALWAYS: "wxcc_allow_outdial_call_always",
    IS_AGENT_PERFORMANCE_TAB_ENABLED: "is-agent-performance-tab-enabled",
    DESKTOP_WXCC_QUEUE_STATS_TAB: "desktop_wxcc_queue_stats_tab",
    DESKTOP_WXCC_QUEUE_STATS_DETAIL_VIEW: "desktop_wxcc_queue_stats_detail_view",
    DESKTOP_WXCC_INTERACTIONS_PAGE: "desktop_wxcc_interactions_page",
    DESKTOP_WEBEX_DIRECTORY_VIEW: "desktop-webex-directory-view",
    DESKTOP_MASK_SENSITIVE_DATA: "wxcc-security-sensitive-data",
    ALLOW_CONF_TRANSFER_TO_EPDN: "allow_transfer_to_epdn",
    DESKTOP_OUTDIAL_ORG_SEARCH: "desktop-outdial-org-search",
    DESKTOP_CONFIRM_END_EXIT_CONF: "desktop-confirm-dialog-end-or-exit-for-conf",
    SUPPRESS_WEBEX_CALLING_NOTIFICATION: "suppress-webex-calling-notification",
    WXCC_PROGRESSIVE11_SPECIAL_MODE: "wxcc_progressive11_special_mode",
    CONSULT_TRANSFER_INFINITE_SCROLL: "desktop-consult-transfer-infinite-scrolling",
    DESKTOP_ENHANCED_SIGNIN: "desktop-enhanced-signin",
    DESKTOP_ENABLE_LOGUPLOAD_ON_LOGINGERROR: "desktop-enable-logupload-on-loginerror",
    WXCC_CORE_DISALLOW_PENDING_LOGOUT_STATE_CHANGE: "wxcc_core_disallow_pending_logout_state_change",
    USE_REACHABLE_ENDPOINT: "desktop-use-reachable-endpoint",
    OPTIMIZED_CONNECTION_CHECKS: "desktop-optimized-connection-checks",
    AI_ASSISTANT_V2: "desktop-ai-assistant-v2",
    WXCC_POST_CALL: "wxcc-post-call",
    VISUAL_REBRAND_NEW_LOOK_TOGGLE: "visual-rebrand-new-look-toggle",
    USE_WORKER_TIMER_FOR_CONNECTION_CHECKS: "desktop-use-worker-timer-for-connection-checks",
    DESKTOP_OUTDIAL_ANI_INFINITE_SCROLL: "desktop-outdial-ani-infinite-scrolling",
    WXCC_PERSIST_CONSULT: "wxcc_persist_consult",
    DESKTOP_ENABLE_INTERACTIONS_VIEW_ACTIONS_COLUMN: "desktop-enable-interactions-view-actions-column",
    CXAI_WELLNESS_BREAK_CLIENT: "cxai_wellnessbreak_client",
    DESKTOP_UPLOAD_LOGS_TO_WEBEX: "desktop-upload-logs-to-webex",
    USE_EXTENDED_DISCONNECTION_TIME: "desktop_extended_disconnection_time",
    EXPONENTIAL_RECONNECTION: "desktop-exponential-reconnection",
    MANAGED_FILTER_INFINITE_SCROLLING: "desktop-managed-filter-infinite-scrolling",
    WXCC_DESKTOP_QM_EVALUATIONS: "wxcc_desktop_qm_evaluations",
    REAL_TIME_TRANSCRIPTION_CLIENT: "real_time_transcription_client",
    DESKTOP_TASK_LIST_V2: "desktop-task-list-v2",
    DESKTOP_DIGITAL_INTERACTIONS_CHERRY_PICK: "wxcc_filter_and_pick_conversations",
    DESKTOP_TASK_LIST_ONLY_VISIBLE_ON_TAB: "desktop-task-list-only-visible-on-tab",
    CONFERENCE_TRANSFER: "wxcc_conference_transfer",
    OBSERVE_PERFORMANCE_ENABLED,
    WXCC_RONA_ENHANCEMENTS: "wxcc_rona_enhancements",
    WXCC_SCHEDULED_CALLBACK: "wxcc_scheduled_callback",
    DESKTOP_PERSONAL_GREETING: "desktop_personal_greeting",
    WXCC_AGENT_STATE_CONTROL: "wxcc_agent_state_control",
    DESKTOP_SKILL_PROFILE: "desktop_skill_profile",
    WEBSOCKET_IN_WEBWORKER: "desktop_websocket_in_webworker",
    DESKTOP_ENABLE_LOGIN_1035_RECOVERY: "desktop-enable-login-1035-recovery",
    WXCC_DIALER_PREVIEW_MODE: "wxcc_dialer_preview_mode",
    DESKTOP_WX_CALLING_DEVICE_SELECTION: "desktop-wx-calling-device-selection",
    AGENT_STATISTICS_BY_QUEUE: "wxcc_agent_statistics_by_queue",
    JSSDK_MISUSE_METRICS: "wxcc_jssdk_misuse_metrics",
    AGENT_BASED_QUEUE_MANAGEMENT: "wxcc-esd-agent-based-queue-management",
    WXCC_SYNC_WEBEX_HOLD_RESUME_STATES: "wxcc_sync_webex_hold_resume_states"
};


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentPerformanceTypes: () => (/* reexport safe */ _services_agent_performance_agent_performance_types__WEBPACK_IMPORTED_MODULE_9__.AgentPerformanceTypes),
/* harmony export */   AgentService: () => (/* reexport safe */ _services_agent_index__WEBPACK_IMPORTED_MODULE_10__.AgentService),
/* harmony export */   AgentxServices: () => (/* reexport safe */ _services_services__WEBPACK_IMPORTED_MODULE_7__.AgentxServices),
/* harmony export */   FEATURE_FLAGS: () => (/* reexport safe */ _feature_flag_names__WEBPACK_IMPORTED_MODULE_3__.FEATURE_FLAGS),
/* harmony export */   InteractionsService: () => (/* reexport safe */ _services_interactions_index__WEBPACK_IMPORTED_MODULE_12__.InteractionsService),
/* harmony export */   InteractionsServiceConstants: () => (/* reexport safe */ _services_interactions_index__WEBPACK_IMPORTED_MODULE_12__.InteractionsServiceConstants),
/* harmony export */   SERVICE: () => (/* binding */ SERVICE),
/* harmony export */   StructuredLog: () => (/* reexport safe */ _utils_structuredLog__WEBPACK_IMPORTED_MODULE_16__.StructuredLog),
/* harmony export */   TasksService: () => (/* reexport safe */ _services_tasks_index__WEBPACK_IMPORTED_MODULE_13__.TasksService),
/* harmony export */   TrackingUtils: () => (/* reexport module object */ _services_telemetry_tracking_utils__WEBPACK_IMPORTED_MODULE_14__),
/* harmony export */   WebexCallingUtils: () => (/* reexport module object */ _services_webex_webex_calling_utils__WEBPACK_IMPORTED_MODULE_15__),
/* harmony export */   buildAgentService: () => (/* reexport safe */ _services_agent_index__WEBPACK_IMPORTED_MODULE_10__.buildAgentService),
/* harmony export */   buildInfoService: () => (/* reexport safe */ _services_build_info_build_info_service__WEBPACK_IMPORTED_MODULE_11__.buildInfoService),
/* harmony export */   buildInteractionsService: () => (/* reexport safe */ _services_interactions_index__WEBPACK_IMPORTED_MODULE_12__.buildInteractionsService),
/* harmony export */   formRoleNameForTelemetry: () => (/* binding */ formRoleNameForTelemetry),
/* harmony export */   getRoutingHost: () => (/* binding */ getRoutingHost),
/* harmony export */   getTrackingIdFromErrorObject: () => (/* binding */ getTrackingIdFromErrorObject),
/* harmony export */   initAgentxServices: () => (/* binding */ initAgentxServices),
/* harmony export */   maskSensitiveData: () => (/* binding */ maskSensitiveData),
/* harmony export */   updateAccessToken: () => (/* binding */ updateAccessToken)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./config */ "./src/config.ts");
/* harmony import */ var _core_public_performance_observer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./core/public/performance-observer */ "./src/core/public/performance-observer.ts");
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _feature_flag_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./feature-flag-names */ "./src/feature-flag-names.ts");
/* harmony import */ var _services_featureFlag_feature_flag_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./services/featureFlag/feature-flag-service */ "./src/services/featureFlag/feature-flag-service.ts");
/* harmony import */ var _services_logrocket_log_rocket_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./services/logrocket/log-rocket-service */ "./src/services/logrocket/log-rocket-service.ts");
/* harmony import */ var _services_prometheus_prometheus_tracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./services/prometheus/prometheus-tracking */ "./src/services/prometheus/prometheus-tracking.ts");
/* harmony import */ var _services_services__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./services/services */ "./src/services/services.ts");
/* harmony import */ var _services_summarizer_summarizer_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./services/summarizer/summarizer-service */ "./src/services/summarizer/summarizer-service.ts");
/* harmony import */ var _services_agent_performance_agent_performance_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./services/agent-performance/agent-performance-types */ "./src/services/agent-performance/agent-performance-types.ts");
/* harmony import */ var _services_agent_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./services/agent/index */ "./src/services/agent/index.ts");
/* harmony import */ var _services_build_info_build_info_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./services/build-info/build-info-service */ "./src/services/build-info/build-info-service.ts");
/* harmony import */ var _services_interactions_index__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./services/interactions/index */ "./src/services/interactions/index.ts");
/* harmony import */ var _services_tasks_index__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./services/tasks/index */ "./src/services/tasks/index.ts");
/* harmony import */ var _services_telemetry_tracking_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./services/telemetry/tracking-utils */ "./src/services/telemetry/tracking-utils.ts");
/* harmony import */ var _services_webex_webex_calling_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./services/webex/webex-calling-utils */ "./src/services/webex/webex-calling-utils.ts");
/* harmony import */ var _utils_structuredLog__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./utils/structuredLog */ "./src/utils/structuredLog.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;



















/**
 * Through SERVICE a developer is able to acess all AQM calls and subscribe to applicable Notifs responses.
 * Currently includes: `aqm` service
 */
const SERVICE = new _services_services__WEBPACK_IMPORTED_MODULE_7__.AgentxServices();
SERVICE.featureflag = new _services_featureFlag_feature_flag_service__WEBPACK_IMPORTED_MODULE_4__.FeatureFlagService();
SERVICE.summarizer = new _services_summarizer_summarizer_service__WEBPACK_IMPORTED_MODULE_8__.SummarizerService();
SERVICE.prometheus = new _services_prometheus_prometheus_tracking__WEBPACK_IMPORTED_MODULE_6__.PrometheusService(SERVICE.conf);
SERVICE.logrocket = new _services_logrocket_log_rocket_service__WEBPACK_IMPORTED_MODULE_5__.LogRocketService();
const isObservePerformanceEnabled = JSON.parse((_a = localStorage.getItem(_feature_flag_names__WEBPACK_IMPORTED_MODULE_3__.OBSERVE_PERFORMANCE_ENABLED)) !== null && _a !== void 0 ? _a : "false");
if (isObservePerformanceEnabled) {
    (0,_core_public_performance_observer__WEBPACK_IMPORTED_MODULE_1__.renderPerformanceObserver)();
}
function initAgentxServices(config, accessToken, authService) {
    return __awaiter(this, void 0, void 0, function* () {
        (0,_config__WEBPACK_IMPORTED_MODULE_0__.setAgentxServicesConfig)(config);
        (0,_config__WEBPACK_IMPORTED_MODULE_0__.setAuthService)(authService);
        yield SERVICE.init(accessToken);
    });
}
function updateAccessToken(accessToken) {
    _core_sdk__WEBPACK_IMPORTED_MODULE_2__.http.accessToken = accessToken;
}
/**
 * Return Tracking ID from Error Object
 * @param errorObj
 * @returns Tracking ID
 */
const getTrackingIdFromErrorObject = (errorObj) => {
    var _a, _b, _c, _d, _e;
    if ((errorObj === null || errorObj === void 0 ? void 0 : errorObj.id) === "Service.aqm.reqs.Timeout") {
        // Fetching Tracking ID from success response header if timeout
        return (_d = (_c = (_b = (_a = errorObj === null || errorObj === void 0 ? void 0 : errorObj.details) === null || _a === void 0 ? void 0 : _a.resAxios) === null || _b === void 0 ? void 0 : _b.headers) === null || _c === void 0 ? void 0 : _c.trackingid) === null || _d === void 0 ? void 0 : _d.split("_")[1];
    }
    return (errorObj === null || errorObj === void 0 ? void 0 : errorObj.details) && ((_e = errorObj.details.trackingId) === null || _e === void 0 ? void 0 : _e.split("_")[1]);
};
/**
 * Return Masked string with PII removed
 * @param value
 * @returns Masked string
 */
const maskSensitiveData = (value) => {
    if (!value) {
        return value;
    }
    //eslint-disable-next-line sonarjs/single-char-in-character-classes, sonarjs/slow-regex
    const emailRegEx = /([\p{L}\p{N}])([\p{L}\p{N}._%+-]*)(@[\p{L}\p{N}.-]+\.[\p{L}]{2,})/gu;
    if (emailRegEx.test(value)) {
        return value.replace(emailRegEx, (match, p1, p2, p3) => {
            return p1 + "*".repeat(p2.length) + p3;
        });
    }
    const phoneNumberRegEx = /^[\p{N}+()\s-]{4,}$/u;
    if (phoneNumberRegEx.test(value)) {
        return value.replace(/.(?=.{4})/gu, "*");
    }
    return value;
};
/**
 * Gets rolename and forms it as per required display on Telemetry
 * @param roleName
 * @returns
 */
const formRoleNameForTelemetry = (roleName) => {
    const roleNameArray = roleName.split("_");
    return [...roleNameArray].reverse().join("_");
};
const getRoutingHost = () => {
    return `${_config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY}/v1`;
};


/***/ }),

/***/ "./src/services/actions-channels/actions-channels-service.ts":
/*!*******************************************************************!*\
  !*** ./src/services/actions-channels/actions-channels-service.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ActionsChannelsService: () => (/* binding */ ActionsChannelsService)
/* harmony export */ });
/* harmony import */ var event_emitter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! event-emitter */ "event-emitter");
/* harmony import */ var event_emitter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(event_emitter__WEBPACK_IMPORTED_MODULE_0__);

class ActionChannelSource {
    initOptions(options) {
        if (options) {
            this.options.throttleMs = options.rps && options.rps > 0 ? 1000 / options.rps : this.options.throttleMs;
            this.options.tag = options.tag ? options.tag : this.options.tag;
        }
    }
    createSourceMeta(opts) {
        return Object.assign(Object.assign(Object.assign({ argsCount: opts.argsCount, sourcesCount: this.getSourcesCount(), destinationsCount: this.getDestinationsCount() }, (this.options.tag ? { sentTag: this.options.tag } : null)), { throttledDelayMs: opts.throttledDelayMs }), { throttledDropCount: opts.throttledDropCount });
    }
    constructor(config) {
        this.options = {
            throttleMs: 0,
            tag: "" // Mark service/widget that sending action
        };
        this.lastTimeoutRef = undefined;
        this.last = Date.now();
        this.throttledDelayMs = 0;
        this.throttledDropCount = 0;
        this.actionName = config.actionName;
        this.emitter = config.inject.emitter;
        this.getSourcesCount = config.inject.getSourcesCount;
        this.getDestinationsCount = config.inject.getDestinationsCount;
        //
        this.initOptions(config.options || {});
    }
    send(...args) {
        // Throttling
        const now = Date.now();
        const deltaMs = now - this.last;
        if (this.lastTimeoutRef !== undefined) {
            this.throttledDropCount++;
        }
        window.clearTimeout(this.lastTimeoutRef);
        this.lastTimeoutRef = undefined;
        if (!this.last || !this.options.throttleMs || deltaMs >= this.options.throttleMs) {
            // NO Throttle (large deltaMs OR rps === 0)
            this.last = now;
            const meta = this.createSourceMeta({
                argsCount: args.length,
                throttledDelayMs: this.throttledDelayMs,
                throttledDropCount: this.throttledDropCount
            });
            const payload = {
                meta,
                args
            };
            this.emitter.emit(this.actionName, payload);
            this.throttledDelayMs = 0;
            this.throttledDropCount = 0;
        }
        else {
            // Do Throttle
            this.throttledDelayMs = this.options.throttleMs - deltaMs;
            this.lastTimeoutRef = window.setTimeout(() => this.send(...args), this.throttledDelayMs);
        }
    }
}
class ActionChannelDestination {
    initOptions(options) {
        if (options) {
            this.options.tag = options.tag ? options.tag : this.options.tag;
        }
    }
    constructor(config) {
        this.listenersSet = new Set();
        this.options = {
            tag: "" // Mark service/store that receiving action
        };
        this.actionName = config.actionName;
        this.emitter = config.inject.emitter;
        //
        this.initOptions(config.options || {});
    }
    get listenersCount() {
        return this.listenersSet.size;
    }
    addListener(listener) {
        if (!this.listenersSet.has(listener)) {
            this.listenersSet.add(listener);
        }
        this.emitter.on(this.actionName, listener);
    }
    removeListener(listener) {
        if (this.listenersSet.has(listener)) {
            this.listenersSet.delete(listener);
        }
        this.emitter.off(this.actionName, listener);
    }
    removeAllListeners() {
        this.listenersSet.forEach((l) => this.removeListener(l));
        this.listenersSet.clear();
    }
}
class ActionsChannelsService {
    constructor() {
        this.channelsSources = new Map();
        this.channelsDestinations = new Map();
        this.emitter = event_emitter__WEBPACK_IMPORTED_MODULE_0___default()();
    }
    getChannelsCount(actionName, map) {
        let count = 0;
        for (const [key, value] of map) {
            if (key === actionName) {
                count = value.size;
                break;
            }
        }
        return count;
    }
    getSourceChannelsCount(actionName) {
        return this.getChannelsCount(actionName, this.channelsSources);
    }
    getDestinationChannelsCount(actionName) {
        return this.getChannelsCount(actionName, this.channelsDestinations);
    }
    createSource(actionName, options) {
        const channelSources = this.channelsSources.get(actionName) || new Set();
        if (!this.channelsSources.has(actionName)) {
            this.channelsSources.set(actionName, channelSources);
        }
        const channelSource = new ActionChannelSource({
            actionName,
            inject: {
                emitter: this.emitter,
                getSourcesCount: () => this.getSourceChannelsCount(actionName),
                getDestinationsCount: () => this.getDestinationChannelsCount(actionName)
            },
            options
        });
        channelSources.add(channelSource);
        return channelSource;
    }
    createDestination(actionName, options) {
        const channelDestinations = this.channelsDestinations.get(actionName) || new Set();
        if (!this.channelsDestinations.has(actionName)) {
            this.channelsDestinations.set(actionName, channelDestinations);
        }
        const channelDestination = new ActionChannelDestination({
            actionName,
            inject: { emitter: this.emitter },
            options
        });
        channelDestinations.add(channelDestination);
        return channelDestination;
    }
}


/***/ }),

/***/ "./src/services/agent-performance/DataFetcher.ts":
/*!*******************************************************!*\
  !*** ./src/services/agent-performance/DataFetcher.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DataFetcher: () => (/* binding */ DataFetcher)
/* harmony export */ });
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./agent-performance-types */ "./src/services/agent-performance/agent-performance-types.ts");
/* harmony import */ var _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TahoeRequester */ "./src/services/agent-performance/TahoeRequester.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



const DEFAULT_ANOMALY_THRESHOLD = 0.5;
class DataFetcher {
    constructor() {
        this.requiredAgentColumns = [_TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.AgentId, _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.TeamId];
        this.requiredTeamColumn = _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.TeamId;
        this.forbiddenTeamColumns = [
            _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.AgentName,
            _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.AgentId,
            _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.AgentEmail
        ];
    }
    fetchPerformanceData(startTime, endTime, columns) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!columns || columns.length === 0) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("Columns are required to fetch agent performance data");
                return [];
            }
            const serviceColumns = this.columnNamesToServiceColumns(columns);
            const agentPerformanceData = this.getAgentPerformanceData(startTime, endTime, serviceColumns);
            let teamSessions = [];
            const containsTeamAvgColumn = columns.some((column) => this.isTeamAvgColumn(column));
            if (containsTeamAvgColumn) {
                const teamPerformanceData = this.getTeamPerformanceData(startTime, endTime, containsTeamAvgColumn, serviceColumns);
                teamSessions = (yield teamPerformanceData).data.agentSession.agentSessions;
            }
            const agentSessions = (yield agentPerformanceData).data.agentSession.agentSessions;
            return this.processSessions(agentSessions, teamSessions, columns);
        });
    }
    processSessions(agentSessions, teamSessions, columns) {
        const retTable = [];
        const getDurationObject = (value) => {
            return { duration: value };
        };
        const getPercentageObject = (value) => {
            return { ratio: value };
        };
        agentSessions.forEach((agentSession) => {
            const row = {};
            columns.forEach((column) => {
                switch (column) {
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentName:
                        row[column] = agentSession.agentName;
                        break;
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentId:
                        row[column] = agentSession.agentId;
                        break;
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentEmail:
                        row[column] = agentSession.userLoginId;
                        break;
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamId:
                        row[column] = agentSession.teamId;
                        break;
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamName:
                        row[column] = agentSession.teamName;
                        break;
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.SiteName:
                        row[column] = agentSession.siteName;
                        break;
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedDuration:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConsultRequestDuration:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldDuration:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialConnectedDuration:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialConsultRequestDuration:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialHoldDuration: {
                        row[column] = getDurationObject(this.getAggregationValue(agentSession.aggregation, column));
                        break;
                    }
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AverageHandleTime: {
                        row[column] = getDurationObject(this.computeAverageHandleTime(agentSession));
                        break;
                    }
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldDuration: {
                        this.processTeamSessions(teamSessions, agentSession, column, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldDuration, row);
                        row[column] = getDurationObject(Number(row[column]));
                        break;
                    }
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgConnectedDuration: {
                        this.processTeamSessions(teamSessions, agentSession, column, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedDuration, row);
                        row[column] = getDurationObject(Number(row[column]));
                        break;
                    }
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedCount:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConsultRequestCount:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConsultAnswerCount:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldCount:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TransferCount:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialCount:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialConnectedCount:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialConsultRequestCount:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialConsultAnswerCount:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialHoldCount:
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialTransferCount:
                        row[column] = this.getAggregationValue(agentSession.aggregation, column);
                        break;
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgConnectedCount:
                        this.processTeamSessions(teamSessions, agentSession, column, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedCount, row);
                        break;
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldCount:
                        this.processTeamSessions(teamSessions, agentSession, column, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldCount, row);
                        break;
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgTransferCount:
                        this.processTeamSessions(teamSessions, agentSession, column, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TransferCount, row);
                        break;
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgAverageHandleTime:
                        this.processTeamSessions(teamSessions, agentSession, column, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AverageHandleTime, row);
                        break;
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldCountPerCall: {
                        const connectedCount = this.getAggregationValue(agentSession.aggregation, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedCount);
                        const holdCount = this.getAggregationValue(agentSession.aggregation, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldCount);
                        const holdCountPerCall = this.computeAverage(holdCount, connectedCount);
                        row[column] = getPercentageObject(holdCountPerCall);
                        break;
                    }
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldDurationRatio: {
                        const connectedDuration = this.getAggregationValue(agentSession.aggregation, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedDuration);
                        const holdDuration = this.getAggregationValue(agentSession.aggregation, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldDuration);
                        const holdDurationRatio = this.computeAverage(holdDuration, connectedDuration);
                        row[column] = getPercentageObject(holdDurationRatio);
                        break;
                    }
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TransferCountPerCall: {
                        const transferCount = this.getAggregationValue(agentSession.aggregation, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TransferCount);
                        const connectedCount = this.getAggregationValue(agentSession.aggregation, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedCount);
                        const transferCountPerCall = this.computeAverage(transferCount, connectedCount);
                        row[column] = getPercentageObject(transferCountPerCall);
                        break;
                    }
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldCountPerCall: {
                        this.processTeamSessions(teamSessions, agentSession, column, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldCount, row, true);
                        row[column] = getPercentageObject(Number(row[column]));
                        break;
                    }
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgTransferCountPerCall: {
                        this.processTeamSessions(teamSessions, agentSession, column, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TransferCount, row, true);
                        row[column] = getPercentageObject(Number(row[column]));
                        break;
                    }
                    case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldDurationRatio: {
                        teamSessions.forEach((teamSession) => {
                            if (teamSession.teamId === agentSession.teamId) {
                                const holdDuration = this.getAggregationValue(teamSession.aggregation, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldDuration);
                                const connectedDuration = this.getAggregationValue(teamSession.aggregation, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedDuration);
                                const holdDurationRatio = this.computeAverage(holdDuration, connectedDuration);
                                row[column] = getPercentageObject(holdDurationRatio);
                            }
                        });
                        break;
                    }
                    default:
                        break;
                }
            });
            retTable.push(row);
        });
        this.computeAnomalies(retTable);
        return retTable;
    }
    computeAnomalies(table) {
        const anomalyConfigs = [
            {
                column: _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedCount,
                teamAvgColumn: _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgConnectedCount,
                threshold: DEFAULT_ANOMALY_THRESHOLD
            },
            {
                column: _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedDuration,
                teamAvgColumn: _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgConnectedDuration,
                threshold: DEFAULT_ANOMALY_THRESHOLD
            },
            {
                column: _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldCount,
                teamAvgColumn: _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldCount,
                threshold: DEFAULT_ANOMALY_THRESHOLD
            },
            {
                column: _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldDuration,
                teamAvgColumn: _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldDuration,
                threshold: DEFAULT_ANOMALY_THRESHOLD
            },
            {
                column: _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TransferCount,
                teamAvgColumn: _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgTransferCount,
                threshold: DEFAULT_ANOMALY_THRESHOLD
            },
            {
                column: _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AverageHandleTime,
                teamAvgColumn: _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgAverageHandleTime,
                threshold: DEFAULT_ANOMALY_THRESHOLD
            }
        ];
        const isAnomaly = (value, avgValue, threshold) => value > avgValue + avgValue * threshold || value < avgValue - avgValue * threshold;
        const processAnomaly = (row, config, anomalies) => {
            const columnValue = row[config.column];
            const teamAvgColumnValue = row[config.teamAvgColumn];
            if (typeof columnValue === "number" && typeof teamAvgColumnValue === "number") {
                anomalies.push({
                    column: config.column,
                    comparisonColumn: config.teamAvgColumn,
                    isAnomaly: isAnomaly(columnValue, teamAvgColumnValue, config.threshold)
                });
            }
            else if (columnValue &&
                typeof columnValue === "object" &&
                this.isDurationColumn(config.column) &&
                teamAvgColumnValue &&
                typeof teamAvgColumnValue === "object" &&
                this.isDurationColumn(config.teamAvgColumn)) {
                const columnValueDuration = columnValue.duration;
                const teamAvgColumnValueDuration = teamAvgColumnValue.duration;
                anomalies.push({
                    column: config.column,
                    comparisonColumn: config.teamAvgColumn,
                    isAnomaly: isAnomaly(columnValueDuration, teamAvgColumnValueDuration, config.threshold)
                });
            }
        };
        table.forEach((row) => {
            const anomalies = [];
            anomalyConfigs.forEach((config) => processAnomaly(row, config, anomalies));
            row[_agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.Anomalies] = anomalies;
        });
    }
    computeAverage(total, numItems) {
        return numItems > 0 ? total / numItems : 0;
    }
    computeAverageHandleTime(agentSession) {
        const connectedCount = this.getAggregationValue(agentSession.aggregation, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedCount);
        const connectedDuration = this.getAggregationValue(agentSession.aggregation, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedDuration);
        return this.computeAverage(connectedDuration, connectedCount);
    }
    processTeamSessions(teamSessions, agentSession, teamColumn, agentColumn, row, perCall = false) {
        const teamSession = teamSessions.find((session) => session.teamId === agentSession.teamId);
        if (!teamSession) {
            return;
        }
        let value;
        if (perCall) {
            const aggregationValue = this.getAggregationValue(teamSession.aggregation, agentColumn);
            const connectedCount = this.getAggregationValue(teamSession.aggregation, _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedCount);
            value = this.computeAverage(aggregationValue, connectedCount);
        }
        else {
            const agentCount = this.getAggregationValueUsingServiceColumn(teamSession.aggregation, _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.NumAgentsInTeam);
            const aggregationValue = teamColumn === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgAverageHandleTime
                ? this.computeAverageHandleTime(teamSession)
                : this.getAggregationValue(teamSession.aggregation, agentColumn);
            value = this.computeAverage(aggregationValue, agentCount);
        }
        row[teamColumn] = value;
    }
    getTeamPerformanceData(startTime, endTime, containsTeamAvgColumn, columns) {
        return __awaiter(this, void 0, void 0, function* () {
            // remove forbiddenTeamColumns from serviceColumns and add requiredTeamColumn
            columns = columns.filter((column) => !this.forbiddenTeamColumns.includes(column));
            // append requiredTeamColumn to serviceColumns if not already included
            if (!columns.includes(this.requiredTeamColumn)) {
                columns.push(this.requiredTeamColumn);
            }
            if (containsTeamAvgColumn && !columns.includes(_TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.NumAgentsInTeam)) {
                columns.push(_TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.NumAgentsInTeam);
            }
            const tahoeRequester = new _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeRequester();
            return tahoeRequester.fetchAgentPerformanceData({ startTime, endTime, columns });
        });
    }
    getAggregationValue(aggregations, column) {
        const serviceColumnName = this.columnNamesToServiceColumns([column]).at(0);
        if (serviceColumnName) {
            return this.getAggregationValueUsingServiceColumn(aggregations, serviceColumnName);
        }
        return 0;
    }
    getAggregationValueUsingServiceColumn(aggregations, column) {
        const tahoeRequester = new _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeRequester();
        const aggregationName = tahoeRequester.getAggregationName(column);
        const aggregation = aggregations.find((agg) => agg.name === aggregationName);
        return aggregation ? Number(aggregation.value) : 0;
    }
    getAgentPerformanceData(startTime, endTime, columns) {
        return __awaiter(this, void 0, void 0, function* () {
            // append requiredAgentColumns to serviceColumns if not already included
            this.requiredAgentColumns.forEach((requiredColumn) => {
                if (!columns.includes(requiredColumn)) {
                    columns.push(requiredColumn);
                }
            });
            const tahoeRequester = new _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeRequester();
            return tahoeRequester.fetchAgentPerformanceData({ startTime, endTime, columns });
        });
    }
    columnNamesToServiceColumns(columns) {
        const convertColumn = (column) => {
            switch (column) {
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentName:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.AgentName;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentId:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.AgentId;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AgentEmail:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.AgentEmail;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamId:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.TeamId;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedCount:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.ConnectedCount;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedDuration:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.ConnectedDuration;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConsultRequestCount:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.ConsultRequestCount;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConsultRequestDuration:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.ConsultRequestDuration;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConsultAnswerCount:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.ConsultAnswerCount;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldCount:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.HoldCount;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamName:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.TeamName;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldDuration:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.HoldDuration;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.SiteName:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.SiteName;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TransferCount:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.TransferCount;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialCount:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.OutdialCount;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialConnectedCount:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.OutdialConnectedCount;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialConnectedDuration:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.OutdialConnectedDuration;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialConsultRequestCount:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.OutdialConsultRequestCount;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialConsultRequestDuration:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.OutdialConsultRequestDuration;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialConsultAnswerCount:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.OutdialConsultAnswerCount;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialHoldCount:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.OutdialHoldCount;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialHoldDuration:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.OutdialHoldDuration;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.OutdialTransferCount:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.OutdialTransferCount;
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldDurationRatio:
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldCountPerCall:
                case _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TransferCountPerCall:
                default:
                    return _TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.AgentId;
            }
        };
        let serviceColumns = [];
        if (columns.includes(_agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AverageHandleTime)) {
            serviceColumns.push(_TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.ConnectedDuration);
            serviceColumns.push(_TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.ConnectedCount);
        }
        else if (columns.includes(_agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldCountPerCall)) {
            serviceColumns.push(_TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.ConnectedCount);
            serviceColumns.push(_TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.HoldCount);
        }
        else if (columns.includes(_agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldDurationRatio)) {
            serviceColumns.push(_TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.HoldDuration);
            serviceColumns.push(_TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.ConnectedDuration);
        }
        else if (columns.includes(_agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TransferCountPerCall)) {
            serviceColumns.push(_TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.TransferCount);
            serviceColumns.push(_TahoeRequester__WEBPACK_IMPORTED_MODULE_2__.TahoeColumnType.ConnectedCount);
        }
        else {
            serviceColumns = columns.map((column) => convertColumn(column));
        }
        columns.forEach((column) => {
            const serviceColumn = convertColumn(column);
            if (!serviceColumns.includes(serviceColumn)) {
                serviceColumns.push(serviceColumn);
            }
        });
        return Array.from(new Set(serviceColumns));
    }
    isTeamAvgColumn(column) {
        return (column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgConnectedCount ||
            column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgConnectedDuration ||
            column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldCount ||
            column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldDuration ||
            column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgTransferCount ||
            column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgAverageHandleTime);
    }
    isDurationColumn(column) {
        return (column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.ConnectedDuration ||
            column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.HoldDuration ||
            column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgConnectedDuration ||
            column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldDuration ||
            column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.AverageHandleTime ||
            column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgAverageHandleTime ||
            column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldCountPerCall ||
            column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgHoldDurationRatio ||
            column === _agent_performance_types__WEBPACK_IMPORTED_MODULE_1__.AgentPerformanceTypes.DataFetcherTypes.ColumnName.TeamAvgTransferCountPerCall);
    }
}


/***/ }),

/***/ "./src/services/agent-performance/TahoeRequester.ts":
/*!**********************************************************!*\
  !*** ./src/services/agent-performance/TahoeRequester.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TahoeColumnType: () => (/* binding */ TahoeColumnType),
/* harmony export */   TahoeRequester: () => (/* binding */ TahoeRequester)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _services_service_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../services/service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





const RETRY_AFTER_HEADER = "retry-after";
var AggregationType;
(function (AggregationType) {
    AggregationType["NONE"] = "none";
    AggregationType["SUM"] = "sum";
    AggregationType["AVERAGE"] = "average";
    AggregationType["COUNT"] = "count";
    AggregationType["CARDINALITY"] = "cardinality";
})(AggregationType || (AggregationType = {}));
var TahoeColumnType;
(function (TahoeColumnType) {
    TahoeColumnType[TahoeColumnType["AgentName"] = 1] = "AgentName";
    TahoeColumnType[TahoeColumnType["AgentId"] = 2] = "AgentId";
    TahoeColumnType[TahoeColumnType["AgentEmail"] = 3] = "AgentEmail";
    TahoeColumnType[TahoeColumnType["ConnectedCount"] = 4] = "ConnectedCount";
    TahoeColumnType[TahoeColumnType["ConnectedDuration"] = 5] = "ConnectedDuration";
    TahoeColumnType[TahoeColumnType["ConsultRequestCount"] = 6] = "ConsultRequestCount";
    TahoeColumnType[TahoeColumnType["ConsultRequestDuration"] = 7] = "ConsultRequestDuration";
    TahoeColumnType[TahoeColumnType["ConsultAnswerCount"] = 8] = "ConsultAnswerCount";
    TahoeColumnType[TahoeColumnType["HoldCount"] = 9] = "HoldCount";
    TahoeColumnType[TahoeColumnType["HoldDuration"] = 10] = "HoldDuration";
    TahoeColumnType[TahoeColumnType["TeamId"] = 11] = "TeamId";
    TahoeColumnType[TahoeColumnType["TeamName"] = 12] = "TeamName";
    TahoeColumnType[TahoeColumnType["SiteName"] = 13] = "SiteName";
    TahoeColumnType[TahoeColumnType["TransferCount"] = 14] = "TransferCount";
    TahoeColumnType[TahoeColumnType["NumAgentsInTeam"] = 15] = "NumAgentsInTeam";
    TahoeColumnType[TahoeColumnType["OutdialCount"] = 16] = "OutdialCount";
    TahoeColumnType[TahoeColumnType["OutdialConnectedCount"] = 17] = "OutdialConnectedCount";
    TahoeColumnType[TahoeColumnType["OutdialConnectedDuration"] = 18] = "OutdialConnectedDuration";
    TahoeColumnType[TahoeColumnType["OutdialConsultRequestCount"] = 19] = "OutdialConsultRequestCount";
    TahoeColumnType[TahoeColumnType["OutdialConsultRequestDuration"] = 20] = "OutdialConsultRequestDuration";
    TahoeColumnType[TahoeColumnType["OutdialConsultAnswerCount"] = 21] = "OutdialConsultAnswerCount";
    TahoeColumnType[TahoeColumnType["OutdialHoldCount"] = 22] = "OutdialHoldCount";
    TahoeColumnType[TahoeColumnType["OutdialHoldDuration"] = 23] = "OutdialHoldDuration";
    TahoeColumnType[TahoeColumnType["OutdialTransferCount"] = 24] = "OutdialTransferCount";
})(TahoeColumnType || (TahoeColumnType = {}));
class PerformanceServiceField {
    constructor(asrOperationField, columnField, aggregationType = AggregationType.NONE) {
        this.asrOperationField = asrOperationField;
        this.columnField = columnField;
        this.aggregationType = aggregationType;
    }
    getAggregationName() {
        if (this.aggregationType === AggregationType.NONE) {
            return "";
        }
        return `${this.aggregationType}_${this.asrOperationField}`;
    }
}
class TahoeRequester {
    constructor() {
        this.http = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_2__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_1__.CONF.API_GATEWAY);
        this.performanceServiceFields = [];
        const connectedDurationString = "channelInfo.connectedDuration";
        this.performanceServiceFields = [
            new PerformanceServiceField("agentName", TahoeColumnType.AgentName),
            new PerformanceServiceField("agentId", TahoeColumnType.AgentId),
            new PerformanceServiceField("userLoginId", TahoeColumnType.AgentEmail),
            new PerformanceServiceField("channelInfo.connectedCount", TahoeColumnType.ConnectedCount, AggregationType.SUM),
            new PerformanceServiceField(connectedDurationString, TahoeColumnType.ConnectedDuration, AggregationType.SUM),
            new PerformanceServiceField("channelInfo.consultRequestCount", TahoeColumnType.ConsultRequestCount, AggregationType.SUM),
            new PerformanceServiceField("channelInfo.consultRequestDuration", TahoeColumnType.ConsultRequestDuration, AggregationType.SUM),
            new PerformanceServiceField("channelInfo.consultAnswerCount", TahoeColumnType.ConsultAnswerCount, AggregationType.SUM),
            new PerformanceServiceField("channelInfo.holdCount", TahoeColumnType.HoldCount, AggregationType.SUM),
            new PerformanceServiceField("channelInfo.holdDuration", TahoeColumnType.HoldDuration, AggregationType.SUM),
            new PerformanceServiceField("teamId", TahoeColumnType.TeamId),
            new PerformanceServiceField("teamName", TahoeColumnType.TeamName),
            new PerformanceServiceField("siteName", TahoeColumnType.SiteName),
            new PerformanceServiceField("channelInfo.transferCount", TahoeColumnType.TransferCount, AggregationType.SUM),
            new PerformanceServiceField("agentId", TahoeColumnType.NumAgentsInTeam, AggregationType.CARDINALITY),
            new PerformanceServiceField("channelInfo.outdialCount", TahoeColumnType.OutdialCount, AggregationType.SUM),
            new PerformanceServiceField("channelInfo.outdialConnectedCount", TahoeColumnType.OutdialConnectedCount, AggregationType.SUM),
            new PerformanceServiceField("channelInfo.outdialConnectedDuration", TahoeColumnType.OutdialConnectedDuration, AggregationType.SUM),
            new PerformanceServiceField("channelInfo.outdialConsultRequestCount", TahoeColumnType.OutdialConsultRequestCount, AggregationType.SUM),
            new PerformanceServiceField("channelInfo.outdialConsultRequestDuration", TahoeColumnType.OutdialConsultRequestDuration, AggregationType.SUM),
            new PerformanceServiceField("channelInfo.outdialConsultAnswerCount", TahoeColumnType.OutdialConsultAnswerCount, AggregationType.SUM),
            new PerformanceServiceField("channelInfo.outdialHoldCount", TahoeColumnType.OutdialHoldCount, AggregationType.SUM),
            new PerformanceServiceField("channelInfo.outdialHoldDuration", TahoeColumnType.OutdialHoldDuration, AggregationType.SUM),
            new PerformanceServiceField("channelInfo.outdialTransferCount", TahoeColumnType.OutdialTransferCount, AggregationType.SUM)
        ];
    }
    createErrDetailsObjectWithStatusCode(errObj, errorKey) {
        var _a, _b, _c, _d, _e;
        const details = {
            trackingId: ((_a = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _a === void 0 ? void 0 : _a.headers["trackingid"]) || ((_b = errObj === null || errObj === void 0 ? void 0 : errObj.config) === null || _b === void 0 ? void 0 : _b.headers["TrackingID"]),
            msg: (_c = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _c === void 0 ? void 0 : _c.data,
            statusCode: (_d = errObj.response) === null || _d === void 0 ? void 0 : _d.status,
            retryAfter: (_e = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _e === void 0 ? void 0 : _e.headers[RETRY_AFTER_HEADER]
        };
        return new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details(errorKey !== null && errorKey !== void 0 ? errorKey : "Service.reqs.generic.failure", details);
    }
    buildFilterFields(filterKeyValues) {
        const filters = [];
        filterKeyValues.forEach(([key, value]) => {
            const serviceField = this.getServiceField(key);
            if (serviceField) {
                const filterKey = serviceField.asrOperationField;
                const filterVal = value.replace(/"/g, '\\"'); // escape double quotes
                if (filterKey === null || filterKey === void 0 ? void 0 : filterKey.includes(".")) {
                    const split = filterKey.replace(/"/g, '\\"').split(".");
                    filters.push(`{ ${split[0]}: { ${split[1]}: { equals: "${filterVal}" } } }`);
                }
                else {
                    filters.push(`{ ${filterKey}: { equals: "${filterVal}" } }`);
                }
            }
        });
        return filters.length === 0 ? "" : `{ or: [ ${filters} ] }`;
    }
    buildFilterQuery(params) {
        return `
    filter: {
      and: [
        { channelInfo: { channelType: { equals: "telephony" } } }
        { isActive: { equals: false } }
        ${params.filterKeyValues ? this.buildFilterFields(params.filterKeyValues) : ""}
      ]
    }`;
    }
    buildAggregationFields(columns) {
        let aggregationStr = ``;
        columns === null || columns === void 0 ? void 0 : columns.forEach((column) => {
            const serviceField = this.getServiceField(column);
            if (!serviceField || serviceField.aggregationType === AggregationType.NONE) {
                return;
            }
            aggregationStr += ` { field: "${serviceField.asrOperationField}" name: "${serviceField.getAggregationName()}" type: ${serviceField.aggregationType} } `;
        });
        return aggregationStr;
    }
    buildFieldsString(columns) {
        let groupByStr = ``;
        columns === null || columns === void 0 ? void 0 : columns.forEach((column) => {
            const serviceField = this.getServiceField(column);
            if ((serviceField === null || serviceField === void 0 ? void 0 : serviceField.aggregationType) === AggregationType.NONE) {
                groupByStr += `${serviceField.asrOperationField} `;
            }
        });
        return groupByStr;
    }
    getServiceField(column) {
        return this.performanceServiceFields.find((field) => field.columnField === column);
    }
    buildAgentSessionQuery(params) {
        const aggregations = this.buildAggregationFields(params.columns);
        const aggregationsQuery = aggregations ? `aggregations: [${aggregations}] ` : ``;
        let fieldsString = this.buildFieldsString(params.columns);
        fieldsString += aggregationsQuery ? `aggregation { name value } ` : ``;
        return `agentSession(
        from: ${params.startTime}
        to: ${params.endTime}
        ${aggregationsQuery}
        ${this.buildFilterQuery({ filterKeyValues: params.filterKeyValues })}
      ) {
        agentSessions { ${fieldsString} }
        pageInfo { endCursor hasNextPage }
      }`.replace(/\s+/g, " ");
    }
    getAggregationName(columnType) {
        var _a;
        const serviceField = this.getServiceField(columnType);
        return (_a = serviceField === null || serviceField === void 0 ? void 0 : serviceField.getAggregationName()) !== null && _a !== void 0 ? _a : "";
    }
    fetchAgentPerformanceData(p) {
        return __awaiter(this, void 0, void 0, function* () {
            // Input validation
            if (!p.columns || p.columns.length === 0) {
                throw new Error("Columns are required to build the query");
            }
            // Proceed with the request if validation passes
            let query = `{
      ${this.buildAgentSessionQuery(p)}
    }`;
            query = query.replace(/\s+/g, " ");
            return this.http.req((_p) => ({
                method: "POST",
                url: `/search`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                data: { query },
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.fetchAgentPerformanceData"),
                errId: "Service.agentPerformance.fetchAgentPerformanceData",
                res: {}
            }))(p);
        });
    }
}


/***/ }),

/***/ "./src/services/agent-performance/agent-performance-service.ts":
/*!*********************************************************************!*\
  !*** ./src/services/agent-performance/agent-performance-service.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentPerformanceService: () => (/* binding */ AgentPerformanceService)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _services_service_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../services/service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _DataFetcher__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./DataFetcher */ "./src/services/agent-performance/DataFetcher.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable sonarjs/no-duplicate-string */






const RETRY_AFTER_HEADER = "retry-after";
const MISSING_REQUIRED_PARAMS = "Some of the required params are missing or undefined";
class AgentPerformanceService {
    constructor() {
        this.http = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_2__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_1__.CONF.API_GATEWAY);
        this.httpLocal = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_2__.HttpReqs("http://localhost:8080");
    }
    fetchPerformanceData(startTime, endTime, columns) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!startTime || !endTime) {
                throw new Error(MISSING_REQUIRED_PARAMS);
            }
            const dataFetcher = new _DataFetcher__WEBPACK_IMPORTED_MODULE_4__.DataFetcher();
            return dataFetcher.fetchPerformanceData(startTime, endTime, columns);
        });
    }
    createErrDetailsObjectWithStatusCode(errObj, errorKey) {
        var _a, _b, _c, _d, _e;
        const details = {
            trackingId: ((_a = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _a === void 0 ? void 0 : _a.headers["trackingid"]) || ((_b = errObj === null || errObj === void 0 ? void 0 : errObj.config) === null || _b === void 0 ? void 0 : _b.headers["TrackingID"]),
            msg: (_c = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _c === void 0 ? void 0 : _c.data,
            statusCode: (_d = errObj.response) === null || _d === void 0 ? void 0 : _d.status,
            retryAfter: (_e = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _e === void 0 ? void 0 : _e.headers[RETRY_AFTER_HEADER]
        };
        return new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details(errorKey !== null && errorKey !== void 0 ? errorKey : "Service.reqs.generic.failure", details);
    }
    fetchEvaluationForm(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.orgId || !params.formId) {
                throw new Error(MISSING_REQUIRED_PARAMS);
            }
            const requestFunction = this.httpLocal.req((requestParams) => ({
                method: "GET",
                url: `/api/v1/qm/evaluationForms/${requestParams.orgId}/${requestParams.formId}`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.fetchEvaluationForm"),
                errId: "Service.agentPerformance.fetchEvaluationForm",
                res: {}
            }));
            return requestFunction(params);
        });
    }
    fetchOrgEvaluationForms(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.orgId) {
                throw new Error("Value of orgId must not be null or undefined");
            }
            const requestFunction = this.httpLocal.req((requestParams) => ({
                method: "GET",
                url: `/api/v1/qm/evaluationForms/${requestParams.orgId}`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.fetchOrgEvaluationForms"),
                errId: "Service.agentPerformance.fetchOrgEvaluationForms",
                res: {}
            }));
            return requestFunction(params);
        });
    }
    fetchAIAssistedEvaluations(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.orgId || !params.interactionId) {
                throw new Error(MISSING_REQUIRED_PARAMS);
            }
            const requestFunction = this.httpLocal.req((requestParams) => ({
                method: "GET",
                url: `/api/v1/qm/aiEvaluations/${requestParams.orgId}/by-interaction/${requestParams.interactionId}`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.fetchAIAssistedEvaluations"),
                errId: "Service.agentPerformance.fetchAIAssistedEvaluations",
                res: {}
            }));
            return requestFunction(params);
        });
    }
    triggerAIEvaluation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.orgId || !params.formId || !params.interactionId || !params.transcript || !params.agent) {
                throw new Error(MISSING_REQUIRED_PARAMS);
            }
            const requestFunction = this.httpLocal.req((requestParams) => ({
                method: "POST",
                url: `/api/v1/qm/aiEvaluations/${requestParams.orgId}/${requestParams.formId}/${requestParams.interactionId}`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.triggerAIEvaluation"),
                errId: "Service.agentPerformance.triggerAIEvaluation",
                data: { agent: requestParams.agent, transcript: requestParams.transcript },
                res: {}
            }));
            return requestFunction(params);
        });
    }
    saveEvaluationForm(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.orgId) {
                throw new Error("Value of orgId must not be null or undefined");
            }
            const requestFunction = this.httpLocal.req((requestParams) => ({
                method: "POST",
                url: `/api/v1/qm/evaluationForms/${requestParams.orgId}`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.saveEvaluationForm"),
                errId: "Service.agentPerformance.saveEvaluationForm",
                res: {},
                data: requestParams.data
            }));
            return requestFunction(params);
        });
    }
    updateEvaluationForm(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.orgId || !params.formId || !params.data) {
                throw new Error(MISSING_REQUIRED_PARAMS);
            }
            const requestFunction = this.httpLocal.req((requestParams) => ({
                method: "PUT",
                url: `/api/v1/qm/evaluationForms/${requestParams.orgId}/${requestParams.formId}`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.updateEvaluationForm"),
                errId: "Service.agentPerformance.updateEvaluationForm",
                res: {},
                data: requestParams.data
            }));
            return requestFunction(params);
        });
    }
    createEvaluation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.orgId) {
                throw new Error("Value of orgId must not be null or undefined");
            }
            const requestFunction = this.httpLocal.req((requestParams) => ({
                method: "POST",
                url: `/api/v1/qm/evaluations/${requestParams.orgId}`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.createEvaluation"),
                errId: "Service.agentPerformance.createEvaluation",
                res: {},
                data: requestParams.data
            }));
            return requestFunction(params);
        });
    }
    deleteEvaluationForm(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.orgId || !params.formId) {
                throw new Error(MISSING_REQUIRED_PARAMS);
            }
            const requestFunction = this.httpLocal.req((requestParams) => ({
                method: "DELETE",
                url: `/api/v1/qm/evaluationForms/${requestParams.orgId}/${requestParams.formId}`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.deleteEvaluationForm"),
                errId: "Service.agentPerformance.deleteEvaluationForm",
                res: {}
            }));
            return requestFunction(params);
        });
    }
    archiveEvaluationForm(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.orgId || !params.formId) {
                throw new Error(MISSING_REQUIRED_PARAMS);
            }
            const requestFunction = this.httpLocal.req((requestParams) => ({
                method: "POST",
                url: `/api/v1/qm/evaluationForms/${requestParams.orgId}/${requestParams.formId}/archive`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.archiveEvaluationForm"),
                errId: "Service.agentPerformance.archiveEvaluationForm",
                res: {}
            }));
            return requestFunction(params);
        });
    }
    publishEvaluationForm(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.orgId || !params.formId) {
                throw new Error(MISSING_REQUIRED_PARAMS);
            }
            const requestFunction = this.httpLocal.req((requestParams) => ({
                method: "POST",
                url: `/api/v1/qm/evaluationForms/${requestParams.orgId}/${requestParams.formId}/activate`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.publishEvaluationForm"),
                errId: "Service.agentPerformance.publishEvaluationForm",
                res: {}
            }));
            return requestFunction(params);
        });
    }
    fetchEvaluation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.interactionId || !params.orgId) {
                throw new Error(MISSING_REQUIRED_PARAMS);
            }
            const requestFunction = this.httpLocal.req((requestParams) => ({
                method: "GET",
                url: `/api/v1/qm/evaluations/${requestParams.orgId}/by-interaction/${requestParams.interactionId}`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.fetchEvaluation"),
                errId: "Service.agentPerformance.fetchEvaluation",
                res: {}
            }));
            return requestFunction(params);
        });
    }
    saveEvaluation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.orgId || !params.evaluationId) {
                throw new Error(MISSING_REQUIRED_PARAMS);
            }
            const requestFunction = this.httpLocal.req((requestParams) => ({
                method: "PUT",
                url: `/api/v1/qm/evaluations/${requestParams.orgId}/${requestParams.evaluationId}`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.saveEvaluation"),
                errId: "Service.agentPerformance.saveEvaluation",
                res: {},
                data: requestParams.data
            }));
            return requestFunction(params);
        });
    }
    publishEvaluation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.orgId || !params.evaluationId) {
                throw new Error(MISSING_REQUIRED_PARAMS);
            }
            const requestFunction = this.httpLocal.req((requestParams) => ({
                method: "POST",
                url: `/api/v1/qm/evaluations/${requestParams.orgId}/${requestParams.evaluationId}/publish`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.publishEvaluation"),
                errId: "Service.agentPerformance.publishEvaluation",
                res: {},
                data: requestParams.data
            }));
            return requestFunction(params);
        });
    }
    archiveEvaluation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params.orgId || !params.evaluationId) {
                throw new Error(MISSING_REQUIRED_PARAMS);
            }
            const requestFunction = this.httpLocal.req((requestParams) => ({
                method: "POST",
                url: `/api/v1/qm/evaluations/${requestParams.orgId}/${requestParams.evaluationId}/archive`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_services_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
                err: (e) => this.createErrDetailsObjectWithStatusCode(e, "Service.agentPerformance.archiveEvaluation"),
                errId: "Service.agentPerformance.archiveEvaluation",
                res: {}
            }));
            return requestFunction(params);
        });
    }
}


/***/ }),

/***/ "./src/services/agent-performance/agent-performance-types.ts":
/*!*******************************************************************!*\
  !*** ./src/services/agent-performance/agent-performance-types.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentPerformanceTypes: () => (/* binding */ AgentPerformanceTypes)
/* harmony export */ });
var AgentPerformanceTypes;
(function (AgentPerformanceTypes) {
    let DataFetcherTypes;
    (function (DataFetcherTypes) {
        let ColumnName;
        (function (ColumnName) {
            ColumnName["AgentName"] = "agentName";
            ColumnName["AgentId"] = "agentId";
            ColumnName["AgentEmail"] = "agentEmail";
            ColumnName["TeamName"] = "teamName";
            ColumnName["TeamId"] = "teamId";
            ColumnName["SiteName"] = "siteName";
            ColumnName["SiteId"] = "siteId";
            ColumnName["ConnectedCount"] = "connectedCount";
            ColumnName["ConnectedDuration"] = "connectedDuration";
            ColumnName["ConsultRequestCount"] = "consultRequestCount";
            ColumnName["ConsultRequestDuration"] = "consultRequestDuration";
            ColumnName["ConsultAnswerCount"] = "consultAnswerCount";
            ColumnName["HoldCount"] = "holdCount";
            ColumnName["HoldDuration"] = "holdDuration";
            ColumnName["TransferCount"] = "transferCount";
            ColumnName["AverageHandleTime"] = "averageHandleTime";
            // team average columns
            ColumnName["TeamAvgConnectedCount"] = "teamAvgConnectedCount";
            ColumnName["TeamAvgConnectedDuration"] = "teamAvgConnectedDuration";
            ColumnName["TeamAvgHoldCount"] = "teamAvgHoldCount";
            ColumnName["TeamAvgHoldDuration"] = "teamAvgHoldDuration";
            ColumnName["TeamAvgTransferCount"] = "teamAvgTransferCount";
            ColumnName["TeamAvgAverageHandleTime"] = "teamAvgAverageHandleTime";
            // computed columns below this line
            ColumnName["HoldCountPerCall"] = "holdCountPerCall";
            ColumnName["TransferCountPerCall"] = "transferCountPerCall";
            ColumnName["HoldDurationRatio"] = "holdDurationRatio";
            ColumnName["TeamAvgHoldCountPerCall"] = "teamAvgHoldCountPerCall";
            ColumnName["TeamAvgTransferCountPerCall"] = "teamAvgTransferCountPerCall";
            ColumnName["TeamAvgHoldDurationRatio"] = "teamAvgHoldDurationRatio";
            ColumnName["Anomalies"] = "anomalies";
            // outdial columns
            ColumnName["OutdialCount"] = "outdialCount";
            ColumnName["OutdialConnectedCount"] = "outdialConnectedCount";
            ColumnName["OutdialConnectedDuration"] = "outdialConnectedDuration";
            ColumnName["OutdialConsultRequestCount"] = "outdialConsultRequestCount";
            ColumnName["OutdialConsultRequestDuration"] = "outdialConsultRequestDuration";
            ColumnName["OutdialConsultAnswerCount"] = "outdialConsultAnswerCount";
            ColumnName["OutdialHoldCount"] = "outdialHoldCount";
            ColumnName["OutdialHoldDuration"] = "outdialHoldDuration";
            ColumnName["OutdialTransferCount"] = "outdialTransferCount";
        })(ColumnName = DataFetcherTypes.ColumnName || (DataFetcherTypes.ColumnName = {}));
    })(DataFetcherTypes = AgentPerformanceTypes.DataFetcherTypes || (AgentPerformanceTypes.DataFetcherTypes = {}));
    let EvaluationMode;
    (function (EvaluationMode) {
        EvaluationMode["VIEW"] = "VIEW";
        EvaluationMode["EDIT"] = "EDIT";
        EvaluationMode["CREATE"] = "CREATE";
    })(EvaluationMode = AgentPerformanceTypes.EvaluationMode || (AgentPerformanceTypes.EvaluationMode = {}));
    let QuestionType;
    (function (QuestionType) {
        QuestionType["SINGLE_CHOICE"] = "SINGLE_CHOICE";
    })(QuestionType = AgentPerformanceTypes.QuestionType || (AgentPerformanceTypes.QuestionType = {}));
    let EvaluationStatus;
    (function (EvaluationStatus) {
        EvaluationStatus["ARCHIVED"] = "ARCHIVED";
        EvaluationStatus["DRAFT"] = "DRAFT";
        EvaluationStatus["ACTIVE"] = "ACTIVE";
        EvaluationStatus["PUBLISHED"] = "PUBLISHED";
    })(EvaluationStatus = AgentPerformanceTypes.EvaluationStatus || (AgentPerformanceTypes.EvaluationStatus = {}));
    let EvaluationMetricEvents;
    (function (EvaluationMetricEvents) {
        EvaluationMetricEvents["VIEWING_PUBLISHED_EVALUATION"] = "viewing-published-evaluation";
        EvaluationMetricEvents["RETRIEVE_EVALUATION_FORMS"] = "retrieve-evaluation-forms";
        EvaluationMetricEvents["RETRIEVE_EVALUATION_FORM"] = "retrieve-evaluation-form";
        EvaluationMetricEvents["RETRIEVE_EVALUATION"] = "retrieve-evaluation";
        EvaluationMetricEvents["SAVE_EVALUATION"] = "save-evaluation";
        EvaluationMetricEvents["PUBLISH_EVALUATION"] = "publish-evaluation";
        EvaluationMetricEvents["DISCARD_EVALUATION"] = "discard-evaluation";
        EvaluationMetricEvents["CREATE_EVALUATION"] = "create-evaluation";
        EvaluationMetricEvents["AI_ASSIST_SUGGESTIONS_UNAVAILABLE"] = "ai-assist-suggestions-unavailable";
        EvaluationMetricEvents["ERROR_RETRIEVING_AI_ASSIST_SUGGESTIONS"] = "error-retrieving-ai-assist-suggestions";
        EvaluationMetricEvents["AI_ASSIST_POLLING_MAX_RETRIES"] = "ai-assist-polling-max-retries";
        EvaluationMetricEvents["AI_ASSIST_POLLING_SUCCESS"] = "ai-assist-polling-success";
        EvaluationMetricEvents["AI_ASSIST_POLLING_FAILED"] = "ai-assist-polling-failed";
    })(EvaluationMetricEvents = AgentPerformanceTypes.EvaluationMetricEvents || (AgentPerformanceTypes.EvaluationMetricEvents = {}));
})(AgentPerformanceTypes || (AgentPerformanceTypes = {}));


/***/ }),

/***/ "./src/services/agent/agent-service-rtd.ts":
/*!*************************************************!*\
  !*** ./src/services/agent/agent-service-rtd.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentServiceRtd: () => (/* binding */ AgentServiceRtd)
/* harmony export */ });
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

/**
 * Handles real-time data updates for agents from wxcc rtd
 */
class AgentServiceRtd {
    /**
     * Subscribes to agent global status updates
     * @param callback Function to call when updates are received
     * @returns Subscription object
     */
    subscribeAgentGlobalStatusUpdates(callback) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield ((_a = window.wxcc) === null || _a === void 0 ? void 0 : _a.rtdwc.subscribe({
                    datasetName: "wxcc.rtd.agentglobalstatus",
                    update: (data, deltaData) => {
                        const agents = this.handleAgentStatusUpdate(data.type, data === null || data === void 0 ? void 0 : data.datasetValues, deltaData === null || deltaData === void 0 ? void 0 : deltaData.datasetValues);
                        if (agents) {
                            callback(agents);
                        }
                    }
                }));
            }
            catch (error) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("[AgentsServiceRtd] Failed to subscribe to agent global status rtd", error);
                throw error;
            }
        });
    }
    /**
     * Handles agent status updates
     * @param updateType Type of update (SubscriptionResponse or RealtimeFeed)
     * @param fullData Complete data set (for initial response)
     * @param deltaData Delta data set (for real-time updates)
     * @returns Agent status object
     */
    handleAgentStatusUpdate(updateType, fullData, deltaData) {
        if (fullData && updateType === "SubscriptionResponse") {
            const fullUpdate = fullData.map((data) => this.mapRtdDataToAgent(data));
            return { fullUpdate };
        }
        else if (updateType === "RealtimeFeed" && deltaData && deltaData.length > 0) {
            const removed = deltaData.reduce((acc, data) => {
                if (data.operation === "DELETE") {
                    acc.push(data.data.agentId);
                }
                return acc;
            }, []);
            const updated = deltaData
                .filter((data) => data.operation === "UPSERT")
                .map((data) => this.mapRtdDataToAgent(data));
            return { realTimeUpdate: { updated, removed } };
        }
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.warn("[AgentsServiceRtd] Invalid or unsupported update type", updateType);
        return {};
    }
    /**
     * Maps rtd data to agent
     * @param dataSetValue Agent global status from rtd
     * @returns Mapped agent
     */
    mapRtdDataToAgent(dataSetValue) {
        const partialAgent = {
            agentId: dataSetValue.data.agentId,
            agentName: dataSetValue.data.agentName,
            agentEmail: dataSetValue.data.agentEmail,
            globalState: dataSetValue.data.globalState,
            globalStateTimestamp: dataSetValue.data.globalStateTimestamp,
            agentPhone: dataSetValue.data.agentPhone,
            lastLoginTime: dataSetValue.data.lastLoginTime,
            siteName: dataSetValue.data.siteName,
            teamName: dataSetValue.data.teamName,
            teamId: dataSetValue.data.teamId,
            idleCodeName: dataSetValue.data.idleCodeName || "",
            idleCodeId: dataSetValue.data.idleCodeId || "",
            orgId: dataSetValue.data.orgId || "",
            changedByRole: dataSetValue.data.changedByRole || "",
            changedById: dataSetValue.data.changedById || "",
            changedByName: dataSetValue.data.changedByName || "",
            reason: dataSetValue.data.reason || "",
            skillsProfile: dataSetValue.data.skillsProfile || "",
            associatedQueueIds: dataSetValue.data.associatedQueueIds || []
        };
        return partialAgent;
    }
}


/***/ }),

/***/ "./src/services/agent/agent-service.ts":
/*!*********************************************!*\
  !*** ./src/services/agent/agent-service.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentService: () => (/* binding */ AgentService),
/* harmony export */   buildAgentService: () => (/* binding */ buildAgentService)
/* harmony export */ });
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _agent_service_rtd__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./agent-service-rtd */ "./src/services/agent/agent-service-rtd.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


class AgentService {
    constructor(agentServiceRtd) {
        this.agentServiceRtd = agentServiceRtd;
        this.subscribers = new Map();
    }
    subscribeAgentGlobalStatusUpdates(callback) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!callback) {
                throw new Error("callback is required to subscribe to agent global stats updates");
            }
            if (Array.from(this.subscribers.values()).some((subscriber) => subscriber.callback === callback)) {
                throw new Error("Already subscribed to agents global status updates");
            }
            const agentGlobalStatsSubscription = yield this.agentServiceRtd.subscribeAgentGlobalStatusUpdates(callback);
            return this.addSubscription(callback, agentGlobalStatsSubscription);
        });
    }
    stopAgentGlobalStatusUpdates(subscriberId) {
        return __awaiter(this, void 0, void 0, function* () {
            const subscriber = this.subscribers.get(subscriberId);
            if (!subscriber) {
                return;
            }
            if (subscriber.agentGlobalStatsSubscription) {
                subscriber.agentGlobalStatsSubscription.unsubscribe();
            }
            this.subscribers.delete(subscriberId);
        });
    }
    addSubscription(callback, agentGlobalStatsSubscription) {
        const subscriptionId = (0,_service_utils__WEBPACK_IMPORTED_MODULE_0__.generateUUID)();
        this.subscribers.set(subscriptionId, {
            callback,
            agentGlobalStatsSubscription
        });
        return subscriptionId;
    }
}
function buildAgentService() {
    return new AgentService(new _agent_service_rtd__WEBPACK_IMPORTED_MODULE_1__.AgentServiceRtd());
}


/***/ }),

/***/ "./src/services/agent/index.ts":
/*!*************************************!*\
  !*** ./src/services/agent/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentService: () => (/* reexport safe */ _agent_service__WEBPACK_IMPORTED_MODULE_0__.AgentService),
/* harmony export */   buildAgentService: () => (/* reexport safe */ _agent_service__WEBPACK_IMPORTED_MODULE_0__.buildAgentService)
/* harmony export */ });
/* harmony import */ var _agent_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./agent-service */ "./src/services/agent/agent-service.ts");



/***/ }),

/***/ "./src/services/agentx-backend-proxy/agentx-backend-for-jssdk.ts":
/*!***********************************************************************!*\
  !*** ./src/services/agentx-backend-proxy/agentx-backend-for-jssdk.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   exposedBackendAPIs: () => (/* binding */ exposedBackendAPIs),
/* harmony export */   exposedBackendContactAPIs: () => (/* binding */ exposedBackendContactAPIs),
/* harmony export */   fetchPaginatedAuxCodesHandler: () => (/* binding */ fetchPaginatedAuxCodesHandler)
/* harmony export */ });
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../index */ "./src/index.ts");
/* harmony import */ var _aqm_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../aqm/constants */ "./src/services/aqm/constants.ts");
/* harmony import */ var _agentx_backend_proxy_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./agentx-backend-proxy-service */ "./src/services/agentx-backend-proxy/agentx-backend-proxy-service.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




function exposedBackendAPIs() {
    function fetchMockOutidalANIList() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            let outdialANIListObject;
            try {
                const response = yield (0,_agentx_backend_proxy_service__WEBPACK_IMPORTED_MODULE_3__.absService)().fetchOutdialANICMS({
                    orgId: ((_a = _index__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    outdialANIId: ((_b = _index__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _b === void 0 ? void 0 : _b.outdialANIId) || ""
                });
                outdialANIListObject = {
                    data: Object.assign(Object.assign({}, response), { jsMethod: "mockOutdialAni" }),
                    orgId: (_c = _index__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _c === void 0 ? void 0 : _c.orgId,
                    trackingId: response.trackingId || "",
                    type: "mockOutdialAniList"
                };
                //update the outdial ani store obj
                window.dispatchEvent(new CustomEvent("outdial-update-ani-list-jssdk", {
                    detail: { data: outdialANIListObject },
                    bubbles: true,
                    composed: true
                }));
            }
            catch (error) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("Error fetching outdial entries: ", error);
                throw error;
            }
            return outdialANIListObject;
        });
    }
    function fetchAllAddressBookEntries() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            let completeAddressBook = [];
            try {
                const response = yield (0,_agentx_backend_proxy_service__WEBPACK_IMPORTED_MODULE_3__.absService)().fetchAddressBooksCMS({
                    orgId: ((_a = _index__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "",
                    addressBookId: ((_b = _index__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _b === void 0 ? void 0 : _b.addressBookId) || "",
                    page: 0,
                    pageSize: 50
                });
                completeAddressBook = completeAddressBook.concat(response.speedDials);
                const totalPages = response.totalPages;
                const promises = [];
                for (let page = 1; page < totalPages; page++) {
                    promises.push((0,_agentx_backend_proxy_service__WEBPACK_IMPORTED_MODULE_3__.absService)().fetchAddressBooksCMS({
                        orgId: ((_c = _index__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _c === void 0 ? void 0 : _c.orgId) || "",
                        addressBookId: ((_d = _index__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _d === void 0 ? void 0 : _d.addressBookId) || "",
                        page,
                        pageSize: 50
                    }));
                }
                const responses = yield Promise.all(promises);
                responses.forEach((res) => {
                    completeAddressBook = completeAddressBook.concat(res.speedDials);
                });
            }
            catch (error) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("Error fetching all address book entries: ", error);
                throw error;
            }
            return { speedDials: completeAddressBook };
        });
    }
    return {
        mockOutdialAniList: () => __awaiter(this, void 0, void 0, function* () {
            return fetchMockOutidalANIList();
        }),
        fetchAddressBooks: () => __awaiter(this, void 0, void 0, function* () {
            return fetchAllAddressBookEntries();
        })
    };
}
function exposedBackendContactAPIs() {
    function fetchVteamsEntries(payload) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            let response;
            try {
                response = yield (0,_agentx_backend_proxy_service__WEBPACK_IMPORTED_MODULE_3__.absService)().fetchVteams({
                    payload,
                    orgId: (_a = _index__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId,
                    userId: (_b = _index__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _b === void 0 ? void 0 : _b.agentId
                });
            }
            catch (error) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("Error fetching vTeams entries: ", error);
                throw error;
            }
            return {
                data: {
                    agentSessionId: payload === null || payload === void 0 ? void 0 : payload.agentSessionId,
                    callData: "",
                    data: {
                        allowConsultToQueue: ((_c = _index__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _c === void 0 ? void 0 : _c.allowConsultToQueue) || "",
                        vteamList: response
                    },
                    jsMethod: "vteamListChanged"
                },
                orgId: (_d = _index__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _d === void 0 ? void 0 : _d.orgId,
                trackingId: payload === null || payload === void 0 ? void 0 : payload.trackingId,
                type: "VteamList"
            };
        });
    }
    return {
        vteamList: (p) => __awaiter(this, void 0, void 0, function* () {
            return fetchVteamsEntries(p.data);
        })
    };
}
// common method to fetch paginated aux codes which is used by agentx-js-api
const fetchPaginatedAuxCodesHandler = (auxcodePayload) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const params = Object.assign(Object.assign({}, auxcodePayload), { orgId: ((_a = _index__WEBPACK_IMPORTED_MODULE_1__.SERVICE.conf.profile) === null || _a === void 0 ? void 0 : _a.orgId) || "" });
        let response;
        if (params.workType === _aqm_constants__WEBPACK_IMPORTED_MODULE_2__.IDLE_CODE) {
            response = yield _index__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchPaginatedIdleCodes(params);
        }
        else {
            response = yield _index__WEBPACK_IMPORTED_MODULE_1__.SERVICE.abs.fetchPaginatedWrapUpCodes(params);
        }
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("event=fetchPaginatedAuxCodesSuccess for workType:", params.workType);
        return response ? response : {};
    }
    catch (error) {
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("event=fetchPaginatedAuxCodesError : Error fetching auxCode", error);
        throw error;
    }
});


/***/ }),

/***/ "./src/services/agentx-backend-proxy/agentx-backend-proxy-service.ts":
/*!***************************************************************************!*\
  !*** ./src/services/agentx-backend-proxy/agentx-backend-proxy-service.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   absService: () => (/* binding */ absService)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _agentx_backend_for_jssdk__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./agentx-backend-for-jssdk */ "./src/services/agentx-backend-proxy/agentx-backend-for-jssdk.ts");






const HTTP_HEADERS_WITH_RETRY = Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "allow-retry": "true" });
function absService() {
    const http = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_2__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_1__.CONF.AGENTX_BACKEND_PROXY_SERVICE_HOST);
    const FETCH_IDLECODES_FAILED = "Service.abs.fetchIdleCodesFailed";
    const CMS_BASE_URL = "/cms";
    return {
        fetchAddressBooksCMS: http.req((p) => ({
            url: `${CMS_BASE_URL}/address-book/${p.addressBookId}?page=${p.page}&pageSize=${p.pageSize || 50}&search=${p.search || ""}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchAddressBooksCMS",
            res: {}
        })),
        fetchCmsInitConfig: http.req((p) => ({
            url: `${CMS_BASE_URL}/agent-config/${p.userId}${p.isSupervisor ? "?supervisor=true" : ""}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: /* istanbul ignore next */ (e) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                return new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details("Service.abs.fetchCmsInitConfig", {
                    status: (_b = (_a = e.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 0,
                    type: (_e = (_d = (_c = e.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errorDetails) !== null && _e !== void 0 ? _e : "",
                    trackingId: (_h = (_g = (_f = e.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.trackingId) !== null && _h !== void 0 ? _h : ""
                });
            },
            method: "GET",
            errId: "Service.abs.fetchCmsInitConfig",
            res: {}
        })),
        fetchIdleCodes: http.req((p) => {
            let url = `${CMS_BASE_URL}/agent-config/idle-codes/${p.accessType}`;
            if (p.ids && Array.isArray(p.ids) && p.ids.length > 0) {
                const ids = p.ids.join(",");
                url += `?ids=${ids}`;
            }
            return {
                url,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
                data: {},
                err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
                method: "GET",
                errId: FETCH_IDLECODES_FAILED,
                res: []
            };
        }),
        fetchPaginatedIdleCodes: http.req((p) => {
            let url = `${CMS_BASE_URL}/agent-config/v2/idle-codes`;
            const searchFields = "name";
            if ((p === null || p === void 0 ? void 0 : p.search) !== undefined && (p === null || p === void 0 ? void 0 : p.search) !== "") {
                url += `?search=${p.search}&ids=${searchFields}`;
            }
            if ((p === null || p === void 0 ? void 0 : p.page) !== undefined && (p === null || p === void 0 ? void 0 : p.page) >= 0) {
                const append = url.includes("?") ? "&" : "?";
                url += `${append}page=${p.page}&pageSize=${p.pageSize}`;
            }
            if ((p === null || p === void 0 ? void 0 : p.customFilter) !== undefined && (p === null || p === void 0 ? void 0 : p.customFilter) !== "") {
                const append = url.includes("?") ? "&" : "?";
                url += `${append}customFilter=${p.customFilter}`;
            }
            if ((p === null || p === void 0 ? void 0 : p.supervisedUserId) !== undefined && (p === null || p === void 0 ? void 0 : p.supervisedUserId) !== "") {
                const append = url.includes("?") ? "&" : "?";
                url += `${append}supervisedUserId=${p.supervisedUserId}`;
            }
            if ((p === null || p === void 0 ? void 0 : p.desktopProfileFilter) !== undefined) {
                const append = url.includes("?") ? "&" : "?";
                url += `${append}desktopProfileFilter=${p.desktopProfileFilter}`;
            }
            return {
                url,
                headers: Object.assign(Object.assign({}, HTTP_HEADERS_WITH_RETRY), { "X-ORGANIZATION-ID": p.orgId }),
                data: {},
                err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
                method: "GET",
                errId: FETCH_IDLECODES_FAILED,
                res: {}
            };
        }),
        fetchAgentsByOrgId: http.req((p) => {
            const url = `${CMS_BASE_URL}/agent-config/agents?pageNumber=${p.page}&pageSize=${p.pageSize}&sortOrder=${p.sortOrder}&search==field=="firstName";value=="${p.searchValue}"`;
            return {
                url,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
                data: {},
                err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
                method: "GET",
                errId: "Service.abs.fetchAgentsFailed",
                res: {}
            };
        }),
        fetchDefaultAuxCodes: http.req((p) => {
            const url = `${CMS_BASE_URL}/agent-config/default-aux-codes`;
            return {
                url,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
                data: {},
                err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
                method: "GET",
                errId: FETCH_IDLECODES_FAILED,
                res: {}
            };
        }),
        fetchWrapUpCodes: http.req((p) => {
            let url = `${CMS_BASE_URL}/agent-config/wrapup-codes/${p.accessType}`;
            if (p.ids && Array.isArray(p.ids) && p.ids.length > 0) {
                const ids = p.ids.join(",");
                url += `?ids=${ids}`;
            }
            return {
                url,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
                data: {},
                err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
                method: "GET",
                errId: "Service.abs.fetchWrapUpCodesFailed",
                res: {}
            };
        }),
        fetchPaginatedWrapUpCodes: http.req((p) => {
            let url = `${CMS_BASE_URL}/agent-config/v2/wrapup-codes`;
            if ((p === null || p === void 0 ? void 0 : p.search) !== undefined && (p === null || p === void 0 ? void 0 : p.search) !== "") {
                url += `?search=${p.search}`;
            }
            if ((p === null || p === void 0 ? void 0 : p.page) !== undefined && (p === null || p === void 0 ? void 0 : p.page) >= 0) {
                const append = url.includes("?") ? "&" : "?";
                url += `${append}page=${p.page}&pageSize=${p.pageSize}`;
            }
            if ((p === null || p === void 0 ? void 0 : p.customFilter) !== undefined && (p === null || p === void 0 ? void 0 : p.customFilter) !== "") {
                const append = url.includes("?") ? "&" : "?";
                url += `${append}customFilter=${p.customFilter}`;
            }
            return {
                url,
                headers: Object.assign(Object.assign({}, HTTP_HEADERS_WITH_RETRY), { "X-ORGANIZATION-ID": p.orgId }),
                data: {},
                err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
                method: "GET",
                errId: "Service.abs.fetchWrapUpCodesFailed",
                res: {}
            };
        }),
        fetchManagedTeams: http.req((p) => ({
            url: `${CMS_BASE_URL}/managed-teams/${p.userId}`,
            headers: Object.assign(Object.assign({}, HTTP_HEADERS_WITH_RETRY), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            method: "GET",
            errId: "Service.abs.fetchManagedTeamsFailed",
            res: {}
        })),
        fetchManagedQueues: http.req((p) => ({
            url: `${CMS_BASE_URL}/managed-queues/${p.userId}`,
            headers: Object.assign(Object.assign({}, HTTP_HEADERS_WITH_RETRY), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            method: "GET",
            errId: "Service.abs.fetchManagedQueuesFailed",
            res: {}
        })),
        fetchVteams: http.req((p) => ({
            url: `${CMS_BASE_URL}/vteams/${p.userId}?type=${p.payload.type}&channelType=${p.payload.channelType}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: p.payload,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            method: "GET",
            errId: "Service.abs.FetchVTeamListFailed",
            res: {}
        })),
        fetchOutdialANICMS: http.req((p) => ({
            url: `${CMS_BASE_URL}/outdial-ani/${p.outdialANIId}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            method: "GET",
            errId: "Service.abs.fetchOutdialANICMS",
            res: {}
        })),
        fetchPaginatedOutdialANI: http.req((p) => {
            let url = `${CMS_BASE_URL}/outdial-ani/${p.outdialANIId}/?page=${p.page}&pageSize=${p.pageSize}`;
            if ((p === null || p === void 0 ? void 0 : p.search) !== undefined && (p === null || p === void 0 ? void 0 : p.search) !== "") {
                url += `&search=${p.search}`;
            }
            return {
                url,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
                data: {},
                err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
                method: "GET",
                errId: "Service.abs.fetchOutdialANICMS",
                res: {}
            };
        }),
        fetchTeams: http.req((p) => ({
            url: `${CMS_BASE_URL}/team/${p.id}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            method: "GET",
            errId: "Service.abs.fetchTeamsFailed",
            res: {}
        })),
        secureCADVariables: http.req((data) => ({
            url: `/secure`,
            headers: Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS),
            data,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            method: "POST",
            errId: "Service.secure.secureCADVariablesFailed",
            res: {}
        })),
        fetchEpDnMappings: http.req((p) => ({
            url: `${CMS_BASE_URL}/ep-dn-mapping`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            method: "GET",
            errId: "Service.abs.epDnMappingsFailed",
            res: {}
        })),
        fetchEpList: http.req((p) => ({
            url: `${CMS_BASE_URL}/entry-point?pageNumber=${p.payload.pageNumber}&pageSize=${p.payload.pageSize}&channelType=${p.payload.channelType}&search=${p.payload.search || ""}`,
            headers: Object.assign(Object.assign({}, HTTP_HEADERS_WITH_RETRY), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            method: "GET",
            errId: "Service.abs.fetchEpListFailed",
            res: {}
        })),
        fetchPaginatedEpDnMappingList: http.req((p) => ({
            url: `${CMS_BASE_URL}/dial-number?pageNumber=${p.payload.pageNumber}&pageSize=${p.payload.pageSize}&channelType=${p.payload.channelType}&search=${encodeURIComponent(p.payload.search || "")}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            method: "GET",
            errId: "Service.abs.fetchPaginatedEpDnMappingListFailed",
            res: {}
        })),
        fetchPaginatedTeamsList: http.req((p) => {
            const baseurl = `${CMS_BASE_URL}/v2/teams`;
            const queryParams = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (p.page !== undefined && p.page >= 0 && { page: String(p.page) })), (p.pageSize !== undefined && p.pageSize >= 0 && { pageSize: String(p.pageSize) })), (p.search && { search: p.search })), (p.supervisorView && { supervisorView: String(p.supervisorView) })), (p.customFilter && { customFilter: p.customFilter }));
            const queryParamsString = new URLSearchParams(queryParams).toString();
            const url = `${baseurl}?${queryParamsString}`;
            return {
                url,
                headers: Object.assign(Object.assign({}, HTTP_HEADERS_WITH_RETRY), { "X-ORGANIZATION-ID": p.orgId }),
                data: {},
                err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
                method: "GET",
                errId: "Service.abs.fetchTeamsListFailed",
                res: {}
            };
        }),
        fetchQueueList: http.req((p) => ({
            url: `${CMS_BASE_URL}/queues?pageNumber=${p.payload.pageNumber}&pageSize=${p.payload.pageSize}&channelType=${p.payload.channelType}&search=${p.payload.search || ""}&desktopProfileFilter=${p.payload.desktopProfileFilter}`,
            headers: Object.assign(Object.assign({}, HTTP_HEADERS_WITH_RETRY), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            method: "GET",
            errId: "Service.abs.fetchQueuesFailed",
            res: {}
        })),
        fetchAgentIdleCodes: http.req((p) => ({
            url: `${CMS_BASE_URL}/user-idle-code/${p.agentId}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            method: "GET",
            errId: FETCH_IDLECODES_FAILED,
            res: {}
        })),
        fetchQueueDetails: http.req((p) => ({
            url: `${CMS_BASE_URL}/queues-detail/?ids=${p.queueIds}`,
            headers: Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            method: "GET",
            errId: "Service.abs.fetchQueuesFailed",
            res: {}
        })),
        fetchPaginatedAuxCodes: _agentx_backend_for_jssdk__WEBPACK_IMPORTED_MODULE_5__.fetchPaginatedAuxCodesHandler
    };
}


/***/ }),

/***/ "./src/services/api-ai-assistant-service/api-ai-assistant-service.ts":
/*!***************************************************************************!*\
  !*** ./src/services/api-ai-assistant-service/api-ai-assistant-service.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ApiAiAssistantService: () => (/* binding */ ApiAiAssistantService)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");



class ApiAiAssistantService {
    constructor() {
        this.http = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_AI_ASSISTANT_SERVICE_URL);
        this.httpMethods = {
            POST: "POST",
            GET: "GET"
        };
        this.sendEvent = this.http.req((p) => ({
            url: `/event`,
            headers: this.getRequestHeaders(),
            method: this.httpMethods.POST,
            data: p,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_2__.createErrDetailsObject,
            errId: "Service.apiAiAssistant.sendEventFailed",
            res: {}
        }));
    }
    getRequestHeaders() {
        return {
            "Content-Type": "application/json"
        };
    }
}


/***/ }),

/***/ "./src/services/aqm/ai-assistant-service.ts":
/*!**************************************************!*\
  !*** ./src/services/aqm/ai-assistant-service.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   aqmAiAssistant: () => (/* binding */ aqmAiAssistant)
/* harmony export */ });
function aqmAiAssistant(aqm) {
    return {
        eRealtimeTranscriptionAvailable: aqm.evt({
            bind: {
                type: "REAL_TIME_TRANSCRIPTION",
                data: { notifType: "REAL_TIME_TRANSCRIPTION" }
            },
            msg: {}
        })
    };
}


/***/ }),

/***/ "./src/services/aqm/aqm-service-configs.ts":
/*!*************************************************!*\
  !*** ./src/services/aqm/aqm-service-configs.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   aqmConfigs: () => (/* binding */ aqmConfigs)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");


/*
 * aqmConfigs
 * @param reqs
 * @category AQM Service
 */
function aqmConfigs(aqm) {
    const applicationErrorID = "Service.aqm.configs.application";
    return {
        application: aqm.reqEmpty(() => ({
            url: "/application",
            notifSuccess: {
                bind: {
                    type: "AgentPropertyChanged",
                    data: { jsMethod: "agentPropertyChanged" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "AgentConfigFailed"
                },
                errId: applicationErrorID
            },
            err: /* istanbul ignore next */ (e) => {
                var _a, _b, _c, _d, _e, _f, _g;
                _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("Error in making /application request:", e);
                return new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details(applicationErrorID, {
                    status: (_b = (_a = e.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 0,
                    type: (_d = (_c = e.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errorType,
                    trackingId: (_g = (_f = (_e = e.response) === null || _e === void 0 ? void 0 : _e.headers) === null || _f === void 0 ? void 0 : _f.trackingid) === null || _g === void 0 ? void 0 : _g.split("_")[1]
                });
            }
        })),
        eUpdateAgentProfile: aqm.evt({
            bind: {
                type: "UpdateAgentProfile",
                data: { jsMethod: "updateAgentProfile" }
            },
            msg: {}
        })
    };
}
// JS DOC Comments - Type Definitions
/**
 * @typedef {Object} Service_Aqm_Configs_Entity
 * @summary Service.Aqm.Configs.Entity
 * @property {Boolean} isSystem Determines whether the entity is generated by the system  or configured by the administrator.
 * @property {String} name Name of the entity.
 * @property {String} id Unique identifier for the entity.
 * @property {Boolean} isDefault Determines whether the entity (idle code) is default or not.
 * The default entity (idle code) will be used as the global state of the agent on initial login.
 */
/**
 * @typedef {Object} Service_Aqm_Configs_WrapupData
 * @summary Service.Aqm.Configs.WrapupData
 * @property {Object} wrapUpProps Wrap up properties.
 * @property {Boolean|Undefined} wrapUpProps.autoWrapup=false Determines whether auto wrap up is enabled or not.
 * @property {Number|Undefined} wrapUpProps.autoWrapupInterval=0 Auto wrap up interval.
 * @property {Array<Service_Aqm_Configs_WrapUpReason>} wrapUpProps.wrapUpReasonList=[]] Wrap up reason list.
 * @property {String} wrapUpProps.interactionId="" Unique identifier of the user interaction.
 * @property {Boolean|Undefined} wrapUpProps.allowCancelAutoWrapup=false Determines whether auto wrap up cancellation is allowed or not.
 */
/**
 * @typedef {Object} Service_Aqm_Configs_WrapUpReason
 * @summary Service.Aqm.Configs.WrapUpReason
 * @property {Boolean} isSystem Determines whether the wrap up reason is generated by the system  or configured by the administrator.
 * @property {String} name Name of the wrap up reason.
 * @property {String} id Unique Identifier for the wrap up reason.
 * @property {Boolean} isDefault Determines whether the wrap up reason is default or not.
 * The default wrap up reason is used in the case of the auto wrap up.
 */


/***/ }),

/***/ "./src/services/aqm/aqm-service-connection.ts":
/*!****************************************************!*\
  !*** ./src/services/aqm/aqm-service-connection.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ConnectionService: () => (/* binding */ ConnectionService)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! set-interval-async/dynamic */ "set-interval-async/dynamic");
/* harmony import */ var set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../.. */ "./src/index.ts");
/* harmony import */ var _feature_flag_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../feature-flag-names */ "./src/feature-flag-names.ts");
/* harmony import */ var _services_service_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../services/service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./constants */ "./src/services/aqm/constants.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







/**
 * aqmContact
 * @param reqs
 * @category AQM Service
 */
function ConnectionService(notifs) {
    let connectionProp = { lostConnectionRecoveryTimeout: _constants__WEBPACK_IMPORTED_MODULE_5__.LOST_CONNECTION_RECOVERY_TIMEOUT };
    const wsDisconnectAllowed = ___WEBPACK_IMPORTED_MODULE_2__.SERVICE.featureflag.isFeatureFlagEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_3__.FEATURE_FLAGS.USE_EXTENDED_DISCONNECTION_TIME)
        ? _constants__WEBPACK_IMPORTED_MODULE_5__.WS_DISCONNECT_ALLOWED_EXTENDED
        : _constants__WEBPACK_IMPORTED_MODULE_5__.WS_DISCONNECT_ALLOWED;
    let reconnectingTimer;
    let restoreTimer;
    let isConnectionLost;
    let isRestoreFailed;
    let isSocketReconnected;
    const { send, signal } = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.withData();
    const OnConnectionLost = signal;
    const OnConnectionLostSend = send;
    let isKeepAlive;
    let reconnectInterval;
    const randomizedConnectivityCheckIntervals = _constants__WEBPACK_IMPORTED_MODULE_5__.CONNECTIVITY_CHECK_INTERVALS_LIST.map((v) => Math.floor(v * (1 + 0.5 * Math.random())));
    let randomizedIntervalsCounter = 0;
    const dispatchEvent = (_socketReconnected = false) => {
        OnConnectionLostSend({
            isConnectionLost,
            isRestoreFailed,
            isSocketReconnected: !notifs.isSocketClosed() && (_socketReconnected !== null && _socketReconnected !== void 0 ? _socketReconnected : isSocketReconnected),
            isKeepAlive
        });
    };
    const handleConnectionLost = function () {
        isConnectionLost = true;
        dispatchEvent();
    };
    const clearTimerOnRestoreFailed = () => __awaiter(this, void 0, void 0, function* () {
        if (reconnectInterval) {
            (0,set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_1__.clearIntervalAsync)(reconnectInterval);
        }
    });
    const handleRestoreFailed = function () {
        return __awaiter(this, void 0, void 0, function* () {
            isRestoreFailed = true;
            notifs.setShouldReconnect(false);
            dispatchEvent();
            clearTimerOnRestoreFailed();
        });
    };
    const updateConnectionData = () => {
        isRestoreFailed = false;
        isConnectionLost = false;
        isSocketReconnected = false;
    };
    const setConnectionProp = function (prop) {
        connectionProp = prop;
    };
    function clearTimeoutWithFeatureFlag(timer) {
        if (___WEBPACK_IMPORTED_MODULE_2__.SERVICE.featureflag.isFeatureFlagEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_3__.FEATURE_FLAGS.USE_WORKER_TIMER_FOR_CONNECTION_CHECKS)) {
            _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.clearTimeout(timer);
        }
        else {
            clearTimeout(timer);
        }
    }
    function setTimeoutWithFeatureFlag(callback, ms) {
        if (___WEBPACK_IMPORTED_MODULE_2__.SERVICE.featureflag.isFeatureFlagEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_3__.FEATURE_FLAGS.USE_WORKER_TIMER_FOR_CONNECTION_CHECKS)) {
            return _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.setTimeout(callback, ms);
        }
        else {
            return setTimeout(callback, ms);
        }
    }
    const onPing = function (msg) {
        const event = JSON.parse(msg);
        if (reconnectingTimer) {
            clearTimeoutWithFeatureFlag(reconnectingTimer);
        }
        if (restoreTimer) {
            clearTimeoutWithFeatureFlag(restoreTimer);
        }
        isKeepAlive = event["keepalive"] === "true";
        if (((isConnectionLost && !isRestoreFailed) || isKeepAlive) && !isSocketReconnected) {
            updateConnectionData();
            dispatchEvent();
        }
        else if (isSocketReconnected && isKeepAlive) {
            updateConnectionData();
            dispatchEvent(true);
        }
        /** if there is no message coming from web socket for 8 seconds, then show the connection lost message*/
        reconnectingTimer = setTimeoutWithFeatureFlag(handleConnectionLost, wsDisconnectAllowed);
        restoreTimer = setTimeoutWithFeatureFlag(handleRestoreFailed, connectionProp && connectionProp.lostConnectionRecoveryTimeout);
    };
    const handleSocketClose = function () {
        return __awaiter(this, void 0, void 0, function* () {
            ___WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug("Network/WebSocket/HandleClose", "Trying to reconnect to notifs socket");
            const onlineStatus = yield (0,_services_service_utils__WEBPACK_IMPORTED_MODULE_4__.checkOnlineStatus)();
            if (onlineStatus) {
                notifs.init();
                clearTimerOnRestoreFailed();
                isSocketReconnected = true;
            }
            else {
                ___WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error("Network/WebSocket/NoNetwork", "Browser network not available");
            }
        });
    };
    function reconnectWithExponentialDelay() {
        const nextDelay = randomizedIntervalsCounter >= randomizedConnectivityCheckIntervals.length
            ? randomizedConnectivityCheckIntervals[randomizedConnectivityCheckIntervals.length - 1]
            : randomizedConnectivityCheckIntervals[randomizedIntervalsCounter];
        if (randomizedIntervalsCounter >= randomizedConnectivityCheckIntervals.length) {
            ___WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error(`Network/WebSocket//Reconnection/unexpectedIntervalCounterValue`, "", {
                randomizedIntervalsCounter
            });
        }
        ___WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace("Network/WebSocket/StartDelayedReconnect", `Connection service will try to reconnect in ${nextDelay}`, { delay: nextDelay });
        reconnectInterval = (0,set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_1__.setIntervalAsync)(() => __awaiter(this, void 0, void 0, function* () {
            yield handleSocketClose();
            randomizedIntervalsCounter++;
            (0,set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_1__.clearIntervalAsync)(reconnectInterval);
            if (!isSocketReconnected) {
                reconnectWithExponentialDelay();
            }
            else {
                randomizedIntervalsCounter = 0;
            }
        }), nextDelay);
    }
    const onSocketClose = function () {
        ___WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug("Network/WebSocket/OnSocketClose", "Socket connection is closed");
        clearTimerOnRestoreFailed();
        randomizedIntervalsCounter = 0;
        if (___WEBPACK_IMPORTED_MODULE_2__.SERVICE.featureflag.isFeatureFlagEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_3__.FEATURE_FLAGS.EXPONENTIAL_RECONNECTION)) {
            reconnectWithExponentialDelay();
        }
        else {
            reconnectInterval = (0,set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_1__.setIntervalAsync)(() => __awaiter(this, void 0, void 0, function* () {
                yield handleSocketClose();
            }), _constants__WEBPACK_IMPORTED_MODULE_5__.CONNECTIVITY_CHECK_INTERVAL);
        }
    };
    notifs.onMessage.listen(onPing);
    notifs.onSocketClose.listen(onSocketClose);
    return {
        setConnectionProp,
        OnConnectionLost,
        handleSocketClose
    };
}


/***/ }),

/***/ "./src/services/aqm/aqm-service-contact-types.ts":
/*!*******************************************************!*\
  !*** ./src/services/aqm/aqm-service-contact-types.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);

// JS DOC Comments - Type Definitions
/**
 * @typedef  {Object} Service_Aqm_Contact_AgentContact_Data
 * @summary Service.Aqm.Contact.AgentContact.data
 * @property {String} mediaResourceId Unique identifier of the digital media.
 * @property {String} agentId Unique identifier of the agent.
 * @property {String} destAgentId Unique identifier of the destination/secondary agent.
 * @property {String} trackingId Unique identifier for tracking the API request.
 * @property {String} consultMediaResourceId Unique identifier for the digital media.
 * @property {Service_Aqm_Contact_Interaction} interaction Details for the user interaction.
 * @property {String} interactionId Unique identifier of the user interaction.
 * @property {String} orgId Unique identifier of the organization.
 * @property {String} owner Unique identifier for the agent who owns the task.
 * @property {String} queueMgr Queue Manager.
 * @property {Number} ronaTimeout RONA Timeout.
 * @property {String} type EventName which describes the unique notifs response that are used to the attach listener for web socket response.
 * @property {Boolean} isConsulted Determines whether the agent is consulted or not.
 * @property {Boolean} isConferencing Determines whether the agent is in a conference call or not.
 * @property {String} updatedBy Unique identifier of the agent who updated CAD variables of the task.
 * @property {String} destinationType The type of the request to be placed. The destination type can be Agent, Queue, or DN.
 * @property {Boolean} autoResumed Determines whether the recording resumed automatically or not.
 * @property {String} reasonCode Reason code for the error.
 * @property {String} reason Reason for the error.
 */
/**
 * @typedef {Object} Service_Aqm_Contact_Interaction
 * @summary Service.Aqm.Contact.Interaction
 * @property {MEDIA_CHANNEL} mediaType Determines the type of media. The possible values are email, chat, telephony, social, sms, whatsapp , appleMessages or facebook.
 * @property {String} state Determines the current contact state.
 * @property {Any} participants Provides list of participants with details for each participant.
 * @property {String} interactionId Unique identifier of the user interaction.
 * @property {String} orgId Unique identifier of the organization.
 * @property {Object} callProcessingDetails Call processing details.
 * @property {String} callProcessingDetails.ani
 * @property {String} callProcessingDetails.displayAni
 * In case of inbound for telephony it (Automatic Number Identification) determines number of the customer while for chat and email it determines the email of the customer.
 * @property {String} callProcessingDetails.dnis In case of outbound it (Dialed Number Identification) determines the number of the customer care.
 * @property {String} callProcessingDetails.tenantId Database unique identifier of the organization.
 * @property {String} callProcessingDetails.QueueId Unique identifier of the routing queue.
 * @property {String} callProcessingDetails.vteamId Unique identifier of the virtual team.
 * @property {String} callProcessingDetails.pauseResumeEnabled
 * Determines if you want the agent to have access to the Privacy Shield icon during call recording so that the agent can pause and resume recording.
 * @property {String} callProcessingDetails.pauseDuration
 * Provides the number of seconds that recording will be paused if the user does not click the Turn Off Privacy Shield button.
 * @property {String} callProcessingDetails.isPaused Determines whether call is paused or not.
 * @property {String} callProcessingDetails.recordInProgress Determines whether recording is in progress or not.
 * @property {String} callProcessingDetails.ctqInProgress Determines where consult to queue call is in progress or not.
 * @property {String} callProcessingDetails.outdialTransferToQueueEnabled Determines whether outdial transfer to queue is in enabled or not.
 * @property {String} callProcessingDetails.convIvrTranscript Determines whether IVR transcript is available for current user interaction or not.
 * @property {String} callProcessingDetails.customerName Name of the customer.
 * @property {String} callProcessingDetails.virtualTeamName Name of the virtual team.
 * @property {String} callProcessingDetails.ronaTimeout RONA timeout.
 * @property {String} callProcessingDetails.category The value selected by the customer while initiating a chat.
 * @property {String} callProcessingDetails.reason The reason for the customer contact.
 * @property {String} callProcessingDetails.sourceNumber Source number.
 * @property {String} callProcessingDetails.sourcePage Source page.
 * @property {String} callProcessingDetails.appUser Name of the customer for the social channel.
 * @property {String} callProcessingDetails.customerNumber Number of the customer.
 * @property {String} callProcessingDetails.reasonCode The reason code for the customer contact.
 * @property {String} callProcessingDetails.IvrPath IVR path.
 * @property {String} callProcessingDetails.fromAddress Email ID of the customer (inbound email).
 * @property {String} callProcessingDetails.parentInteractionId Parent interactionId for EP-DN secondary interacion.
 * @property {String} callProcessingDetails.childInteractionId Child InteracionId of secondary interaction.
 * @property {String} callProcessingDetails.relationshipType parent relationship type ex: consult.
 * @property {String} callProcessingDetails.parent_ANI Parent ani for secondary agent for EP-DN Consult.
 * @property {String} callProcessingDetails.parent_DNIS parent dnis for secondary agent for EP-DN Consult.
 * @property {Record<String>} media
 * @property {String} media.mediaResourceId Unique identifier of the digital media.
 * @property {MEDIA_CHANNEL} media.mediaType Determines the type of media. The possible values are email, chat, telephony, social, sms, whatsapp or facebook.
 * @property {String} media.mediaMgr Media manager.
 * @property {Array<String>} media.participants List of the participants in the digital media.
 * @property {String} media.mType Identifies whether the media is coming from mail call or consult call.
 * @property {Boolean} media.isHold Determines whether the call is on hold or not.
 * @property {Number|null} media.holdTimestamp The timestamp when the call is put on hold.
 * @property {String} owner Unique identifier for the agent who owns the interaction.
 * @property {MEDIA_CHANNEL} mediaChannel Determines the type of media. The possible values are email, chat, telephony, social, sms, whatsapp, appleMessages or facebook.
 * @property {Object} contactDirection Direction of call from a dialer to recipient.
 * @property {String} contactDirection.type Type of the direction of call from a dialer to recipient. Possible values are OUTBOUND or INBOUND.
 * @property {String} outboundType  Tells if the outbound call is normal outdial call or preview campaign call or courtesy call back call.
 * @property {String} outdialAgentId Unique identifier of the agent who initiated the outdial call.
 * @property {Record<String>} callFlowParams Call flow parameters.
 * @property {String} callFlowParams.name Name of the call flow parameter.
 * @property {String} callFlowParams.description Description of the call flow parameter.
 * @property {String} callFlowParams.valueDataType Data type for the value of the call flow parameter.
 * @property {String} callFlowParams.value Value for the call flow parameter.
 * @property {Record.<string, Service_Aqm_Contact_callAssociatedData>} callAssociatedData Record of Call - Associated Data (CAD) variables.
 */
/**
 * @typedef {Object} Service_Aqm_Contact_callAssociatedData
 * @summary Service.Aqm.Contact.callAssociatedData
 * @description Call - Associated Data (CAD) variables.
 * @property {String} displayName Label for the CAD variable.
 * @property {String} name Key for the CAD variable.
 * @property {Boolean} agentEditable Determines whether the value of the CAD variable can be edited by the agent or not.
 * @property {Boolean} agentViewable Determines whether the CAD variable can be displayed to the agent or not.
 * @property {String} value Value of the CAD variable.
 * @property {String} type Determines the type of the value for the CAD variable. It can be boolean, string, integer, decimal, or date.
 */
/**
 * @typedef {String} MEDIA_CHANNEL
 * @summary Private: aqm.service.contact
 * @description Determines the type of media. The possible values are email, chat, telephony, social, sms, whatsapp, appleMessages or facebook.
 */


/***/ }),

/***/ "./src/services/aqm/aqm-service-contact.ts":
/*!*************************************************!*\
  !*** ./src/services/aqm/aqm-service-contact.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   aqmContact: () => (/* binding */ aqmContact)
/* harmony export */ });
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _aqm_service_contact_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./aqm-service-contact-types */ "./src/services/aqm/aqm-service-contact-types.ts");


/*
 * aqmContact
 * @param reqs
 * @category AQM Service
 */
// eslint-disable-next-line max-lines-per-function
function aqmContact(aqm, http) {
    return {
        /*
         * End contact
         */
        end: aqm.req((p) => ({
            url: `/contact/${p.interactionId}/end`,
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_0__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "AgentWrapup", interactionId: p.interactionId }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "AgentContactEndFailed" }
                },
                errId: "Service.aqm.contact.end"
            }
        })),
        /*
         * Cancel popover
         */
        cancelTask: aqm.req((p) => ({
            url: `/contact/${p.interactionId}/end`,
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_0__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "ContactEnded", interactionId: p.interactionId }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "AgentContactEndFailed" }
                },
                errId: "Service.aqm.contact.end"
            }
        })),
        /*
         * Wrapup contact
         */
        wrapup: aqm.req((p) => ({
            url: `/contact/${p.interactionId}/wrapup`,
            data: p.data,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_0__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "AgentWrappedUp", interactionId: p.interactionId }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "AgentWrapupFailed" }
                },
                errId: "Service.aqm.contact.wrapup"
            }
        })),
        /*
         * Decline contact
         */
        decline: aqm.req((p) => ({
            url: `/contact/${p.interactionId}/decline`,
            data: p.data,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_0__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: p.isConsult ? "AgentConsultFailed" : "AgentOfferContactRona", interactionId: p.interactionId }
                },
                msg: {}
            }
        })),
        /*
         * Get list of queues available.
         */
        vteamList: aqm.req((p) => ({
            url: `/vteams`,
            data: p.data,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_0__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "VteamList",
                    data: { jsMethod: "vteamListChanged" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "VteamListFailed",
                    data: { statusCode: 500 }
                },
                errId: "Service.aqm.contact.VteamListFailed"
            }
        })),
        /*
         * Get contact history by ani
         */
        fetchHistoryByANI: http.req((p) => ({
            url: `/contactHistoryByANI/${p.ani}?startTime=${p.startTime}&endTime=${p.endTime}`,
            errId: "Service.aqm.contact.fetchHistoryByANI",
            err: _service_utils__WEBPACK_IMPORTED_MODULE_0__.createErrDetailsObject,
            res: {}
        })),
        /*
         * Get contact history by agent
         */
        fetchHistoryByAgent: http.req((p) => ({
            url: `/contactHistoryByAgent?startTime=${p.startTime}&endTime=${p.endTime}`,
            errId: "Service.aqm.contact.fetchHistoryByAgent",
            err: _service_utils__WEBPACK_IMPORTED_MODULE_0__.createErrDetailsObject,
            res: {}
        })),
        /*
         * Get (inbound/outbound) transcripts for selected contact
         */
        fetchTranscript: http.req((p) => ({
            url: `/transcript/${p.transcriptId}`,
            errId: "Service.aqm.contact.fetchTranscript",
            err: _service_utils__WEBPACK_IMPORTED_MODULE_0__.createErrDetailsObject,
            res: ""
        })),
        // EVENTS
        // ------------------------
        eAgentContact: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentContact" }
            },
            msg: {}
        }),
        eAgentContactAssigned: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentContactAssigned" }
            },
            msg: {}
        }),
        eAgentContactAssignFailed: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentContactAssignFailed" }
            },
            msg: {}
        }),
        eAgentContactEnded: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactEnded" }
            },
            msg: {}
        }),
        eAgentContactWrappedUp: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentWrappedUp" }
            },
            msg: {}
        }),
        eAgentOfferContact: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentOfferContact" }
            },
            msg: {}
        }),
        eAgentOfferContactRona: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentOfferContactRona" }
            },
            msg: {}
        }),
        eAgentContactReserved: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentContactReserved" }
            },
            msg: {}
        }),
        eAgentInviteFailed: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentInviteFailed" }
            },
            msg: {}
        }),
        eAgentOfferConsult: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentOfferConsult" }
            },
            msg: {}
        }),
        eAgentWrapup: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentWrapup" }
            },
            msg: {}
        }),
        eAgentOfferCampaignReserved: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentOfferCampaignReservation" }
            },
            msg: {}
        }),
        eAgentCampaignContactUpdated: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "CampaignContactUpdated" }
            },
            msg: {}
        }),
        eAgentAddCampaignReserved: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentAddCampaignReservation" }
            },
            msg: {}
        }),
        eAgentContactHeld: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentContactHeld" }
            },
            msg: {}
        }),
        eResumeRecording: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactRecordingResumed" }
            },
            msg: {}
        }),
        ePauseRecording: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactRecordingPaused" }
            },
            msg: {}
        }),
        eConsultTransfer: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsultTransferred" }
            },
            msg: {}
        }),
        eAgentConsultTransferFailed: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsultTransferFailed" }
            },
            msg: {}
        }),
        eContactMerged: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactMerged" }
            },
            msg: {}
        }),
        eAgentblindTransferred: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentBlindTransferred" }
            },
            msg: {}
        }),
        eAgentvteamTransfer: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentVteamTransferred" }
            },
            msg: {}
        }),
        eCallRecordingStarted: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactRecordingStarted" }
            },
            msg: {}
        }),
        eAgentContactUnHeld: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentContactUnheld" }
            },
            msg: {}
        }),
        eAgentConsultCreated: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsultCreated" }
            },
            msg: {}
        }),
        eAgentConsultConferenced: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsultConferenced" }
            },
            msg: {}
        }),
        eAgentConsultEnded: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsultEnded" }
            },
            msg: {}
        }),
        eAgentCtqCancelled: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentCtqCancelled" }
            },
            msg: {}
        }),
        eAgentConsultConferenceEnded: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsultConferenceEnded" }
            },
            msg: {}
        }),
        eAgentConsulting: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsulting" }
            },
            msg: {}
        }),
        eAgentConsultFailed: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsultFailed" }
            },
            msg: {}
        }),
        eAgentConsultEndFailed: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsultEndFailed" }
            },
            msg: {}
        }),
        eAgentCtqFailed: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentCtqFailed" }
            },
            msg: {}
        }),
        eAgentCtqCancelFailed: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentCtqCancelFailed" }
            },
            msg: {}
        }),
        eAgentConsultConferenceEndFailed: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsultConferenceEndFailed" }
            },
            msg: {}
        }),
        eAgentContactCleanup: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactCleanup" }
            },
            msg: {}
        }),
        eContactCallbackFailed: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactCallbackFailed" }
            },
            msg: {}
        }),
        eContactOwnerChanged: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactOwnerChanged" }
            },
            msg: {}
        }),
        eParticipantJoinedConference: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "ParticipantJoinedConference" }
            },
            msg: {}
        }),
        eParticipantLeftConference: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "ParticipantLeftConference" }
            },
            msg: {}
        }),
        eAgentConferenceTransferred: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConferenceTransferred" }
            },
            msg: {}
        }),
        eParticipantPostCallActivity: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "ParticipantPostCallActivity" }
            },
            msg: {}
        }),
        eAgentConsultConferencing: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsultConferencing" }
            },
            msg: {}
        }),
        eAgentConsultTransferring: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsultTransferring" }
            },
            msg: {}
        }),
        eAgentMediaForkUpdate: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentMediaForkUpdate" }
            },
            msg: {}
        })
    };
}


/***/ }),

/***/ "./src/services/aqm/aqm-service-dialer-utils.ts":
/*!******************************************************!*\
  !*** ./src/services/aqm/aqm-service-dialer-utils.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   encryptSecureCAD: () => (/* binding */ encryptSecureCAD),
/* harmony export */   validateSharedCADVariable: () => (/* binding */ validateSharedCADVariable)
/* harmony export */ });
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../index */ "./src/index.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const checkVariableLength = (cad) => {
    for (const i of Object.keys(cad)) {
        if (cad[i].length > 256) {
            return false;
        }
    }
    return true;
};
const validateSharedCADVariable = (args) => {
    return new Promise((_resolve, _reject) => {
        const fieldLength = Object.keys(args).length;
        if (fieldLength > 30) {
            _reject("Keys cant be more then 30.");
        }
        else if (checkVariableLength(args)) {
            _resolve();
        }
        else {
            _reject("Maximum length for a CAD variable value is 256 characters.");
        }
    });
};
const encryptSecureCAD = (args) => __awaiter(void 0, void 0, void 0, function* () {
    const dataToEncrypt = {};
    Object.entries(args.data.attributes).forEach(([key, value]) => {
        if (args.secureCad.indexOf(key) !== -1) {
            dataToEncrypt[key] = value;
        }
    });
    if (Object.keys(dataToEncrypt).length > 0) {
        const secureData = {
            data: dataToEncrypt,
            action: "encrypt",
            keyId: args.keyId,
            keyVersion: args.keyVersion
        };
        try {
            const encryptedData = yield _index__WEBPACK_IMPORTED_MODULE_0__.SERVICE.abs.secureCADVariables(secureData);
            const decryp = encryptedData["data"];
            Object.keys(args.data.attributes).forEach((key) => {
                if (args.secureCad.indexOf(key) !== -1) {
                    args.data.attributes[key] = decryp[key];
                }
            });
            return Promise.resolve("success");
        }
        catch (_a) {
            return Promise.reject("encryption error");
        }
    }
    return Promise.resolve("success");
});


/***/ }),

/***/ "./src/services/aqm/aqm-service-dialer.ts":
/*!************************************************!*\
  !*** ./src/services/aqm/aqm-service-dialer.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   aqmDialer: () => (/* binding */ aqmDialer)
/* harmony export */ });
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../index */ "./src/index.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _aqm_service_dialer_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./aqm-service-dialer-utils */ "./src/services/aqm/aqm-service-dialer-utils.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



function aqmDialer(aqm) {
    const onUpdateCADVariables = aqm.req((p) => ({
        url: `/tasks/${p.interactionId}`,
        host: (0,_index__WEBPACK_IMPORTED_MODULE_0__.getRoutingHost)(),
        data: p.data,
        method: "patch",
        err: _service_utils__WEBPACK_IMPORTED_MODULE_1__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactUpdated", interactionId: p.interactionId }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactUpdateFailed" }
            },
            errId: "Service.aqm.dialer.ContactUpdateFailed"
        }
    }));
    return {
        startOutdial: aqm.req((p) => ({
            url: "/tasks",
            host: (0,_index__WEBPACK_IMPORTED_MODULE_0__.getRoutingHost)(),
            data: p.data,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_1__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "AgentOfferContact" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "AgentOutboundFailed" }
                },
                errId: "Service.aqm.dialer.startOutdial"
            }
        })),
        /**
         * CAD Variable Update
         */
        updateCadVariables: (args) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield (0,_aqm_service_dialer_utils__WEBPACK_IMPORTED_MODULE_2__.validateSharedCADVariable)(args.data.attributes);
                // encrypt only secure CAD Variables
                if (_index__WEBPACK_IMPORTED_MODULE_0__.SERVICE.featureflag.isSecureCADVariablesEnabled() && args.secureCad && args.secureCad.length > 0) {
                    try {
                        yield (0,_aqm_service_dialer_utils__WEBPACK_IMPORTED_MODULE_2__.encryptSecureCAD)(Object.assign({ secureCad: [] }, args));
                        return onUpdateCADVariables(args);
                    }
                    catch (e) {
                        return Promise.reject(e);
                    }
                }
                return onUpdateCADVariables(args);
            }
            catch (e) {
                return Promise.reject(e);
            }
        }),
        acceptPreviewContact: aqm.req((p) => ({
            url: `/dialer/campaign/${p.data.campaignId}/preview-task/${p.data.interactionId}/accept`,
            host: (0,_index__WEBPACK_IMPORTED_MODULE_0__.getRoutingHost)(),
            method: "post",
            err: _service_utils__WEBPACK_IMPORTED_MODULE_1__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "AgentContactAssigned" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "CampaignPreviewAcceptFailed" }
                },
                errId: "Service.aqm.dialer.acceptPreview"
            }
        })),
        skipPreviewContact: aqm.req((p) => ({
            url: `/dialer/campaign/${p.data.campaignId}/preview-task/${p.data.interactionId}/skip`,
            host: (0,_index__WEBPACK_IMPORTED_MODULE_0__.getRoutingHost)(),
            method: "post",
            err: _service_utils__WEBPACK_IMPORTED_MODULE_1__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "CampaignContactUpdated" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "CampaignPreviewSkipFailed" }
                },
                errId: "Service.aqm.dialer.skipPreview"
            }
        })),
        removePreviewContact: aqm.req((p) => ({
            url: `/dialer/campaign/${p.data.campaignId}/preview-task/${p.data.interactionId}/remove`,
            host: (0,_index__WEBPACK_IMPORTED_MODULE_0__.getRoutingHost)(),
            method: "post",
            err: _service_utils__WEBPACK_IMPORTED_MODULE_1__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "CampaignContactUpdated" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "CampaignPreviewRemoveFailed" }
                },
                errId: "Service.aqm.dialer.removePreview"
            }
        })),
        eOutdialFailed: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentOutboundFailed" }
            },
            msg: {}
        }),
        eContactUpdated: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactUpdated" }
            },
            msg: {}
        }),
        eCampaignPreviewAcceptFailed: aqm.evt({
            bind: {
                type: "CampaignPreviewAcceptFailed",
                data: { type: "CampaignPreviewAcceptFailed" }
            },
            msg: {}
        }),
        eCampaignPreviewSkipFailed: aqm.evt({
            bind: {
                type: "CampaignPreviewSkipFailed",
                data: { type: "CampaignPreviewSkipFailed" }
            },
            msg: {}
        }),
        eCampaignPreviewRemoveFailed: aqm.evt({
            bind: {
                type: "CampaignPreviewRemoveFailed",
                data: { type: "CampaignPreviewRemoveFailed" }
            },
            msg: {}
        })
    };
}


/***/ }),

/***/ "./src/services/aqm/aqm-service-screenpop.ts":
/*!***************************************************!*\
  !*** ./src/services/aqm/aqm-service-screenpop.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   aqmScreenPop: () => (/* binding */ aqmScreenPop)
/* harmony export */ });
/**
 *
 * @param aqm Screen pop event handler
 */
function aqmScreenPop(aqm) {
    return {
        eScreenPop: aqm.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "ScreenPop" }
            },
            msg: {}
        })
    };
}


/***/ }),

/***/ "./src/services/aqm/aqm-service.ts":
/*!*****************************************!*\
  !*** ./src/services/aqm/aqm-service.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AqmService: () => (/* binding */ AqmService)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_aqm_notifs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../core/aqm-notifs */ "./src/core/aqm-notifs.ts");
/* harmony import */ var _core_aqm_reqs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../core/aqm-reqs */ "./src/core/aqm-reqs.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _workers_workerUtil__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../workers/workerUtil */ "./src/workers/workerUtil.ts");
/* harmony import */ var _agentx_backend_proxy_agentx_backend_for_jssdk__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../agentx-backend-proxy/agentx-backend-for-jssdk */ "./src/services/agentx-backend-proxy/agentx-backend-for-jssdk.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");
/* harmony import */ var _ai_assistant_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./ai-assistant-service */ "./src/services/aqm/ai-assistant-service.ts");
/* harmony import */ var _aqm_service_configs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./aqm-service-configs */ "./src/services/aqm/aqm-service-configs.ts");
/* harmony import */ var _aqm_service_connection__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./aqm-service-connection */ "./src/services/aqm/aqm-service-connection.ts");
/* harmony import */ var _aqm_service_contact__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./aqm-service-contact */ "./src/services/aqm/aqm-service-contact.ts");
/* harmony import */ var _aqm_service_dialer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./aqm-service-dialer */ "./src/services/aqm/aqm-service-dialer.ts");
/* harmony import */ var _aqm_service_screenpop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./aqm-service-screenpop */ "./src/services/aqm/aqm-service-screenpop.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./constants */ "./src/services/aqm/constants.ts");
/* harmony import */ var _routing_agent_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./routing-agent-service */ "./src/services/aqm/routing-agent-service.ts");
/* harmony import */ var _routing_contact__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./routing-contact */ "./src/services/aqm/routing-contact.ts");
/* harmony import */ var _routing_supervisor_service__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./routing-supervisor-service */ "./src/services/aqm/routing-supervisor-service.ts");
/* harmony import */ var _schedule_callback_ScheduleCallback__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./schedule-callback/ScheduleCallback */ "./src/services/aqm/schedule-callback/ScheduleCallback.ts");



















function dispatchEventForRTD(isConnected) {
    window.dispatchEvent(new CustomEvent(_constant__WEBPACK_IMPORTED_MODULE_7__.RtdConstants.RTD_PING_EVENT, {
        detail: isConnected,
        bubbles: true,
        composed: true
    }));
}
/**
 * Aqm Service.
 * Initializes Notifs connection as well as provides interface to emit AQM requests.
 */
class AqmService {
    constructor(accessToken, organizationId, init, useWebsocketInWebworker, autoResolveAfterDelay) {
        this.connectionWorker = null;
        this.httpApi = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_4__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_1__.CONF.API_GATEWAY);
        this.useWebsocketInWebworker = useWebsocketInWebworker;
        this.notifs = new _core_aqm_notifs__WEBPACK_IMPORTED_MODULE_2__.AqmNotifs();
        this.aqm = new _core_aqm_reqs__WEBPACK_IMPORTED_MODULE_3__.AqmReqs(this.notifs);
        const http = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_4__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_1__.CONF.AQM_HOST);
        this.agent = Object.assign(Object.assign({}, (0,_routing_agent_service__WEBPACK_IMPORTED_MODULE_15__.routingAgent)(this.aqm)), (0,_agentx_backend_proxy_agentx_backend_for_jssdk__WEBPACK_IMPORTED_MODULE_6__.exposedBackendAPIs)());
        this.supervisor = Object.assign({}, (0,_routing_supervisor_service__WEBPACK_IMPORTED_MODULE_17__.routingSupervisor)(this.aqm));
        this.configs = (0,_aqm_service_configs__WEBPACK_IMPORTED_MODULE_9__.aqmConfigs)(this.aqm);
        this.contact = Object.assign(Object.assign(Object.assign({}, (0,_aqm_service_contact__WEBPACK_IMPORTED_MODULE_11__.aqmContact)(this.aqm, http)), (0,_routing_contact__WEBPACK_IMPORTED_MODULE_16__.createRoutingContactAPIS)(this.aqm, this.httpApi)), (0,_agentx_backend_proxy_agentx_backend_for_jssdk__WEBPACK_IMPORTED_MODULE_6__.exposedBackendContactAPIs)());
        this.dialer = (0,_aqm_service_dialer__WEBPACK_IMPORTED_MODULE_12__.aqmDialer)(this.aqm);
        this.connectionConfig = (0,_aqm_service_connection__WEBPACK_IMPORTED_MODULE_10__.ConnectionService)(this.notifs);
        this.screenpop = (0,_aqm_service_screenpop__WEBPACK_IMPORTED_MODULE_13__.aqmScreenPop)(this.aqm);
        this.aiAssistant = Object.assign({}, (0,_ai_assistant_service__WEBPACK_IMPORTED_MODULE_8__.aqmAiAssistant)(this.aqm));
        const { send, signal } = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.withData();
        this.OnConnectionLostSend = send;
        this.OnConnectionLost = signal;
        this.scheduleCallback = new _schedule_callback_ScheduleCallback__WEBPACK_IMPORTED_MODULE_18__["default"](this.httpApi);
        init(() => useWebsocketInWebworker
            ? this.createAqmWebworker(accessToken, organizationId, autoResolveAfterDelay)
            : this.notifs.init());
    }
    closeSocket(shouldReconnect, reason) {
        var _a;
        this.useWebsocketInWebworker
            ? (_a = this.connectionWorker) === null || _a === void 0 ? void 0 : _a.postMessage({
                type: _constants__WEBPACK_IMPORTED_MODULE_14__.ConnectionWorkerMessageType.REQUEST_CLOSE_SOCKET,
                reason,
                shouldReconnect
            })
            : this.notifs.close(shouldReconnect, reason);
    }
    createAqmWebworker(accessToken, organizationId, autoResolveAfterDelay) {
        return new Promise((resolve, rejects) => {
            this.connectionWorker = (0,_workers_workerUtil__WEBPACK_IMPORTED_MODULE_5__.createWorker)("aqm-service-connection.worker.js", (event) => {
                var _a;
                if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.type) === _constants__WEBPACK_IMPORTED_MODULE_14__.ConnectionWorkerMessageType.WEBSOCKET_OPENED) {
                    resolve();
                }
                this.workerMessageHandler(event);
            }, (errorEvent) => {
                rejects(new Error(errorEvent.message));
            });
            this.connectionWorker.postMessage({
                type: _constants__WEBPACK_IMPORTED_MODULE_14__.ConnectionWorkerMessageType.START,
                organizationId,
                host: _config__WEBPACK_IMPORTED_MODULE_1__.CONF.NOTIF_HOST,
                accessToken,
                autoResolveAfterDelay
            });
        });
    }
    workerMessageHandler(event) {
        var _a, _b, _c, _d;
        if (((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.type) === _constants__WEBPACK_IMPORTED_MODULE_14__.ConnectionWorkerMessageType.WEBSOCKET_OPENED) {
            dispatchEventForRTD(true);
            this.OnConnectionLostSend({
                isConnectionLost: false,
                isRestoreFailed: false,
                isSocketReconnected: true,
                isKeepAlive: false
            });
        }
        if (((_b = event === null || event === void 0 ? void 0 : event.data) === null || _b === void 0 ? void 0 : _b.type) === _constants__WEBPACK_IMPORTED_MODULE_14__.ConnectionWorkerMessageType.WEBSOCKET_CLOSED) {
            dispatchEventForRTD(false);
            this.OnConnectionLostSend({
                isConnectionLost: true,
                isRestoreFailed: false,
                isSocketReconnected: false,
                isKeepAlive: false
            });
        }
        if (((_c = event === null || event === void 0 ? void 0 : event.data) === null || _c === void 0 ? void 0 : _c.type) === _constants__WEBPACK_IMPORTED_MODULE_14__.ConnectionWorkerMessageType.WEBSOCKET_DEFINITIVELY_CLOSED) {
            dispatchEventForRTD(false);
            this.OnConnectionLostSend({
                isConnectionLost: true,
                isRestoreFailed: true,
                isSocketReconnected: false,
                isKeepAlive: false
            });
        }
        if (((_d = event === null || event === void 0 ? void 0 : event.data) === null || _d === void 0 ? void 0 : _d.type) === _constants__WEBPACK_IMPORTED_MODULE_14__.ConnectionWorkerMessageType.WEBSOCKET_MESSAGE_RECEIVED) {
            this.aqm.onMessageForWebsocketWorker(event.data.message);
        }
    }
}


/***/ }),

/***/ "./src/services/aqm/constants.ts":
/*!***************************************!*\
  !*** ./src/services/aqm/constants.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CLOSE_SOCKET_TIMEOUT_DURATION: () => (/* binding */ CLOSE_SOCKET_TIMEOUT_DURATION),
/* harmony export */   CONNECTIVITY_CHECK_INTERVAL: () => (/* binding */ CONNECTIVITY_CHECK_INTERVAL),
/* harmony export */   CONNECTIVITY_CHECK_INTERVALS_LIST: () => (/* binding */ CONNECTIVITY_CHECK_INTERVALS_LIST),
/* harmony export */   ConnectionWorkerMessageType: () => (/* binding */ ConnectionWorkerMessageType),
/* harmony export */   DN: () => (/* binding */ DN),
/* harmony export */   EP_DN: () => (/* binding */ EP_DN),
/* harmony export */   IDLE_CODE: () => (/* binding */ IDLE_CODE),
/* harmony export */   KEEPALIVE_INTERVAL: () => (/* binding */ KEEPALIVE_INTERVAL),
/* harmony export */   KeepaliveWorkerMessageType: () => (/* binding */ KeepaliveWorkerMessageType),
/* harmony export */   LOST_CONNECTION_RECOVERY_TIMEOUT: () => (/* binding */ LOST_CONNECTION_RECOVERY_TIMEOUT),
/* harmony export */   METHOD_NAME: () => (/* binding */ METHOD_NAME),
/* harmony export */   ON_CLOSE_ONLINE_CHECK_TIMEOUT: () => (/* binding */ ON_CLOSE_ONLINE_CHECK_TIMEOUT),
/* harmony export */   PING_API_URL: () => (/* binding */ PING_API_URL),
/* harmony export */   WEBSOCKET_REGISTRATION_API: () => (/* binding */ WEBSOCKET_REGISTRATION_API),
/* harmony export */   WELCOME_MESSAGE_TIMEOUT: () => (/* binding */ WELCOME_MESSAGE_TIMEOUT),
/* harmony export */   WS_DISCONNECT_ALLOWED: () => (/* binding */ WS_DISCONNECT_ALLOWED),
/* harmony export */   WS_DISCONNECT_ALLOWED_EXTENDED: () => (/* binding */ WS_DISCONNECT_ALLOWED_EXTENDED)
/* harmony export */ });
const WS_DISCONNECT_ALLOWED = 8000;
const WS_DISCONNECT_ALLOWED_EXTENDED = 17000; // 4 keepalive events + 1 second
const LOST_CONNECTION_RECOVERY_TIMEOUT = 120000;
const CONNECTIVITY_CHECK_INTERVAL = 1000;
const CONNECTIVITY_CHECK_INTERVALS_LIST = [1000, 2000, 5000, 15000, 30000, 60000];
const EP_DN = "EP-DN";
const DN = "DN";
const IDLE_CODE = "IDLE_CODE";
var KeepaliveWorkerMessageType;
(function (KeepaliveWorkerMessageType) {
    KeepaliveWorkerMessageType.NOTIFY_MESSAGE_FROM_WEBSOCKET = "notify_message_received";
    KeepaliveWorkerMessageType.TERMINATE = "terminate";
    KeepaliveWorkerMessageType.START = "start";
    KeepaliveWorkerMessageType.KEEPALIVE = "keepalive";
    KeepaliveWorkerMessageType.REQUEST_CLOSE_SOCKET = "close_socket";
})(KeepaliveWorkerMessageType || (KeepaliveWorkerMessageType = {}));
var ConnectionWorkerMessageType;
(function (ConnectionWorkerMessageType) {
    ConnectionWorkerMessageType.WEBSOCKET_MESSAGE_RECEIVED = "websocket_message_received";
    ConnectionWorkerMessageType.CONNECTION_STATE = "connection_state";
    ConnectionWorkerMessageType.WEBSOCKET_OPENED = "websocket_opened";
    ConnectionWorkerMessageType.WEBSOCKET_CLOSED = "websocket_closed";
    ConnectionWorkerMessageType.WEBSOCKET_DEFINITIVELY_CLOSED = "websocket_definitely_closed";
    ConnectionWorkerMessageType.WEBSOCKET_SEND_MESSAGE = "websocket_send_message";
    ConnectionWorkerMessageType.START = "start";
    ConnectionWorkerMessageType.REQUEST_CLOSE_SOCKET = "close_socket";
    ConnectionWorkerMessageType.UPDATE_ACCESS_TOKEN = "update_access_token";
})(ConnectionWorkerMessageType || (ConnectionWorkerMessageType = {}));
const WELCOME_MESSAGE_TIMEOUT = 7000;
const WEBSOCKET_REGISTRATION_API = "/v1/notification/subscribe";
const ON_CLOSE_ONLINE_CHECK_TIMEOUT = 3000;
// from config.ts
const KEEPALIVE_INTERVAL = 4000;
const CLOSE_SOCKET_TIMEOUT_DURATION = 17000;
const PING_API_URL = "https://reachable.webex.com";
const METHOD_NAME = "GET";


/***/ }),

/***/ "./src/services/aqm/routing-agent-service.ts":
/*!***************************************************!*\
  !*** ./src/services/aqm/routing-agent-service.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   routingAgent: () => (/* binding */ routingAgent)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../index */ "./src/index.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");



/*
 * routingAgent
 * @param reqs
 * @category Routing Service
 */
function routingAgent(routing) {
    return {
        reload: routing.reqEmpty(() => ({
            host: (0,_index__WEBPACK_IMPORTED_MODULE_1__.getRoutingHost)(),
            url: "/agents/reload",
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_2__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "AgentReloginSuccess",
                    data: { type: ["AgentReloginSuccess", "AgentChannelReloginSuccess"] }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "AgentReloginFailed",
                    data: { type: "AgentReloginFailed" }
                },
                errId: "Service.aqm.agent.reload"
            }
        })),
        logout: routing.req((p) => ({
            url: "/agents/logout",
            host: (0,_index__WEBPACK_IMPORTED_MODULE_1__.getRoutingHost)(),
            data: p.data,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_2__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "Logout",
                    data: { type: "AgentLogoutSuccess" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "Logout",
                    data: { type: "AgentLogoutFailed" }
                },
                errId: "Service.aqm.agent.logout"
            }
        })),
        stationLogin: routing.req((p) => ({
            url: "/agents/login",
            host: (0,_index__WEBPACK_IMPORTED_MODULE_1__.getRoutingHost)(),
            data: p.data,
            err: /* istanbul ignore next */ (e) => {
                var _a, _b, _c, _d, _e, _f, _g;
                return new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details("Service.aqm.agent.stationLogin", {
                    status: (_b = (_a = e.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 0,
                    type: (_d = (_c = e.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errorType,
                    trackingId: (_g = (_f = (_e = e.response) === null || _e === void 0 ? void 0 : _e.headers) === null || _f === void 0 ? void 0 : _f.trackingid) === null || _g === void 0 ? void 0 : _g.split("_")[1]
                });
            },
            notifSuccess: {
                bind: {
                    type: "StationLogin",
                    data: { type: "AgentStationLoginSuccess" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "StationLogin",
                    data: { type: "AgentStationLoginFailed" }
                },
                errId: "Service.aqm.agent.stationLoginFailed"
            }
        })),
        stateChange: routing.req((p) => ({
            url: "/agents/session/state",
            host: (0,_index__WEBPACK_IMPORTED_MODULE_1__.getRoutingHost)(),
            data: Object.assign(Object.assign({}, p.data), { auxCodeId: p.data.auxCodeIdArray }),
            err: _service_utils__WEBPACK_IMPORTED_MODULE_2__.createErrDetailsObject,
            method: "put",
            notifSuccess: {
                bind: {
                    type: "AgentStateChange",
                    data: { type: "AgentStateChangeSuccess" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "AgentStateChange",
                    data: { type: "AgentStateChangeFailed" }
                },
                errId: "Service.aqm.agent.stateChange"
            }
        })),
        eMockOutdialAniList: routing.evt({
            bind: {
                type: "mockOutdialAniList"
            },
            msg: {}
        }),
        eAgentDNRegistered: routing.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentDNRegistered" }
            },
            msg: {}
        }),
        eAgentDNRegisterFailure: routing.evt({
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentDNRegisterFailure" }
            },
            msg: {}
        }),
        eAgentMultiLogin: routing.evt({
            bind: {
                type: "AGENT_MULTI_LOGIN",
                data: { type: "AgentMultiLoginCloseSession" }
            },
            msg: {}
        }),
        eAgentChannelReloginSuccess: routing.evt({
            bind: {
                type: "AgentChannelReloginSuccess",
                data: { type: "AgentChannelReloginSuccess" }
            },
            msg: {}
        }),
        // jsapi required events
        eAgentReloginSuccess: routing.evt({
            bind: {
                type: "AgentReloginSuccess",
                data: { type: "AgentReloginSuccess" }
            },
            msg: {}
        }),
        eAgentStationLoginSuccess: routing.evt({
            bind: {
                type: "StationLogin",
                data: { type: "AgentStationLoginSuccess" }
            },
            msg: {}
        }),
        eAgentStateChangeSuccess: routing.evt({
            bind: {
                type: "AgentStateChange",
                data: { type: "AgentStateChangeSuccess" }
            },
            msg: {}
        }),
        eAgentChannelStateChanged: routing.evt({
            bind: {
                type: "AgentChannelStateChanged",
                data: { type: "AgentChannelStateChanged" }
            },
            msg: {}
        }),
        eAgentLogoutSuccess: routing.evt({
            bind: {
                type: "Logout",
                data: { type: "AgentLogoutSuccess" }
            },
            msg: {}
        })
    };
}
// JS DOC Comments - Type Definitions
/**
 * @typedef {Object} Service_Aqm_Agent_StateChange
 * @summary Service.Aqm.Agent.StateChange
 * @property {Service_Aqm_Agent_AgentState} state State of the agent. Possible values are Available, Idle, and RONA.
 * @property {String} auxCodeIdArray Unique identifier for the global desktop state.
 */
/**
 * @typedef {String} Service_Aqm_Agent_AgentState
 * @summary Service.Aqm.Agent.AgentState
 * @description State of the agent. Possible values are Available, Idle, and RONA.
 */
/**
 * @typedef {Object} Service_Aqm_Agent_OutdialAni
 * @summary Service.Aqm.Agent.OutdialAni
 * @property {String} id Unique Identifier for the outdial ANI.
 * @property {String} name Name of the outdial ANI.
 */


/***/ }),

/***/ "./src/services/aqm/routing-contact.ts":
/*!*********************************************!*\
  !*** ./src/services/aqm/routing-contact.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   buildBlindTransferParamData: () => (/* binding */ buildBlindTransferParamData),
/* harmony export */   buildConsultTransferParamData: () => (/* binding */ buildConsultTransferParamData),
/* harmony export */   buildVTeamsTransferParamData: () => (/* binding */ buildVTeamsTransferParamData),
/* harmony export */   createRoutingContactAPIS: () => (/* binding */ createRoutingContactAPIS)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_aqm_reqs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/aqm-reqs */ "./src/core/aqm-reqs.ts");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../index */ "./src/index.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./constants */ "./src/services/aqm/constants.ts");






/*
 * Create routing Contact APIS
 * @param reqs
 * @category Routing Service
 */
const getDestAgentTypeForEporEPDN = () => {
    if (_index__WEBPACK_IMPORTED_MODULE_2__.SERVICE.featureflag.isWxccPersistCallEnabled() || _index__WEBPACK_IMPORTED_MODULE_2__.SERVICE.featureflag.isWxccMultiPartyConfEnabled()) {
        return _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.ENTRY_POINT;
    }
    return _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.EPDN;
};
const buildConsultConferenceParamData = (dataPassed, interactionIdPassed) => {
    const data = Object.assign(Object.assign({}, ("agentId" in dataPassed && { agentId: dataPassed.agentId })), { to: dataPassed.destAgentId, destinationType: "" });
    if ("destinationType" in dataPassed) {
        if (dataPassed.destinationType === _constants__WEBPACK_IMPORTED_MODULE_5__.DN) {
            data.destinationType = _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.DIAL_NUMBER;
        }
        if (dataPassed.destinationType === _constants__WEBPACK_IMPORTED_MODULE_5__.EP_DN) {
            data.destinationType = getDestAgentTypeForEporEPDN();
        }
    }
    else {
        data.destinationType = _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.AGENT;
    }
    return {
        interactionId: interactionIdPassed,
        data
    };
};
const buildConsultParamData = (data, pData, pUrl) => {
    if (pData) {
        if ("queueId" in pData && pUrl === "ctq") {
            data.to = pData.queueId;
            data.destinationType = _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.QUEUE;
        }
        else if ("destinationType" in pData && "destAgentId" in pData) {
            data.to = pData.destAgentId;
            data.destinationType =
                pData.destinationType === "DN" ? _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.DIAL_NUMBER : getDestAgentTypeForEporEPDN();
        }
        else if ("destAgentId" in pData) {
            data.to = pData.destAgentId;
            data.destinationType = _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.AGENT;
        }
        // MultiParty Feature Consult
        if ("holdParticipants" in pData && !pData.holdParticipants) {
            // If holdParticipants is not present then api will consider as true
            // If holdParticipants is present and false then we will send to api
            data.holdParticipants = pData.holdParticipants;
        }
    }
};
const buildBlindTransferParamData = (pInteractionId, pData) => {
    const data = {
        to: (pData === null || pData === void 0 ? void 0 : pData.destAgentId) || "",
        destinationType: pData && "destinationType" in pData ? _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.DIAL_NUMBER : _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.AGENT
    };
    return {
        interactionId: pInteractionId,
        data
    };
};
const buildConsultTransferParamData = (pInteractionId, pData) => {
    const data = {
        to: (pData === null || pData === void 0 ? void 0 : pData.destAgentId) || "",
        destinationType: pData && pData.destinationType
            ? pData.destinationType === _constants__WEBPACK_IMPORTED_MODULE_5__.EP_DN
                ? getDestAgentTypeForEporEPDN()
                : _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.DIAL_NUMBER
            : _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.AGENT
    };
    return {
        interactionId: pInteractionId,
        data
    };
};
const buildVTeamsTransferParamData = (pInteractionId, pData) => {
    const data = {
        to: (pData === null || pData === void 0 ? void 0 : pData.vteamId) || "",
        destinationType: pData.vteamType === "inboundqueue" ? _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.QUEUE : _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.EPDN
    };
    return {
        interactionId: pInteractionId,
        data
    };
};
function createRoutingContactAPIS(routing, http) {
    const consultV2 = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/consult`,
        data: p.data,
        timeout: p.data && p.data.destinationType === _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.QUEUE ? "disabled" : _core_aqm_reqs__WEBPACK_IMPORTED_MODULE_1__.TIMEOUT_REQ,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsultCreated", interactionId: p.interactionId }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: {
                    type: p.data && p.data.destinationType === _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.QUEUE ? "AgentCtqFailed" : "AgentConsultFailed"
                }
            },
            errId: "Service.aqm.contact.consult"
        },
        notifCancel: {
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentCtqCancelled", interactionId: p.interactionId }
            },
            msg: {}
        }
    }));
    const exitConference = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/conference/exit `,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        data: {},
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: { type: "ParticipantLeftConference", interactionId: p.interactionId }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: { type: "ParticipantLeftConferenceFailed" } //to be finalized
            },
            errId: "Service.aqm.contact.consultConference"
        }
    }));
    const conferenceTransfer = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/conference/transfer`,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        data: {},
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConferenceTransferred", interactionId: p.interactionId }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConferenceTransferFailed" }
            },
            errId: "Service.aqm.contact.conferenceTransfer"
        }
    }));
    const consultEndV2 = routing.req((p) => {
        // Setting false value for optional attribute
        const { interactionId, isConsult, isSecondaryEpDnAgent = false, queueId } = p;
        return {
            url: `/v1/tasks/${interactionId}/consult/end`,
            host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
            data: queueId
                ? {
                    queueId
                }
                : {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "RoutingMessage",
                    data: {
                        type: queueId
                            ? "AgentCtqCancelled"
                            : isSecondaryEpDnAgent
                                ? "ContactEnded"
                                : isConsult
                                    ? "AgentConsultEnded"
                                    : "AgentConsultConferenceEnded",
                        interactionId: p.interactionId
                    }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: queueId ? "AgentCtqCancelFailed" : "AgentConsultEndFailed" }
                },
                errId: queueId ? "Service.aqm.contact.cancelCtq" : "Service.aqm.contact.consultEnd"
            }
        };
    });
    const buddyAgentsV2 = routing.req((p) => ({
        url: `/v1/agents/buddyList`,
        data: p.data,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "BuddyAgents",
                data: { type: "BuddyAgents" }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "BuddyAgents",
                data: { type: "BuddyAgentsRetrieveFailed" }
            },
            errId: "Service.aqm.contact.BuddyAgentsRetrieveFailed"
        }
    }));
    const blindTransferV2 = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/transfer`,
        data: p.data,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: {
                    type: p.data.destinationType === _constant__WEBPACK_IMPORTED_MODULE_3__.DESTINATION_TYPE.DIAL_NUMBER
                        ? ["AgentBlindTransferred", "AgentVteamTransferred"]
                        : "AgentBlindTransferred",
                    interactionId: p.interactionId
                }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentBlindTransferFailedEvent" }
            },
            errId: "Service.aqm.contact.AgentBlindTransferFailedEvent"
        }
    }));
    const consultConferenceV2 = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/consult/conference`,
        data: p.data,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: {
                    type: ["AgentConsultConferenced", "AgentConsultConferencing"],
                    interactionId: p.interactionId
                } //any of the two events can be received for API success event
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsultConferenceFailed" }
            },
            errId: "Service.aqm.contact.consultConference"
        }
    }));
    const vteamTransferV2 = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/transfer`,
        data: p.data,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentVteamTransferred", interactionId: p.interactionId }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentVteamTransferFailed" }
            },
            errId: "Service.aqm.contact.AgentVteamTransferFailed"
        }
    }));
    const consultTransferV2 = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/consult/transfer`,
        data: p.data,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: {
                    type: ["AgentConsultTransferred", "AgentConsultTransferring"],
                    interactionId: p.interactionId
                }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentConsultTransferFailed" }
            },
            errId: "Service.aqm.contact.AgentConsultTransferFailed"
        }
    }));
    // Modify this logic using shared-actions so there is no need to pass parameters to endV2
    const endV2 = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/end`,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        data: {},
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: {
                    type: p.isEndingFromNonPrimary ? "ParticipantLeftConference" : "AgentWrapup",
                    interactionId: p.interactionId
                }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: { type: p.isEndingFromNonPrimary ? "AgentConsultConferenceEndFailed" : "AgentContactEndFailed" }
            },
            errId: "Service.aqm.contact.end"
        }
    }));
    const cancelTaskV2 = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/end`,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        data: {},
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactEnded", interactionId: p.interactionId }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentContactEndFailed" }
            },
            errId: "Service.aqm.contact.end"
        }
    }));
    const wrapupV2 = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/wrapup`,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        data: p.data,
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentWrappedUp", interactionId: p.interactionId }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentWrapupFailed" }
            },
            errId: "Service.aqm.contact.wrapup"
        }
    }));
    const reject = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/reject`,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        data: p.data,
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: { type: ["AgentConsultFailed", "AgentOfferContactRona"], interactionId: p.interactionId }
            },
            msg: {}
        }
    }));
    const acceptV2 = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/accept`,
        data: {},
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentContactAssigned", interactionId: p.interactionId }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: { type: "AgentContactAssignFailed", interactionId: p.interactionId }
            },
            errId: "Service.aqm.contact.accept"
        }
    }));
    const pauseRecordingV2 = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/record/pause`,
        data: {},
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactRecordingPaused", interactionId: p.interactionId }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactRecordingPauseFailed", interactionId: p.interactionId }
            },
            errId: "Service.aqm.contact.pauseRecording"
        }
    }));
    const resumeRecordingV2 = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/record/resume`,
        data: p.data,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactRecordingResumed", interactionId: p.interactionId }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: { type: "ContactRecordingResumeFailed", interactionId: p.interactionId }
            },
            errId: "Service.aqm.contact.resumeRecording"
        }
    }));
    const holdOrUnHoldMedia = routing.req((p) => ({
        url: `/v1/tasks/${p.interactionId}/${p.actionType}`,
        data: p.data,
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        notifSuccess: {
            bind: {
                type: "RoutingMessage",
                data: {
                    type: p.actionType === "unhold" ? "AgentContactUnheld" : "AgentContactHeld",
                    interactionId: p.interactionId
                }
            },
            msg: {}
        },
        notifFail: {
            bind: {
                type: "RoutingMessage",
                data: { type: p.actionType === "unhold" ? "AgentContactUnHoldFailed" : "AgentContactHoldFailed" }
            },
            errId: p.actionType === "unhold" ? "Service.aqm.contact.unHold" : "Service.aqm.contact.hold"
        }
    }));
    const postCallConsultHoldOrUnHold = http.req((p) => ({
        method: "POST",
        url: `/v1/tasks/${p.interactionId}/${p.actionType}`,
        data: p.data,
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        errId: `Service.aqm.contact.postCall${p.actionType.charAt(0).toUpperCase() + p.actionType.slice(1)}`,
        res: {}
    }));
    const getHoldOrUnholdRequest = (actionType, interactionId, isPostCallConsult, data) => {
        if (isPostCallConsult) {
            return postCallConsultHoldOrUnHold({ interactionId, actionType, data });
        }
        else {
            return holdOrUnHoldMedia({ interactionId, actionType, data });
        }
    };
    const assign = http.req((p) => ({
        method: "POST",
        url: `/v1/tasks/${encodeURIComponent(p.interactionId)}/assign`,
        err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
        host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
        errId: `Service.aqm.contact.assign`,
        res: {}
    }));
    return {
        consult: (p) => {
            const data = {
                to: "",
                destinationType: ""
            };
            buildConsultParamData(data, p.data, p.url);
            const param = {
                interactionId: p.interactionId,
                data
            };
            return consultV2(param);
        },
        consultV2,
        consultAccept: routing.req((p) => ({
            url: `/v1/tasks/${p.interactionId}/consult/accept`,
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_4__.createErrDetailsObject,
            host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
            notifSuccess: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "AgentConsulting", interactionId: p.interactionId }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "RoutingMessage",
                    data: { type: "AgentContactAssignFailed" }
                },
                errId: "Service.aqm.contact.consultAccept"
            }
        })),
        consultEnd: (p) => {
            // Setting false value for optional attribute
            const { interactionId, isConsult, isSecondaryEpDnAgent = false } = p;
            return consultEndV2({ interactionId, isConsult, isSecondaryEpDnAgent });
        },
        consultEndV2,
        cancelCtq: (p) => {
            return consultEndV2({
                interactionId: p.interactionId,
                isConsult: false,
                queueId: p.data && p.data.queueId ? p.data.queueId : ""
            });
        },
        exitConference,
        conferenceTransfer,
        hold: (p) => {
            return getHoldOrUnholdRequest("hold", p.interactionId, p.isPostCallConsult, p.data);
        },
        unHold: (p) => {
            return getHoldOrUnholdRequest("unhold", p.interactionId, p.isPostCallConsult, p.data);
        },
        consultConference: (p) => {
            const paramsDataForConferenceV2 = buildConsultConferenceParamData(p.data, p.interactionId);
            return consultConferenceV2(paramsDataForConferenceV2);
        },
        consultConferenceV2,
        /*
         * Get list of Agents
         */
        buddyAgents: (p) => {
            const data = Object.assign({ agentProfileId: p.data.agentProfileId, mediaType: p.data.channelName }, (p.data.state && { state: p.data.state }));
            const par = {
                data
            };
            return buddyAgentsV2(par);
        },
        buddyAgentsV2,
        blindTransfer: (p) => {
            return blindTransferV2(buildBlindTransferParamData(p.interactionId, p.data));
        },
        blindTransferV2,
        vteamTransfer: (p) => {
            return vteamTransferV2(buildVTeamsTransferParamData(p.interactionId, p.data));
        },
        vteamTransferV2,
        consultTransfer: (p) => {
            return consultTransferV2(buildConsultTransferParamData(p.interactionId, p.data));
        },
        consultTransferV2,
        end: (p) => {
            return endV2({ interactionId: p.interactionId, isEndingFromNonPrimary: p.isEndingFromNonPrimary });
        },
        endV2,
        cancelTask: (p) => {
            return cancelTaskV2({
                interactionId: p.interactionId
            });
        },
        cancelTaskV2,
        wrapup: (p) => {
            const par = {
                interactionId: p.interactionId,
                data: {
                    auxCodeId: p.data.auxCodeId,
                    wrapUpReason: p.data.wrapUpReason
                }
            };
            return wrapupV2(par);
        },
        wrapupV2,
        decline: (p) => {
            // with the code refactor of CX-15000, we don't need isConsult field, but keeping them for typescript
            return reject({ interactionId: p.interactionId, data: p.data });
        },
        reject,
        accept: (p) => {
            return acceptV2(p);
        },
        acceptV2,
        pauseRecording: (p) => {
            return pauseRecordingV2(p);
        },
        pauseRecordingV2,
        resumeRecording: (p) => {
            return resumeRecordingV2(p);
        },
        resumeRecordingV2,
        assign
    };
}


/***/ }),

/***/ "./src/services/aqm/routing-supervisor-service.ts":
/*!********************************************************!*\
  !*** ./src/services/aqm/routing-supervisor-service.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   routingSupervisor: () => (/* binding */ routingSupervisor)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../index */ "./src/index.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _aqm_service_contact_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./aqm-service-contact-types */ "./src/services/aqm/aqm-service-contact-types.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");






function routingSupervisor(routing) {
    const httpApi = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY);
    return {
        startMonitoring: routing.req((p) => ({
            url: "/monitor",
            host: (0,_index__WEBPACK_IMPORTED_MODULE_2__.getRoutingHost)(),
            data: p.data,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "MonitoringRequest",
                    data: { type: "MonitoringRequestCreated" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "MonitoringRequest",
                    data: { type: "MonitoringRequestCreateFailed" }
                },
                errId: "Service.aqm.supervisor.monitoringFailed"
            }
        })),
        endMonitoring: routing.req((p) => ({
            url: `/monitor/${p.interactionId}/end`,
            host: (0,_index__WEBPACK_IMPORTED_MODULE_2__.getRoutingHost)(),
            data: p.interactionId,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "MonitoringRequest",
                    data: { type: "MonitoringEnded" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "MonitoringRequest",
                    data: { type: "MonitoringEndFailed" }
                },
                errId: "Service.aqm.supervisor.monitoringEndFailed"
            }
        })),
        holdMonitoring: routing.req((p) => ({
            url: `/monitor/${p.interactionId}/hold`,
            host: (0,_index__WEBPACK_IMPORTED_MODULE_2__.getRoutingHost)(),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "MonitoringRequest",
                    data: { type: "MonitoringHeld" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "MonitoringRequest",
                    data: { type: "MonitoringHoldFailed" }
                },
                errId: "Service.aqm.supervisor.monitoringHoldFailed"
            }
        })),
        unHoldMonitoring: routing.req((p) => ({
            url: `/monitor/${p.interactionId}/unhold`,
            host: (0,_index__WEBPACK_IMPORTED_MODULE_2__.getRoutingHost)(),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "MonitoringRequest",
                    data: { type: "MonitoringUnHeld" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "MonitoringRequest",
                    data: { type: "MonitoringUnHoldFailed" }
                },
                errId: "Service.aqm.supervisor.monitoringUnHoldFailed"
            }
        })),
        bargeIn: routing.req((p) => ({
            url: `/v1/monitor/${p.interactionId}/bargeIn`,
            host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "AgentMonitorStateChanged",
                    data: { type: "AgentMonitorStateChanged" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "MonitoringRequest",
                    data: { type: "AgentMonitorStateChangeFailed" }
                },
                errId: "Service.aqm.supervisor.bargeInFailed"
            }
        })),
        changeAgentState: routing.req((p) => ({
            url: "/v1/agents/session/state",
            host: _config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY,
            method: "put",
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: p.data,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "AgentStateChange",
                    data: { type: "AgentStateChangeSuccess" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "AgentStateChange",
                    data: { type: "AgentStateChangeFailed" }
                },
                errId: "Service.aqm.supervisor.changeAgentStateFailed"
            }
        })),
        signoutAgent: httpApi.req((p) => ({
            url: "/v1/agents/logout",
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_5__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: p.data,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            notifSuccess: {
                bind: {
                    type: "Logout",
                    data: { type: "AgentLogoutSuccess" }
                },
                msg: {}
            },
            notifFail: {
                bind: {
                    type: "Logout",
                    data: { type: "AgentLogoutFailed" }
                },
                errId: "Service.aqm.agent.logout"
            },
            method: "PUT",
            errId: "Service.aqm.supervisor.signoutAgentFailed",
            res: {}
        })),
        eMonitoringOffered: routing.evt({
            bind: {
                type: "MonitoringRequest",
                data: { type: "MonitoringOffered" }
            },
            msg: {}
        }),
        eMonitoringStarted: routing.evt({
            bind: {
                type: "MonitoringRequest",
                data: { type: "MonitoringStarted" }
            },
            msg: {}
        }),
        eMonitoringRequestCreateFailed: routing.evt({
            bind: {
                type: "MonitoringRequest",
                data: { type: "MonitoringRequestCreateFailed" }
            },
            msg: {}
        }),
        eMonitoringFailed: routing.evt({
            bind: {
                type: "MonitoringRequest",
                data: { type: "MonitoringFailed" }
            },
            msg: {}
        }),
        eMonitoringEnded: routing.evt({
            bind: {
                type: "MonitoringRequest",
                data: { type: "MonitoringEnded" }
            },
            msg: {}
        }),
        eMonitoringEndFailed: routing.evt({
            bind: {
                type: "MonitoringRequest",
                data: { type: "MonitoringEndFailed" }
            },
            msg: {}
        }),
        eMonitoringHeld: routing.evt({
            bind: {
                type: "MonitoringRequest",
                data: { type: "MonitoringHeld" }
            },
            msg: {}
        }),
        eMonitoringHoldFailed: routing.evt({
            bind: {
                type: "MonitoringRequest",
                data: { type: "MonitoringHoldFailed" }
            },
            msg: {}
        }),
        eMonitoringUnHeld: routing.evt({
            bind: {
                type: "MonitoringRequest",
                data: { type: "MonitoringUnHeld" }
            },
            msg: {}
        }),
        eMonitoringUnHoldFailed: routing.evt({
            bind: {
                type: "MonitoringRequest",
                data: { type: "MonitoringUnHoldFailed" }
            },
            msg: {}
        }),
        eChangeAgentState: routing.evt({
            bind: {
                type: "ChangeAgentStateRequest",
                data: { type: "ChangeAgentState" }
            },
            msg: {}
        }),
        eAgentMonitorStateChanged: routing.evt({
            bind: {
                type: "AgentMonitorStateChanged",
                data: { type: "AgentMonitorStateChanged" }
            },
            msg: {}
        }),
        eAgentMonitorStateChangeFailed: routing.evt({
            bind: {
                type: "MonitoringRequest",
                data: { type: "AgentMonitorStateChangeFailed" }
            },
            msg: {}
        }),
        eAgentMonitoringEnded: routing.evt({
            bind: {
                type: "MonitoringEnded",
                data: { type: "MonitoringEnded" }
            },
            msg: {}
        })
    };
}


/***/ }),

/***/ "./src/services/aqm/schedule-callback/ScheduleCallback.ts":
/*!****************************************************************!*\
  !*** ./src/services/aqm/schedule-callback/ScheduleCallback.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../constant */ "./src/services/constant.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



const FETCH_PAGE_SIZE = "100";
const END_POINT = "/v1/scheduled-callback";
class ScheduleCallback {
    constructor(httpApi) {
        this.httpApi = httpApi;
    }
    createErrDetailsObjectForScheduleCallback(errObj, errorKey) {
        var _a, _b, _c, _d;
        const details = {
            trackingId: ((_a = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _a === void 0 ? void 0 : _a.headers["trackingid"]) || ((_b = errObj === null || errObj === void 0 ? void 0 : errObj.config) === null || _b === void 0 ? void 0 : _b.headers["TrackingID"]),
            msg: (_c = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _c === void 0 ? void 0 : _c.data,
            statusCode: (_d = errObj.response) === null || _d === void 0 ? void 0 : _d.status
        };
        return new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details(errorKey, details);
    }
    fetchByCallbackPhoneNumber(page, phoneNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`Fetching scheduled callback for customer phone number`);
            if (!phoneNumber) {
                throw new Error("Phone number is required");
            }
            if (page < 0) {
                throw new Error("Page number must be greater than equal to 0");
            }
            const queryParams = new URLSearchParams({
                callbackNumber: phoneNumber,
                pageSize: FETCH_PAGE_SIZE,
                page: String(page)
            }).toString();
            const url = `${END_POINT}?${queryParams}`;
            return this.httpApi.req(() => ({
                url,
                headers: Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_2__.HTTP_HEADERS),
                data: {},
                method: "GET",
                errId: "Service.routing.fetchByCallbackPhoneNumberError",
                err: (e) => this.createErrDetailsObjectForScheduleCallback(e, "Service.routing.fetchByCallbackNumberError"),
                res: {}
            }))({ phoneNumber });
        });
    }
    save(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            // Create the request function
            return this.httpApi.req((p) => ({
                url: END_POINT,
                headers: Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_2__.HTTP_HEADERS),
                data: p.data,
                method: "POST",
                errId: "Service.routing.saveScheduleCallbackError",
                err: (e) => this.createErrDetailsObjectForScheduleCallback(e, "Service.routing.saveScheduleCallbackError"),
                res: {} // Specify the expected response type
            }))({ data: payload });
        });
    }
    updateCallBackDetails(updatedCallbackDetails) {
        return __awaiter(this, void 0, void 0, function* () {
            _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`Updating scheduled callback details for callbackId: ${updatedCallbackDetails.id}`);
            const url = `${END_POINT}/${updatedCallbackDetails.id}`;
            // Create the request function
            return this.httpApi.req((p) => ({
                url,
                headers: Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_2__.HTTP_HEADERS),
                data: p.updatedCallbackDetails,
                method: "PUT",
                errId: "Service.routing.updateScheduleCallbackError",
                err: (e) => this.createErrDetailsObjectForScheduleCallback(e, "Service.routing.updateScheduleCallbackError"),
                res: {}
            }))({ updatedCallbackDetails });
        });
    }
    deleteScheduleCallback(id) {
        return __awaiter(this, void 0, void 0, function* () {
            _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`Delete scheduled callback details for callbackId: ${id}`);
            if (!id) {
                throw new Error("Id is required");
            }
            const url = `${END_POINT}/${id}`;
            // Create the request function
            return this.httpApi.req(() => ({
                url,
                headers: Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_2__.HTTP_HEADERS),
                method: "DELETE",
                errId: "Service.routing.scheduleCallback",
                err: (e) => this.createErrDetailsObjectForScheduleCallback(e, "Service.routing.deleteScheduleCallbackError"),
                res: {}
            }))({});
        });
    }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ScheduleCallback);


/***/ }),

/***/ "./src/services/avatar/avatar-service.ts":
/*!***********************************************!*\
  !*** ./src/services/avatar/avatar-service.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AvatarService: () => (/* binding */ AvatarService)
/* harmony export */ });
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const REQUEST_DEBOUNCE_TIME = 50;
const DSS_REQUEST_RETRIES = 5;
const EMAILS_IN_SINGLE_HYDRA_REQUEST = 5;
class AvatarService {
    constructor(webexService, microsoftService) {
        this.cache = new Map();
        this.pendingEmails = new Map();
        this.requestingAvatars = false;
        this.dssRetries = DSS_REQUEST_RETRIES;
        this.requestWebexAvatarUrls = () => {
            if (this.requestingAvatars) {
                return;
            }
            this.requestingAvatars = true;
            const pendingEmailsCopy = new Map();
            for (const [email, pendingPromises] of this.pendingEmails) {
                const avatarUrl = this.findCacheItem(email);
                if (avatarUrl || avatarUrl === "") {
                    this.resolvePromises(pendingPromises, avatarUrl);
                    this.pendingEmails.delete(email);
                }
                else if (pendingEmailsCopy.size < EMAILS_IN_SINGLE_HYDRA_REQUEST) {
                    pendingEmailsCopy.set(email, pendingPromises);
                    this.pendingEmails.delete(email);
                }
                else {
                    break;
                }
            }
            if (pendingEmailsCopy.size > 0) {
                this.requestWebexAvatarUrlsBatch(pendingEmailsCopy);
            }
            else {
                this.requestingAvatars = false;
            }
        };
        this.webexService = webexService;
        this.microsoftService = microsoftService;
    }
    init() {
        this.pendingEmails.forEach((pendingPromises) => {
            this.rejectPromises(pendingPromises, "[avatar-service] Avatar service is being reinitialized");
        });
        this.pendingEmails.clear();
        this.cache.clear();
        this.requestingAvatars = false;
        this.dssRetries = DSS_REQUEST_RETRIES;
    }
    getAvatarUrl(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const avatarUrl = this.findCacheItem(email);
            if (avatarUrl || avatarUrl === "") {
                return avatarUrl;
            }
            else if (this.dssRetries > 0) {
                return this.requestAvatarUrl(email);
            }
            else {
                return undefined;
            }
        });
    }
    findCacheItem(email) {
        return this.cache.get(email);
    }
    requestAvatarUrl(email) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const pendingPromises = this.pendingEmails.get(email) || [];
                pendingPromises.push({ resolve, reject });
                this.pendingEmails.set(email, pendingPromises);
                setTimeout(() => {
                    this.requestWebexAvatarUrls();
                }, REQUEST_DEBOUNCE_TIME);
            });
        });
    }
    resolvePromises(pendingPromises, avatarUrl) {
        if (pendingPromises) {
            pendingPromises.forEach((pendingPromise) => {
                setTimeout(() => {
                    pendingPromise.resolve(avatarUrl);
                });
            });
        }
    }
    rejectPromises(pendingPromises, msg) {
        if (pendingPromises) {
            pendingPromises.forEach((pendingPromise) => {
                setTimeout(() => {
                    pendingPromise.reject(msg);
                });
            });
        }
    }
    requestWebexAvatarUrlsBatch(pendingEmails) {
        if (!this.webexService.webexInitializedStatus()) {
            pendingEmails.forEach((pendingPromises) => {
                this.rejectPromises(pendingPromises, `[avatar-service] WebexService is not initialized`);
            });
            this.requestingAvatars = false;
            return;
        }
        this.webexService.registerToDSS().then(() => {
            const emails = [...pendingEmails.keys()];
            this.webexService
                .lookupUsersByEmail(emails)
                .then((users) => {
                users.forEach((user) => {
                    this.cache.set(user.email, user.avatarUrl);
                    this.resolvePromises(pendingEmails.get(user.email), user.avatarUrl);
                    pendingEmails.delete(user.email);
                });
                pendingEmails.forEach((pendingPromises, email) => {
                    this.cache.set(email, ""); // skip fetching details for missing user on next access
                    this.rejectPromises(pendingPromises, `[avatar-service] user ${email} not found`);
                });
                this.dssRetries = DSS_REQUEST_RETRIES;
            })
                .catch((err) => {
                pendingEmails.forEach((pendingPromises) => {
                    this.rejectPromises(pendingPromises, err);
                });
                this.dssRetries--;
            })
                .finally(() => {
                this.requestingAvatars = false;
                if (this.pendingEmails.size > 0) {
                    setTimeout(() => {
                        this.requestWebexAvatarUrls();
                    });
                }
            });
        });
    }
}


/***/ }),

/***/ "./src/services/build-info/build-info-service.ts":
/*!*******************************************************!*\
  !*** ./src/services/build-info/build-info-service.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   buildInfoService: () => (/* binding */ buildInfoService)
/* harmony export */ });
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");



function buildInfoService() {
    const http = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_0__.HttpReqs(window.location.origin, false);
    return {
        getBuildVersion: http.reqEmptyWithoutAuth(() => ({
            url: `/build_info`,
            headers: Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_1__.HTTP_HEADERS),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_2__.createErrDetailsObject,
            method: "GET",
            errId: "Service.buildInfo.reqs.Failure",
            res: {}
        }))
    };
}


/***/ }),

/***/ "./src/services/cms/cms-service.ts":
/*!*****************************************!*\
  !*** ./src/services/cms/cms-service.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   cmsService: () => (/* binding */ cmsService)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../index */ "./src/index.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






function cmsService() {
    const httpApi = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY);
    const fetchAllTeamsByPages = (orgId, filter = false) => __awaiter(this, void 0, void 0, function* () {
        const result = [];
        let url = `/organization/${orgId}/v2/team?page=0&pageSize=500`;
        if (filter && (filter === null || filter === void 0 ? void 0 : filter.dbId)) {
            url = `${url}&filter=dbId=="${filter.dbId}"`;
        }
        try {
            while (url) {
                const response = yield _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.cms.fetchTeamsByPage({ orgId, url });
                const { data, meta } = response;
                url = meta.links.next;
                result.push(...data);
            }
        }
        catch (error) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`event=fetchTeamsFailed for page url: ${url} for org ${orgId}`, error);
            throw error;
        }
        return result;
    });
    const fetchAllManagedTeamsByPages = (orgId) => __awaiter(this, void 0, void 0, function* () {
        const result = [];
        let url = `/organization/${orgId}/v2/team?agentView=true&page=0&pageSize=500&attributes=id,name,dbId,siteId`;
        try {
            while (url) {
                const response = yield _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.cms.fetchTeamsByPage({ orgId, url });
                const { data, meta } = response;
                url = meta.links.next;
                result.push(...data);
            }
        }
        catch (error) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`event=fetchManagedTeamsFailed for page url: ${url} for org ${orgId}`, error);
            throw error;
        }
        return result;
    });
    const fetchAllManagedQueuesByPages = (orgId) => __awaiter(this, void 0, void 0, function* () {
        const result = [];
        let url = `/organization/${orgId}/v2/contact-service-queue?agentView=true&page=0&pageSize=500&attributes=id,name`;
        try {
            while (url) {
                const response = yield _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.cms.fetchQueuesByPage({ orgId, url });
                const { data, meta } = response;
                url = meta.links.next;
                result.push(...data);
            }
        }
        catch (error) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`event=fetchManagedQueueFailed for page url: ${url} for org ${orgId}`, error);
            throw error;
        }
        return result;
    });
    const fetchAllEntryPointsByPages = (orgId) => __awaiter(this, void 0, void 0, function* () {
        const result = [];
        let url = `/organization/${orgId}/v2/entry-point?agentView=true&pageSize=1000`;
        try {
            while (url) {
                const response = yield _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.cms.fetchEntryPointsByPage({ orgId, url });
                const { data, meta } = response;
                url = meta.links.next;
                result.push(...data);
            }
        }
        catch (error) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`event=fetchEntryPointsFailed for page url: ${url} for org ${orgId}`, error);
            throw error;
        }
        return result;
    });
    const fetchAllAddressBookByPages = (p) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const result = [];
        const promises = [];
        const orgId = p.orgId;
        const addressBookId = p.addressBookId;
        const pageSize = 1000;
        const url = `/organization/${p.orgId}/v2/address-book/${p.addressBookId}/entry?pageSize=${pageSize}&attributes=name,number&sort=name,ASC`;
        try {
            const response = yield _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.cms.fetchAddressBookByPage({ orgId, url });
            const { data, meta } = response;
            result.push(...data);
            if ((meta === null || meta === void 0 ? void 0 : meta.totalPages) > 1) {
                for (let i = 1; i < meta.totalPages; i++) {
                    const nextUrl = `${url}&page=${i}`;
                    promises.push(_index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.cms.fetchAddressBookByPage({ orgId, url: nextUrl }));
                }
                const allResponse = yield Promise.all(promises);
                allResponse.forEach((item) => {
                    result.push(...item.data);
                });
            }
        }
        catch (error) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`event=fetchAddressBookFailed for page url: ${url} for org ${p.orgId}`, error);
            if (((_b = (_a = error === null || error === void 0 ? void 0 : error.details) === null || _a === void 0 ? void 0 : _a.msg) === null || _b === void 0 ? void 0 : _b.status) === 429 && p.allowRetry) {
                return fetchAllAddressBookByPages({ orgId, addressBookId, allowRetry: false });
            }
            else {
                throw error;
            }
        }
        return result;
    });
    const fetchMicrosoftConfigHandler = (p, allowRetry = true) => __awaiter(this, void 0, void 0, function* () {
        var _c, _d;
        try {
            return yield _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.cms.fetchMicrosoftConfigData(p);
        }
        catch (error) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`event=fetchMicrosoftConfig Failed to fetch the microsoft org config`, error);
            if (((_d = (_c = error === null || error === void 0 ? void 0 : error.details) === null || _c === void 0 ? void 0 : _c.msg) === null || _d === void 0 ? void 0 : _d.status) === 429 && allowRetry) {
                yield (0,_service_utils__WEBPACK_IMPORTED_MODULE_5__.sleep)(_service_utils__WEBPACK_IMPORTED_MODULE_5__.RETRY_INTERVAL);
                return fetchMicrosoftConfigHandler(p, false);
            }
            else {
                throw error;
            }
        }
    });
    const reassignQueueAgentsHandler = (p) => __awaiter(this, void 0, void 0, function* () {
        var _e, _f, _g, _h, _j;
        try {
            yield _index__WEBPACK_IMPORTED_MODULE_3__.SERVICE.cms.reassignQueueAgentsData(p);
            return {};
        }
        catch (error) {
            if (((_f = (_e = error === null || error === void 0 ? void 0 : error.details) === null || _e === void 0 ? void 0 : _e.msg) === null || _f === void 0 ? void 0 : _f.status) === 422) {
                const errorData = (_h = (_g = error === null || error === void 0 ? void 0 : error.details) === null || _g === void 0 ? void 0 : _g.msg) === null || _h === void 0 ? void 0 : _h.data;
                const isMaxAgentsExceeded = ((_j = errorData === null || errorData === void 0 ? void 0 : errorData.error) === null || _j === void 0 ? void 0 : _j.key) === "contact_service_queue.agent_based.agents";
                _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`event=reassignQueueAgentsFailed status=422 queueId=${p.queueId} trackingId=${errorData === null || errorData === void 0 ? void 0 : errorData.trackingId} maxAgentsLimitExceeded=${isMaxAgentsExceeded}`, error);
            }
            throw error;
        }
    });
    return {
        fetchChatResponses: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/chat-template`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchChatResponses",
            res: {}
        })),
        fetchTeamsById: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/team/${p.teamId}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId, "x-ignore-internal-data": "false" }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchTeamsById",
            res: {}
        })),
        fetchTeamsByPage: httpApi.req((p) => ({
            url: p.url,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId, "x-ignore-internal-data": "false" }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchAllTeams",
            res: {}
        })),
        fetchQueuesByPage: httpApi.req((p) => ({
            url: p.url,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId, "x-ignore-internal-data": "false" }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchAllQueues",
            res: {}
        })),
        fetchDesktopLayout: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/desktop-layout/${p.desktopLayoutId}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchDesktopLayout",
            res: {}
        })),
        fetchGlobalDesktopLayoutV2: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/desktop-layout?filter=global==true`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchDefaultDesktopLayout",
            res: {}
        })),
        fetchUserRecord: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/user/by-ci-user-id/${p.userId}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchUserRecord",
            res: {}
        })),
        fetchUserProfile: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/user-profile/${p.profileId}?agentView=true`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchUserProfile",
            res: {}
        })),
        fetchEntryPointsByPage: httpApi.req((p) => ({
            url: p.url,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchEntryPointsList",
            res: {}
        })),
        fetchDialNumberList: httpApi.req((p) => ({
            url: p.url,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchDialNumberList",
            res: {}
        })),
        fetchAddressBookByPage: httpApi.req((p) => ({
            // after testing change http to httpApi
            url: p.url,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchAddressBookList",
            res: {}
        })),
        fetchOrgUrlMappingByNameV2: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/org-url-mapping?filter=name=in=(${_constant__WEBPACK_IMPORTED_MODULE_4__.KEY_PATH})`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchOrgUrlMappingByNameV2",
            res: {}
        })),
        fetchMicrosoftConfigData: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/v2/microsoft-config`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchMicrosoftConfig",
            res: {}
        })),
        fetchWebexConfigData: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/webex-config`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchWebexConfig",
            res: {}
        })),
        fetchAIGeneratedSummaries: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/v2/generated-summaries`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchAIGeneratedSummaries",
            res: {}
        })),
        fetchAIAgentBurnout: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/v2/agent-burnout`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchAIAgentBurnout",
            res: {}
        })),
        fetchOrganizationSettings: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/organization-setting`,
            headers: _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS,
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchOrganizationSettings",
            res: {}
        })),
        fetchAIFeature: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/v2/ai-feature`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchAIFeature",
            res: {}
        })),
        fetchQueueDetailsById: httpApi.req((p) => ({
            url: (() => {
                let baseUrl = `/organization/${p.orgId}/v2/contact-service-queue/${p.queueId}`;
                if (p.agentsUpdatedInfo) {
                    baseUrl += `?agentsUpdatedInfo=${p.agentsUpdatedInfo.toString()}`;
                }
                return baseUrl;
            })(),
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchQueueDetailsById",
            res: {}
        })),
        reassignQueueAgentsData: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/v2/contact-service-queue/${p.queueId}/reassign-agents`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: { add: p.addedAgents, remove: p.removedAgents },
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "PATCH",
            errId: "Service.cms.reassignQueueAgents",
            res: {}
        })),
        fetchSkillProfiles: httpApi.req((p) => ({
            url: (() => {
                var _a, _b;
                let baseUrl = `/organization/${p.orgId}/v2/skill-profile?attributes=id,name&sort=name,asc&pageSize=${(_a = p.pageSize) !== null && _a !== void 0 ? _a : 100}&page=${(_b = p.page) !== null && _b !== void 0 ? _b : 0}`;
                if (p.search && p.search.length > 0) {
                    baseUrl += `&search=field=="name";value=="${p.search}"`;
                }
                return baseUrl;
            })(),
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchSkillProfiles",
            res: {}
        })),
        fetchSkillProfile: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/skill-profile/${p.skillProfileId}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "GET",
            errId: "Service.cms.fetchSkillProfile",
            res: {}
        })),
        fetchUsersByPage: httpApi.req((p) => {
            const baseUrl = `/organization/${p.orgId}/v2/user`;
            const queryParams = new URLSearchParams(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (p.filter && { filter: p.filter })), (p.userInQueue !== undefined && { userInQueue: p.userInQueue ? "assigned" : "unassigned" })), (p.queueId && { queueId: p.queueId })), { supervisorManagedAgentsOnly: "true" }), (p.attributes && { attributes: p.attributes })), (p.sort && { sort: p.sort })), (p.page !== undefined && { page: p.page.toString() })), (p.pageSize !== undefined && { pageSize: p.pageSize.toString() })), (p.searchValue && {
                search: `fields=in=("firstName","lastName");value=="${p.searchValue}"`
            })));
            return {
                url: `${baseUrl}?${queryParams.toString()}`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
                data: {},
                err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
                method: "GET",
                errId: "Service.cms.fetchUsersByPage",
                res: {}
            };
        }),
        fetchQueueConfigLimit: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/config-limit/${p.queueId}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "PATCH",
            errId: "Service.cms.fetchQueueConfigLimit ",
            res: {}
        })),
        fetchCherryPickEnabledQueues: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/contact-service-queue/fetch-manually-assignable-queues/?page=0&pageSize=1000`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {
                agentId: p.agentId,
                teamId: p.teamId
            },
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "POST",
            errId: "Service.cms.fetchCherryPickEnabledQueues",
            res: {}
        })),
        fetchMicrosoftConfig: fetchMicrosoftConfigHandler,
        fetchAllTeams: fetchAllTeamsByPages,
        fetchAllManagedTeams: fetchAllManagedTeamsByPages,
        fetchAllManagedQueues: fetchAllManagedQueuesByPages,
        fetchAllEntryPoints: fetchAllEntryPointsByPages,
        fetchAllAddressBook: fetchAllAddressBookByPages,
        reassignQueueAgents: reassignQueueAgentsHandler,
        updateUser: httpApi.req((p) => ({
            url: `/organization/${p.orgId}/user/${p.userId}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: p.data,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_5__.createErrDetailsObject,
            method: "PATCH",
            errId: "Service.cms.updateUser",
            res: {}
        }))
    };
}


/***/ }),

/***/ "./src/services/conf/conf-service.ts":
/*!*******************************************!*\
  !*** ./src/services/conf/conf-service.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ConfService: () => (/* binding */ ConfService)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../.. */ "./src/index.ts");
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



const IDLE = "Idle";
const LOGGEDIN = "LoggedIn";
class ConfService {
    constructor(aqm, abs) {
        this.profile = null;
        this.subStatus = IDLE;
        this.status = LOGGEDIN;
        this.DEFAULT_PAGE_SIZE = 100;
        this.getSortedVoiceOptions = (loginVoiceOptions) => {
            const sortedVoiceOptions = [];
            _constant__WEBPACK_IMPORTED_MODULE_2__.LOGIN_VOICE_OPTIONS_FOR_ORDER.forEach((option) => {
                if (loginVoiceOptions.includes(option)) {
                    sortedVoiceOptions.push(option);
                }
            });
            return sortedVoiceOptions;
        };
        this.getLoginVoiceOptions = (loginVoiceOptions, webRtcEnabled) => {
            if (loginVoiceOptions) {
                if (webRtcEnabled) {
                    if (loginVoiceOptions.length !== 0) {
                        return this.getSortedVoiceOptions(loginVoiceOptions.sort());
                    }
                }
                else {
                    // remove browser option if webRtc is not Enabled
                    const index = loginVoiceOptions.indexOf(___WEBPACK_IMPORTED_MODULE_0__.SERVICE.constants.LoginVoiceOptions.BROWSER, 0);
                    if (index > -1) {
                        loginVoiceOptions === null || loginVoiceOptions === void 0 ? void 0 : loginVoiceOptions.splice(index, 1);
                    }
                    return loginVoiceOptions.length === 0 ? [] : this.getSortedVoiceOptions(loginVoiceOptions.sort());
                }
            }
            return _constant__WEBPACK_IMPORTED_MODULE_2__.DEFAULT_LOGIN_VOICE_OPTIONS;
        };
        this.getDefaultIdleCode = (idleCodes) => {
            return idleCodes === null || idleCodes === void 0 ? void 0 : idleCodes.find((c) => c.isDefault);
        };
        this.getDefaultWrapUpCode = (wrapUpReasonList) => {
            return wrapUpReasonList === null || wrapUpReasonList === void 0 ? void 0 : wrapUpReasonList.find((c) => c.isDefault);
        };
        this.updateAuxCodeConfig = (idleCodes, wrapUpReasonList) => {
            var _a;
            if (this.profile) {
                if (!___WEBPACK_IMPORTED_MODULE_0__.SERVICE.featureflag.isDesktopAuxCodesInfiniteScrollEnabled()) {
                    // For Idle codes
                    this.profile.idleCodes = idleCodes;
                    const defaultIdleData = this.getDefaultIdleCode(idleCodes);
                    if (defaultIdleData) {
                        // Update default Idle code
                        this.setDefaultIdleCode(defaultIdleData);
                    }
                }
                // For WrapUp codes
                this.profile.wrapupCodes = wrapUpReasonList;
                if ((_a = this.profile.wrapUpData) === null || _a === void 0 ? void 0 : _a.wrapUpProps) {
                    this.profile.wrapUpData.wrapUpProps.wrapUpReasonList = wrapUpReasonList;
                }
                const defaultWrapUpData = this.getDefaultWrapUpCode(wrapUpReasonList);
                if (defaultWrapUpData) {
                    // Update default WrapUp code
                    this.setDefaultWrapUpCode(defaultWrapUpData);
                }
            }
        };
        this.updateWrapUpCodeConfig = (agentWrapUpCodes) => {
            var _a;
            if (this.profile) {
                this.profile.agentWrapUpCodes = agentWrapUpCodes;
                // Updating the old wrapupCodes with the new wrapupCodes for backward compatibility
                this.profile.wrapupCodes = agentWrapUpCodes.data;
                if ((_a = this.profile.wrapUpData) === null || _a === void 0 ? void 0 : _a.wrapUpProps) {
                    this.profile.wrapUpData.wrapUpProps.wrapUpReasonList = agentWrapUpCodes.data;
                }
            }
        };
        this.setDefaultIdleCode = (defaultIdleData) => {
            var _a;
            if (this.profile && defaultIdleData) {
                this.profile.idleCode = defaultIdleData; // Idle code Object.
                this.profile.defaultIdleName = (_a = defaultIdleData === null || defaultIdleData === void 0 ? void 0 : defaultIdleData.name) !== null && _a !== void 0 ? _a : "";
            }
        };
        this.setDefaultWrapUpCode = (defaultWrapUpData) => {
            var _a;
            if (this.profile && defaultWrapUpData) {
                this.profile.defaultWrapupCode = (_a = defaultWrapUpData === null || defaultWrapUpData === void 0 ? void 0 : defaultWrapUpData.id) !== null && _a !== void 0 ? _a : "";
                this.profile.agentDefaultWrapUpCode = defaultWrapUpData;
            }
        };
        this.initializeProfile = (configResp, orgId) => {
            var _a;
            this.profile.loginVoiceOptions = this.getLoginVoiceOptions(configResp === null || configResp === void 0 ? void 0 : configResp.loginVoiceOptions, (_a = configResp === null || configResp === void 0 ? void 0 : configResp.webRtcEnabled) !== null && _a !== void 0 ? _a : false);
            this.profile.webRtcEnabled = configResp.webRtcEnabled;
            this.profile.regexUS = new RegExp(configResp === null || configResp === void 0 ? void 0 : configResp.regexUS);
            this.profile.regexOther = new RegExp(configResp === null || configResp === void 0 ? void 0 : configResp.regexOther);
            this.profile.orgId = orgId !== null && orgId !== void 0 ? orgId : "";
            this.profile.agentSubStatus = this.subStatus;
            this.profile.agentStatus = this.status;
            this.aqm.connectionConfig.setConnectionProp({
                lostConnectionRecoveryTimeout: this.profile.lostConnectionRecoveryTimeout
            });
        };
        this.parseAgentBooleanAttribute = (agent, name) => {
            var _a, _b;
            return JSON.parse((_b = (_a = agent.attribute.find((item) => item.name === name)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "false");
        };
        this.parseAgentProfileBooleanAttribute = (profile, name) => {
            var _a, _b;
            const profileAttribute = "profile-attribute";
            return JSON.parse((_b = (_a = profile[profileAttribute].find((item) => item.name === name)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "false");
        };
        this.aqm = aqm;
        this.abs = abs;
    }
    getFormattedUrl(url) {
        if (!url.includes("https")) {
            url = `https://${url}`;
        }
        return url;
    }
    fetchProfile(orgId, userId, isSupervisor = false) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        return __awaiter(this, void 0, void 0, function* () {
            // request
            _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("event=requestAgentConfig | Requesting agent configurations");
            // In order to get the current agent state - 'Available' on reload.
            this.aqm.agent.eAgentStateChangeSuccess.listen((data) => {
                this.subStatus = data.data.subStatus;
            });
            this.aqm.agent.eAgentReloginSuccess.listen((data) => {
                this.status = data.data.status;
            });
            const ifMaerskEnabled = () => {
                return ___WEBPACK_IMPORTED_MODULE_0__.SERVICE.featureflag.isDesktopMaerskEnhancementEnabled();
            };
            const isMaerskEnabled = ifMaerskEnabled();
            const isDesktopAuxCodesInfiniteScrollEnabled = ___WEBPACK_IMPORTED_MODULE_0__.SERVICE.featureflag.isDesktopAuxCodesInfiniteScrollEnabled();
            const storedUserRole = localStorage.getItem("userRole");
            const newOrgId = orgId || sessionStorage.getItem("orgId") || "";
            const configResp = yield this.abs.fetchCmsInitConfig({
                orgId: newOrgId,
                userId: userId || sessionStorage.getItem("agentId"),
                isSupervisor: isSupervisor || storedUserRole === "supervisor" || storedUserRole === "supervisorAgent"
            });
            this.profile = configResp;
            this.initializeProfile(configResp, newOrgId);
            if (!isDesktopAuxCodesInfiniteScrollEnabled && !isMaerskEnabled) {
                // If isDesktopAuxCodesInfiniteScrollEnabled and isMaerskEnabled FF is not enabled,
                // then /agent-config endpoint will return the whole idleCodes.
                this.updateAuxCodeConfig((_a = configResp === null || configResp === void 0 ? void 0 : configResp.idleCodes) !== null && _a !== void 0 ? _a : [], (_d = (_c = (_b = configResp.wrapUpData) === null || _b === void 0 ? void 0 : _b.wrapUpProps) === null || _c === void 0 ? void 0 : _c.wrapUpReasonList) !== null && _d !== void 0 ? _d : []);
            }
            if (((_e = configResp.urlMappings) === null || _e === void 0 ? void 0 : _e.acqueonApiUrl) && ((_f = configResp.urlMappings) === null || _f === void 0 ? void 0 : _f.acqueonConsoleUrl)) {
                this.profile.lcmUrl =
                    (_l = this.getFormattedUrl((_k = (_j = new URL((_h = this.getFormattedUrl((_g = configResp.urlMappings) === null || _g === void 0 ? void 0 : _g.acqueonApiUrl)) !== null && _h !== void 0 ? _h : "")) === null || _j === void 0 ? void 0 : _j.hostname) !== null && _k !== void 0 ? _k : "")) !== null && _l !== void 0 ? _l : "";
                this.profile.campaignManagerAdditionalInfo = `URI=${(_r = (_q = (_p = new URL((_o = this.getFormattedUrl((_m = configResp.urlMappings) === null || _m === void 0 ? void 0 : _m.acqueonConsoleUrl)) !== null && _o !== void 0 ? _o : "")) === null || _p === void 0 ? void 0 : _p.pathname) === null || _q === void 0 ? void 0 : _q.replace(/\//, "")) !== null && _r !== void 0 ? _r : ""};APIURI=${(_w = (_v = (_u = new URL((_t = this.getFormattedUrl((_s = configResp.urlMappings) === null || _s === void 0 ? void 0 : _s.acqueonApiUrl)) !== null && _t !== void 0 ? _t : "")) === null || _u === void 0 ? void 0 : _u.pathname) === null || _v === void 0 ? void 0 : _v.replace(/\//, "")) !== null && _w !== void 0 ? _w : ""}`;
            }
            _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("CmsConfigResp from proxy Abs:::", this.profile);
            return this.profile;
        });
    }
    updateProfileTeams(teams) {
        if (this.profile) {
            this.profile.teams = teams;
        }
    }
    updateProfileTeamsMeta(teamsMeta) {
        if (this.profile) {
            this.profile.teamsMeta = teamsMeta;
        }
    }
}


/***/ }),

/***/ "./src/services/constant.ts":
/*!**********************************!*\
  !*** ./src/services/constant.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   APP_NAME: () => (/* binding */ APP_NAME),
/* harmony export */   CACHE_CONTROL_HEADER: () => (/* binding */ CACHE_CONTROL_HEADER),
/* harmony export */   DEFAULT_CROSS_CLIENT_STATE_TTL: () => (/* binding */ DEFAULT_CROSS_CLIENT_STATE_TTL),
/* harmony export */   DEFAULT_LOGIN_VOICE_OPTIONS: () => (/* binding */ DEFAULT_LOGIN_VOICE_OPTIONS),
/* harmony export */   DESTINATION_TYPE: () => (/* binding */ DESTINATION_TYPE),
/* harmony export */   EXPIRATION_OFFSET: () => (/* binding */ EXPIRATION_OFFSET),
/* harmony export */   HTTP_HEADERS: () => (/* binding */ HTTP_HEADERS),
/* harmony export */   KEY_PATH: () => (/* binding */ KEY_PATH),
/* harmony export */   LOGIN_VOICE_OPTIONS_FOR_ORDER: () => (/* binding */ LOGIN_VOICE_OPTIONS_FOR_ORDER),
/* harmony export */   LoginVoiceOptions: () => (/* binding */ LoginVoiceOptions),
/* harmony export */   MEDIA_SUBCHANNEL_TYPES: () => (/* binding */ MEDIA_SUBCHANNEL_TYPES),
/* harmony export */   MERCURY_TIME_OFFSET_THRESHOLD_MS: () => (/* binding */ MERCURY_TIME_OFFSET_THRESHOLD_MS),
/* harmony export */   MICROSOFT_URLS: () => (/* binding */ MICROSOFT_URLS),
/* harmony export */   MicrosoftServiceEvents: () => (/* binding */ MicrosoftServiceEvents),
/* harmony export */   NON_PROD_WEBEX_URL: () => (/* binding */ NON_PROD_WEBEX_URL),
/* harmony export */   PRESENCE_MERCURY_REG: () => (/* binding */ PRESENCE_MERCURY_REG),
/* harmony export */   RETRY_TIMEOUT: () => (/* binding */ RETRY_TIMEOUT),
/* harmony export */   REVOKE_PRESENCE_TOKEN_FAILURE: () => (/* binding */ REVOKE_PRESENCE_TOKEN_FAILURE),
/* harmony export */   RtdConstants: () => (/* binding */ RtdConstants),
/* harmony export */   WEBEX_CALLING: () => (/* binding */ WEBEX_CALLING),
/* harmony export */   WEBEX_CALLING_MERC_SYNC: () => (/* binding */ WEBEX_CALLING_MERC_SYNC),
/* harmony export */   WEB_CALLING: () => (/* binding */ WEB_CALLING),
/* harmony export */   constant: () => (/* binding */ constant),
/* harmony export */   uuipEol: () => (/* binding */ uuipEol)
/* harmony export */ });
var AgentState;
(function (AgentState) {
    AgentState["Idle"] = "Idle";
    AgentState["Available"] = "Available";
    AgentState["RONA"] = "RONA";
    AgentState["AvailableAuxCodeId"] = "0";
})(AgentState || (AgentState = {}));
var ContactDirection;
(function (ContactDirection) {
    ContactDirection["INBOUND"] = "INBOUND";
    ContactDirection["OUTBOUND"] = "OUTBOUND";
})(ContactDirection || (ContactDirection = {}));
var WebexConstants;
(function (WebexConstants) {
    WebexConstants["CALL_INACTIVE"] = "CALL_INACTIVE";
    WebexConstants["MEETING_INACTIVE_TERMINATING"] = "MEETING_INACTIVE_TERMINATING";
    WebexConstants["CALL"] = "CALL";
    WebexConstants["MEETING"] = "MEETING";
    WebexConstants["INCOMING"] = "INCOMING";
    WebexConstants["JOIN"] = "JOIN";
    WebexConstants["WEBEX_DND"] = "WEBEX_DND";
    WebexConstants["WEBEX_MEETING_TIME_STAMP"] = "webex-meeting-time-stamp";
    WebexConstants["WEBEX_PRESENCE_UPDATE"] = "event:apheleia.subscription_update";
    WebexConstants["AX_PRESENCE_STATE_UPDATE"] = "ax-presence-state-update";
    WebexConstants["WEBEX_SDK_PRESENCE_UPDATE"] = "updated";
    WebexConstants["WEBEX_CALL_MUTE_STATE_UPDATE"] = "event:telephony_calls.muted";
    WebexConstants["WEBEX_CALL_UNMUTE_STATE_UPDATE"] = "event:telephony_calls.unmuted";
    WebexConstants["WEBEX_CALL_HOLD_STATE_UPDATE"] = "event:telephony_calls.held";
    WebexConstants["WEBEX_CALL_RESUME_STATE_UPDATE"] = "event:telephony_calls.resumed";
})(WebexConstants || (WebexConstants = {}));
var AcqueonConstants;
(function (AcqueonConstants) {
    AcqueonConstants["ACQUEON_API_URL"] = "ACQUEON_API_URL";
    AcqueonConstants["CALABRIO_URL"] = "CALABRIO_URL";
    AcqueonConstants["ACQUEON_CONSOLE_URL"] = "ACQUEON_CONSOLE_URL";
})(AcqueonConstants || (AcqueonConstants = {}));
var RtdConstants;
(function (RtdConstants) {
    RtdConstants["RTD_PING_EVENT"] = "rtd-online-status";
})(RtdConstants || (RtdConstants = {}));
var LoginVoiceOptions;
(function (LoginVoiceOptions) {
    LoginVoiceOptions["AGENT_DN"] = "AGENT_DN";
    LoginVoiceOptions["EXTENSION"] = "EXTENSION";
    LoginVoiceOptions["BROWSER"] = "BROWSER";
})(LoginVoiceOptions || (LoginVoiceOptions = {}));
var MicrosoftServiceEvents;
(function (MicrosoftServiceEvents) {
    MicrosoftServiceEvents["RENEW_ACCESS_TOKEN_FAILURE"] = "RENEW_ACCESS_TOKEN_FAILURE";
})(MicrosoftServiceEvents || (MicrosoftServiceEvents = {}));
const IMAGE_BASE_URL = "/images/illustrations";
const APPLE_DARK_NORMAL = `${IMAGE_BASE_URL}/apple-messages-dark.svg`;
const APPLE_LIGNT_NORMAL = `${IMAGE_BASE_URL}/apple-messages-dark.svg`;
const GBM_DARK_COMMUNICATION = `${IMAGE_BASE_URL}/gbm-communication-status-dark.svg`;
const GBM_LIGHT_COMMUNICATION = `${IMAGE_BASE_URL}/gbm-communication-status-light.svg`;
const EMAIL_OUTBOUND_LIGHT_NORMAL = `${IMAGE_BASE_URL}/email-outgoing.svg`;
const EMAIL_OUTBOUND_DARK_NORMAL = `${IMAGE_BASE_URL}/email-outgoing-darkUI.svg`;
const EMAIL_OUTBOUND_LIGHT_COMMUNICATION = `${IMAGE_BASE_URL}/email-outgoing-communication.svg`;
const EMAIL_OUTBOUND_DARK_COMMUNICATION = `${IMAGE_BASE_URL}/email-outgoing-communication-darkUI.svg`;
const EMAIL_OUTBOUND_LIGHT_AIH = `${IMAGE_BASE_URL}/email-outgoing-aih-light.svg`;
const EMAIL_OUTBOUND_DARK_AIH = `${IMAGE_BASE_URL}/email-outgoing-aih-light.svg`;
const SMS_OUTBOUND_LIGHT_NORMAL = `${IMAGE_BASE_URL}/SMS-outgoing.svg`;
const SMS_OUTBOUND_DARK_NORMAL = `${IMAGE_BASE_URL}/SMS-outgoing-darkUI.svg`;
const SMS_OUTBOUND_LIGHT_COMMUNICATION = `${IMAGE_BASE_URL}/SMS-outgoing-communication.svg`;
const SMS_OUTBOUND_DARK_COMMUNICATION = `${IMAGE_BASE_URL}/SMS-outgoing-communication-darkUI.svg`;
const SMS_OUTBOUND_LIGHT_AIH = `${IMAGE_BASE_URL}/SMS-outgoing-aih-light.svg`;
const SMS_OUTBOUND_DARK_AIH = `${IMAGE_BASE_URL}/SMS-outgoing-aih-light.svg`;
const SMS_INBOUND_LIGHT_NORMAL = `${IMAGE_BASE_URL}/SMS-incoming.svg`;
const SMS_INBOUND_LIGHT_AIH = `${IMAGE_BASE_URL}/SMS-incoming-AIH.svg`;
const SMS_INBOUND_LIGHT_COMMUNICATION = `${IMAGE_BASE_URL}/SMS-incoming-communication.svg`;
const SMS_INBOUND_DARK_NORMAL = `${IMAGE_BASE_URL}/SMS-incoming-darkUI.svg`;
const SMS_INBOUND_DARK_AIH = `${IMAGE_BASE_URL}/SMS-incoming-AIH-darkUI.svg`;
const SMS_INBOUND_DARK_COMMUNICATION = `${IMAGE_BASE_URL}/SMS-incoming-communication-darkUI.svg`;
/*
  normal - When the task item is Active
  unselected - When the task item is inactive/ unselected
  aih - AIH Icon
  communication - Communication status icon used in the Accordion
  notification -  Chat Message Notification Icon
*/
const MEDIA_SUBCHANNEL_TYPES = {
    appleMessages: {
        normal: {
            dark: APPLE_DARK_NORMAL,
            light: APPLE_LIGNT_NORMAL
        },
        unselected: {
            dark: APPLE_DARK_NORMAL,
            light: APPLE_LIGNT_NORMAL
        },
        aih: {
            dark: `${IMAGE_BASE_URL}/apple-messages-aih-dark.svg`,
            light: `${IMAGE_BASE_URL}/apple-messages-aih-light.svg`
        },
        communication: {
            dark: `${IMAGE_BASE_URL}/apple-messages-communication-status-dark.svg`,
            light: `${IMAGE_BASE_URL}/apple-messages-communication-status-light.svg`
        },
        notification: {
            dark: APPLE_DARK_NORMAL,
            light: APPLE_LIGNT_NORMAL
        }
    },
    googleMessages: {
        normal: {
            dark: `${IMAGE_BASE_URL}/gbm-dark.svg`,
            light: `${IMAGE_BASE_URL}/gbm-light.svg`
        },
        unselected: {
            dark: `${IMAGE_BASE_URL}/gbm-nostroke-dark.svg`,
            light: `${IMAGE_BASE_URL}/gbm-nostroke-light.svg`
        },
        aih: {
            dark: `${IMAGE_BASE_URL}/gbm-aih-dark.svg`,
            light: `${IMAGE_BASE_URL}/gbm-aih-light.svg`
        },
        communication: {
            dark: GBM_DARK_COMMUNICATION,
            light: GBM_LIGHT_COMMUNICATION
        },
        notification: {
            dark: GBM_DARK_COMMUNICATION,
            light: GBM_LIGHT_COMMUNICATION
        }
    },
    outboundEmail: {
        normal: {
            dark: EMAIL_OUTBOUND_DARK_NORMAL,
            light: EMAIL_OUTBOUND_LIGHT_NORMAL
        },
        unselected: {
            dark: EMAIL_OUTBOUND_DARK_NORMAL,
            light: EMAIL_OUTBOUND_LIGHT_NORMAL
        },
        aih: {
            dark: EMAIL_OUTBOUND_DARK_AIH,
            light: EMAIL_OUTBOUND_LIGHT_AIH
        },
        communication: {
            dark: EMAIL_OUTBOUND_DARK_COMMUNICATION,
            light: EMAIL_OUTBOUND_LIGHT_COMMUNICATION
        },
        notification: {
            dark: EMAIL_OUTBOUND_DARK_NORMAL,
            light: EMAIL_OUTBOUND_LIGHT_NORMAL
        }
    },
    outboundSms: {
        normal: {
            dark: SMS_OUTBOUND_DARK_NORMAL,
            light: SMS_OUTBOUND_LIGHT_NORMAL
        },
        unselected: {
            dark: SMS_OUTBOUND_DARK_NORMAL,
            light: SMS_OUTBOUND_LIGHT_NORMAL
        },
        aih: {
            dark: SMS_OUTBOUND_DARK_AIH,
            light: SMS_OUTBOUND_LIGHT_AIH
        },
        communication: {
            dark: SMS_OUTBOUND_DARK_COMMUNICATION,
            light: SMS_OUTBOUND_LIGHT_COMMUNICATION
        },
        notification: {
            dark: SMS_OUTBOUND_DARK_NORMAL,
            light: SMS_OUTBOUND_LIGHT_NORMAL
        }
    },
    sms: {
        normal: {
            dark: SMS_INBOUND_DARK_NORMAL,
            light: SMS_INBOUND_LIGHT_NORMAL
        },
        unselected: {
            dark: SMS_INBOUND_DARK_NORMAL,
            light: SMS_INBOUND_LIGHT_NORMAL
        },
        aih: {
            dark: SMS_INBOUND_DARK_AIH,
            light: SMS_INBOUND_LIGHT_AIH
        },
        communication: {
            dark: SMS_INBOUND_DARK_COMMUNICATION,
            light: SMS_INBOUND_LIGHT_COMMUNICATION
        },
        notification: {
            dark: SMS_INBOUND_DARK_NORMAL,
            light: SMS_INBOUND_LIGHT_NORMAL
        }
    }
};
var DESTINATION_TYPE;
(function (DESTINATION_TYPE) {
    DESTINATION_TYPE["QUEUE"] = "queue";
    DESTINATION_TYPE["DIAL_NUMBER"] = "dialNumber";
    DESTINATION_TYPE["AGENT"] = "agent";
    DESTINATION_TYPE["EPDN"] = "entrypointDialNumber";
    DESTINATION_TYPE["ENTRY_POINT"] = "entryPoint";
})(DESTINATION_TYPE || (DESTINATION_TYPE = {}));
function constant() {
    return {
        AgentState,
        ContactDirection,
        WebexConstants,
        AcqueonConstants,
        RtdConstants,
        LoginVoiceOptions,
        MicrosoftServiceEvents,
        MEDIA_SUBCHANNEL_TYPES,
        DESTINATION_TYPE
    };
}
const KEY_PATH = "ACQUEON_API_URL,ACQUEON_CONSOLE_URL";
const DEFAULT_LOGIN_VOICE_OPTIONS = ["AGENT_DN", "EXTENSION"];
const LOGIN_VOICE_OPTIONS_FOR_ORDER = ["AGENT_DN", "EXTENSION", "BROWSER"];
const NON_PROD_WEBEX_URL = {
    U2C: "https://u2c-intb.ciscospark.com/u2c/api/v1",
    HYDRA: "https://hydra-intb.ciscospark.com/v1"
};
const WEB_CALLING = {
    INDICATOR_CALLING: "calling",
    INDICATOR_CONTACT_CENTER: "contactcenter",
    CALLING_REGISTER_EVENT: "registered",
    CALLING_ERROR: "error",
    CALLING_UN_REGISTERED: "unregistered",
    CALLING_INCOMING_EVENT: "line:incoming_call",
    CALL_DISCONNECT_EVENT: "disconnect",
    DTMF_TONE_CHANGED_EVENT: "dtmfTone:changed",
    CALL_REMOTE_MEDIA_UPDATE_EVENT: "remote_media",
    CALL_ESTABLISHED_EVENT: "established",
    AX_WC_NOT_FOUND: "ax-web-call-not-found",
    AX_WC_DEVICE_REGISTERED: "web-calling-device-registered",
    AX_WC_DEVICE_REGISTERING: "web-calling-device-registering",
    AX_WC_DEVICE_DISCONNECTED: "web-calling-device-disconnected",
    AX_WC_ESTABLISHED: "ax-web-call-established",
    AX_WC_REMOTE_MEDIA_UPDATE: "ax-web-call-remote-media-update",
    AX_WC_INCOMING: "ax-web-call-incoming"
};
const WEBEX_CALLING = {
    ANSWER_CALL_SUCCESS: "webex-calling-answer-call-success",
    ANSWER_CALL_FAILED: "webex-calling-answer-call-failed",
    REJECT_CALL_SUCCESS: "webex-calling-reject-call-success",
    REJECT_CALL_FAILED: "webex-calling-reject-call-failed",
    HANG_UP_CALL_SUCCESS: "webex-calling-hang-up-call-success",
    HANG_UP_CALL_FAILED: "webex-calling-hang-up-call-failed",
    RESUME_CALL_SUCCESS: "webex-calling-resume-call-success",
    RESUME_CALL_FAILED: "webex-calling-resume-call-failed",
    HOLD_CALL_SUCCESS: "webex-calling-hold-call-success",
    HOLD_CALL_FAILED: "webex-calling-hold-call-failed",
    MUTE_CALL_SUCCESS: "webex-calling-mute-call-success",
    MUTE_CALL_FAILED: "webex-calling-mute-call-failed",
    UNMUTE_CALL_SUCCESS: "webex-calling-unmute-call-success",
    UNMUTE_CALL_FAILED: "webex-calling-unmute-call-failed",
    TRANSMIT_DTMF_FAILED: "webex-calling-transmit-dtmf-failed",
    GET_CALL_DETAILS_FAILED: "webex-calling-get-call-details-failed",
    GET_PREFERRED_ANSWER_ENDPOINTS_FAILED: "webex-calling-get-preferred-answer-endpoints-failed",
    SET_PREFERRED_ANSWER_ENDPOINT_FAILED: "webex-calling-set-preferred-answer-endpoint-failed",
    GET_CONTACT_CENTER_EXTENSIONS_FAILED: "webex-calling-get-contact-center-extensions-failed"
};
const WEBEX_CALLING_MERC_SYNC = {
    MUTE_UNMUTE: "webex-calling-merc-sync-mute-unmute",
    HOLD_RESUME: "webex-calling-merc-sync-hold-resume"
};
const PRESENCE_MERCURY_REG = {
    AX_MERCURY_SUCCESSFUL: "presence-mercury-success",
    AX_MERCURY_FAILURE: "presence-mercury-failure",
    AX_MERCURY_RETRYING: "presence-mercury-retry"
};
const MICROSOFT_URLS = {
    FETCH_USERS: "users",
    FETCH_USERS_PRESENCE: "communications/getPresencesByUserId",
    BATCH_REQUEST: "$batch"
};
const RETRY_TIMEOUT = 1000;
const REVOKE_PRESENCE_TOKEN_FAILURE = "revoke-presence-token-failure";
const DEFAULT_CROSS_CLIENT_STATE_TTL = 15 * 60; // refresh the cross-client-state every 15 minutes
const APP_NAME = "wxcc";
const EXPIRATION_OFFSET = 30 * 1000; // refresh the cross-client-state 30 seconds before it expires
// For each ping to mercury, we expect to receive a pong within 15 seconds, so the max tolerable latency each way
// for the mercury connection (and therefore largest variation expected in time offset) is about 7.5 seconds
const MERCURY_TIME_OFFSET_THRESHOLD_MS = 7500;
const uuipEol = "<uuip-eol>";
const CACHE_CONTROL_HEADER = "no-cache, no-store, must-revalidate";
const HTTP_HEADERS = {
    "Content-Type": "application/json",
    "Cache-Control": CACHE_CONTROL_HEADER
};


/***/ }),

/***/ "./src/services/emm/emm-service.ts":
/*!*****************************************!*\
  !*** ./src/services/emm/emm-service.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   emmService: () => (/* binding */ emmService)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");




function emmService() {
    const http = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_2__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_1__.CONF.EMM_HOST);
    const fetchContentErrId = "Service.emm.fetchContent";
    return {
        fetchContent: http.req((p) => ({
            url: `/organization/${p.orgId}/task/${p.taskId}/emailcontent`,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: fetchContentErrId,
            res: {}
        })),
        fetchEmailContentFromEmm: http.req((url) => ({
            url: `/${url.substring(url.indexOf("organization"))}`,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: fetchContentErrId,
            res: {}
        })),
        fetchReplyTemplate: http.req((p) => ({
            url: `/organization/${p.orgId}/emailtemplate`,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: "Service.emm.fetchReplyContent",
            res: {}
        })),
        downloadAttachment: http.req((p) => ({
            url: `/${p.resourceUrl.substring(p.resourceUrl.indexOf("organization"))}`,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: "Service.emm.downloadAttachment",
            responseType: "arraybuffer",
            res: {}
        })),
        addAttachment: http.req((p) => ({
            url: `/organization/${p.orgId}/task/${p.taskId}/blob`,
            headers: { "Content-Type": `multipart/form-data; boundary=` },
            data: p.data,
            err: (e) => new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details("Service.emm.addAttachment", { axiosError: e.response }),
            res: {}
        })),
        deleteAttachment: http.req((p) => ({
            url: `/${p.resourceUrl.substring(p.resourceUrl.indexOf("organization"))}`,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            method: "DELETE",
            errId: "Service.emm.deleteAttachment",
            res: {}
        })),
        sendEmail: http.req((p) => ({
            url: `/organization/${p.orgId}/task/${p.taskId}/sendemail`,
            data: p.data,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: "Service.emm.sendEmail",
            res: {}
        }))
    };
}


/***/ }),

/***/ "./src/services/featureFlag/feature-flag-service.ts":
/*!**********************************************************!*\
  !*** ./src/services/featureFlag/feature-flag-service.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FeatureFlagService: () => (/* binding */ FeatureFlagService)
/* harmony export */ });
/* harmony import */ var _splitsoftware_splitio__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @splitsoftware/splitio */ "@splitsoftware/splitio");
/* harmony import */ var _splitsoftware_splitio__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_splitsoftware_splitio__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _feature_flag_names__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../feature-flag-names */ "./src/feature-flag-names.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



const FEATURE_ON = "on";
const SECONDS_30 = 30;
class FeatureFlagService {
    constructor() {
        this.callDropSummaryEnabled = false;
        this.virtualAgentSummaryEnabled = false;
        this.wellnessBreakConfigEnabled = false;
        this.realTimeTranscriptionConfigEnabled = false;
    }
    initSplitioSdk(orgId, authorizationKey = "") {
        return __awaiter(this, void 0, void 0, function* () {
            if (authorizationKey) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("Fetched SplitIO Key Successfully");
            }
            else {
                _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("SplitIO Key Fetch failed");
            }
            this.orgId = orgId;
            this.splitio = (0,_splitsoftware_splitio__WEBPACK_IMPORTED_MODULE_0__.SplitFactory)({
                core: {
                    authorizationKey,
                    key: orgId
                },
                scheduler: {
                    telemetryRefreshRate: SECONDS_30,
                    impressionsRefreshRate: SECONDS_30,
                    eventsPushRate: SECONDS_30,
                    featuresRefreshRate: SECONDS_30
                },
                sync: {
                    splitFilters: [
                        {
                            type: "byName",
                            values: Object.values(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS)
                        }
                    ]
                }
            });
            this.splitClient = this.splitio.client();
            return new Promise((resolve, reject) => {
                this.splitClient &&
                    this.splitClient.on(this.splitClient.Event.SDK_READY, () => {
                        _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[FeatureFlagService] Split IO SDK is ready");
                        localStorage.setItem(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.OBSERVE_PERFORMANCE_ENABLED, this.isFeatureFlagEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.OBSERVE_PERFORMANCE_ENABLED) ? "true" : "false");
                        return resolve(this.splitClient);
                    });
                this.splitClient &&
                    this.splitClient.on(this.splitClient.Event.SDK_READY_TIMED_OUT, () => {
                        _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error("[FeatureFlagService] Split IO Failed");
                        return reject(this.splitClient);
                    });
            });
        });
    }
    isVideoEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.CARE_VIDEO_ESCALATE, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.CARE_VIDEO_ESCALATE));
    }
    isCareAttachmentEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.CARE_ATTACHMENT, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.CARE_ATTACHMENT));
    }
    isDigitalFFEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WCC_DIGITAL_V3, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WCC_DIGITAL_V3));
    }
    isPCIComplianceEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WCC_PCI_COMPLIANCE, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WCC_PCI_COMPLIANCE));
    }
    isDesktopReasonCodeEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_REASON_CODE, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_REASON_CODE));
    }
    isIMIChatEnabled() {
        const treatment = this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.IMI_CHAT_WIDGET);
        /* eslint no-console: */
        console.log(`${_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.IMI_CHAT_WIDGET} feature flag is : ${treatment}`);
        /**
         * `treatment` can be one of: NATIVE / IMI / MIXED_MODE
         * IMI FF will be treated as false only when `treatment` is NATIVE
         */
        return ["IMI", "MIXED_MODE"].includes(treatment);
    }
    isSteeringDigitsAppendEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.STEERING_DIGITS_APPEND, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.STEERING_DIGITS_APPEND));
    }
    isTahoeEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_TAHOE_ENABLED, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_TAHOE_ENABLED));
    }
    isCJDSEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_CJDS_ENABLED, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_CJDS_ENABLED));
    }
    isSecureCADVariablesEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.SECURE_VARIABLES_ENABLED, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.SECURE_VARIABLES_ENABLED));
    }
    isFeatureEnabled(flag, treatment) {
        return treatment === FEATURE_ON;
    }
    isDesktopConsumeWelcomeEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_CONSUME_WELCOME, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_CONSUME_WELCOME));
    }
    isCanaryOrg() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.CANARY_ORG, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.CANARY_ORG));
    }
    isLogRocketEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_LOGROCKET, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_LOGROCKET));
    }
    isLogRocketMaskingDisabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_LOGROCKET_DISABLE_TEXT_MASKING, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_LOGROCKET_DISABLE_TEXT_MASKING));
    }
    isIMIGlobalVariablesEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.IMI_GLOBAL_VARIABLES, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.IMI_GLOBAL_VARIABLES));
    }
    isGlobalVariablesEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.GLOBAL_VARIABLES, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.GLOBAL_VARIABLES));
    }
    isDesktopConsultToEntryPointDnEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_CONSULT_TO_ENTRY_POINT_DN, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_CONSULT_TO_ENTRY_POINT_DN));
    }
    isDesktopMaxSessionLimitsEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_MAX_SESSION_LIMITS, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_MAX_SESSION_LIMITS));
    }
    isCallbackRetryEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_CALLBACK_RETRY, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_CALLBACK_RETRY));
    }
    isWebRTCEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_WEBRTC, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_WEBRTC));
    }
    isDesktopManagedFilterInfScrollingEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.MANAGED_FILTER_INFINITE_SCROLLING, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.MANAGED_FILTER_INFINITE_SCROLLING));
    }
    isWebRTCSupervisorEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_SUPERVISOR_WEBRTC, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_SUPERVISOR_WEBRTC));
    }
    isProgressiveCampaignEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.PROGRESSIVE_CAMPAIGN, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.PROGRESSIVE_CAMPAIGN));
    }
    isProgressiveCampaign1NEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_PROGRESSIVE_CAMPAIGN_N, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_PROGRESSIVE_CAMPAIGN_N));
    }
    isSignoutBySupervisorEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_SIGNOUT_BY_SUPERVISOR, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_SIGNOUT_BY_SUPERVISOR));
    }
    isDesktopMaerskEnhancementEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_MAERSK_ENHANCEMENT, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_MAERSK_ENHANCEMENT));
    }
    isESDPostInteractionInsightsEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.ESD_POST_INTERACTION_INSIGHTS, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.ESD_POST_INTERACTION_INSIGHTS));
    }
    isDesktopMaerskAcqueonTeamId() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_MAERSK_ENHANCEMENT_ACQUEON, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_MAERSK_ENHANCEMENT_ACQUEON));
    }
    isDesktopCpdViewEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_DESKTOP_VIEW_IN_CPD, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_DESKTOP_VIEW_IN_CPD));
    }
    isAddressBookInfiniteScrollEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.ADDRESSBOOK_INFINITE_SCROLL, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.ADDRESSBOOK_INFINITE_SCROLL));
    }
    isSDKCallingInfoLevelLogsEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.SDK_CALLING_INFO_LEVEL_LOGS, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.SDK_CALLING_INFO_LEVEL_LOGS));
    }
    isDesktopMSStateSyncEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_MSFT_STATE_SYNC, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_MSFT_STATE_SYNC));
    }
    isDesktopAuxCodesInfiniteScrollEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_AUX_CODES_INFINITE_SCROLL, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_AUX_CODES_INFINITE_SCROLL));
    }
    isDesktopWebexStateSyncEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_WEBEX_STATE_SYNC, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_WEBEX_STATE_SYNC));
    }
    isDesktopEmergencyNotificationEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_EMERGENCY_NOTIFICATION, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_EMERGENCY_NOTIFICATION));
    }
    isWebrtcRingingEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WEBRTC_RINGING, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WEBRTC_RINGING));
    }
    isWebrtcEndCallEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WEBRTC_ENDCALL, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WEBRTC_ENDCALL));
    }
    isRecordingsRicherMetadataEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.RECORDINGS_DISPLAY_RICHER_METADATA, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.RECORDINGS_DISPLAY_RICHER_METADATA));
    }
    isWxccMultiPartyConfEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_MULTI_PARTY_CONF, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_MULTI_PARTY_CONF));
    }
    isDesktopConferenceRecordingEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_ENABLE_CONF_RECORDING, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_ENABLE_CONF_RECORDING));
    }
    isWxccPersistCallEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_PERSIST_CALL, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_PERSIST_CALL));
    }
    updateRealTimeTranscriptEnablement(isRealTimeTranscriptionEnabled) {
        this.realTimeTranscriptionConfigEnabled = isRealTimeTranscriptionEnabled;
    }
    updateAiFeatureFlags(isCallDropSummaryEnabled, isVirtualAgentSummaryEnabled, isWellnessBreakEnabled) {
        this.callDropSummaryEnabled = isCallDropSummaryEnabled;
        this.virtualAgentSummaryEnabled = isVirtualAgentSummaryEnabled;
        this.wellnessBreakConfigEnabled = isWellnessBreakEnabled;
    }
    isAiAssistantEnabled() {
        return this.callDropSummaryEnabled || this.virtualAgentSummaryEnabled || this.isWellnessBreakClientEnabled();
    }
    isCallDropSummaryEnabled() {
        return this.callDropSummaryEnabled;
    }
    isVirtualAgentSummaryEnabled() {
        return this.virtualAgentSummaryEnabled;
    }
    isWellnessBreakClientEnabled() {
        return (this.wellnessBreakConfigEnabled &&
            this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.CXAI_WELLNESS_BREAK_CLIENT, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.CXAI_WELLNESS_BREAK_CLIENT)));
    }
    isQMWShowConsultRecordingsEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.QMW_SHOW_CONSULT_RECORDINGS, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.QMW_SHOW_CONSULT_RECORDINGS));
    }
    showSignedOutAgents() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.SHOW_SIGNED_OUT_AGENTS, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.SHOW_SIGNED_OUT_AGENTS));
    }
    isAutoCSATEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.AUTO_CSAT, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.AUTO_CSAT));
    }
    isWxccAllowOutdialCallAlwaysEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_ALLOW_OUTDIAL_CALL_ALWAYS, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_ALLOW_OUTDIAL_CALL_ALWAYS));
    }
    isAgentPerformanceTabEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.IS_AGENT_PERFORMANCE_TAB_ENABLED, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.IS_AGENT_PERFORMANCE_TAB_ENABLED));
    }
    isQueueStatsTabEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_WXCC_QUEUE_STATS_TAB, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_WXCC_QUEUE_STATS_TAB));
    }
    isQueueStatsDetailViewEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_WXCC_QUEUE_STATS_DETAIL_VIEW, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_WXCC_QUEUE_STATS_DETAIL_VIEW));
    }
    isInteractionsPageEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_WXCC_INTERACTIONS_PAGE, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_WXCC_INTERACTIONS_PAGE));
    }
    isWebexDirectoryViewEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_WEBEX_DIRECTORY_VIEW, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_WEBEX_DIRECTORY_VIEW));
    }
    isMaskSensitiveDataFFEnabled() {
        var _a;
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_MASK_SENSITIVE_DATA, (_a = this.splitClient) === null || _a === void 0 ? void 0 : _a.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_MASK_SENSITIVE_DATA));
    }
    isAllowConfTransferToEpDnEnabled() {
        var _a;
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.ALLOW_CONF_TRANSFER_TO_EPDN, (_a = this.splitClient) === null || _a === void 0 ? void 0 : _a.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.ALLOW_CONF_TRANSFER_TO_EPDN));
    }
    isOutdialOrgSearchEnabled() {
        var _a;
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_OUTDIAL_ORG_SEARCH, (_a = this.splitClient) === null || _a === void 0 ? void 0 : _a.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_OUTDIAL_ORG_SEARCH));
    }
    isConfirmDialogEnabled() {
        var _a;
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_CONFIRM_END_EXIT_CONF, (_a = this.splitClient) === null || _a === void 0 ? void 0 : _a.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_CONFIRM_END_EXIT_CONF));
    }
    isUsingReachableEndpoint() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.USE_REACHABLE_ENDPOINT, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.USE_REACHABLE_ENDPOINT));
    }
    isJssdkMisuseMetricsEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.USE_REACHABLE_ENDPOINT, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.JSSDK_MISUSE_METRICS));
    }
    isAiAssistantV2Enabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.AI_ASSISTANT_V2, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.AI_ASSISTANT_V2));
    }
    isWxccPostCallEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_POST_CALL, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_POST_CALL));
    }
    isRecordingTranscriptionEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.RECORDING_TRANSCRIPTION, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.RECORDING_TRANSCRIPTION));
    }
    isWxccDesktopQMEvaluationsEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_DESKTOP_QM_EVALUATIONS, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_DESKTOP_QM_EVALUATIONS));
    }
    isRealTimeTranscriptionEnabled() {
        return (this.realTimeTranscriptionConfigEnabled &&
            this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.REAL_TIME_TRANSCRIPTION_CLIENT, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.REAL_TIME_TRANSCRIPTION_CLIENT)));
    }
    isWxccRonaEnhancementsEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_RONA_ENHANCEMENTS, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_RONA_ENHANCEMENTS));
    }
    isTaskListV2Enabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_TASK_LIST_V2, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_TASK_LIST_V2));
    }
    isDigitalChannelCherryPickEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_DIGITAL_INTERACTIONS_CHERRY_PICK, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_DIGITAL_INTERACTIONS_CHERRY_PICK));
    }
    isTaskListOnlyVisibleOnTabEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_TASK_LIST_ONLY_VISIBLE_ON_TAB, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_TASK_LIST_ONLY_VISIBLE_ON_TAB));
    }
    isInteractionsViewActionsColumnEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_ENABLE_INTERACTIONS_VIEW_ACTIONS_COLUMN, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.DESKTOP_ENABLE_INTERACTIONS_VIEW_ACTIONS_COLUMN));
    }
    isWxccScheduledCallBackEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_SCHEDULED_CALLBACK, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.WXCC_SCHEDULED_CALLBACK));
    }
    isWxccAgentStatisticsByQueueEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.AGENT_STATISTICS_BY_QUEUE, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.AGENT_STATISTICS_BY_QUEUE));
    }
    isAgentBasedQueueManagementEnabled() {
        return this.isFeatureEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.AGENT_BASED_QUEUE_MANAGEMENT, this.splitClient.getTreatment(_feature_flag_names__WEBPACK_IMPORTED_MODULE_2__.FEATURE_FLAGS.AGENT_BASED_QUEUE_MANAGEMENT));
    }
    /**
     * Check if the feature flag is enabled
     * @param featureFlag The name of the feature flag
     * @returns true if the feature flag is enabled, false otherwise
     */
    isFeatureFlagEnabled(featureFlag) {
        return this.isFeatureEnabled(featureFlag, this.splitClient.getTreatment(featureFlag, { hostname: window.location.host }));
    }
}


/***/ }),

/***/ "./src/services/i18n/i18n-default-init-options.ts":
/*!********************************************************!*\
  !*** ./src/services/i18n/i18n-default-init-options.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I18N_DEFAULT_INIT_OPTIONS: () => (/* binding */ I18N_DEFAULT_INIT_OPTIONS)
/* harmony export */ });
//'cimode' the output text will be the key. (for testing)
const lng =  true ? undefined : 0;
const I18N_DEFAULT_INIT_OPTIONS = {
    debug: false,
    defaultNS: "app",
    ns: ["app", "react"],
    fallbackLng: "en",
    backend: {
        loadPath: "/i18n/{{lng}}/{{ns}}.json"
    },
    detection: {
        order: ["navigator", "cookie", "queryString", "localStorage", "sessionStorage", "htmlTag", "path", "subdomain"],
        lookupQuerystring: "lng",
        lookupCookie: "lng",
        lookupLocalStorage: "lng",
        lookupSessionStorage: "lng",
        lookupFromPathIndex: 0,
        lookupFromSubdomainIndex: 0
    },
    lng
};


/***/ }),

/***/ "./src/services/i18n/i18n-service.ts":
/*!*******************************************!*\
  !*** ./src/services/i18n/i18n-service.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i18nService: () => (/* binding */ i18nService)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _i18n_default_init_options__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./i18n-default-init-options */ "./src/services/i18n/i18n-default-init-options.ts");



function i18nService() {
    const i18n = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.I18N.createService({ logger: _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger });
    return Object.assign(i18n, {
        get DEFAULT_INIT_OPTIONS() {
            return JSON.parse(JSON.stringify(_i18n_default_init_options__WEBPACK_IMPORTED_MODULE_2__.I18N_DEFAULT_INIT_OPTIONS));
        }
    });
}


/***/ }),

/***/ "./src/services/integration/microsoft/microsoft-authentication.ts":
/*!************************************************************************!*\
  !*** ./src/services/integration/microsoft/microsoft-authentication.ts ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MicrosoftService: () => (/* binding */ MicrosoftService)
/* harmony export */ });
/* harmony import */ var _microsoft_microsoft_graph_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @microsoft/microsoft-graph-client */ "@microsoft/microsoft-graph-client");
/* harmony import */ var _microsoft_microsoft_graph_client__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_microsoft_microsoft_graph_client__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../index */ "./src/index.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../constant */ "./src/services/constant.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _microsoft_oauth_handler__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./microsoft-oauth-handler */ "./src/services/integration/microsoft/microsoft-oauth-handler.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./utils */ "./src/services/integration/microsoft/utils.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










class MicrosoftService extends _microsoft_oauth_handler__WEBPACK_IMPORTED_MODULE_8__.MicrosoftAuthCodeHandler {
    constructor(accessToken) {
        super();
        this.accessToken = "";
        this.activeUserId = null; // Active Microsoft Account User ID.
        this.scope = "https://graph.microsoft.com/.default offline_access openid profile";
        this.clientId = "";
        this.tenantId = "";
        this.msftPresenceServiceUrl = "";
        this.jabberService = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_3__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_2__.CONF.JABBER_HOST_URL, true);
        this.http = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_3__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_2__.CONF.U2C_SERVICE_URL, true);
        this.graphClient = null;
        this.tokenResponse = undefined;
        this.authProviderCallback = (done) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const tokenForGraphClient = (_a = this.getToken()) === null || _a === void 0 ? void 0 : _a.access_token;
            //If token is valid and is present in the sessionStorage
            if (this.isTokenValid() && tokenForGraphClient) {
                done(null, tokenForGraphClient);
            }
            else {
                //Token not valid or not present in sessionStorage, we will call the renewAccessToken function.
                _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("[GraphClientService]: Token is expired or not valid, Invoking renew token service");
                try {
                    const currentRefreshToken = (_b = this.getToken()) === null || _b === void 0 ? void 0 : _b.refresh_token;
                    if (currentRefreshToken) {
                        const response = yield this.renewAccessTokenSilently(currentRefreshToken);
                        done(null, response.access_token);
                    }
                    else {
                        throw new Error("Refresh Token is not found in session Storage");
                    }
                }
                catch (e) {
                    //If renewAccessToken fails then do SSO silent login
                    _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info(`[GraphClientService]: Renewing access token is failed ${e === null || e === void 0 ? void 0 : e.message}. Invoking SSO silent`);
                    try {
                        const response = yield this.ssoSilent();
                        done(null, response.access_token);
                    }
                    catch (_c) {
                        _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error(`[GraphClientService]: Encountered an error during token retrieval. Graph client authentication is failed`);
                        this.onMessageSend({ eventType: _constant__WEBPACK_IMPORTED_MODULE_6__.MicrosoftServiceEvents.RENEW_ACCESS_TOKEN_FAILURE });
                        done("Error to retrieve access token", null);
                    }
                }
            }
        });
        this.fetchMicrosoftPressenceAPIURL = this.http.req((p) => ({
            url: `/org/${p === null || p === void 0 ? void 0 : p.orgId}/catalog?services=msft-presence-service&format=serviceList`,
            headers: {},
            method: "GET",
            err: _service_utils__WEBPACK_IMPORTED_MODULE_7__.createErrDetailsObject,
            res: {}
        }));
        this.getEventInstance = () => {
            return this.onMessage;
        };
        this.accessToken = accessToken;
        const { send, signal } = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.Signal.create.withData();
        this.onMessage = signal;
        this.onMessageSend = send;
    }
    initialize(clientId, tenantId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.clientId = clientId;
            this.tenantId = tenantId;
            this.initializeOAuthService(this.clientId, this.tenantId);
            _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("[MicrosoftService]: Initializing Microsoft Auth Service SUCCESS");
            return this.isInitialized;
        });
    }
    loginPopup() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.getPopUpActiveStatus()) {
                    // MSLogin pop up window is already opened.
                    throw new Error("[MicrosoftService] : Login Popup Interaction in progress");
                }
                else {
                    const redirectUri = this.getLoginRedirectURL();
                    const codeValue = yield this.invokeLoginPopUp({ redirectUri, scope: this.scope });
                    // Fetch accessToken using Jabber Service API.
                    const allowRetry = true;
                    const payload = { tenantId: this.tenantId, code: codeValue };
                    const response = yield this.fetchExchangeToken(payload, allowRetry);
                    this.setToken(response);
                    return response;
                }
            }
            catch (error) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error("[MicrosoftService]: Error on loginPopup ", error === null || error === void 0 ? void 0 : error.message);
                throw error;
            }
        });
    }
    logoutPopup() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const redirectUri = this.getLogoutRedirectURL();
                yield this.invokeLogout({ redirectUri });
            }
            catch (error) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error("[MicrosoftService]: Error on logoutPopup ", error);
                throw error;
            }
        });
    }
    ssoSilent() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const redirectUri = this.getLoginRedirectURL();
                const codeValue = yield this.invokeSilentSSOLogin({ redirectUri, scope: this.scope });
                // Fetch accessToken using Jabber Service API.
                const allowRetry = true;
                const payload = { tenantId: this.tenantId, code: codeValue };
                const response = yield this.fetchExchangeToken(payload, allowRetry);
                this.setToken(response);
                return response;
            }
            catch (error) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error("[MicrosoftService]: Error on ssoSilent ", error === null || error === void 0 ? void 0 : error.message);
                throw error;
            }
        });
    }
    isTokenValid(accessTokenExpiryTime) {
        var _a, _b;
        const expiryTime = (_b = accessTokenExpiryTime !== null && accessTokenExpiryTime !== void 0 ? accessTokenExpiryTime : (_a = this.getToken()) === null || _a === void 0 ? void 0 : _a.accessTokenExpiryTime) !== null && _b !== void 0 ? _b : false;
        if (expiryTime) {
            return new Date().getTime() < Number(expiryTime);
        }
        return false;
    }
    getTokenFromCache() {
        const tokenResponse = sessionStorage.getItem(_utils__WEBPACK_IMPORTED_MODULE_9__.MSFT_TOKEN);
        if (tokenResponse && tokenResponse !== "") {
            // Parse the Token response from the session storage.
            try {
                return JSON.parse(tokenResponse);
            }
            catch (_a) {
                return null;
            }
        }
        else {
            return null;
        }
    }
    renewAccessTokenSilently(refreshToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const payload = { tenantId: this.tenantId, refreshToken };
                const allowRetry = true;
                const response = yield this.renewAccessToken(payload, allowRetry);
                this.setToken(response); // Save the new Token set in the Microsoft Authentication Instance.
                return response;
            }
            catch (_a) {
                throw new Error("Renew Access Token API has experienced an operational failure, Acquire Token Silent is Failed");
            }
        });
    }
    acquireTokenSilent() {
        return __awaiter(this, void 0, void 0, function* () {
            const tokenCache = this.getTokenFromCache();
            if (!tokenCache) {
                throw new Error("Token not found in Cache");
            }
            if (this.isTokenValid(tokenCache.accessTokenExpiryTime)) {
                // In cache, Valid token is available.
                // Save the valid token set in the Microsoft Authentication Instance.
                this.setToken(tokenCache);
                return tokenCache;
            }
            else {
                // Token values are present in cache, But access token is expired, Using the renew token from cache to get new access token.
                // Refresh tokens have a longer lifetime than access tokens. The default lifetime for the refresh tokens is 24 hours for single page apps and 90 days for all other scenarios.
                // [REFER: https://learn.microsoft.com/en-us/entra/identity-platform/refresh-tokens]
                // Invoke Jabber Service API for get new access token.
                return this.renewAccessTokenSilently(tokenCache.refresh_token);
            }
        });
    }
    /**
     *
     * @param value - JWT Token
     * @returns null
     */
    setActiveUserId(value) {
        var _a;
        try {
            const profileInfo = (0,_utils__WEBPACK_IMPORTED_MODULE_9__.decodeJwt)(value);
            if (profileInfo && profileInfo.payload) {
                const { oid } = profileInfo.payload;
                // The Object ID, often referred to as "oid," is a unique identifier assigned to each user in Azure Active Directory (Azure AD).
                this.activeUserId = oid !== null && oid !== void 0 ? oid : null;
                this.setUserInfo((_a = profileInfo.payload) !== null && _a !== void 0 ? _a : {});
            }
        }
        catch (_b) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error("[MicrosoftService]: Error on updating the active user id from microsoft profile: id_token");
        }
    }
    /**
     * Set the microsoft Signed-In user informations to the session storage.
     */
    setUserInfo(userInfo) {
        var _a;
        _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("[MicrosoftService]: Microsoft authenticated user identity provider information:", userInfo);
        _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("[MicrosoftService]: Microsoft User ID:", (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.oid) !== null && _a !== void 0 ? _a : "");
        sessionStorage.setItem(_utils__WEBPACK_IMPORTED_MODULE_9__.MSFT_USER_INFO, JSON.stringify(userInfo));
    }
    /**
     * Remove the microsoft Signed-In user informations to the session storage.
     */
    removeUserInfo() {
        sessionStorage.removeItem(_utils__WEBPACK_IMPORTED_MODULE_9__.MSFT_USER_INFO);
        _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info(`[MicrosoftService]: ${_utils__WEBPACK_IMPORTED_MODULE_9__.MSFT_USER_INFO} is successfully removed from session storage`);
    }
    /**
     * Set the microsoft token to the session storage and OAuth Class.
     * While setting the token, expiry time will be calculated and stored in the session storage.
     */
    setToken(tokenResponse) {
        return __awaiter(this, void 0, void 0, function* () {
            let accessTokenExpiryTime = "";
            if (tokenResponse.accessTokenExpiryTime) {
                accessTokenExpiryTime = tokenResponse.accessTokenExpiryTime;
            }
            else {
                const tokenExpiredAfterInMilliSeconds = parseInt(tokenResponse.expires_in, 10) * 1000; // 60 mins
                const tokenExpirationSkewInMilliSeconds = 10 * 60 * 1000; // 10 mins
                // Cisco Jabber Service will not return the token expiry time in seconds.
                // According the Microsoft Documentation, the token expiry time will be in 60 minutes.
                accessTokenExpiryTime = (new Date().getTime() +
                    tokenExpiredAfterInMilliSeconds -
                    tokenExpirationSkewInMilliSeconds).toString();
            }
            _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("[MicrosoftService]: Updating the Microsoft Token to sessionStorage.");
            this.tokenResponse = Object.assign(Object.assign({}, tokenResponse), { accessTokenExpiryTime });
            sessionStorage.setItem(_utils__WEBPACK_IMPORTED_MODULE_9__.MSFT_TOKEN, JSON.stringify(this.tokenResponse));
            // Update the LoggedIn User Id.
            if (this.tokenResponse.id_token) {
                // The id_token is a JSON Web Token (JWT) that is included in the response when a user authenticates with an identity provider, such as Azure Active Directory (Azure AD).
                // This token contains information about the authenticated user and is typically used for identity-related tasks in authentication and authorization processes.
                this.setActiveUserId(this.tokenResponse.id_token);
            }
            else {
                _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error("[MicrosoftService]: Error retrieving the `id_token` from Jabber Service containing microsoft authenticated user information like user id and email address");
            }
        });
    }
    /**
     * Return the token stored in the OAuth Instance.
     */
    getToken() {
        return this.tokenResponse;
    }
    executeApiToFetchExchangeToken(tenantId, code) {
        return __awaiter(this, void 0, void 0, function* () {
            const postExchangeTokenApi = this.jabberService.req((p) => {
                const requestData = new URLSearchParams();
                requestData.append("tenant", p === null || p === void 0 ? void 0 : p.tenantId);
                requestData.append("code", p === null || p === void 0 ? void 0 : p.code);
                requestData.append("userObjectId", "");
                requestData.append("client_id", _config__WEBPACK_IMPORTED_MODULE_2__.CONF.MICROSOFT_CLIENT_ID);
                requestData.append("redirect_uri", _config__WEBPACK_IMPORTED_MODULE_2__.CONF.HOST_URL);
                requestData.append("scope", this.scope);
                return {
                    url: `/jabber-integration/api/v1/msteams/token`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Origin: _config__WEBPACK_IMPORTED_MODULE_2__.CONF.HOST_URL
                    },
                    data: requestData.toString(),
                    method: "POST",
                    err: _service_utils__WEBPACK_IMPORTED_MODULE_7__.handleExternalServiceErrorDetails,
                    res: {}
                };
            });
            return postExchangeTokenApi({
                tenantId,
                code
            });
        });
    }
    fetchExchangeToken(payload, allowRetry) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.executeApiToFetchExchangeToken(payload.tenantId, payload.code);
            }
            catch (e) {
                // Retrying on failure
                const error = e;
                if (allowRetry && (error === null || error === void 0 ? void 0 : error.details) && ((_a = error.details) === null || _a === void 0 ? void 0 : _a.status) === 429) {
                    // Retry on too many requests
                    yield (0,_service_utils__WEBPACK_IMPORTED_MODULE_7__.sleep)(_service_utils__WEBPACK_IMPORTED_MODULE_7__.RETRY_INTERVAL);
                    _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info(`[MicrosoftService]: Rate Limit exceeded. Retrying endpoint: "api/v1/msteams/token" after ${_service_utils__WEBPACK_IMPORTED_MODULE_7__.RETRY_INTERVAL} seconds`);
                    allowRetry = false; // Sending allowRetry as FALSE as we want to retry only once.
                    return this.fetchExchangeToken(payload, allowRetry);
                }
                else {
                    _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error("[MicrosoftService]: Error on exhangeToken ", (_c = (_b = error === null || error === void 0 ? void 0 : error.details) === null || _b === void 0 ? void 0 : _b.msg) === null || _c === void 0 ? void 0 : _c.message);
                    throw new Error(`${(_f = (_e = (_d = error === null || error === void 0 ? void 0 : error.details) === null || _d === void 0 ? void 0 : _d.msg) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : "Error on retrieving token from exhangeToken Jabber Service"}`);
                }
            }
        });
    }
    initiateMicrosoftLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.acquireTokenSilent();
                _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("[MicrosoftService]: acquireTokenSilent success");
                return response;
            }
            catch (silentError) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("[MicrosoftService]: acquireTokenSilent is Failed.", silentError === null || silentError === void 0 ? void 0 : silentError.message);
                return this.handleSilentError();
            }
        });
    }
    handleSilentError() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.ssoSilent();
                _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("[MicrosoftService]: ssoSilent success");
                return response;
            }
            catch (ssoError) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("[MicrosoftService]: ssoSilent Failed.", ssoError === null || ssoError === void 0 ? void 0 : ssoError.message);
                return this.handleSsoError();
            }
        });
    }
    handleSsoError() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.loginPopup();
                _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("[MicrosoftService]: loginPopup success");
                return response;
            }
            catch (popupError) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error("[MicrosoftService]: loginPopup Failed:", popupError === null || popupError === void 0 ? void 0 : popupError.message);
                throw popupError;
            }
        });
    }
    getLoginRedirectURL() {
        return _config__WEBPACK_IMPORTED_MODULE_2__.CONF.HOST_URL.replace(/\/$/, ""); // Remove Trailing slash from the host url;
    }
    getLogoutRedirectURL() {
        const APPLICATION_HOST = _config__WEBPACK_IMPORTED_MODULE_2__.CONF.HOST_URL.replace(/\/$/, ""); // Remove Trailing slash from the host url
        return `${APPLICATION_HOST}`;
    }
    executeApiToFetchRenewToken(tenantId, refreshToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const postRenewTokenApi = this.jabberService.req((p) => {
                const requestData = new URLSearchParams();
                requestData.append("tenant", p.tenantId);
                requestData.append("refresh_token", p.refreshToken);
                requestData.append("userObjectId", "");
                requestData.append("client_id", _config__WEBPACK_IMPORTED_MODULE_2__.CONF.MICROSOFT_CLIENT_ID);
                requestData.append("redirect_uri", _config__WEBPACK_IMPORTED_MODULE_2__.CONF.HOST_URL);
                requestData.append("scope", this.scope);
                return {
                    url: `/jabber-integration/api/v1/msteams/token`,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Origin: _config__WEBPACK_IMPORTED_MODULE_2__.CONF.HOST_URL
                    },
                    data: requestData.toString(),
                    method: "POST",
                    err: _service_utils__WEBPACK_IMPORTED_MODULE_7__.handleExternalServiceErrorDetails,
                    res: {}
                };
            });
            return postRenewTokenApi({
                tenantId,
                refreshToken
            });
        });
    }
    /**
     *
     * @param allowRetry - if true, retry the request after 200 ms
     * @returns
     */
    renewAccessToken(payload, allowRetry) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // Fetch renewToken using Jabber Service API.
                return yield this.executeApiToFetchRenewToken(payload.tenantId, payload.refreshToken);
            }
            catch (e) {
                const error = e;
                if (allowRetry && (error === null || error === void 0 ? void 0 : error.details) && ((_a = error.details) === null || _a === void 0 ? void 0 : _a.status) === 429) {
                    // Too many requests
                    yield (0,_service_utils__WEBPACK_IMPORTED_MODULE_7__.sleep)(_service_utils__WEBPACK_IMPORTED_MODULE_7__.RETRY_INTERVAL);
                    _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info(`[MicrosoftService]: Rate Limit exceeded. Retrying endpoint: "api/v1/msteams/token" after ${_service_utils__WEBPACK_IMPORTED_MODULE_7__.RETRY_INTERVAL} seconds`);
                    const retry = false; // Sending allowRetry as FALSE as we want to retry only once.
                    return this.renewAccessToken(payload, retry);
                }
                else {
                    _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error("[MicrosoftService]: Error on renewAccessToken ", (_c = (_b = error === null || error === void 0 ? void 0 : error.details) === null || _b === void 0 ? void 0 : _b.msg) === null || _c === void 0 ? void 0 : _c.message);
                    throw new Error(`${(_f = (_e = (_d = error === null || error === void 0 ? void 0 : error.details) === null || _d === void 0 ? void 0 : _d.msg) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : "Error on retrieving token from renewToken Jabber Service"}`);
                }
            }
        });
    }
    initializeGraphClient() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isInitialized) {
                const graphClient = _microsoft_microsoft_graph_client__WEBPACK_IMPORTED_MODULE_0__.Client.init({
                    debugLogging: true,
                    authProvider: this.authProviderCallback
                });
                this.graphClient = graphClient;
            }
        });
    }
    graphRequestHandler(payload) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            // Default headers
            let headers = {
                "content-type": "application/json",
                ConsistencyLevel: "eventual"
            };
            if (payload.customHeaders && Object.keys(payload.customHeaders).length > 0) {
                // payload.customHeaders
                headers = Object.assign(Object.assign({}, headers), payload.customHeaders);
            }
            // Add Endpoint URL.
            const requestClient = (_a = this.graphClient) === null || _a === void 0 ? void 0 : _a.api(payload.endPoint);
            // Add Headers
            requestClient === null || requestClient === void 0 ? void 0 : requestClient.headers(headers);
            // Add field for selecting
            if (payload.selectParameters && payload.selectParameters.length > 0) {
                requestClient === null || requestClient === void 0 ? void 0 : requestClient.select(payload.selectParameters);
            }
            if (payload.filter) {
                requestClient === null || requestClient === void 0 ? void 0 : requestClient.filter(payload.filter);
            }
            if (payload.orderby) {
                requestClient === null || requestClient === void 0 ? void 0 : requestClient.orderby(payload.orderby);
            }
            if (payload.isBetaVersion) {
                requestClient === null || requestClient === void 0 ? void 0 : requestClient.version("beta");
            }
            if (payload.count) {
                requestClient === null || requestClient === void 0 ? void 0 : requestClient.top(payload.count); // helpful for fetch the certain number of records.
                requestClient === null || requestClient === void 0 ? void 0 : requestClient.count(true); // helpful for identify the no.of records present in the api.
                if (payload.skipToken && payload.skipToken !== "") {
                    requestClient === null || requestClient === void 0 ? void 0 : requestClient.skipToken(payload.skipToken);
                }
            }
            if (payload.method === "GET") {
                return requestClient === null || requestClient === void 0 ? void 0 : requestClient.get();
            }
            // For POST Method
            return requestClient === null || requestClient === void 0 ? void 0 : requestClient.post(payload.requestData);
        });
    }
    fetchUsers(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const selectParameters = ["id", "userPrincipalName", "businessPhones", "department", "displayName", "jobTitle"];
            const graphRequestPayload = {
                endPoint: _constant__WEBPACK_IMPORTED_MODULE_6__.MICROSOFT_URLS.FETCH_USERS,
                method: "GET",
                selectParameters,
                orderby: "displayName ASC"
            };
            if (payload.skipToken) {
                graphRequestPayload.skipToken = payload.skipToken;
            }
            if (payload.count) {
                graphRequestPayload.count = payload.count;
            }
            let searchQuery;
            if (payload.searchQuery) {
                const value = payload.searchQuery;
                // Encode URI is required for search the phone number withg special character, like +1-(922)123456
                const phoneNumber = encodeURIComponent(payload.searchQuery);
                searchQuery = `startswith(department,'${value}')`;
                searchQuery += ` OR startswith(displayName,'${value}')`;
                searchQuery += ` OR startswith(jobTitle,'${value}')`;
                searchQuery += ` OR businessPhones/any(p:startsWith(p, '${phoneNumber}'))`;
            }
            // Default Filter Query
            let filterQuery = "accountEnabled eq true"; // To prevent the not active users/deleted users
            if (this.activeUserId) {
                // Pre-Defined filter value for remove the signed-in user.
                filterQuery += ` AND NOT(id eq '${this.activeUserId}')`;
            }
            if (searchQuery) {
                filterQuery += ` AND (${searchQuery})`;
            }
            graphRequestPayload.filter = filterQuery;
            return this.graphRequestHandler(graphRequestPayload);
        });
    }
    batchRequest(batchRequests) {
        return __awaiter(this, void 0, void 0, function* () {
            // For Batch Request
            // https://github.com/microsoftgraph/msgraph-sdk-javascript/blob/dev/docs/content/Batching.md
            // https://learn.microsoft.com/en-us/graph/sdks/batch-requests?tabs=typescript
            const response = yield this.graphRequestHandler({
                endPoint: _constant__WEBPACK_IMPORTED_MODULE_6__.MICROSOFT_URLS.BATCH_REQUEST,
                requestData: { requests: batchRequests },
                method: "POST"
            });
            return new _microsoft_microsoft_graph_client__WEBPACK_IMPORTED_MODULE_0__.BatchResponseContent(response);
        });
    }
    fetchUserPresence(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.graphRequestHandler({
                endPoint: _constant__WEBPACK_IMPORTED_MODULE_6__.MICROSOFT_URLS.FETCH_USERS_PRESENCE,
                requestData: payload.requestData,
                method: "POST"
            });
        });
    }
    msLogout() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.removeToken(); // Removes the token stores in session storage
                this.removeUserInfo(); // Removes the MS Signed-In user information in session storage
                yield this.logoutPopup();
                return true;
            }
            catch (error) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error("[MicrosoftService]: Error on logout ", error);
                throw error;
            }
        });
    }
    presenceAPI() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const profileOrgId = ((_b = (_a = _index__WEBPACK_IMPORTED_MODULE_5__.SERVICE.conf) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.orgId) || "";
            if (this.msftPresenceServiceUrl === "") {
                const U2CResponse = yield this.fetchMicrosoftPressenceAPIURL({ orgId: profileOrgId, token: this.accessToken });
                this.msftPresenceServiceUrl = U2CResponse.services[0].serviceUrls[0].baseUrl;
            }
            const sessionData = JSON.parse((_c = sessionStorage.getItem(_utils__WEBPACK_IMPORTED_MODULE_9__.MSFT_TOKEN)) !== null && _c !== void 0 ? _c : "{}");
            if (sessionData && sessionData.refresh_token) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.info("[PresenceStateSync] : Session data successfully fetched");
                const httpPresence = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_3__.HttpReqs(this.msftPresenceServiceUrl, true);
                const postPresenceApi = httpPresence.req((p) => ({
                    url: `/userMapping`,
                    headers: {
                        msftToken: p.msftToken,
                        webexToken: p.accessToken,
                        msftRefreshToken: p.msftRefreshToken
                    },
                    method: "POST",
                    err: _service_utils__WEBPACK_IMPORTED_MODULE_7__.createErrDetailsObject,
                    res: {}
                }));
                return postPresenceApi({
                    accessToken: this.accessToken,
                    msftRefreshToken: sessionData === null || sessionData === void 0 ? void 0 : sessionData.refresh_token,
                    msftToken: (sessionData === null || sessionData === void 0 ? void 0 : sessionData.access_token) || ""
                });
            }
            _core_sdk__WEBPACK_IMPORTED_MODULE_4__.logger.error("[PresenceStateSync] : Presence API error. Unable to get refresh token ");
            return Promise.reject("Error : Unable to get refresh token");
        });
    }
}


/***/ }),

/***/ "./src/services/integration/microsoft/microsoft-oauth-handler.ts":
/*!***********************************************************************!*\
  !*** ./src/services/integration/microsoft/microsoft-oauth-handler.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MicrosoftAuthCodeHandler: () => (/* binding */ MicrosoftAuthCodeHandler)
/* harmony export */ });
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils */ "./src/services/integration/microsoft/utils.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



const NotInitializedError = new Error("[Microsoft OAuth Handler]: Microsoft OAuth config service is not initialized.");
const PopupTarget = "about:blank";
class MicrosoftAuthCodeHandler {
    constructor() {
        this.isInitialized = false;
        this.isPopUpActive = false;
        this.currentWindow = null;
        this.DEFAULT_AUTHORITY_HOST = "https://login.microsoftonline.com";
        this.defaultTimeoutOptions = {
            windowTimeout: 60000,
            iframeTimeout: 10000,
            pollInterval: 30
        };
        this.unloadWindow = (e) => {
            if (this.currentWindow) {
                this.currentWindow.close();
            }
            // Guarantees browser unload will happen, so no other errors will be thrown.
            e.preventDefault();
        };
    }
    /**
     * Method to initialize the microsoft OAuth service required config values based on tenantId and clientId
     * @param clientId - Azure App ClientID
     * @param tenantId - Customer Id
     * @returns Window
     */
    initializeOAuthService(clientId, tenantId) {
        this.msConfig = {
            clientId,
            tenantId,
            authority: `${this.DEFAULT_AUTHORITY_HOST}/${tenantId}`,
            endPoints: {
                authorizationURL: `${this.DEFAULT_AUTHORITY_HOST}/${tenantId}/oauth2/v2.0/authorize`,
                logoutURL: `${this.DEFAULT_AUTHORITY_HOST}/${tenantId}/oauth2/v2.0/logout`
            }
        };
        this.isInitialized = true;
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("[Microsoft OAuth Handler]: Initializing Microsoft OAuth Handler Service SUCCESS");
        window.addEventListener("beforeunload", this.unloadWindow);
        return true;
    }
    /**
     * Helper function to open popup window dimensions and position
     * @param urlNavigate - URL to open in window
     * @param popupName - Name of the popup window
     * @returns Window
     */
    promptUserLogin(urlNavigate, popupName) {
        const { width, height, top, left } = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.loginPromptDimension)();
        this.currentWindow = window.open(urlNavigate, popupName, `width=${width}, height=${height}, top=${top}, left=${left}, scrollbars=yes`);
        return this.currentWindow;
    }
    /**
     * Helper function to open authorization URL inside the hidden iframe
     * @param redirectUri - URL to open in iframe
     * @param scope - Microsoft authorization scopes
     * @returns Promise<string>
     */
    invokeSilentSSOLogin(props) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isInitialized || !this.msConfig) {
                throw NotInitializedError;
            }
            const urlNavigate = this.getAuthenticationUrl(Object.assign(Object.assign({}, props), { prompt: "none" }));
            const iframe = this.loadIframeSync(urlNavigate);
            if (iframe) {
                const urlString = yield this.monitorIframeResponse(iframe);
                const response = this.getAuthCodeFromUrl(urlString);
                _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("[Microsoft OAuth Handler]: Fetching the auth code from microsoft Silent SSO is successful.");
                return response;
            }
            else {
                throw new Error("[Microsoft OAuth Handler]: Error on creating the silent SSO Iframe.");
            }
        });
    }
    /**
     * Use when we extract the auth code from the microsoft auth response URL
     * @param urlString - response url received from the microsoft oauth authorize service.
     * @returns string
     */
    getAuthCodeFromUrl(urlString) {
        const url = new URL(urlString);
        const codeValue = url.searchParams.get("code");
        if (codeValue && codeValue.length > 0) {
            return codeValue;
        }
        else {
            throw new Error(`[Microsoft OAuth Handler]: Error on retrieving the code from microsoft auth response URL: ${urlString}`);
        }
    }
    /**
     * Helper function to generate the microsoft authorization URL
     * @param redirectUri - URL to open in iframe
     * @param scope - Microsoft authorization scopes
     * @returns string
     */
    getAuthenticationUrl(props) {
        var _a;
        if (!this.isInitialized || !this.msConfig) {
            throw NotInitializedError;
        }
        const { scope, redirectUri, clientId, nonce, state } = props;
        const queryParams = {
            client_id: clientId !== null && clientId !== void 0 ? clientId : (_a = this.msConfig) === null || _a === void 0 ? void 0 : _a.clientId,
            response_type: "code",
            response_mode: "query",
            scope,
            redirect_uri: redirectUri,
            nonce: nonce !== null && nonce !== void 0 ? nonce : (0,_service_utils__WEBPACK_IMPORTED_MODULE_1__.generateUUID)(),
            state: state !== null && state !== void 0 ? state : (0,_service_utils__WEBPACK_IMPORTED_MODULE_1__.generateUUID)()
        };
        if (props.prompt) {
            queryParams.prompt = props.prompt;
        }
        const params = new URLSearchParams(queryParams).toString();
        const authorizeUrl = new URL(this.msConfig.endPoints.authorizationURL);
        return `${authorizeUrl}?${params}`;
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     * @param request
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */
    invokeLoginPopUp(props) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isInitialized || !this.msConfig) {
                throw NotInitializedError;
            }
            const popUpName = this.generatePopupName((_a = this.msConfig) === null || _a === void 0 ? void 0 : _a.clientId);
            const urlNavigate = this.getAuthenticationUrl(Object.assign({}, props));
            // Invoke the blank popup window to invoke the popup immediately.
            // Later asap we can update the URL in same popup window.
            const popupWindow = this.promptUserLogin(PopupTarget, popUpName);
            if (popupWindow) {
                this.isPopUpActive = true;
                // Interaction In Progress - set interaction status.
                popupWindow.location.href = urlNavigate; // Load the microsoft URL in the popup window.
                _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("[Microsoft OAuth Handler]: Invoking the popup window for microsoft login is successful.");
                // Monitor the popup window authentication is successful.
                const urlString = yield this.monitorPopupResponse(popupWindow);
                const response = this.getAuthCodeFromUrl(urlString);
                _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("[Microsoft OAuth Handler]: Fetching the auth code from microsoft login popup window is successful.");
                return response;
            }
            else {
                throw new Error("[Microsoft OAuth Handler]: Error on opening popup window.");
            }
        });
    }
    /**
     * Use when initiating the logout process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */
    invokeLogout({ clientId, redirectUri }) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isInitialized || !this.msConfig) {
                throw NotInitializedError;
            }
            const popUpName = this.generatePopupName((_a = this.msConfig) === null || _a === void 0 ? void 0 : _a.clientId);
            const queryParams = {
                client_id: clientId !== null && clientId !== void 0 ? clientId : (_b = this.msConfig) === null || _b === void 0 ? void 0 : _b.clientId,
                redirect_uri: redirectUri
            };
            const params = new URLSearchParams(queryParams).toString();
            const authorizeUrl = new URL(this.msConfig.endPoints.logoutURL);
            const urlNavigate = `${authorizeUrl}?${params}`;
            // Invoke the blank popup window to invoke the popup immediately.
            // Later asap we can update the URL in same popup window.
            const popupWindow = this.promptUserLogin(PopupTarget, popUpName);
            if (popupWindow) {
                // Interaction In Progress - set interaction status.
                popupWindow.location.href = urlNavigate; // Load the microsoft URL in the popup window.
                setTimeout(function () {
                    popupWindow.close();
                }, 10000); // Close the popup window after 10 seconds.
                _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("[Microsoft OAuth Handler]: Invoking the popup window for microsoft logout is successful.");
                // Monitor the popup window authentication is successful.
                const response = yield this.monitorPopupResponse(popupWindow);
                _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("[Microsoft OAuth Handler]: Fetching the auth code from microsoft logout popup window is successful.");
                return response;
            }
            else {
                throw new Error("[Microsoft OAuth Handler]: Error on opening popup window.");
            }
        });
    }
    /**
     * Use when initiating the logout process via opening a popup window in the user's browser
     * it will clear the token from the local storage.
     * @returns void
     */
    removeToken() {
        sessionStorage.removeItem(_utils__WEBPACK_IMPORTED_MODULE_2__.MSFT_TOKEN);
    }
    /**
     * Monitors a window until it loads a url with the same origin.
     * @param popupWindow - window that is being monitored
     * @returns Promise<string>
     */
    monitorPopupResponse(popupWindow) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const intervalId = setInterval(() => {
                    // Window is closed
                    if (popupWindow.closed) {
                        clearInterval(intervalId);
                        reject(new Error("[Microsoft OAuth Handler]: User cancelled the flow"));
                        return;
                    }
                    let href = "";
                    try {
                        /*
                         * Will throw if cross origin,
                         * which should be caught and ignored
                         * since we need the interval to keep running while on STS UI.
                         */
                        href = popupWindow.location.href;
                    }
                    catch (_a) {
                        // Ignore adding the logs for interval to fetch the href from location.
                    }
                    // Don't process blank pages or cross domain
                    if (!href || href === PopupTarget) {
                        return;
                    }
                    clearInterval(intervalId);
                    let responseString = "";
                    if (popupWindow) {
                        responseString = popupWindow.location.href;
                    }
                    resolve(responseString);
                }, this.defaultTimeoutOptions.pollInterval);
            }).finally(() => {
                this.cleanPopup(popupWindow);
                this.isPopUpActive = false;
            });
        });
    }
    /**
     *  Method to check the login popup window is opened or not.
     * @returns Boolean
     */
    getPopUpActiveStatus() {
        return this.isPopUpActive;
    }
    /**
     * Monitors an iframe content window until it loads a url with a response, or hits a specified timeout.
     * @param iframe
     * @returns Promise<string>
     */
    monitorIframeResponse(iframe) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                /*
                 * Polling for iframes can be purely timing based,
                 */
                let intervalId = 0;
                const timeoutId = window.setTimeout(() => {
                    window.clearInterval(intervalId);
                    reject(new Error("[Microsoft OAuth Handler]: SSO Silent Iframe Timeout"));
                }, this.defaultTimeoutOptions.iframeTimeout);
                intervalId = window.setInterval(() => {
                    let href = "";
                    const contentWindow = iframe.contentWindow;
                    try {
                        /*
                         * Will throw if cross origin,
                         * which should be caught and ignored
                         * since we need the interval to keep running while on STS UI.
                         */
                        href = contentWindow ? contentWindow.location.href : "";
                    }
                    catch (_a) {
                        // Ignore adding the logs for interval to fetch the href from location.
                    }
                    if (!href || href === PopupTarget) {
                        return;
                    }
                    let responseString = "";
                    if (contentWindow) {
                        responseString = contentWindow.location.href;
                    }
                    window.clearTimeout(timeoutId);
                    window.clearInterval(intervalId);
                    resolve(responseString);
                }, 30);
            }).finally(() => {
                this.removeHiddenIframe(iframe);
            });
        });
    }
    /**
     * Closes popup, removes any state vars created during popup calls.
     * @param popupWindow
     * @returns void
     */
    cleanPopup(popupWindow) {
        if (popupWindow) {
            // Close window.
            popupWindow.close();
        }
        window.removeEventListener("beforeunload", this.unloadWindow);
        // Interaction is completed - remove interaction status.
    }
    /**
     * @hidden
     * Creates a new hidden iframe or gets an existing one for silent token renewal.
     * @ignore
     */
    createHiddenIframe() {
        const authFrame = document.createElement("iframe");
        authFrame.style.visibility = "hidden";
        authFrame.style.position = "absolute";
        authFrame.style.width = authFrame.style.height = "0";
        authFrame.style.border = "0";
        authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
        document.body.appendChild(authFrame);
        return authFrame;
    }
    /**
     * @hidden
     * Removes a hidden iframe from the page.
     * @ignore
     */
    removeHiddenIframe(iframe) {
        if (document.body === iframe.parentNode) {
            document.body.removeChild(iframe);
        }
    }
    /**
     * Helper function to generate the iframe along with microsoft authorization URL
     * @param urlNavigate - URL to open in iframe
     * @returns HTMLIFrameElement
     */
    loadIframeSync(urlNavigate) {
        const iFrameHandle = this.createHiddenIframe();
        iFrameHandle.src = urlNavigate;
        return iFrameHandle;
    }
    /**
     * Helper function to generate the unique popup window name
     * @param clientId - Azure App ClientID
     * @returns string
     */
    generatePopupName(clientId) {
        const POPUP_NAME_PREFIX = "contact-center";
        return `${POPUP_NAME_PREFIX}.${clientId !== null && clientId !== void 0 ? clientId : ""}.${(0,_service_utils__WEBPACK_IMPORTED_MODULE_1__.generateUUID)()}}`;
    }
}


/***/ }),

/***/ "./src/services/integration/microsoft/utils.ts":
/*!*****************************************************!*\
  !*** ./src/services/integration/microsoft/utils.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MSFT_TOKEN: () => (/* binding */ MSFT_TOKEN),
/* harmony export */   MSFT_USER_INFO: () => (/* binding */ MSFT_USER_INFO),
/* harmony export */   createRefreshTokenKey: () => (/* binding */ createRefreshTokenKey),
/* harmony export */   decodeJwt: () => (/* binding */ decodeJwt),
/* harmony export */   getRevokeInterval: () => (/* binding */ getRevokeInterval),
/* harmony export */   loginPromptDimension: () => (/* binding */ loginPromptDimension)
/* harmony export */ });
const CACHE_KEY_SEPARATOR = "-";
const REFRESH_TOKEN = "RefreshToken";
function generateAccountId(credentialEntity) {
    const accountId = [credentialEntity.homeAccountId, credentialEntity.environment];
    return accountId.join(CACHE_KEY_SEPARATOR).toLowerCase();
}
/**
 * Generate Credential Id key component as per the schema: <credential_type>-<client_id>-<realm>
 */
function generateCredentialId(credentialEntity) {
    const clientOrFamilyId = credentialEntity.credentialType === REFRESH_TOKEN
        ? credentialEntity.familyId || credentialEntity.clientId
        : credentialEntity.clientId;
    const credentialId = [credentialEntity.credentialType, clientOrFamilyId, ""];
    return credentialId.join(CACHE_KEY_SEPARATOR).toLowerCase();
}
function generateCredentialKey(credentialEntity) {
    const credentialKey = [generateAccountId(credentialEntity), generateCredentialId(credentialEntity), "", "", ""];
    return credentialKey.join(CACHE_KEY_SEPARATOR).toLowerCase();
}
/**
 * Create RefreshTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */
function createRefreshTokenKey(homeAccountId, environment, clientId, familyId) {
    const rtEntity = {
        credentialType: REFRESH_TOKEN,
        homeAccountId,
        environment,
        clientId
    };
    if (familyId) {
        rtEntity.familyId = familyId;
    }
    return generateCredentialKey(rtEntity);
}
/* returns time left to token expire in milliseconds. */
function getRevokeInterval(expiresOn) {
    return new Date(expiresOn).valueOf() - Math.floor(Date.now());
}
const loginPromptDimension = () => {
    const DEFAULT_POPUP_WIDTH = 483;
    const DEFAULT_POPUP_HEIGHT = 600;
    /**
     * adding winLeft and winTop to account for dual monitor
     * using screenLeft and screenTop for IE8 and earlier
     */
    const winLeft = window.screenLeft ? window.screenLeft : window.screenX;
    const winTop = window.screenTop ? window.screenTop : window.screenY;
    /**
     * window.innerWidth displays browser window"s height and width excluding toolbars
     * using document.documentElement.clientWidth for IE8 and earlier
     */
    const winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    const width = DEFAULT_POPUP_WIDTH;
    const height = DEFAULT_POPUP_HEIGHT;
    const top = Math.max(0, winHeight / 2 - DEFAULT_POPUP_HEIGHT / 2 + winTop);
    const left = Math.max(0, winWidth / 2 - DEFAULT_POPUP_WIDTH / 2 + winLeft);
    return {
        width,
        height,
        top,
        left
    };
};
const base64UrlDecode = (base64Url) => {
    // Add padding if necessary and replace URL-safe characters
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    // Base64 decode and convert to string
    return window.atob(base64);
};
const decodeJwt = (jwt) => {
    // Split the JWT into its three parts
    try {
        const [header, payload] = jwt.split(".");
        // Base64 decode each part
        const decodedHeader = base64UrlDecode(header);
        const decodedPayload = base64UrlDecode(payload);
        // Parse the JSON in each part
        const headerObj = JSON.parse(decodedHeader);
        const payloadObj = JSON.parse(decodedPayload);
        // Return the decoded header and payload
        return { header: headerObj, payload: payloadObj };
    }
    catch (_a) {
        throw new Error("Error on decrypting Json Web Token");
    }
};
const MSFT_TOKEN = "msft-token";
const MSFT_USER_INFO = "msft-user-info";


/***/ }),

/***/ "./src/services/interactions/index.ts":
/*!********************************************!*\
  !*** ./src/services/interactions/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsService: () => (/* reexport safe */ _interactions_service__WEBPACK_IMPORTED_MODULE_0__.InteractionsService),
/* harmony export */   InteractionsServiceConstants: () => (/* reexport safe */ _interactions_service_constants__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants),
/* harmony export */   buildInteractionsService: () => (/* reexport safe */ _interactions_service__WEBPACK_IMPORTED_MODULE_0__.buildInteractionsService)
/* harmony export */ });
/* harmony import */ var _interactions_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./interactions-service */ "./src/services/interactions/interactions-service.ts");
/* harmony import */ var _interactions_service_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./interactions-service-constants */ "./src/services/interactions/interactions-service-constants.ts");




/***/ }),

/***/ "./src/services/interactions/interactions-service-constants.ts":
/*!*********************************************************************!*\
  !*** ./src/services/interactions/interactions-service-constants.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsServiceConstants: () => (/* binding */ InteractionsServiceConstants)
/* harmony export */ });
var InteractionsServiceConstants;
(function (InteractionsServiceConstants) {
    let QueryType;
    (function (QueryType) {
        QueryType["Active"] = "active";
        QueryType["Queued"] = "queued";
        QueryType["Completed"] = "completed";
    })(QueryType = InteractionsServiceConstants.QueryType || (InteractionsServiceConstants.QueryType = {}));
    let QueryField;
    (function (QueryField) {
        QueryField["Id"] = "id";
        QueryField["Status"] = "status";
        QueryField["ChannelType"] = "channelType";
        QueryField["CreatedTime"] = "createdTime";
        QueryField["EndedTime"] = "endedTime";
        QueryField["Origin"] = "origin";
        QueryField["Destination"] = "destination";
        QueryField["ContactReason"] = "contactReason";
        QueryField["Direction"] = "direction";
        QueryField["ChannelSubType"] = "channelSubType";
        QueryField["CustomerName"] = "customer.name";
        QueryField["CustomerPhone"] = "customer.phoneNumber";
        QueryField["CustomerEmail"] = "customer.email";
        QueryField["IsActive"] = "isActive";
        QueryField["EmailSubject"] = "channelMetaData.email.subject";
        QueryField["ChatReason"] = "channelMetaData.chat.chatReason";
        QueryField["QueueId"] = "lastQueue.id";
        QueryField["QueueName"] = "lastQueue.name";
        QueryField["QueueDuraion"] = "lastQueue.duration";
        QueryField["SiteId"] = "lastSite.id";
        QueryField["SiteName"] = "lastSite.name";
        QueryField["TeamId"] = "lastTeam.id";
        QueryField["TeamName"] = "lastTeam.name";
        QueryField["EntryPointId"] = "lastEntryPoint.id";
        QueryField["EntryPointName"] = "lastEntryPoint.name";
        QueryField["PreviousQueueId"] = "previousQueue.id";
        QueryField["PreviousQueueName"] = "previousQueue.name";
        QueryField["WrapUpCodeId"] = "lastWrapupCodeId";
        QueryField["WrapUpCodeName"] = "lastWrapupCodeName";
        QueryField["AgentId"] = "lastAgent.id";
        QueryField["AgentName"] = "lastAgent.name";
        QueryField["AgentSignInId"] = "lastAgent.signInId";
        QueryField["AgentSessionId"] = "lastAgent.sessionId";
        QueryField["AgentPhoneNumber"] = "lastAgent.phoneNumber";
        QueryField["AgentChannelId"] = "lastAgent.channelId";
        QueryField["EmailBccList"] = "emailBccList";
        QueryField["EmailCcList"] = "emailCcList";
        QueryField["EmailToList"] = "emailToList";
        QueryField["TotalDuration"] = "totalDuration";
        QueryField["CSATScore"] = "csatScore";
        QueryField["BlindTransferCount"] = "blindTransferCount";
        QueryField["ConferenceCount"] = "conferenceCount";
        QueryField["ConferenceDuration"] = "conferenceDuration";
        QueryField["ConsultCount"] = "consultCount";
        QueryField["ConsultDuration"] = "consultDuration";
        QueryField["HoldCount"] = "holdCount";
        QueryField["HoldDuration"] = "holdDuration";
        QueryField["ConnectedCount"] = "connectedCount";
        QueryField["ConnectedDuration"] = "connectedDuration";
        QueryField["TransferCount"] = "transferCount";
        QueryField["WrapUpDuration"] = "wrapupDuration";
        QueryField["RingingDuration"] = "ringingDuration";
        QueryField["QueueDuration"] = "queueDuration";
        QueryField["QueueCount"] = "queueCount";
        QueryField["CallCompletedCount"] = "callCompletedCount";
        QueryField["Sentiment"] = "sentiment";
        QueryField["AutoCSAT"] = "autoCsat";
        QueryField["MatchedSkills"] = "matchedSkills";
        QueryField["RequiredSkills"] = "requiredSkills";
        QueryField["MatchedSkillsProfile"] = "matchedSkillsProfile";
        QueryField["IsWithInServiceLevel"] = "isWithInServiceLevel";
        QueryField["IsContactHandled"] = "isContactHandled";
        QueryField["PreviousAgentId"] = "previousAgentId";
        QueryField["PreviousAgentSessionId"] = "previousAgentSessionId";
        QueryField["PreviousAgentName"] = "previousAgentName";
        QueryField["IsOutdial"] = "isOutdial";
        QueryField["AgentToQueueTransferCount"] = "agentToQueueTransferCount";
        QueryField["LastActivityTime"] = "lastActivityTime";
    })(QueryField = InteractionsServiceConstants.QueryField || (InteractionsServiceConstants.QueryField = {}));
    let SortOrder;
    (function (SortOrder) {
        SortOrder["Ascending"] = "asc";
        SortOrder["Descending"] = "desc";
    })(SortOrder = InteractionsServiceConstants.SortOrder || (InteractionsServiceConstants.SortOrder = {}));
    let FilterType;
    (function (FilterType) {
        FilterType["StringFilter"] = "string";
        FilterType["NumberFilter"] = "number";
        FilterType["BooleanFilter"] = "boolean";
        FilterType["SetFilter"] = "set";
        FilterType["ChannelTypeFilter"] = "channelType";
        FilterType["CSATFilter"] = "csat";
    })(FilterType = InteractionsServiceConstants.FilterType || (InteractionsServiceConstants.FilterType = {}));
    let FilterOperator;
    (function (FilterOperator) {
        FilterOperator["Equals"] = "equals";
        FilterOperator["Contains"] = "contains";
        FilterOperator["GreaterThan"] = "gt";
        FilterOperator["GreaterThanOrEqual"] = "gte";
        FilterOperator["LessThan"] = "lt";
        FilterOperator["LessThanOrEqual"] = "lte";
    })(FilterOperator = InteractionsServiceConstants.FilterOperator || (InteractionsServiceConstants.FilterOperator = {}));
})(InteractionsServiceConstants || (InteractionsServiceConstants = {}));


/***/ }),

/***/ "./src/services/interactions/interactions-service-rtd.ts":
/*!***************************************************************!*\
  !*** ./src/services/interactions/interactions-service-rtd.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsRtdEndpoint: () => (/* binding */ InteractionsRtdEndpoint)
/* harmony export */ });
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _interactions_service_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./interactions-service-constants */ "./src/services/interactions/interactions-service-constants.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


/**
 * Handles real-time data interaction updates from WebexCC RTD
 */
class InteractionsRtdEndpoint {
    /**
     * Subscribes to interaction updates
     * @param queryType Type of interactions to subscribe to (active or queued)
     * @param callback Function to call when updates are received
     * @returns Subscription object
     */
    subscribeInteractionUpdates(queryType, callback) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield ((_a = window.wxcc) === null || _a === void 0 ? void 0 : _a.rtdwc.subscribe({
                    datasetName: "wxcc.rtd.contactstats",
                    update: (data, deltaData) => {
                        let interactions;
                        if (queryType === _interactions_service_constants__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Active) {
                            interactions = this.handleActiveInteractionUpdate(data.type, data === null || data === void 0 ? void 0 : data.datasetValues, deltaData === null || deltaData === void 0 ? void 0 : deltaData.datasetValues);
                        }
                        else if (queryType === _interactions_service_constants__WEBPACK_IMPORTED_MODULE_1__.InteractionsServiceConstants.QueryType.Queued) {
                            interactions = this.handleQueuedInteractionUpdate(data.type, data === null || data === void 0 ? void 0 : data.datasetValues, deltaData === null || deltaData === void 0 ? void 0 : deltaData.datasetValues);
                        }
                        else {
                            _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error(`event=subscribeInteractionUpdates Invalid queryType: ${queryType}`);
                        }
                        if (interactions) {
                            callback(interactions);
                        }
                    }
                }));
            }
            catch (error) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("event=subscribeInteractionUpdates Failed to subscribe to contactStats RTD", error);
                throw error;
            }
        });
    }
    /**
     * Maps RTD data to task details
     * @param dataSetValue Agent contact stats from RTD
     * @returns Mapped task details
     */
    mapRtdDataToTaskDetails(dataSetValue) {
        const partialTask = {
            id: dataSetValue.data.interactionId,
            status: dataSetValue.data.status,
            channelType: dataSetValue.data.channelType,
            origin: dataSetValue.data.origin,
            destination: dataSetValue.data.destination,
            direction: dataSetValue.data.contactDirection,
            lastQueue: {
                id: dataSetValue.data.queueId,
                name: dataSetValue.data.queueName,
                duration: 0 // Not available in RTD data
            },
            lastTeam: {
                id: dataSetValue.data.teamId,
                name: dataSetValue.data.teamName
            },
            lastSite: {
                id: dataSetValue.data.siteId,
                name: dataSetValue.data.siteName
            },
            lastAgent: {
                id: dataSetValue.data.agentId,
                name: dataSetValue.data.agentName,
                phoneNumber: dataSetValue.data.destinationAgentDNIS || "",
                signInId: "",
                sessionId: "",
                channelId: ""
            }
        };
        return partialTask;
    }
    /**
     * Handles interaction updates (both active and queued)
     * @param updateType Type of update
     * @param fullData Complete dataset (for initial responses)
     * @param deltaData Delta dataset (for realtime updates)
     * @returns Formatted interaction update object
     */
    handleInteractionUpdate(updateType, fullData, deltaData) {
        if (fullData && updateType === "SubscriptionResponse") {
            const fullUpdate = fullData.map((data) => this.mapRtdDataToTaskDetails(data));
            return { fullUpdate };
        }
        else if (updateType === "RealtimeFeed" && deltaData && deltaData.length > 0) {
            const removed = deltaData.filter((data) => data.operation === "DELETE").map((data) => data.key);
            const updated = deltaData
                .filter((data) => data.operation === "UPSERT")
                .map((data) => this.mapRtdDataToTaskDetails(data));
            return { realTimeUpdate: { updated, removed } };
        }
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.warn("[InteractionsRtd] Invalid or unsupported update type received:", updateType);
        return {};
    }
    handleActiveInteractionUpdate(updateType, fullData, deltaData) {
        return this.handleInteractionUpdate(updateType, fullData, deltaData);
    }
    handleQueuedInteractionUpdate(updateType, fullData, deltaData) {
        return this.handleInteractionUpdate(updateType, fullData, deltaData);
    }
}


/***/ }),

/***/ "./src/services/interactions/interactions-service-search.ts":
/*!******************************************************************!*\
  !*** ./src/services/interactions/interactions-service-search.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsSearchApi: () => (/* binding */ InteractionsSearchApi),
/* harmony export */   createErrDetailsObjectWithStatusCode: () => (/* binding */ createErrDetailsObjectWithStatusCode)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var gql_query_builder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! gql-query-builder */ "gql-query-builder");
/* harmony import */ var gql_query_builder__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(gql_query_builder__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! graphql */ "graphql");
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(graphql__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! set-interval-async/dynamic */ "set-interval-async/dynamic");
/* harmony import */ var set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./interactions-service-constants */ "./src/services/interactions/interactions-service-constants.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










const FIFTEEN_SEC_MS = 15 * 1000;
const ONE_DAY_MS = 24 * 60 * 60 * 1000;
const MAX_FAILURES = 3;
function createErrDetailsObjectWithStatusCode(errObj, errorKey) {
    var _a, _b, _c, _d, _e;
    const details = {
        trackingId: ((_a = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _a === void 0 ? void 0 : _a.headers["trackingid"]) || ((_b = errObj === null || errObj === void 0 ? void 0 : errObj.config) === null || _b === void 0 ? void 0 : _b.headers["TrackingID"]),
        msg: (_c = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _c === void 0 ? void 0 : _c.data,
        statusCode: (_d = errObj.response) === null || _d === void 0 ? void 0 : _d.status,
        retryAfter: (_e = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _e === void 0 ? void 0 : _e.headers["retry-after"]
    };
    return new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details(errorKey !== null && errorKey !== void 0 ? errorKey : "Service.reqs.generic.failure", details);
}
class InteractionsSearchApi {
    constructor() {
        this.http = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_5__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_4__.CONF.API_GATEWAY);
        this.createFetchMoreFunc = (queryType, params, pageInfo, callback) => {
            const fetchMoreParams = Object.assign({}, params);
            let nextPageInfo = Object.assign({}, pageInfo);
            return () => __awaiter(this, void 0, void 0, function* () {
                if (nextPageInfo.hasNextPage) {
                    const nextPageResponse = yield this.fetchInteractions(queryType, Object.assign(Object.assign({}, fetchMoreParams), { cursor: nextPageInfo.endCursor }));
                    callback(nextPageResponse.tasks);
                    nextPageInfo = nextPageResponse.pageInfo;
                }
                return nextPageInfo.hasNextPage;
            });
        };
    }
    fetchCompletedInteractions(params, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.fetchInteractions(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryType.Completed, params);
            callback(data.tasks);
            return {
                fetchMore: this.createFetchMoreFunc(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryType.Completed, params, data.pageInfo, callback)
            };
        });
    }
    /**
     * @throws {Error} When callback is not provided
     * @throws {UUIPErr.Details} When the interaction service request fails
     */
    startQueuedPolling(callback, sortBy, filters // Added queueIds parameter
    ) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!callback) {
                throw new Error("callback is required to subscribe to interaction updates");
            }
            let failureCount = 0;
            // Initial fetch for the past 24 hours
            const initialParams = {
                startTime: Date.now() - ONE_DAY_MS,
                endTime: Date.now(),
                cursor: "NA",
                sortBy,
                filters
            };
            const firstResponse = yield this.fetchInteractions(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryType.Queued, initialParams);
            callback(firstResponse.tasks);
            const fetchMore = this.createFetchMoreFunc(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryType.Queued, initialParams, firstResponse.pageInfo, callback);
            const intervalId = (0,set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_3__.setIntervalAsync)(() => __awaiter(this, void 0, void 0, function* () {
                try {
                    const updateParams = {
                        startTime: Date.now() - ONE_DAY_MS,
                        endTime: Date.now(),
                        cursor: "NA",
                        sortBy,
                        filters
                    };
                    const res = yield this.fetchInteractions(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryType.Queued, updateParams);
                    callback(res.tasks);
                    failureCount = 0;
                }
                catch (err) {
                    failureCount++;
                    if (failureCount >= MAX_FAILURES) {
                        _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("[InteractionsSearch] Max polling failures reached, stopping polling");
                        yield (0,set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_3__.clearIntervalAsync)(intervalId);
                    }
                    if (err instanceof _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details || err instanceof Error) {
                        _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("[InteractionsSearch] error calling fetchInteractions while polling:", err);
                    }
                    else {
                        _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("[InteractionsSearch] unknown error calling fetchInteractions while polling:", err);
                    }
                }
            }), FIFTEEN_SEC_MS);
            return { intervalId, fetchMore };
        });
    }
    buildQueryTypeFilters(queryType) {
        switch (queryType) {
            case _interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryType.Queued:
                return { status: { equals: "parked" } };
            case _interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryType.Completed:
                return { isActive: { equals: false } };
            default:
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("Unknown query type:", queryType);
                return null;
        }
    }
    buildUserSelectedFilters(filters) {
        if (!filters) {
            return [];
        }
        const createNestedObjectWithInnermost = (names) => {
            if (names.length === 0) {
                const emptyObject = {};
                return { rootObject: emptyObject, innermostObject: emptyObject };
            }
            const [current, ...rest] = names;
            const { rootObject: childNestedObject, innermostObject } = createNestedObjectWithInnermost(rest);
            const nestedObject = { [current]: childNestedObject };
            return { rootObject: nestedObject, innermostObject };
        };
        const filterObjects = [];
        const keys = Object.keys(filters);
        // If both ChannelType and ChannelSubType are present, use one OR filter with values from both
        if (keys.includes(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChannelType) &&
            keys.includes(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChannelSubType) &&
            filters[_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChannelType] &&
            filters[_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChannelType].length > 0 &&
            filters[_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChannelSubType] &&
            filters[_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChannelSubType].length > 0) {
            const getChannelFilterString = (key, filter) => {
                return filter.map((value) => {
                    const { rootObject, innermostObject } = createNestedObjectWithInnermost(key.split("."));
                    innermostObject[value.operator] = value.filter;
                    return rootObject;
                });
            };
            const channelTypeFilter = getChannelFilterString(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChannelType, filters[_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChannelType]);
            const channelSubTypeFilter = getChannelFilterString(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChannelSubType, filters[_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChannelSubType]);
            filterObjects.push({ or: [...channelTypeFilter, ...channelSubTypeFilter] });
            // Clear ChannelType and ChannelSubType from filters to avoid duplication
            filters[_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChannelType] = undefined;
            filters[_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChannelSubType] = undefined;
        }
        filterObjects.push(...Object.entries(filters).map(([key, values]) => {
            if (!values || values.length === 0) {
                return null;
            }
            if (values[0].filterType === _interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.FilterType.ChannelTypeFilter ||
                values[0].filterType === _interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.FilterType.CSATFilter ||
                values[0].filterType === _interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.FilterType.SetFilter) {
                const filterValues = values.map((value) => {
                    const { rootObject, innermostObject } = createNestedObjectWithInnermost(key.split("."));
                    innermostObject[value.operator] = value.filter;
                    return rootObject;
                });
                if (filterValues.length === 1) {
                    return filterValues[0];
                }
                return { or: filterValues };
            }
            if (values[0].filterType === _interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.FilterType.StringFilter ||
                values[0].filterType === _interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.FilterType.NumberFilter ||
                values[0].filterType === _interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.FilterType.BooleanFilter) {
                const filterValues = values.map((value) => {
                    const { rootObject, innermostObject } = createNestedObjectWithInnermost(key.split("."));
                    innermostObject[value.operator] = value.filter;
                    return rootObject;
                });
                if (filterValues.length === 1) {
                    return filterValues[0];
                }
                return { and: filterValues };
            }
            _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("Unknown filter type:", values[0].filterType);
            return null;
        }));
        // Remove null values
        return filterObjects.filter((filter) => filter !== null);
    }
    buildFilterObject(queryType, filters) {
        const filtersArray = [{ id: { notequals: "" } }];
        const queryTypeFilter = this.buildQueryTypeFilters(queryType);
        if (queryTypeFilter) {
            filtersArray.push(queryTypeFilter);
        }
        if (filters) {
            const userSelectedFilters = this.buildUserSelectedFilters(filters);
            if (userSelectedFilters.length > 0) {
                filtersArray.push(...userSelectedFilters);
            }
        }
        return {
            and: filtersArray
        };
    }
    buildQuery(queryType, params) {
        const addSortParam = (field, sortBy) => {
            return (sortBy === null || sortBy === void 0 ? void 0 : sortBy.fields.includes(field)) ? `(sort:${sortBy.order})` : "";
        };
        const taskDetailsQuery = (0,gql_query_builder__WEBPACK_IMPORTED_MODULE_1__.query)({
            operation: "taskDetails",
            variables: {
                from: { type: "Long", value: params.startTime, required: true },
                to: { type: "Long", value: params.endTime, required: true },
                pagination: { type: "Pagination", value: { cursor: params.cursor }, required: false },
                filter: { type: "TaskDetailsFilters", value: this.buildFilterObject(queryType, params.filters) }
            },
            fields: [
                {
                    tasks: [
                        `id ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.Id, params.sortBy)}`,
                        `status ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.Status, params.sortBy)}`,
                        `channelType ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChannelType, params.sortBy)}`,
                        `createdTime ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.CreatedTime, params.sortBy)}`,
                        `endedTime ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.EndedTime, params.sortBy)}`,
                        `origin ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.Origin, params.sortBy)}`,
                        `destination ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.Destination, params.sortBy)}`,
                        `contactReason ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ContactReason, params.sortBy)}`,
                        `direction ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.Direction, params.sortBy)}`,
                        `channelSubType ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChannelSubType, params.sortBy)}`,
                        {
                            customer: [
                                `name ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.CustomerName, params.sortBy)}`,
                                `phoneNumber ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.CustomerPhone, params.sortBy)}`,
                                `email ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.CustomerEmail, params.sortBy)}`
                            ]
                        },
                        `isActive ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.IsActive, params.sortBy)}`,
                        {
                            channelMetaData: [
                                {
                                    email: [
                                        `subject ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.EmailSubject, params.sortBy)}`
                                    ]
                                },
                                {
                                    chat: [
                                        `chatReason ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ChatReason, params.sortBy)}`
                                    ]
                                }
                            ]
                        },
                        {
                            lastQueue: [
                                `id ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.QueueId, params.sortBy)}`,
                                `name ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.QueueName, params.sortBy)}`,
                                `duration ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.QueueDuraion, params.sortBy)}`
                            ]
                        },
                        {
                            lastSite: [
                                `id ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.SiteId, params.sortBy)}`,
                                `name ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.SiteName, params.sortBy)}`
                            ]
                        },
                        {
                            lastTeam: [
                                `id ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.TeamId, params.sortBy)}`,
                                `name ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.TeamName, params.sortBy)}`
                            ]
                        },
                        {
                            lastEntryPoint: [
                                `id ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.EntryPointId, params.sortBy)}`,
                                `name ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.EntryPointName, params.sortBy)}`
                            ]
                        },
                        {
                            previousQueue: [
                                `id ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.PreviousQueueId, params.sortBy)}`,
                                `name ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.PreviousQueueName, params.sortBy)}`
                            ]
                        },
                        `lastWrapUpCodeId ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.WrapUpCodeId, params.sortBy)}`,
                        `lastWrapupCodeName ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.WrapUpCodeName, params.sortBy)}`,
                        {
                            lastAgent: [
                                `id ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.AgentId, params.sortBy)}`,
                                `name ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.AgentName, params.sortBy)}`,
                                `signInId ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.AgentSignInId, params.sortBy)}`,
                                `sessionId ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.AgentSessionId, params.sortBy)}`,
                                `phoneNumber ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.AgentPhoneNumber, params.sortBy)}`,
                                `channelId ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.AgentChannelId, params.sortBy)}`
                            ]
                        },
                        `emailBccList ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.EmailBccList, params.sortBy)}`,
                        `emailCcList ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.EmailCcList, params.sortBy)}`,
                        `emailToList ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.EmailToList, params.sortBy)}`,
                        `totalDuration ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.TotalDuration, params.sortBy)}`,
                        `csatScore ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.CSATScore, params.sortBy)}`,
                        `blindTransferCount ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.BlindTransferCount, params.sortBy)}`,
                        `conferenceCount ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ConferenceCount, params.sortBy)}`,
                        `conferenceDuration ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ConferenceDuration, params.sortBy)}`,
                        `consultCount ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ConsultCount, params.sortBy)}`,
                        `consultDuration ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ConsultDuration, params.sortBy)}`,
                        `holdCount ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.HoldCount, params.sortBy)}`,
                        `holdDuration ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.HoldDuration, params.sortBy)}`,
                        `connectedCount ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ConnectedCount, params.sortBy)}`,
                        `connectedDuration ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.ConnectedDuration, params.sortBy)}`,
                        `transferCount ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.TransferCount, params.sortBy)}`,
                        `wrapupDuration ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.WrapUpDuration, params.sortBy)}`,
                        `ringingDuration ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.RingingDuration, params.sortBy)}`,
                        `queueDuration ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.QueueDuration, params.sortBy)}`,
                        `queueCount ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.QueueCount, params.sortBy)}`,
                        `callCompletedCount ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.CallCompletedCount, params.sortBy)}`,
                        `sentiment`,
                        `autoCsat ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.AutoCSAT, params.sortBy)}`,
                        `matchedSkills`,
                        `requiredSkills`,
                        `matchedSkillsProfile`,
                        `isWithInServiceLevel ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.IsWithInServiceLevel, params.sortBy)}`,
                        `isContactHandled ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.IsContactHandled, params.sortBy)}`,
                        `previousAgentId ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.PreviousAgentId, params.sortBy)}`,
                        `previousAgentSessionId ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.PreviousAgentSessionId, params.sortBy)}`,
                        `previousAgentName ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.PreviousAgentName, params.sortBy)}`,
                        `isOutdial ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.IsOutdial, params.sortBy)}`,
                        `agentToQueueTransferCount ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.AgentToQueueTransferCount, params.sortBy)}`,
                        `lastActivityTime ${addSortParam(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.LastActivityTime, params.sortBy)}`
                    ]
                },
                {
                    pageInfo: ["endCursor", "hasNextPage"]
                }
            ]
        });
        // Check that the query parses correctly before sending it
        try {
            (0,graphql__WEBPACK_IMPORTED_MODULE_2__.parse)(taskDetailsQuery.query);
        }
        catch (error) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("Error parsing GraphQL query:", taskDetailsQuery.query, "error:", error);
            throw error;
        }
        // Validate that required variables are present and of the expected types
        if (typeof taskDetailsQuery.variables.from !== "number") {
            throw new Error('Variable "from" must be a number (timestamp)');
        }
        if (typeof taskDetailsQuery.variables.to !== "number") {
            throw new Error('Variable "to" must be a number (timestamp)');
        }
        if (taskDetailsQuery.variables.from > taskDetailsQuery.variables.to) {
            throw new Error('"from" time must be before "to" time');
        }
        if (taskDetailsQuery.variables.pagination && typeof taskDetailsQuery.variables.pagination.cursor !== "string") {
            throw new Error('Variable "pagination.cursor" must be a string');
        }
        if (!taskDetailsQuery.variables.filter || typeof taskDetailsQuery.variables.filter !== "object") {
            throw new Error('Variable "filter" must be a valid object');
        }
        return taskDetailsQuery;
    }
    fetchInteractions(queryType, params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (params.sortBy &&
                (params.sortBy.fields.includes(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.Sentiment) ||
                    params.sortBy.fields.includes(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.MatchedSkills) ||
                    params.sortBy.fields.includes(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.RequiredSkills) ||
                    params.sortBy.fields.includes(_interactions_service_constants__WEBPACK_IMPORTED_MODULE_9__.InteractionsServiceConstants.QueryField.MatchedSkillsProfile))) {
                throw new Error("Sorting by sentiment, matchedSkills, requiredSkill or matchedSkillsProfile is not supported");
            }
            const req = this.http.req((data) => ({
                url: `/search`,
                headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_7__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_service_utils__WEBPACK_IMPORTED_MODULE_8__.generateUUID)()}` }),
                data,
                err: (e) => createErrDetailsObjectWithStatusCode(e, "Service.interactions.fetchInteractions"),
                method: "POST",
                errId: "Service.interactions.fetchInteractions",
                res: {}
            }));
            const response = yield req(this.buildQuery(queryType, params));
            return response.data.taskDetails;
        });
    }
}


/***/ }),

/***/ "./src/services/interactions/interactions-service.ts":
/*!***********************************************************!*\
  !*** ./src/services/interactions/interactions-service.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   InteractionsService: () => (/* binding */ InteractionsService),
/* harmony export */   buildInteractionsService: () => (/* binding */ buildInteractionsService)
/* harmony export */ });
/* harmony import */ var set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! set-interval-async/dynamic */ "set-interval-async/dynamic");
/* harmony import */ var set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _interactions_service_rtd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./interactions-service-rtd */ "./src/services/interactions/interactions-service-rtd.ts");
/* harmony import */ var _interactions_service_search__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./interactions-service-search */ "./src/services/interactions/interactions-service-search.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





class InteractionsService {
    constructor(interactionsSearchApi, interactionsRtd) {
        this.interactionsSearchApi = interactionsSearchApi;
        this.interactionsRtd = interactionsRtd;
        this.subscribers = new Map();
    }
    fetchCompletedInteractions(startTime, endTime, callback, sortBy, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.interactionsSearchApi.fetchCompletedInteractions({
                startTime,
                endTime,
                cursor: "NA",
                sortBy,
                filters
            }, callback);
        });
    }
    subscribeInteractionUpdates(queryType, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!callback) {
                throw new Error("callback is required to subscribe to interaction updates");
            }
            if (Array.from(this.subscribers.values()).some((subscriber) => subscriber.callback === callback)) {
                throw new Error("Already subscribed to interaction updates");
            }
            const rtdSubscription = yield this.interactionsRtd.subscribeInteractionUpdates(queryType, callback);
            return this.addSubscription(callback, { rtdSubscription });
        });
    }
    stopInteractionUpdates(subscriptionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const subscriber = this.subscribers.get(subscriptionId);
            if (!subscriber) {
                return;
            }
            if (subscriber.pollingResponse) {
                yield (0,set_interval_async_dynamic__WEBPACK_IMPORTED_MODULE_0__.clearIntervalAsync)(subscriber.pollingResponse.intervalId);
            }
            if (subscriber.rtdSubscription) {
                subscriber.rtdSubscription.unsubscribe();
            }
            this.subscribers.delete(subscriptionId);
        });
    }
    startQueuedPolling(callback, sortBy, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const pollingResponse = yield this.interactionsSearchApi.startQueuedPolling(callback, sortBy, filters);
                return this.addSubscription(callback, { pollingResponse });
            }
            catch (error) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`event=startQueuedPolling "Failed to start queued polling`, error);
                throw error;
            }
        });
    }
    fetchMoreQueuedInteractions(subscriptionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const subscriber = this.subscribers.get(subscriptionId);
            if (!(subscriber === null || subscriber === void 0 ? void 0 : subscriber.pollingResponse)) {
                throw new Error(`Subscription with ID ${subscriptionId} not found`);
            }
            return subscriber.pollingResponse.fetchMore();
        });
    }
    addSubscription(callback, params) {
        if (Array.from(this.subscribers.values()).some((subscriber) => subscriber.callback === callback)) {
            throw new Error("Callback is already subscribed");
        }
        const subscriptionId = (0,_service_utils__WEBPACK_IMPORTED_MODULE_2__.generateUUID)();
        _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[InteractionsService] New subscription created:", subscriptionId);
        this.subscribers.set(subscriptionId, {
            callback,
            pollingResponse: params.pollingResponse,
            rtdSubscription: params.rtdSubscription
        });
        return subscriptionId;
    }
}
function buildInteractionsService() {
    return new InteractionsService(new _interactions_service_search__WEBPACK_IMPORTED_MODULE_4__.InteractionsSearchApi(), new _interactions_service_rtd__WEBPACK_IMPORTED_MODULE_3__.InteractionsRtdEndpoint());
}


/***/ }),

/***/ "./src/services/logrocket/constants.ts":
/*!*********************************************!*\
  !*** ./src/services/logrocket/constants.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FieldNamesConstant: () => (/* binding */ FieldNamesConstant)
/* harmony export */ });
const FieldNamesConstant = () => {
    return [
        "emails",
        "email",
        "access_token",
        "userName",
        "AgentName",
        "token",
        "displayName",
        "nickName",
        "firstName",
        "lastName",
        "phoneNumbers",
        "phoneNumber",
        "text",
        "ani",
        "computedTitle",
        "mobile",
        "contactData"
    ];
};


/***/ }),

/***/ "./src/services/logrocket/log-rocket-sanitizer.ts":
/*!********************************************************!*\
  !*** ./src/services/logrocket/log-rocket-sanitizer.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LogRocketSanitizer: () => (/* binding */ LogRocketSanitizer)
/* harmony export */ });
/* harmony import */ var logrocket_fuzzy_search_sanitizer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! logrocket-fuzzy-search-sanitizer */ "logrocket-fuzzy-search-sanitizer");
/* harmony import */ var logrocket_fuzzy_search_sanitizer__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(logrocket_fuzzy_search_sanitizer__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./constants */ "./src/services/logrocket/constants.ts");


class LogRocketSanitizer {
    constructor() {
        this.fuzzySanitizer = logrocket_fuzzy_search_sanitizer__WEBPACK_IMPORTED_MODULE_0___default().setup((0,_constants__WEBPACK_IMPORTED_MODULE_1__.FieldNamesConstant)());
    }
    requestSanitizer(request) {
        return this.fuzzySanitizer.requestSanitizer(request);
    }
    responseSanitizer(response) {
        return this.fuzzySanitizer.responseSanitizer(response);
    }
}


/***/ }),

/***/ "./src/services/logrocket/log-rocket-service.ts":
/*!******************************************************!*\
  !*** ./src/services/logrocket/log-rocket-service.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LogRocketService: () => (/* binding */ LogRocketService)
/* harmony export */ });
/* harmony import */ var logrocket__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! logrocket */ "logrocket");
/* harmony import */ var logrocket__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(logrocket__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _log_rocket_sanitizer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./log-rocket-sanitizer */ "./src/services/logrocket/log-rocket-sanitizer.ts");


const isNotAllowedURL = (url) => {
    if (!url) {
        return false;
    }
    const notAllowedURLs = ["secure", "/ab/api/cms"];
    return notAllowedURLs.some((notAllowedURL) => url.toLowerCase().indexOf(notAllowedURL) !== -1);
};
class LogRocketService {
    init(authorizationKey, enableSanitization) {
        const sanitizer = new _log_rocket_sanitizer__WEBPACK_IMPORTED_MODULE_1__.LogRocketSanitizer();
        logrocket__WEBPACK_IMPORTED_MODULE_0___default().init(authorizationKey, {
            dom: {
                inputSanitizer: enableSanitization,
                textSanitizer: enableSanitization
            },
            network: {
                requestSanitizer: (request) => {
                    if (request === null || request === void 0 ? void 0 : request.headers["Authorization"]) {
                        request.headers["Authorization"] = "*";
                    }
                    if (request === null || request === void 0 ? void 0 : request.headers["authorization"]) {
                        request.headers["authorization"] = "*";
                    }
                    if (isNotAllowedURL(request.url)) {
                        request.body = "*";
                    }
                    return sanitizer.requestSanitizer(request);
                },
                responseSanitizer: (response) => {
                    if (isNotAllowedURL(response.url)) {
                        response.body = "*";
                        return response;
                    }
                    else {
                        return sanitizer.responseSanitizer(response);
                    }
                }
            }
        });
    }
    identify(id, associatedData) {
        logrocket__WEBPACK_IMPORTED_MODULE_0___default().identify(id, associatedData);
    }
}


/***/ }),

/***/ "./src/services/mediaStorage/media-storage-service.ts":
/*!************************************************************!*\
  !*** ./src/services/mediaStorage/media-storage-service.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MediaStorage: () => (/* binding */ MediaStorage)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




class MediaStorage {
    constructor() {
        this.http = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_3__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_2__.CONF.MEDIA_SERVICE_HOST);
        this.metaDataErrorId = "Service.mediaStorage.metaData";
        this.fetchMetaData = this.http.req((p) => ({
            url: `/media/organization/${p.orgId}/interaction/${p.interactionId}/ivrtranscript?timeOutMins=${p.timeoutMins}`,
            method: "GET",
            err: (e) => new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details(this.metaDataErrorId, { axiosError: e.response }),
            res: {}
        }));
        this.fetchConversation = (url) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                axios__WEBPACK_IMPORTED_MODULE_1___default().get(url)
                    .then((conversationResponse) => {
                    resolve(conversationResponse.data);
                })
                    .catch((e) => {
                    reject(new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details("Service.mediaStorage.conversation", { axiosError: e.response }));
                });
            });
        });
        // flattern the params object recursively
        this.getFlatParams = (params, paramKey) => {
            let flatParams = {};
            if (Array.isArray(params)) {
                params.forEach((param) => {
                    if (param && typeof param === "object") {
                        flatParams = Object.assign(Object.assign({}, flatParams), this.getFlatParams(param, paramKey));
                    }
                    else {
                        flatParams[paramKey] = param;
                    }
                });
            }
            else {
                Object.keys(params).forEach((key) => {
                    const finalKey = paramKey ? `${paramKey} ${key}` : key;
                    if (params[key] && typeof params[key] === "object") {
                        flatParams = Object.assign(Object.assign({}, flatParams), this.getFlatParams(params[key], finalKey));
                    }
                    else {
                        flatParams[finalKey] = params[key];
                    }
                });
            }
            return flatParams;
        };
        this.parseConversations = (conversation, botName) => {
            conversation.forEach((transcript, index) => {
                if (transcript.bot) {
                    transcript.bot.botName = botName;
                    if (transcript.bot.parameters) {
                        transcript.bot.parameters = this.getFlatParams(transcript.bot.parameters, "");
                    }
                    conversation[index] = transcript;
                }
            });
            return conversation;
        };
        this.fetchIVRTranscript = (orgId, interactionId, timeoutMins) => __awaiter(this, void 0, void 0, function* () {
            const metaData = yield this.fetchMetaData({ orgId, interactionId, timeoutMins });
            let transcriptConversations = [];
            const transcriptMetaDataList = metaData.transcripts;
            for (const transcriptMetaData of transcriptMetaDataList) {
                let { conversation } = yield this.fetchConversation(transcriptMetaData.transcriptPath);
                conversation = this.parseConversations(conversation, transcriptMetaData.botName);
                transcriptConversations = transcriptConversations.concat(conversation);
            }
            return transcriptConversations;
        });
        this.fetchStorageEmailContent = (url) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                axios__WEBPACK_IMPORTED_MODULE_1___default().get(url)
                    .then((emailContentResponse) => {
                    resolve(emailContentResponse.data);
                })
                    .catch((e) => {
                    reject({ axiosError: e.message });
                });
            });
        });
        this.getStorageUrl = this.http.req((resourceUrl) => ({
            url: `/${resourceUrl.substring(resourceUrl.indexOf("mediastorage/v1"))}`,
            method: "GET",
            err: (e) => new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details(this.metaDataErrorId, { axiosError: e.response }),
            res: {}
        }));
        this.downloadStorageAttachment = (url) => __awaiter(this, void 0, void 0, function* () {
            const data = yield this.getStorageUrl(url);
            return new Promise((resolve, reject) => {
                axios__WEBPACK_IMPORTED_MODULE_1___default().get(data.preSignedUrl, {
                    responseType: "arraybuffer"
                })
                    .then((emailContentResponse) => {
                    resolve(emailContentResponse.data);
                })
                    .catch((e) => {
                    reject({ axiosError: e.message });
                });
            });
        });
    }
}


/***/ }),

/***/ "./src/services/pci/pci-service.ts":
/*!*****************************************!*\
  !*** ./src/services/pci/pci-service.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   pciService: () => (/* binding */ pciService)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");
/* eslint-disable @typescript-eslint/no-explicit-any */



function pciService() {
    const http = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_0__.CONF.COMPLIANCE_SERVICE_URL);
    return {
        pciCheck: http.req((p) => ({
            url: `/content/pci/`,
            res: {},
            data: p.data,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_2__.createErrDetailsObject,
            errId: "Service.pci.pciCheck"
        })),
        fetchPciSettings: http.req((p) => ({
            url: `/digital-media-pci/organization/${p.orgId}`,
            res: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_2__.createErrDetailsObject,
            errId: "Service.pci.fetchPciSettings"
        })),
        fetchPciAllowedAttachmentTypes: http.req(() => ({
            url: `/validate/pci/supportedFormats`,
            res: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_2__.createErrDetailsObject,
            errId: "Service.pci.fetchPciAllowedAttachmentTypes"
        }))
    };
}


/***/ }),

/***/ "./src/services/prometheus/constants.ts":
/*!**********************************************!*\
  !*** ./src/services/prometheus/constants.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PrometheusConstant: () => (/* binding */ PrometheusConstant)
/* harmony export */ });
const PrometheusConstant = () => {
    return {
        AGENT_LOGIN: "AGENT_LOGIN",
        AGENT_LOGOUT: "AGENT_LOGOUT",
        AGENT_STATE_CHANGE: "AGENT_STATE_CHANGE",
        WEB_SOCKET_DISCONNECT: "WEB_SOCKET_DISCONNECT",
        CUSTOM_LAYOUT_LOAD_FAIL: "CUSTOM_LAYOUT_LOAD_FAIL",
        WEBRTC_REGISTRATION_FAILURE: "WEBRTC_REGISTRATION_FAILURE",
        WEBRTC_REGISTRATION_RETRY: "WEBRTC_REGISTRATION_RETRY",
        CI_TOKEN_REFRESH: "CI_TOKEN_REFRESH"
    };
};


/***/ }),

/***/ "./src/services/prometheus/prometheus-service.ts":
/*!*******************************************************!*\
  !*** ./src/services/prometheus/prometheus-service.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getGeneralizeLabels: () => (/* binding */ getGeneralizeLabels),
/* harmony export */   getRegisterEvent: () => (/* binding */ getRegisterEvent),
/* harmony export */   getTimeStampDifference: () => (/* binding */ getTimeStampDifference),
/* harmony export */   submitIntoStorage: () => (/* binding */ submitIntoStorage),
/* harmony export */   unifyEventNames: () => (/* binding */ unifyEventNames)
/* harmony export */ });
/* harmony import */ var _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../telemetry/constants */ "./src/services/telemetry/constants.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./constants */ "./src/services/prometheus/constants.ts");


const getTimeStampDifference = (startDate, endDate) => {
    return (endDate.getTime() - startDate.getTime()) / 1000;
};
const getRegisterEvent = (_db, event) => {
    const registerEventIndex = _db.findIndex((a) => a.event === event);
    if (registerEventIndex > -1) {
        const registerEvent = _db[registerEventIndex];
        _db.splice(registerEventIndex, 1);
        return { updatedDb: _db, registerEvent };
    }
    else {
        return { updatedDb: null, registerEvent: null };
    }
};
const unifyEventNames = (event) => {
    switch (event) {
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AGENT_STATE_CHANGE: {
            return (0,_constants__WEBPACK_IMPORTED_MODULE_1__.PrometheusConstant)().AGENT_STATE_CHANGE;
        }
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.STATION_LOGIN: {
            return (0,_constants__WEBPACK_IMPORTED_MODULE_1__.PrometheusConstant)().AGENT_LOGIN;
        }
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.SIGN_OUT: {
            return (0,_constants__WEBPACK_IMPORTED_MODULE_1__.PrometheusConstant)().AGENT_LOGOUT;
        }
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WEB_SOCKET_DISCONNECT: {
            return (0,_constants__WEBPACK_IMPORTED_MODULE_1__.PrometheusConstant)().WEB_SOCKET_DISCONNECT;
        }
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CUSTOM_LAYOUT_LOAD_FAIL: {
            return (0,_constants__WEBPACK_IMPORTED_MODULE_1__.PrometheusConstant)().CUSTOM_LAYOUT_LOAD_FAIL;
        }
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WEBRTC_REGISTRATION_FAILURE: {
            return (0,_constants__WEBPACK_IMPORTED_MODULE_1__.PrometheusConstant)().WEBRTC_REGISTRATION_FAILURE;
        }
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WEBRTC_REGISTRATION_RETRY: {
            return (0,_constants__WEBPACK_IMPORTED_MODULE_1__.PrometheusConstant)().WEBRTC_REGISTRATION_RETRY;
        }
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CI_TOKEN_REFRESH: {
            return (0,_constants__WEBPACK_IMPORTED_MODULE_1__.PrometheusConstant)().CI_TOKEN_REFRESH;
        }
        default: {
            return event;
        }
    }
};
/*
 * Generalize Label Object to label string for grok patten search.
 * Label: event
 * Label: org_id
 * Label: state
 * Label: old_state
 * Label: status
 * Label: reason_code
 * Label: duration
 * Label: media_type
 * Label: media_channel
 * Label: interaction_id
 */
const getGeneralizeLabels = (options) => {
    const labels = [
        "event",
        "org_id",
        "state",
        "old_state",
        "status",
        "reason_code",
        "duration",
        "media_type",
        "error_code",
        "media_channel"
    ];
    let labelString = "";
    for (const i in labels) {
        const label = labels[i];
        if (Number(i) > 0) {
            labelString += "|";
        }
        if (options[label] || options[label] === false) {
            labelString += ` ${label}=${options[label]} `;
        }
        else {
            labelString += ` ${label}=null `;
        }
    }
    labelString += `|`;
    return labelString.trim();
};
const submitIntoStorage = (event) => {
    const existingStorage = localStorage.getItem("prometheus-logs") || "";
    let existingStorageParsed = [];
    try {
        existingStorageParsed = JSON.parse(existingStorage);
    }
    catch (_a) {
        existingStorageParsed = [];
    }
    existingStorageParsed.push({ message: event, level: "info" });
    localStorage.setItem("prometheus-logs", JSON.stringify(existingStorageParsed));
};


/***/ }),

/***/ "./src/services/prometheus/prometheus-tracking.ts":
/*!********************************************************!*\
  !*** ./src/services/prometheus/prometheus-tracking.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PrometheusService: () => (/* binding */ PrometheusService)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./constants */ "./src/services/prometheus/constants.ts");
/* harmony import */ var _prometheus_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./prometheus-service */ "./src/services/prometheus/prometheus-service.ts");


class PrometheusService {
    constructor(confService) {
        this._db = [];
        this.EVENT = (0,_constants__WEBPACK_IMPORTED_MODULE_0__.PrometheusConstant)();
        this.confService = confService;
    }
    init() {
        return this;
    }
    startEvent(event, options) {
        const unifiedEventName = (0,_prometheus_service__WEBPACK_IMPORTED_MODULE_1__.unifyEventNames)(event);
        this._db.push({ event: unifiedEventName, timestamp: options.timestamp });
    }
    endEvent(event, options) {
        var _a, _b;
        const unifiedEventName = (0,_prometheus_service__WEBPACK_IMPORTED_MODULE_1__.unifyEventNames)(event);
        const { updatedDb, registerEvent } = (0,_prometheus_service__WEBPACK_IMPORTED_MODULE_1__.getRegisterEvent)(this._db, unifiedEventName);
        if (registerEvent) {
            if (updatedDb) {
                this._db = updatedDb;
            }
            const duration = (0,_prometheus_service__WEBPACK_IMPORTED_MODULE_1__.getTimeStampDifference)(registerEvent === null || registerEvent === void 0 ? void 0 : registerEvent.timestamp, options.timestamp);
            const generalizeLabels = (0,_prometheus_service__WEBPACK_IMPORTED_MODULE_1__.getGeneralizeLabels)(Object.assign(Object.assign({ org_id: (_b = (_a = this.confService) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.orgId, event: unifiedEventName }, options), { duration }));
            (0,_prometheus_service__WEBPACK_IMPORTED_MODULE_1__.submitIntoStorage)(generalizeLabels);
        }
    }
}


/***/ }),

/***/ "./src/services/qmw/qmw-service.ts":
/*!*****************************************!*\
  !*** ./src/services/qmw/qmw-service.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createErrDetailsObjectWithStatusCode: () => (/* binding */ createErrDetailsObjectWithStatusCode),
/* harmony export */   qmwService: () => (/* binding */ qmwService)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");






const RETRY_AFTER_HEADER = "retry-after";
const createErrDetailsObjectWithStatusCode = (errObj, errorKey) => {
    var _a, _b, _c, _d, _e;
    const details = {
        trackingId: ((_a = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _a === void 0 ? void 0 : _a.headers["trackingid"]) || ((_b = errObj === null || errObj === void 0 ? void 0 : errObj.config) === null || _b === void 0 ? void 0 : _b.headers["TrackingID"]),
        msg: (_c = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _c === void 0 ? void 0 : _c.data,
        statusCode: (_d = errObj.response) === null || _d === void 0 ? void 0 : _d.status,
        retryAfter: (_e = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _e === void 0 ? void 0 : _e.headers[RETRY_AFTER_HEADER]
    };
    return new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details(errorKey !== null && errorKey !== void 0 ? errorKey : "Service.reqs.generic.failure", details);
};
function qmwService() {
    const http = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_3__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_2__.CONF.API_GATEWAY);
    return {
        fetchTasks: http.req((p) => ({
            url: `/search`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_service_utils__WEBPACK_IMPORTED_MODULE_5__.generateUUID)()}` }),
            data: {
                query: `
        query($startTime: Long!,$endTime: Long!)
        {
    
          task(
            from: $startTime
            to: $endTime
             filter: {
              and: [
                { channelType: { equals: telephony } }
                { status : { equals: "ended" } }
                { captureRequested: { equals: true} }
                { isRecordingDeleted: { equals: false } }
              ]
            } 
           #Start with Page 0     
            pagination: { cursor: "${p.pageNumber}" }
          ) {
            tasks {
              id
              origin
              destination
              autoCsat
              lastQueue {
                name
              }
              lastTeam {
                name
              }
              owner {
                name
              }
              connectedDuration
              lastWrapupCodeName
              createdTime
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
        }
        `,
                variables: {
                    startTime: p.startTime,
                    endTime: p.endTime
                }
            },
            err: (e) => createErrDetailsObjectWithStatusCode(e, "Service.qmw.fetchTasks"),
            method: "POST",
            errId: "Service.qmw.fetchTasks",
            res: {}
        })),
        fetchCaptureMetaData: http.req((p) => ({
            url: `/search`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_service_utils__WEBPACK_IMPORTED_MODULE_5__.generateUUID)()}` }),
            data: {
                query: `{
            taskDetails(
              from: ${p.startTime - luxon__WEBPACK_IMPORTED_MODULE_1__.Duration.fromObject({ days: 1 }).toMillis()}
              to: ${p.startTime + luxon__WEBPACK_IMPORTED_MODULE_1__.Duration.fromObject({ days: 1 }).toMillis()}
              filter: {
                  id:{equals: "${p.taskId}"}
              }
            ) {
              tasks {
                id
                activities (first: 100) {
                  nodes {
                    eventName
                    createdTime
                    endedTime
                    duration
                    agentName
                    agentId
                    destinationAgentName
                  }
                }
              }
            }
          }`
            },
            err: (e) => createErrDetailsObjectWithStatusCode(e, "Service.qmw.fetchCaptureMetaData"),
            method: "POST",
            errId: "Service.qmw.fetchCaptureMetaData",
            res: {}
        })),
        fetchCapture: http.req((p) => ({
            url: `/v1/captures/query`,
            headers: Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_4__.HTTP_HEADERS),
            data: {
                query: {
                    taskIds: [p.taskId],
                    includeSegments: false
                }
            },
            err: (e) => createErrDetailsObjectWithStatusCode(e, "Service.qmw.fetchCapture"),
            method: "POST",
            errId: "Service.qmw.fetchCapture",
            res: {}
        }))
    };
}


/***/ }),

/***/ "./src/services/service-utils.ts":
/*!***************************************!*\
  !*** ./src/services/service-utils.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   RETRY_INTERVAL: () => (/* binding */ RETRY_INTERVAL),
/* harmony export */   checkOnlineStatus: () => (/* binding */ checkOnlineStatus),
/* harmony export */   createErrDetailsObject: () => (/* binding */ createErrDetailsObject),
/* harmony export */   formatStringsForLogs: () => (/* binding */ formatStringsForLogs),
/* harmony export */   generateUUID: () => (/* binding */ generateUUID),
/* harmony export */   getCanaryFlagFromSessionStorage: () => (/* binding */ getCanaryFlagFromSessionStorage),
/* harmony export */   handleExternalServiceErrorDetails: () => (/* binding */ handleExternalServiceErrorDetails),
/* harmony export */   sleep: () => (/* binding */ sleep)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../config */ "./src/config.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./constant */ "./src/services/constant.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




const getCommonErrorDetails = (errObj) => {
    var _a, _b, _c, _d, _e;
    return {
        trackingId: ((_b = (_a = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b["trackingid"]) || ((_d = (_c = errObj === null || errObj === void 0 ? void 0 : errObj.config) === null || _c === void 0 ? void 0 : _c.headers) === null || _d === void 0 ? void 0 : _d["TrackingID"]),
        msg: (_e = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _e === void 0 ? void 0 : _e.data
    };
};
const createErrDetailsObject = (errObj) => {
    const details = getCommonErrorDetails(errObj);
    return new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details("Service.reqs.generic.failure", details);
};
const handleExternalServiceErrorDetails = (errObj) => {
    var _a, _b;
    const details = getCommonErrorDetails(errObj);
    return new _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Err.Details("Service.reqs.externalService.generic.failure", Object.assign(Object.assign({}, details), { status: (_b = (_a = errObj === null || errObj === void 0 ? void 0 : errObj.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : "" }));
};
const getCanaryFlagFromSessionStorage = () => {
    const flag = sessionStorage.getItem("canary");
    return flag === "true" ? true : false;
};
/**
 * Pings an API and checks if API is returning 200 or not
 * In localhost pings GET method and HEAD method otherwise
 * @returns onlineStatus
 */
const checkOnlineStatus = function () {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const online = yield fetch(_config__WEBPACK_IMPORTED_MODULE_2__.PING_API_URL, {
                method: _config__WEBPACK_IMPORTED_MODULE_2__.METHOD_NAME,
                headers: {
                    "cache-control": _constant__WEBPACK_IMPORTED_MODULE_3__.CACHE_CONTROL_HEADER
                }
            });
            return online.status === 200;
        }
        catch (_a) {
            return false;
        }
    });
};
const generateUUID = () => {
    let d = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.utc().toMillis();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0; // eslint-disable-line no-bitwise
        d = Math.floor(d / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16); // eslint-disable-line no-bitwise
    });
};
const RETRY_INTERVAL = 200;
const sleep = (interval) => new Promise((resolve) => setTimeout(() => resolve(true), interval));
const formatStringsForLogs = (logs) => logs.replaceAll(_constant__WEBPACK_IMPORTED_MODULE_3__.uuipEol, "\n");


/***/ }),

/***/ "./src/services/services.ts":
/*!**********************************!*\
  !*** ./src/services/services.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentxServices: () => (/* binding */ AgentxServices)
/* harmony export */ });
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _feature_flag_names__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../feature-flag-names */ "./src/feature-flag-names.ts");
/* harmony import */ var _services_shortcutKey_shortcutkey_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../services/shortcutKey/shortcutkey-service */ "./src/services/shortcutKey/shortcutkey-service.ts");
/* harmony import */ var _actions_channels_actions_channels_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./actions-channels/actions-channels-service */ "./src/services/actions-channels/actions-channels-service.ts");
/* harmony import */ var _agent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./agent */ "./src/services/agent/index.ts");
/* harmony import */ var _agent_performance_agent_performance_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./agent-performance/agent-performance-service */ "./src/services/agent-performance/agent-performance-service.ts");
/* harmony import */ var _agentx_backend_proxy_agentx_backend_proxy_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./agentx-backend-proxy/agentx-backend-proxy-service */ "./src/services/agentx-backend-proxy/agentx-backend-proxy-service.ts");
/* harmony import */ var _api_ai_assistant_service_api_ai_assistant_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./api-ai-assistant-service/api-ai-assistant-service */ "./src/services/api-ai-assistant-service/api-ai-assistant-service.ts");
/* harmony import */ var _aqm_aqm_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./aqm/aqm-service */ "./src/services/aqm/aqm-service.ts");
/* harmony import */ var _avatar_avatar_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./avatar/avatar-service */ "./src/services/avatar/avatar-service.ts");
/* harmony import */ var _cms_cms_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./cms/cms-service */ "./src/services/cms/cms-service.ts");
/* harmony import */ var _conf_conf_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./conf/conf-service */ "./src/services/conf/conf-service.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./constant */ "./src/services/constant.ts");
/* harmony import */ var _emm_emm_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./emm/emm-service */ "./src/services/emm/emm-service.ts");
/* harmony import */ var _i18n_i18n_service__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./i18n/i18n-service */ "./src/services/i18n/i18n-service.ts");
/* harmony import */ var _integration_microsoft_microsoft_authentication__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./integration/microsoft/microsoft-authentication */ "./src/services/integration/microsoft/microsoft-authentication.ts");
/* harmony import */ var _interactions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./interactions */ "./src/services/interactions/index.ts");
/* harmony import */ var _mediaStorage_media_storage_service__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./mediaStorage/media-storage-service */ "./src/services/mediaStorage/media-storage-service.ts");
/* harmony import */ var _pci_pci_service__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./pci/pci-service */ "./src/services/pci/pci-service.ts");
/* harmony import */ var _qmw_qmw_service__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./qmw/qmw-service */ "./src/services/qmw/qmw-service.ts");
/* harmony import */ var _tahoe_tahoe_service__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./tahoe/tahoe-service */ "./src/services/tahoe/tahoe-service.ts");
/* harmony import */ var _tasks__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./tasks */ "./src/services/tasks/index.ts");
/* harmony import */ var _telemetry_telemetry_service__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./telemetry/telemetry-service */ "./src/services/telemetry/telemetry-service.ts");
/* harmony import */ var _userPreferences_user_preferences_service__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./userPreferences/user-preferences-service */ "./src/services/userPreferences/user-preferences-service.ts");
/* harmony import */ var _webex_web_calling_service__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./webex/web-calling-service */ "./src/services/webex/web-calling-service.ts");
/* harmony import */ var _webex_webex_calling_service__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./webex/webex-calling-service */ "./src/services/webex/webex-calling-service.ts");
/* harmony import */ var _webex_webex_service__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./webex/webex-service */ "./src/services/webex/webex-service.ts");
/* harmony import */ var _webexMetrics_webex_metrics_service__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./webexMetrics/webex-metrics-service */ "./src/services/webexMetrics/webex-metrics-service.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




























class AgentxServices {
    constructor() {
        // Predefined services that are not require init (like i18n - we have to show texts even before login is done)
        this.i18n = (0,_i18n_i18n_service__WEBPACK_IMPORTED_MODULE_14__.i18nService)();
        this.isIniting = false;
        this.isInited = false;
    }
    get telemetry() {
        if (!this._telemetry) {
            this._telemetry = new _telemetry_telemetry_service__WEBPACK_IMPORTED_MODULE_22__.TelemetryService(this.webexMetrics, this.prometheus);
        }
        return this._telemetry;
    }
    init(accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            this.isIniting = true;
            _core_sdk__WEBPACK_IMPORTED_MODULE_0__.http.accessToken = accessToken;
            if (this.aqm !== undefined) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("aqm service already initialized");
                return;
            }
            const promises = [];
            this.aqm = new _aqm_aqm_service__WEBPACK_IMPORTED_MODULE_8__.AqmService(accessToken, this.featureflag.orgId, (i) => promises.push(i), this.featureflag.isFeatureFlagEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_1__.FEATURE_FLAGS.WEBSOCKET_IN_WEBWORKER), !this.featureflag.isFeatureFlagEnabled(_feature_flag_names__WEBPACK_IMPORTED_MODULE_1__.FEATURE_FLAGS.DESKTOP_CONSUME_WELCOME));
            this.emm = (0,_emm_emm_service__WEBPACK_IMPORTED_MODULE_13__.emmService)();
            this.cms = (0,_cms_cms_service__WEBPACK_IMPORTED_MODULE_10__.cmsService)();
            this.abs = (0,_agentx_backend_proxy_agentx_backend_proxy_service__WEBPACK_IMPORTED_MODULE_6__.absService)();
            this.conf = new _conf_conf_service__WEBPACK_IMPORTED_MODULE_11__.ConfService(this.aqm, this.abs);
            this.tahoe = (0,_tahoe_tahoe_service__WEBPACK_IMPORTED_MODULE_20__.tahoeService)();
            this.pci = (0,_pci_pci_service__WEBPACK_IMPORTED_MODULE_18__.pciService)();
            this.mediaStorage = new _mediaStorage_media_storage_service__WEBPACK_IMPORTED_MODULE_17__.MediaStorage();
            this.shortcut = (0,_services_shortcutKey_shortcutkey_service__WEBPACK_IMPORTED_MODULE_2__.shortcutKeyService)();
            this.constants = (0,_constant__WEBPACK_IMPORTED_MODULE_12__.constant)();
            this.actionsChannels = new _actions_channels_actions_channels_service__WEBPACK_IMPORTED_MODULE_3__.ActionsChannelsService();
            this.webex = new _webex_webex_service__WEBPACK_IMPORTED_MODULE_26__.WebexService(accessToken);
            this.webexMetrics = new _webexMetrics_webex_metrics_service__WEBPACK_IMPORTED_MODULE_27__.WebexMetricsService(this.webex);
            this.telemetry.init();
            this.userPrefs = (0,_userPreferences_user_preferences_service__WEBPACK_IMPORTED_MODULE_23__.userPrefsService)();
            this.webCalling = new _webex_web_calling_service__WEBPACK_IMPORTED_MODULE_24__.WebCallingService();
            this.webexCalling = new _webex_webex_calling_service__WEBPACK_IMPORTED_MODULE_25__.WebexCallingService(accessToken);
            this.qmw = (0,_qmw_qmw_service__WEBPACK_IMPORTED_MODULE_19__.qmwService)();
            this.microsoft = new _integration_microsoft_microsoft_authentication__WEBPACK_IMPORTED_MODULE_15__.MicrosoftService(accessToken);
            this.interactions = (0,_interactions__WEBPACK_IMPORTED_MODULE_16__.buildInteractionsService)();
            this.avatar = new _avatar_avatar_service__WEBPACK_IMPORTED_MODULE_9__.AvatarService(this.webex, this.microsoft);
            this.agentPerformance = new _agent_performance_agent_performance_service__WEBPACK_IMPORTED_MODULE_5__.AgentPerformanceService();
            this.apiAIAssistant = new _api_ai_assistant_service_api_ai_assistant_service__WEBPACK_IMPORTED_MODULE_7__.ApiAiAssistantService();
            this.agentService = (0,_agent__WEBPACK_IMPORTED_MODULE_4__.buildAgentService)();
            this.tasks = new _tasks__WEBPACK_IMPORTED_MODULE_21__.TasksService(this.aqm);
            // fake token is a special case for Jest environment
            if (accessToken !== "fake-token") {
                yield Promise.all(promises.map((f) => f()));
            }
            this.isIniting = false;
            this.isInited = true;
        });
    }
}


/***/ }),

/***/ "./src/services/shortcutKey/ShortcutUtil.ts":
/*!**************************************************!*\
  !*** ./src/services/shortcutKey/ShortcutUtil.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DEFAULT_SHORTCUT_KEYS: () => (/* binding */ DEFAULT_SHORTCUT_KEYS),
/* harmony export */   KEY_CONFLICT_EVENT: () => (/* binding */ KEY_CONFLICT_EVENT),
/* harmony export */   KEY_CONFLICT_RESOLVED: () => (/* binding */ KEY_CONFLICT_RESOLVED),
/* harmony export */   KEY_EXECUTE_EVENT: () => (/* binding */ KEY_EXECUTE_EVENT),
/* harmony export */   KEY_REGISTRATION_EVENT: () => (/* binding */ KEY_REGISTRATION_EVENT),
/* harmony export */   KEY_UP_EVENT: () => (/* binding */ KEY_UP_EVENT),
/* harmony export */   MODIFIERS: () => (/* binding */ MODIFIERS),
/* harmony export */   REGISTERED_KEYS: () => (/* binding */ REGISTERED_KEYS),
/* harmony export */   findMatchingKey: () => (/* binding */ findMatchingKey),
/* harmony export */   hasConflict: () => (/* binding */ hasConflict),
/* harmony export */   validModifierKeysPressed: () => (/* binding */ validModifierKeysPressed)
/* harmony export */ });
const SEPARATOR_CHAR = "_";
const KEY_UP_EVENT = "keyup";
const KEY_REGISTRATION_EVENT = "register";
const KEY_EXECUTE_EVENT = "execute";
const KEY_CONFLICT_EVENT = "conflict";
const KEY_CONFLICT_RESOLVED = "conflict_resolved";
const AGENT_PROFILE_ELEMENT = "agentx-react-agent-profile";
const INTERACTION_CONTROL_ELEMENT = "agentx-react-interaction-control";
const INTERACTION_CONTROL_GROUP = "app:keyboardShortcutKeys.interactionControl.componentName";
const INTERACTION_POPOVER_GROUP = "app:keyboardShortcutKeys.interactionPopover.componentName";
const AGENT_PROFILE_GROUP = "app:keyboardShortcutKeys.userProfile.componentName";
const agent = "agent";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const supervisor = "supervisor";
const all = "all";
const validModifierKeysPressed = (keyEvent) => {
    return (((keyEvent.ctrlKey && keyEvent.shiftKey) ||
        (keyEvent.altKey && keyEvent.shiftKey) ||
        (keyEvent.ctrlKey && keyEvent.altKey) ||
        keyEvent.ctrlKey ||
        keyEvent.altKey ||
        keyEvent.shiftKey) &&
        keyEvent.key !== "Shift" &&
        keyEvent.key !== "Control" &&
        keyEvent.key !== "Alt");
};
const findMatchingKey = (shortcutKeyMap, event) => {
    const combiMatch = [];
    event.ctrlKey && combiMatch.push("ctrlKey");
    event.altKey && combiMatch.push("altKey");
    event.shiftKey && combiMatch.push("shiftKey");
    const modifierKeyCombination = combiMatch.join(SEPARATOR_CHAR);
    let matchingKey;
    shortcutKeyMap.forEach((shortcutEntry) => {
        // sonar.issue.ignore.block.start
        if (shortcutEntry.modifierKeys === modifierKeyCombination &&
            shortcutEntry.key === String.fromCharCode(event.keyCode).toLowerCase()) {
            // sonar.issue.ignore.block.end
            matchingKey = shortcutEntry;
        }
    });
    return matchingKey;
};
const hasConflict = (data, value) => (data === null || data === void 0 ? void 0 : data.key) && (data === null || data === void 0 ? void 0 : data.modifierKeys) && value.key + value.modifierKeys === (data === null || data === void 0 ? void 0 : data.key) + (data === null || data === void 0 ? void 0 : data.modifierKeys);
const REGISTERED_KEYS = {
    EXPAND_COLLAPSE_INTERACTION_PANEL_KEY: "y",
    SAVE_EDITED_CAD_KEY: "m",
    REVERT_EDITED_CAD_KEY: "z",
    HOLD_RESUME_CALL_KEY: "v",
    TRANSFER_KEY: "x",
    CONSULT_KEY: "c",
    END_KEY: "e",
    CONFERENCE_KEY: "h",
    PAUSE_RESUME_RECORDING_KEY: "z",
    GO_TO_AVAILABLE_KEY: "r",
    OPEN_STATE_SELECTOR_KEY: "n",
    SEND_EMAIL_KEY: "s",
    REPLY_EMAIL_KEY: "6",
    REPLY_ALL_EMAIL_KEY: "5",
    OPEN_USER_PROFILE_KEY: "u",
    ENABLE_SILENT_NOTIFICATION_KEY: "d",
    OPEN_SHORTCUT_KEY_MODAL_KEY: "f",
    DOWNLOAD_ERROR_REPORT_KEY: "2",
    SIGNOUT_KEY: "l",
    ACCEPT_TASK_KEY: "a",
    SWITCH_POPOVER_KEY: "p",
    EXPAND_COLLAPSE_POPOVER_KEY: "9",
    OPEN_OUTDIAL_KEY: "o",
    OPEN_WRAP_UP_KEY: "w",
    EXPAND_COLLAPSE_TASK_LIST_PANEL_KEY: "7",
    OPEN_NOTIFICATION_CENTER_KEY: "i",
    OPEN_NAVIGATION_TAB_KEY: "t",
    REFRESH_KEY: "b",
    SWITCH_TASK_KEY: "8",
    ACCEPT_ALL_TASK_KEY: "4",
    EXPAND_COLLAPSE_WEBEX: "3",
    MINIMIZE_RESTORE_WEBEX: "1",
    OPEN_DTMF_KEYPAD: "k"
};
const MODIFIERS = {
    CTRL_SHIFT: "ctrlKey_shiftKey",
    ALT_SHIFT: "altKey_shiftKey",
    CTRL_ALT: "ctrlKey_altKey",
    SHIFT: "shiftKey",
    CTRL: "ctrlKey",
    ALT: "altKey"
};
const DEFAULT_SHORTCUT_KEYS = {
    agentState: [
        {
            widgetElement: "agentx-react-state-selector",
            group: "app:keyboardShortcutKeys.agentState.componentName",
            action: "app:keyboardShortcutKeys.agentState.availableState",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.GO_TO_AVAILABLE_KEY,
            role: agent
        },
        {
            widgetElement: "agentx-react-state-selector",
            group: "app:keyboardShortcutKeys.agentState.componentName",
            action: "app:keyboardShortcutKeys.agentState.idleState",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.OPEN_STATE_SELECTOR_KEY,
            role: agent
        }
    ],
    outDial: [
        {
            widgetElement: "agentx-react-out-dial",
            group: "app:keyboardShortcutKeys.outDial.componentName",
            action: "app:keyboardShortcutKeys.outDial.outboundCall",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.OPEN_OUTDIAL_KEY,
            role: agent
        }
    ],
    notification: [
        {
            widgetElement: "agentx-wc-menu-notification",
            group: "app:keyboardShortcutKeys.notification.componentName",
            action: "app:keyboardShortcutKeys.notification.notificationCenter",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.OPEN_NOTIFICATION_CENTER_KEY,
            role: all
        },
        {
            widgetElement: "agentx-wc-menu-notification",
            group: "app:keyboardShortcutKeys.notification.componentName",
            action: "app:keyboardShortcutKeys.notification.silentNotification",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.ENABLE_SILENT_NOTIFICATION_KEY,
            role: all
        }
    ],
    interactionPopover: [
        {
            widgetElement: INTERACTION_CONTROL_ELEMENT,
            group: INTERACTION_POPOVER_GROUP,
            action: "app:keyboardShortcutKeys.interactionPopover.acceptPopover",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.ACCEPT_TASK_KEY,
            role: agent
        },
        {
            widgetElement: INTERACTION_CONTROL_ELEMENT,
            group: INTERACTION_POPOVER_GROUP,
            action: "app:keyboardShortcutKeys.interactionPopover.switchPopover",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.SWITCH_POPOVER_KEY,
            role: all
        },
        {
            widgetElement: INTERACTION_CONTROL_ELEMENT,
            group: INTERACTION_POPOVER_GROUP,
            action: "app:keyboardShortcutKeys.interactionPopover.expandPopover",
            modifierKeys: MODIFIERS.CTRL_SHIFT,
            key: REGISTERED_KEYS.EXPAND_COLLAPSE_POPOVER_KEY,
            role: all
        },
        {
            widgetElement: INTERACTION_CONTROL_ELEMENT,
            group: INTERACTION_POPOVER_GROUP,
            action: "app:keyboardShortcutKeys.interactionPopover.acceptAll",
            modifierKeys: MODIFIERS.CTRL_SHIFT,
            key: REGISTERED_KEYS.ACCEPT_ALL_TASK_KEY,
            role: all
        }
    ],
    interactionControl: [
        {
            widgetElement: INTERACTION_CONTROL_ELEMENT,
            group: INTERACTION_CONTROL_GROUP,
            action: "app:keyboardShortcutKeys.interactionControl.holdOrResumeCall",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.HOLD_RESUME_CALL_KEY,
            role: agent
        },
        {
            widgetElement: INTERACTION_CONTROL_ELEMENT,
            group: INTERACTION_CONTROL_GROUP,
            action: "app:keyboardShortcutKeys.interactionControl.pauseOrResumeRecording",
            modifierKeys: MODIFIERS.CTRL_SHIFT,
            key: REGISTERED_KEYS.PAUSE_RESUME_RECORDING_KEY,
            role: agent
        },
        {
            widgetElement: INTERACTION_CONTROL_ELEMENT,
            group: INTERACTION_CONTROL_GROUP,
            action: "app:keyboardShortcutKeys.interactionControl.conferenceRequest",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.CONFERENCE_KEY,
            role: agent
        },
        {
            widgetElement: INTERACTION_CONTROL_ELEMENT,
            group: INTERACTION_CONTROL_GROUP,
            action: "app:keyboardShortcutKeys.interactionControl.consultRequest",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.CONSULT_KEY,
            role: agent
        },
        {
            widgetElement: INTERACTION_CONTROL_ELEMENT,
            group: INTERACTION_CONTROL_GROUP,
            action: "app:keyboardShortcutKeys.interactionControl.endAllChannel",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.END_KEY,
            role: all
        },
        {
            widgetElement: INTERACTION_CONTROL_ELEMENT,
            group: INTERACTION_CONTROL_GROUP,
            action: "app:keyboardShortcutKeys.interactionControl.transferRequest",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.TRANSFER_KEY,
            role: agent
        },
        {
            widgetElement: INTERACTION_CONTROL_ELEMENT,
            group: INTERACTION_CONTROL_GROUP,
            action: "app:keyboardShortcutKeys.interactionControl.saveEditedCADVariables",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.SAVE_EDITED_CAD_KEY,
            role: all
        },
        {
            widgetElement: INTERACTION_CONTROL_ELEMENT,
            group: INTERACTION_CONTROL_GROUP,
            action: "app:keyboardShortcutKeys.interactionControl.revertEditedCADVariables",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.REVERT_EDITED_CAD_KEY,
            role: all
        },
        {
            widgetElement: INTERACTION_CONTROL_ELEMENT,
            group: INTERACTION_CONTROL_GROUP,
            action: "app:keyboardShortcutKeys.interactionControl.expandOrCollapse",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.EXPAND_COLLAPSE_INTERACTION_PANEL_KEY,
            role: all
        },
        {
            widgetElement: INTERACTION_CONTROL_ELEMENT,
            group: INTERACTION_CONTROL_GROUP,
            action: "app:keyboardShortcutKeys.interactionControl.wrapUpReason",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.OPEN_WRAP_UP_KEY,
            role: agent
        }
    ],
    userProfile: [
        {
            widgetElement: AGENT_PROFILE_ELEMENT,
            group: AGENT_PROFILE_GROUP,
            action: "app:keyboardShortcutKeys.userProfile.openUserProfile",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.OPEN_USER_PROFILE_KEY,
            role: all
        },
        {
            widgetElement: AGENT_PROFILE_ELEMENT,
            group: AGENT_PROFILE_GROUP,
            action: "app:keyboardShortcutKeys.userProfile.signout",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.SIGNOUT_KEY,
            role: all
        },
        {
            widgetElement: AGENT_PROFILE_ELEMENT,
            group: AGENT_PROFILE_GROUP,
            action: "app:keyboardShortcutKeys.userProfile.openKeyboardShortcutList",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.OPEN_SHORTCUT_KEY_MODAL_KEY,
            role: all
        },
        {
            widgetElement: AGENT_PROFILE_ELEMENT,
            group: AGENT_PROFILE_GROUP,
            action: "app:keyboardShortcutKeys.userProfile.downloadErrorReport",
            modifierKeys: MODIFIERS.CTRL_SHIFT,
            key: REGISTERED_KEYS.DOWNLOAD_ERROR_REPORT_KEY,
            role: all
        }
    ],
    taskList: [
        {
            widgetElement: "agentx-wc-task-list",
            group: "app:keyboardShortcutKeys.taskList.componentName",
            action: "app:keyboardShortcutKeys.taskList.switchBetweenActiveTask",
            modifierKeys: MODIFIERS.CTRL_SHIFT,
            key: REGISTERED_KEYS.SWITCH_TASK_KEY,
            role: all
        },
        {
            widgetElement: "agentx-wc-task-list",
            group: "app:keyboardShortcutKeys.taskList.componentName",
            action: "app:keyboardShortcutKeys.taskList.expandOrCollapseTaskPanel",
            modifierKeys: MODIFIERS.CTRL_SHIFT,
            key: REGISTERED_KEYS.EXPAND_COLLAPSE_TASK_LIST_PANEL_KEY,
            role: all
        }
    ],
    connectorView: [
        {
            widgetElement: "agentx-wc-connector",
            group: "app:keyboardShortcutKeys.conectorView.componentName",
            action: "app:keyboardShortcutKeys.conectorView.openNavigationTab",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.OPEN_NAVIGATION_TAB_KEY,
            role: all
        },
        {
            widgetElement: "agentx-wc-connector",
            group: "app:keyboardShortcutKeys.conectorView.componentName",
            action: "app:keyboardShortcutKeys.conectorView.refresh",
            modifierKeys: MODIFIERS.CTRL_ALT,
            key: REGISTERED_KEYS.REFRESH_KEY,
            role: all
        }
    ],
    headerActionItems: [
        {
            widgetElement: "webex-opener",
            group: "app:keyboardShortcutKeys.headerActionItems.componentName",
            action: "app:keyboardShortcutKeys.headerActionItems.openWebexApplication",
            modifierKeys: MODIFIERS.CTRL_SHIFT,
            key: REGISTERED_KEYS.EXPAND_COLLAPSE_WEBEX,
            role: all
        },
        {
            widgetElement: "webex-minimize",
            group: "app:keyboardShortcutKeys.headerActionItems.componentName",
            action: "app:keyboardShortcutKeys.headerActionItems.minimizeOrRestoreWebex",
            modifierKeys: MODIFIERS.CTRL_SHIFT,
            key: REGISTERED_KEYS.MINIMIZE_RESTORE_WEBEX,
            role: all
        }
    ],
    callBackModal: [
        {
            widgetElement: "agentx-wc-callback-modal",
            group: "app:keyboardShortcutKeys.callBackModal.componentName",
            action: "app:keyboardShortcutKeys.callBackModal.focusCallBackModal",
            modifierKeys: MODIFIERS.CTRL_SHIFT,
            key: REGISTERED_KEYS.CONSULT_KEY,
            role: agent
        }
    ]
};


/***/ }),

/***/ "./src/services/shortcutKey/shortcutkey-service.ts":
/*!*********************************************************!*\
  !*** ./src/services/shortcutKey/shortcutkey-service.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   shortcutKeyService: () => (/* binding */ shortcutKeyService)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../index */ "./src/index.ts");
/* harmony import */ var _ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ShortcutUtil */ "./src/services/shortcutKey/ShortcutUtil.ts");




function shortcutKeyService() {
    const allShortcutKeyMap = new Map();
    const roleBasedFilteredShortcutKeyMap = new Map();
    const { signal, send } = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.withData();
    function checkUserRole(widgetUserRole) {
        const loggedInUserRole = localStorage.getItem("userRole");
        if (!widgetUserRole && (loggedInUserRole === "agent" || loggedInUserRole === "supervisorAgent")) {
            return true;
        }
        if (widgetUserRole === "all") {
            return true;
        }
        if (loggedInUserRole === "supervisorAgent" && (widgetUserRole === "agent" || widgetUserRole === "supervisor")) {
            return true;
        }
        return loggedInUserRole === widgetUserRole;
    }
    function isSimilarRole(existingWidgetUserRole, newWidgetUserRole) {
        return existingWidgetUserRole === newWidgetUserRole;
    }
    function updateKeyMaps(mapKey, data) {
        allShortcutKeyMap.set(mapKey, data);
        if (checkUserRole(data.role)) {
            roleBasedFilteredShortcutKeyMap.set(mapKey, data);
        }
    }
    function updateShortcutKeyMap(data) {
        if (data) {
            let isRegistrationFromSameComponent = false;
            if (Object.values(_ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__.MODIFIERS).indexOf(data.modifierKeys) < 0) {
                throw Error(`[ShortcutKey] Not supported modifier ${JSON.stringify(data)}`);
            }
            allShortcutKeyMap.forEach((value) => {
                //TODO:CX-3033 Add validation for widgetElement , it should be validated against layout config and should be present in the
                // in case if same widget is included more than once through layout config, then key registration should be done once only
                if (data.group === value.group && (data === null || data === void 0 ? void 0 : data.action) === value.action) {
                    isRegistrationFromSameComponent = true;
                }
                else if ((0,_ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__.hasConflict)(data, value) && isSimilarRole(data.role, value.role)) {
                    _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[ShortcutKey] Conflicted shortcut key found", value, "=>", data);
                    value.isConflict = true;
                    data.isConflict = true;
                    send({ type: _ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__.KEY_CONFLICT_EVENT, data });
                }
            });
            if (!isRegistrationFromSameComponent) {
                const mapKey = data.action + data.modifierKeys + data.key;
                updateKeyMaps(mapKey, data);
            }
            else {
                _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.warn("[ShortcutKey] Duplicate shortcut key registration from same component", data);
            }
        }
    }
    const trackKeyboardEvents = (matchingKey) => {
        _index__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.track(_index__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_EVENT.KEYBOARD_SHORTCUT_KEY_PRESSED, {
            [_index__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.KEYBOARD_SHORTCUT_COMBINATION_PRESSED]: matchingKey.modifierKeys,
            [_index__WEBPACK_IMPORTED_MODULE_2__.SERVICE.telemetry.TELEM_PROPS.KEYBOARD_SHORTCUT_KEY_VALUE]: matchingKey.key
        });
    };
    function handleKeyupEvent(event) {
        // Shortcut key press event listener to execute callback
        const matchingKey = (0,_ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__.findMatchingKey)(roleBasedFilteredShortcutKeyMap, event);
        if (matchingKey) {
            if (matchingKey.isConflict) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.warn("[ShortcutKey] conflicted shortcut keys cannot not work");
                return;
            }
            _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[ShortcutKey] Matching shortcut key found", matchingKey);
            // execute callback if callback is provided while registration of shortcut key
            const cEvt = {
                type: _ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__.KEY_EXECUTE_EVENT,
                data: matchingKey,
                keyboardEvent: event
            };
            // if listenKeyPress back is attached while registration then invoke the listenKeyPress
            if (matchingKey.listenKeyPress) {
                matchingKey.listenKeyPress(cEvt);
            }
            else {
                // send response to listeners on keypress event
                send(cEvt);
            }
            trackKeyboardEvents(matchingKey);
        }
        else {
            _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.warn("[ShortcutKey] No matching shortcut key found", event);
        }
    }
    /**
     * Update keys conflict with the deleted key only.
     * @param modifierKeys
     * @param key
     */
    function updateKeyWithConflcit(modifierKeys, key) {
        let mapKey, count = 0;
        allShortcutKeyMap.forEach((data) => {
            if (data.modifierKeys === modifierKeys && data.key === key) {
                count++;
                mapKey = data.action + data.modifierKeys + data.key;
            }
        });
        if (count === 1 && mapKey) {
            const val = allShortcutKeyMap.get(mapKey);
            if (val) {
                const updVal = Object.assign(Object.assign({}, val), { isConflict: false });
                updateKeyMaps(mapKey, updVal);
            }
        }
    }
    // attach window keyup event listener
    window.addEventListener(_ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__.KEY_UP_EVENT, ((e) => {
        if ((0,_ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__.validModifierKeysPressed)(e)) {
            handleKeyupEvent(e);
        }
    }));
    return {
        event: {
            listenKeyPress: (cb) => {
                return signal.listen((data) => {
                    if (data.type === _ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__.KEY_EXECUTE_EVENT) {
                        cb(data);
                    }
                });
            },
            listenKeyConflict: (cb) => {
                const { stopListen } = signal.listen((data) => {
                    if (data.type === _ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__.KEY_CONFLICT_EVENT) {
                        cb(data);
                    }
                });
                return stopListen;
            },
            listenConflictResolved: (cb) => {
                const { stopListen } = signal.listen((data) => {
                    if (data.type === _ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__.KEY_CONFLICT_RESOLVED) {
                        cb();
                    }
                });
                return stopListen;
            }
        },
        register: (keys) => {
            _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[ShortcutKey] Shortcut Key registration received", keys);
            keys.forEach((key) => {
                updateShortcutKeyMap(key);
            });
        },
        updateRegisterKeys: () => {
            // unregister all the previous keys
            roleBasedFilteredShortcutKeyMap.clear();
            allShortcutKeyMap.forEach((data) => {
                const mapKey = data.action + data.modifierKeys + data.key;
                if (checkUserRole(data.role)) {
                    roleBasedFilteredShortcutKeyMap.set(mapKey, data);
                }
            });
        },
        getRegisteredKeys: () => {
            return roleBasedFilteredShortcutKeyMap;
        },
        unregisterAllKeys: () => {
            allShortcutKeyMap.forEach((data) => {
                const mapKey = data.action + data.modifierKeys + data.key;
                allShortcutKeyMap.delete(mapKey);
                roleBasedFilteredShortcutKeyMap.delete(mapKey);
                updateKeyWithConflcit(data.modifierKeys, data.key);
            });
        },
        /**
         * This needs to be called by 3rd party widgets on unmount.
         * WidgetElement name should be same as in used for registering shortcut keys
         */
        unregisterKeys: (widgetElement) => {
            allShortcutKeyMap.forEach((data) => {
                const mapKey = data.action + data.modifierKeys + data.key;
                if (data.widgetElement === widgetElement) {
                    allShortcutKeyMap.delete(mapKey);
                    roleBasedFilteredShortcutKeyMap.delete(mapKey);
                    updateKeyWithConflcit(data.modifierKeys, data.key);
                }
            });
            let conflict = false;
            allShortcutKeyMap.forEach((data) => {
                if (data.isConflict) {
                    conflict = true;
                }
            });
            if (!conflict) {
                send({ type: _ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__.KEY_CONFLICT_RESOLVED });
            }
        },
        DEFAULT_SHORTCUT_KEYS: _ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_SHORTCUT_KEYS,
        MODIFIERS: _ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__.MODIFIERS,
        REGISTERED_KEYS: _ShortcutUtil__WEBPACK_IMPORTED_MODULE_3__.REGISTERED_KEYS
    };
}


/***/ }),

/***/ "./src/services/summarizer/summarizer-service.ts":
/*!*******************************************************!*\
  !*** ./src/services/summarizer/summarizer-service.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LlmMessage: () => (/* binding */ LlmMessage),
/* harmony export */   SummarizerService: () => (/* binding */ SummarizerService)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../.. */ "./src/index.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");


class LlmMessage {
    constructor() {
        this.role = "system";
        this.content = "";
    }
}
class SummarizerService {
    llmRequestWithSystemMessage(message) {
        return this.llmRequest([
            {
                role: "system",
                content: message
            }
        ]);
    }
    llmRequest(messages, maxTokens = 1000, temperature = 0.6, topP = 1) {
        var _a;
        const clientRequestId = (0,_service_utils__WEBPACK_IMPORTED_MODULE_1__.generateUUID)();
        const body = {
            async: "false",
            clientRequestId,
            aiData: {
                model: "gpt-35-turbo,chat-completions",
                requestBody: {
                    messages,
                    max_tokens: maxTokens,
                    temperature,
                    top_p: topP,
                    frequency_penalty: 0,
                    presence_penalty: 0,
                    stop: "None"
                }
            },
            input: {},
            locale: "en_GB"
        };
        const method = "POST";
        const service = "summarizer";
        const resource = "generate_test";
        return (_a = ___WEBPACK_IMPORTED_MODULE_0__.SERVICE.webex) === null || _a === void 0 ? void 0 : _a.webexRequest(method, service, resource, body).then((res) => {
            var _a, _b, _c;
            return (_c = (_b = (_a = res === null || res === void 0 ? void 0 : res.body) === null || _a === void 0 ? void 0 : _a.results[0]) === null || _b === void 0 ? void 0 : _b.content) !== null && _c !== void 0 ? _c : "";
        });
    }
}


/***/ }),

/***/ "./src/services/tahoe/tahoe-service.ts":
/*!*********************************************!*\
  !*** ./src/services/tahoe/tahoe-service.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   tahoeService: () => (/* binding */ tahoeService)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");




const DEFAULT_CONTACT_HISTORY_PAGE_SIZE = 100;
const DEFAULT_CONTACT_HISTORY_PAGE = 0;
const DEFAULT_AGENT_HISTORY_PAGE_SIZE = 1000;
function tahoeService() {
    const http = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY);
    return {
        fetchAgentHistory: http.req((p) => ({
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_2__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
            url: `/v1/history/agentHistory?` +
                `agentId=${encodeURIComponent(p.agentId)}&page=${DEFAULT_CONTACT_HISTORY_PAGE}&pageSize=${DEFAULT_AGENT_HISTORY_PAGE_SIZE}`,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            method: "GET",
            errId: "Service.tahoe.fetchTahoeHistory",
            res: {}
        })),
        fetchInteractionHistory: http.req((p) => ({
            url: `/v1/history/contactHistory?from=${p.startTime}&to=${p.endTime}&ani=${encodeURIComponent(p.ani)}&agentId=${encodeURIComponent(p.agentId)}&interactionId=${p.interactionId}` +
                `&page=${DEFAULT_CONTACT_HISTORY_PAGE}&pageSize=${DEFAULT_CONTACT_HISTORY_PAGE_SIZE}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_2__.HTTP_HEADERS), { TrackingID: `agentx_${(0,_service_utils__WEBPACK_IMPORTED_MODULE_3__.generateUUID)()}` }),
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            method: "GET",
            errId: "Service.tahoe.fetchInteractionHistory",
            res: {}
        }))
    };
}


/***/ }),

/***/ "./src/services/tasks/index.ts":
/*!*************************************!*\
  !*** ./src/services/tasks/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TasksService: () => (/* reexport safe */ _tasks_service__WEBPACK_IMPORTED_MODULE_0__.TasksService)
/* harmony export */ });
/* harmony import */ var _tasks_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./tasks-service */ "./src/services/tasks/tasks-service.ts");



/***/ }),

/***/ "./src/services/tasks/tasks-service.ts":
/*!*********************************************!*\
  !*** ./src/services/tasks/tasks-service.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TasksService: () => (/* binding */ TasksService)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../.. */ "./src/index.ts");
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


class TasksService {
    constructor(aqmService) {
        this.aqm = aqmService;
    }
    assignTask(taskId) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[TasksService] Attempting to assign task: ${taskId}`);
            try {
                yield this.aqm.contact.assign({ interactionId: taskId });
                _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[TasksService] Task assigned, attempting to accept: ${taskId}`);
                try {
                    const acceptedContact = yield this.aqm.contact.acceptV2({
                        interactionId: taskId
                    });
                    _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[TasksService] Task assigned and accepted successfully: ${acceptedContact.data.interactionId}`);
                    return {
                        success: true,
                        taskId: acceptedContact.data.interactionId,
                        contact: acceptedContact
                    };
                }
                catch (acceptError) {
                    const trackingId = (0,___WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(acceptError);
                    const errorDetails = acceptError;
                    _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[TasksService] Error accepting assigned task: [${taskId}], "Error:", [${(_a = errorDetails.message) !== null && _a !== void 0 ? _a : acceptError}] trackingId: ${trackingId}`);
                    return {
                        success: false,
                        taskId,
                        errorCode: (_b = errorDetails.code) !== null && _b !== void 0 ? _b : "ACCEPT_FAILED",
                        errorMessage: (_c = errorDetails.message) !== null && _c !== void 0 ? _c : "Failed to accept the task after assignment.",
                        trackingId
                    };
                }
            }
            catch (assignError) {
                const trackingId = (0,___WEBPACK_IMPORTED_MODULE_0__.getTrackingIdFromErrorObject)(assignError);
                const errorDetails = assignError;
                _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[TasksService] Error assigning task: [${taskId}], "Error:", [${(_d = errorDetails.message) !== null && _d !== void 0 ? _d : assignError}] trackingId: ${trackingId}`);
                return {
                    success: false,
                    taskId,
                    errorCode: (_e = errorDetails.code) !== null && _e !== void 0 ? _e : "ASSIGN_FAILED",
                    errorMessage: (_f = errorDetails.message) !== null && _f !== void 0 ? _f : "Failed to assign the task.",
                    trackingId
                };
            }
        });
    }
    assignMultipleTasks(taskIds) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!taskIds || taskIds.length === 0) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[TasksService] assignMultipleTasks called with no task IDs.");
                return {
                    overallStatus: "allSucceeded",
                    successfulTasks: [],
                    failedTasks: []
                };
            }
            _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[TasksService] Attempting to assign multiple tasks: ${taskIds}`);
            const taskPromises = taskIds.map((taskId) => this.assignTask(taskId));
            // Using Promise.allSettled to ensure all promises complete
            const results = yield Promise.allSettled(taskPromises);
            const successfulTasks = [];
            const failedTasks = [];
            results.forEach((result) => {
                if (result.status === "fulfilled") {
                    if (result.value.success) {
                        successfulTasks.push(result.value);
                    }
                    else {
                        failedTasks.push(result.value);
                    }
                }
                else {
                    // This case implies an unexpected rejection from assignTask, which is not its current design.
                    // If assignTask could reject, we'd need a way to map result.reason back to a taskId.
                    // For now, logging this as an unexpected scenario.
                    _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[TasksService] Unexpected rejection in assignMultipleTasks for a task:" ${result.reason}`);
                }
            });
            let overallStatus;
            if (failedTasks.length === 0 && successfulTasks.length === taskIds.length) {
                overallStatus = "allSucceeded";
            }
            else if (successfulTasks.length === 0 && failedTasks.length === taskIds.length) {
                overallStatus = "allFailed";
            }
            else if (failedTasks.length > 0) {
                overallStatus = "partialFailure";
            }
            else {
                // This case handles scenarios like taskIds.length > 0 but successfulTasks and failedTasks are both empty,
                // which could happen if all promises were unexpectedly rejected and not caught as 'fulfilled' TaskAssignResult.
                // Or if taskIds was empty (already handled), or if all tasks succeeded but successfulTasks.length !== taskIds.length (data integrity issue).
                // Given the logic, if taskIds.length > 0, and we reach here, it implies some form of failure or unexpected state.
                overallStatus = "allFailed";
                if (successfulTasks.length > 0) {
                    // If some succeeded but not all, and not all failed
                    overallStatus = "partialFailure";
                }
            }
            // Final check for consistency if taskIds was not empty
            if (taskIds.length > 0) {
                if (successfulTasks.length === taskIds.length) {
                    overallStatus = "allSucceeded";
                }
                else if (failedTasks.length === taskIds.length) {
                    overallStatus = "allFailed";
                }
                else {
                    overallStatus = "partialFailure";
                }
            }
            _core_sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info(`[TasksService] assignMultipleTasks completed. Success: ${successfulTasks.length}, Failed: ${failedTasks.length}`);
            return {
                overallStatus,
                successfulTasks,
                failedTasks
            };
        });
    }
}


/***/ }),

/***/ "./src/services/telemetry/constants.ts":
/*!*********************************************!*\
  !*** ./src/services/telemetry/constants.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AGGREGATION_INTERVAL: () => (/* binding */ AGGREGATION_INTERVAL),
/* harmony export */   CACHE_KEYS: () => (/* binding */ CACHE_KEYS),
/* harmony export */   EVENT_CONSTANTS: () => (/* binding */ EVENT_CONSTANTS),
/* harmony export */   PROPS_CONSTANTS: () => (/* binding */ PROPS_CONSTANTS),
/* harmony export */   TELEMETRY_CACHE: () => (/* binding */ TELEMETRY_CACHE),
/* harmony export */   TELEMETRY_ERR_MSG: () => (/* binding */ TELEMETRY_ERR_MSG),
/* harmony export */   httpConstants: () => (/* binding */ httpConstants)
/* harmony export */ });
/* eslint-disable sonarjs/no-duplicate-string */
const TELEMETRY_ERR_MSG = "Error while tracking telemetry ";
const TELEMETRY_CACHE = "agentx--telemetry-temp";
const EVENT_CONSTANTS = {
    STATUS: {
        SUCCESS: "Success",
        FAILED: "Failed"
    },
    STATION_LOGIN_CLICKED: "Station Login Clicked",
    STATION_LOGIN: "Station Login Complete",
    RATE_LIMITING: "Rate Limiting",
    CHANGE_TEAM: "Change Team",
    AGENT_STATE_CHANGE: "Availability Status Change",
    SIGNOUT_REQUESTED: "Sign Out Requested",
    AGENT_HISTORY_RESIZE: "Agent History Resize",
    DARK_MODE_TOGGLE: "Dark Mode Toggle",
    HELP_ICON_CLICKED: "Help Icon Clicked",
    SURVEY_ICON_CLICKED: "Survey Icon Clicked",
    TASK_PANE_TOGGLE: "Task Pane Toggle",
    INTERACTION_CONTROL_PANE_TOGGLE: "Interaction Control Pane Toggle",
    ERROR_DETAILS_DOWNLOADED: "Error Details Downloaded",
    LOGS_UPLOADED_TO_WEBEX: "Logs uploaded to Webex",
    SIGN_OUT: "Sign Out",
    CAD_VARIABLE_UPDATED: "CAD Variables Updated",
    CALL_INITIATED: "Call Initiated",
    CALL_TOAST_MESSAGE_ACCEPTED: "Call Toast Message Accepted",
    CALL_ANSWERED: "Call Answered",
    AGENT_RONA: "Agent RONA",
    CALL_CONFERENCE_CLICKED: "Call Conference Clicked",
    CALL_CONFERENCE_ACTIVATED: "Call Conference Activated",
    CALL_CONFERENCE_ENDED: "Call Conference Ended",
    END_MONITORING_CLICKED: "End Monitoring Clicked",
    CALL_CONSULT_CLICKED: "Call Consult Clicked",
    CALL_CONSULT_ACTIVATED: "Call Consult Activated",
    CALL_CONSULT_END_CLICKED: "Call Consult End Clicked",
    CALL_CONSULT_END_ACTIVATED: "Call Consult End Activated",
    INTERACTION_CONSULT_REQUEST_CLICKED: "Interaction Consult Request Clicked",
    INTERACTION_CONFERENCE_REQUEST_CLICKED: "Interaction Conference Request Clicked",
    CALL_HOLD_CLICKED: "Call Hold Clicked",
    CALL_HOLD_ACTIVATED: "Call Hold Activated",
    CALL_RESUME_CLICKED: "Call Resume Clicked",
    CALL_RESUME_ACTIVATED: "Call Resume Activated",
    CALL_TRANSFER_CLICKED: "Call Transfer Clicked",
    CALL_TRANSFER_ACTIVATED: "Call Transfer Activated",
    CALL_TRANSFER_COMPLETED: "Call Transfer Completed",
    INTERACTION_TRANSFER_REQUEST_CLICKED: "Interaction Transfer Request Clicked",
    CONSULT_CALL_TRANSFER: "Consult Call Transfer Clicked",
    CONFERENCE_TRANSFER: "Conference Transfer",
    CALL_PAUSE_RECORDING_CLICKED: "Call Pause Recording Clicked",
    CALL_PAUSE_RECORDING_ACTIVATED: "Call Pause Recording Activated",
    CALL_RESUME_RECORDING_CLICKED: "Call Resume Recording Clicked",
    CALL_RESUME_RECORDING_ACTIVATED: "Call Resume Recording Activated",
    CALL_COMPLETED: "Call Completed",
    CALL_WRAP_UP_APPLIED: "Wrap Up Reason Applied",
    NOTIFICATION_SETTINGS_UPDATE: "Notification Settings Update",
    IVR_TRANSCRIPT: "IVR Transcript Fetch",
    AGENT_INVITE_FAILED: "Agent Invite Failed",
    SCREEN_POP_VIEWED: "Screen Pop Viewed",
    KEYBOARD_SHORTCUT_KEY_PRESSED: "Keyboard Shortcut Key Pressed",
    CONTACT_HISTORY_VIEWED: "Contact History Viewed",
    WXM_JOURNEY_VIEWED: "WXM Journey Viewed",
    DESKTOP_CONNECTION_LOSS: "Desktop Connection Loss",
    LAYOUT_SETTINGS_EDIT: "Layout Settings Edit",
    LAYOUT_SETTINGS_RESET: "Layout Settings Reset",
    LAYOUT_SETTINGS_SAVE: "Layout Settings Save",
    /*eslint-disable-next-line @wxcc-desktop/no-blocked-words-plugin/no-blocked-words */
    LAYOUT_SETTINGS_MASTER_RESET: "Layout Settings Master Reset",
    NOTIFICATION_SOUND_SETTINGS_UPDATE: "Notification Sound Settings Update",
    WEBEX_APP_OPENED: "Webex App opened",
    WEBEX_APP_CLOSED: "Webex App closed",
    WEBEX_APP_OPENED_BY_SHORTCUT_KEY: "Webex App Opened By Shortcut Key",
    SCREEN_POP_INSIDE_DESKTOP_REFERRED: "Screen Pop Inside Desktop Referred",
    SCREEN_POP_DELIVERED: "Screen Pop Delivered",
    AGENT_STATE_SEARCHED: "Agent State Searched",
    AGENT_HISTORY: "Fetch Agent History",
    AGENT_CONSULT_TRANSFER_SEARCH: "Agent Consult/Transfer Search",
    AGENT_INTERACTION_TRANSFERRED: "Agent Interaction Transferred",
    CHANGE_PROFILE_SETTINGS: "Change Profile Settings",
    SWITCH_USER_ROLE: "Switch User Role",
    LAYOUT_FETCHED_FROM_SERVER: "Layout fetched from Server",
    WEB_SOCKET_CLOSE_REQUEST: "Closing Web Socket from client side",
    STATION_RELOGIN_FAILED: "Station relogin aqm failed",
    PING_FROM_SERVER_LATE: "Ping from server late",
    WEB_SOCKET_DISCONNECT: "Web Socket Disconnect",
    CUSTOM_LAYOUT_LOAD_FAIL: "Custom layout load failed",
    WEBSOCKET_OPENED: "Websocket Opened",
    WELCOME_MESSAGE_RECEIVED: "Welcome Message Received",
    WEBEX_CHAT_TPW_MESSAGE_SEND: "Team Performance Widget Webex Chat Message Sent",
    IDLE_INACTIVITY_SIGN_OUT: "Idle Inactivity Sign Out",
    AID_OPENED: "Active Interaction Details Opened",
    AID_CLOSED: "Active Interaction Details Closed",
    PAUSE_MONITORING_CLICKED: "Pause Monitoring Clicked",
    RESUME_MONITORING_CLICKED: "Resume Monitoring Clicked",
    MIDCALL_MONITORING_STARTED: "Midcall Monitoring Started",
    MIDCALL_MONITORING_OFFERED: "Midcall Monitoring Offered",
    MIDCALL_MONITORING_ENDED: "Midcall Monitoring Ended",
    MIDCALL_MONITORING_FAILED: "Midcall Monitoring Failed",
    BARGE_IN_CLICKED: "Barge In Clicked",
    BARGE_IN_ACTIVATED: "Barge In Activated",
    ADDRESS_BOOK: "Address Book",
    WEBRTC_REGISTRATION: "WebRtc Registration",
    WEBRTC_DISCONNECTED: "WebRtc Disconected",
    WEBRTC_VOICE_CHANNEL_SWITCHED: "Desktop Voice Channel Switched",
    POST_INTERACTION_VISITED: "Post Interaction: Widget Visited",
    PI_TIME_FILTER_SELECTED: "Post Interaction: Time Filter Selected",
    PI_RECORDING_DETAILS_MODAL_CLOSED: "Post Interaction: Recording Details Modal Closed",
    TPW_COLUMN_SORTED: "Team Performance Widget Column Sorted",
    TPW_COLUMN_FILTERED: "Team Performance Widget Column Filtered",
    WC_GRID_COLUMN_BEHAVIOURAL_EVENTS: "WC Grid: Column Behavioral Events",
    WC_GRID_HEADER_BEHAVIOURAL_EVENTS: "WC Grid: Header Behavioral Events",
    WC_GRID_DATE_SELECTED_BEHAVIOURAL_EVENT: "WC Grid: Date range selected Behavioral Event",
    WC_GRID_EXPORT_BEHAVIOURAL_EVENT: "WC Grid: Export data Behavioral Event",
    WC_GRID_ALERT_BEHAVIOURAL_EVENT: "WC Grid: Alert banner showing Behavioral Event",
    DESKTOP_VISITED_PAGE: "Desktop Visited Page",
    STATE_CHANGE_ON_PRESENCE_SYNC: "State Change On Presence Sync",
    WEBRTC_REGISTRATION_FAILURE: "WebRtc registration failure",
    WEBRTC_REGISTRATION_RETRY: "WebRtc Registration Retry",
    CI_TOKEN_REFRESH: "CI token refresh",
    AI_ASSISTANT_COPY_CLICKED: "AI Assistant Copy Clicked",
    AI_ASSISTANT_FEEDBACK_CLICKED: "AI Assistant Feedback Clicked",
    AI_ASSISTANT_OPENED: "AI Assistant Opened",
    AI_ASSISTANT_SUMMARY_NOTIFICATION_FIRED: "AI Assistant Summary Notification Fired",
    AI_ASSISTANT_SUMMARY_GENERATED: "AI Assistant Summary Generated",
    WELLNESS_BREAK_STARTED: "Wellness Break Started",
    WELLNESS_BREAK_ENDED: "Wellness Break Ended",
    WELLNESS_BREAK_CARD_ACCEPTED: "Wellness Break Card Accepted",
    WELLNESS_BREAK_CARD_REJECTED: "Wellness Break Card Rejected",
    WELLNESS_BREAK_CTA_APPROVED: "Wellness Break CTA Approved",
    WELLNESS_BREAK_CTA_REJECTED: "Wellness Break CTA Rejected",
    WELLNESS_BREAK_CTA_USER_REQUEST: "Wellness Break CTA User Request",
    WELLNESS_BREAK_DISPLAY_CTA: "Wellness Break Display CTA",
    WELLNESS_BREAK_CHANGE_STATE_ERROR: "Wellness Break Change State Error",
    WELLNESS_BREAK_GENERIC_ERROR: "Wellness Break Generic Error",
    WELLNESS_BREAK_NO_RESPONSE: "Wellness Break No Response",
    WELLNESS_BREAK_NOTIFICATION_FIRED: "Wellness Break Notification Fired",
    WELLNESS_BREAK_NOTIFICATION_ACCEPTED: "Wellness Break Notification Accepted",
    WELLNESS_BREAK_NOTIFICATION_DISMISSED: "Wellness Break Notification Dismissed",
    WELLNESS_BREAK_NOTIFICATION_REJECTED: "Wellness Break Notification Rejected",
    WELLNESS_BREAK_NOTIFICATION_TIMEOUT: "Wellness Break Notification Timeout",
    WELLNESS_BREAK_PROVIDE_BREAK_EVENT_RECEIVED: "Wellness Break Provide Break Event Received",
    DESKTOP_RELOAD: "DESKTOP_RELOAD",
    DESKTOP_BROWSER_REFRESH: "DESKTOP_BROWSER_REFRESH",
    AGENTX_JS_API_INIT: "agentx-js-sdk-init",
    AGENTX_JS_API_REGISTER_CRM_CONNECTOR: "agentx-js-sdk-register-crm-connector",
    CJDS_WIDGET_LOAD: "[CJDS] Widget Initialized",
    CJDS_WIDGET_IS_DEFAULT_TEMPLATE: "[CJDS] Default Template",
    CJDS_WIDGET_PROGRESSIVE_PROFILE_LOADED: "[CJDS] Progressive Profile Loaded",
    CJDS_WIDGET_PROGRESSIVE_PROFILE_FAILED: "[CJDS] Progressive Profile Failed",
    CJDS_WIDGET_HISTORICAL_EVENTS_LOADED: "[CJDS] Historical Events Loaded",
    CJDS_WIDGET_HISTORICAL_EVENTS_FAILED: "[CJDS] Historical Events Failed",
    CJDS_WIDGET_EVENT_STREAM_FAILED: "[CJDS] Events stream Failed",
    SERVER_TIME_DIFFERENCE: "Server Time Difference",
    DIGITAL_OUTBOUND_TASK_INITIATE: "Digital Outbound Task Initiate",
    DIGITAL_COMPOSER_OUTBOUND_MESSAGE: "Digital Composer Outbound Message",
    DIGITAL_BLOCKLISTED_WORDS_MASKING: "Digital Blocklisted Words Masking",
    DIGITAL_COMPOSER_RICH_FORMATTING_BOLD: "Digital Composer Rich Formatting Bold",
    DIGITAL_COMPOSER_RICH_FORMATTING_ITALICS: "Digital Composer Rich Formatting Italics",
    DIGITAL_COMPOSER_RICH_FORMATTING_UNDERLINE: "Digital Composer Rich Formatting Underline",
    DIGITAL_COMPOSER_ATTACHMENTS_UPLOAD: "Digital Composer Attachments Upload",
    DIGITAL_COMPOSER_ATTACHMENTS_DOWNLOAD: "Digital Composer Attachments Download",
    DIGITAL_COMPOSER_EMOJI_MODAL: "Digital Composer Emoji Modal",
    DIGITAL_COMPOSER_EMOJI: "Digital Composer Emoji",
    DIGITAL_COMPOSER_TEMPLATES_MODAL: "Digital Composer Templates Modal",
    DIGITAL_COMPOSER_TEMPLATE_GROUP_TAB: "Digital Composer Template Group Tab",
    DIGITAL_COMPOSER_TEMPLATE_PREVIEW: "Digital Composer Template Preview",
    DIGITAL_COMPOSER_TEMPLATE_SELECT: "Digital Composer Template Select",
    DIGITAL_COMPOSER_WORKFLOWS_MODAL: "Digital Composer Workflows Modal",
    DIGITAL_COMPOSER_WORKFLOWS: "Digital Composer Workflows",
    DIGITAL_COMPOSER_CLEAR_MESSAGE: "Digital Composer Clear Message",
    DIGITAL_COMPOSER_WHISPER: "Digital Composer Whisper",
    DIGITAL_EMAIL_READ_PANE: "Digital Email Read Pane",
    DIGITAL_EMAIL_READ_PANE_ACCORDION: "Digital Email Read Pane Accordion",
    DIGITAL_EMAIL_READ_PANE_REPLY: "Digital Email Read Pane Reply",
    DIGITAL_EMAIL_READ_PANE_REPLY_ALL: "Digital Email Read Pane Reply All",
    DIGITAL_EMAIL_READ_PANE_FORWARD: "Digital Email Read Pane Forward",
    DIGITAL_EMAIL_TO_RECIPIENTS: "Digital Email To Recipients",
    DIGITAL_EMAIL_CC_RECIPIENTS: "Digital Email CC Recipients",
    DIGITAL_EMAIL_BCC_RECIPIENTS: "Digital Email BCC Recipients",
    DIGITAL_WEB_COMPONENT: "Digital Web Component",
    DIGITAL_ATTACHMENT_ANTIMALWARE_SCAN: "Digital Attachment Antimalware Scan",
    DIGITAL_PII_MASKING: "Digital PII Masking",
    DIGITAL_ATTACHMENT_PCI_SCAN: "Digital Attachment PCI Scan",
    DIGITAL_ATTACHMENT_UPLOAD_STATUS: "Digital Attachment Upload Status",
    DIGITAL_COMPOSER_DRAFT: "Digital Composer Draft",
    DIGITAL_INBOUND_MESSAGE_RECEIVE: "Digital Inbound Message Receive",
    DIGITAL_INBOUND_MESSAGE_READ: "Digital Inbound Message Read",
    DIGITAL_ANTIMALWARE_BANNER: "Digital Antimalware Banner",
    DIGITAL_PCI_BANNER: "Digital PCI Banner",
    DIGITAL_WEAK_CONNECTION_BANNER: "Digital Weak Connection Banner",
    DIGITAL_OUTBOUND_MESSAGE: "Digital Outbound Message",
    NETWORK_REQUEST_USAGE: "Network Request Usage",
    UNCAUGHT_EXCEPTION: "Uncaught Exception",
    MISSING_TRANSLATION: "Missing Translation",
    REALTIME_TRANSCRIPTS_LOADED: "Realtime Transcripts Widget Loaded",
    REALTIME_TRANSCRIPTS_VISIBLE: "Realtime Transcripts Visible",
    REALTIME_TRANSCRIPTS_AVAILABLE: "Realtime Transcripts Available",
    REALTIME_TRANSCRIPTS_FEEDBACK_CLICKED: "Realtime Transcripts Feedback Clicked",
    REALTIME_TRANSCRIPTS_JUMP_TO_BOTTOM_CLICKED: "Realtime Transcripts Jump To Bottom Clicked",
    REALTIME_TRANSCRIPTS_DURATION: "Realtime Transcripts Duration",
    EVALUATION_MONITORING_METRIC: "Evaluation Monitoring Metric",
    AI_ASSIST_SUGGESTIONS_UNAVAILABLE: "AI Assistant Suggestions Unavailable",
    AI_ASSIST_POLLING_FAILED: "AI Assistant Polling Failed",
    AI_ASSIST_POLLING_SUCCESS: "AI Assistant Polling Success",
    CAMPAIGN_PREVIEW_ACCEPT_FAILED: "Campaign Preview Accept Failed",
    CAMPAIGN_PREVIEW_SKIP_FAILED: "Campaign Preview Skip Failed",
    CAMPAIGN_PREVIEW_REMOVE_FAILED: "Campaign Preview Remove Failed",
    HISTORICAL_TRANSCRIPT_FEEDBACK: "Historical Transcript Feedback Rating",
    ENHANCED_STATION_LOGIN_START: "Enhanced Station Login Start",
    ENHANCED_STATION_LOGIN_COMPLETE: "Enhanced Station Login Complete",
    ENHANCED_STATION_LOGIN_SELECTION_CHANGED: "Enhanced Station Login Selection Changed",
    ENHANCED_STATION_LOGIN_INPUT_CHANGED: "Enhanced Station Login Input Changed",
    ENHANCED_STATION_LOGIN_SUBMIT_CLICKED: "Enhanced Station Login Submit Clicked",
    ENHANCED_STATION_LOGIN_CANCEL_CLICKED: "Enhanced Station Login Cancel Clicked",
    ENHANCED_STATION_LOGIN_AUTOLOGIN: "Enhanced Station Login AutoLogin"
    // Adding new metrics? Please add them to the wiki: https://confluence-eng-gpk2.cisco.com/conf/display/UC/List+of+wxcc-desktop+behavioral+metric+events
};
const PROPS_CONSTANTS = {
    CALL_DIRECTION: "Call Direction",
    CONSULT_TYPE: "Consult Type",
    CONSULT_DURATION: "Consult Duration",
    SIGN_IN_TYPE: "Sign In Type",
    AGENT_ID: "Agent ID",
    "Organization ID": "Organization ID",
    "Dark Mode Enabled": "Dark Mode Enabled",
    "Platform Type": "Platform Type",
    "Availability Status": "Availability Status",
    "Number Of Widgets": "Number Of Widgets",
    "Interaction Control State": "Interaction Control State",
    "Task Pane State": "Task Pane State",
    "Tenant ID": "Tenant ID",
    "Team Name": "Team Name",
    Locale: "Locale",
    "Site ID": "Site ID",
    "Browser Height": "Browser Height",
    "Browser Width": "Browser Width",
    "Agent ID": "Agent ID",
    "New Widget State": "New Widget State",
    "Previous Availability Status": "Previous Availability Status",
    "Time In Previous Status": "Time In Previous Status",
    TRANSFER_TYPE: "Transfer Type",
    DIAL_NUMBER_TYPE: "Dial Number Type",
    PAUSE_RECORDING_TIME: "Pause Recording Time",
    TOTAL_CALL_TIME: "Total Call Time",
    TOTAL_CONSULT: "Total Number Of Consult",
    TOTAL_CONSULT_TIME: "Total Consult Time",
    HOLD_TIME: "Hold Time",
    TOTAL_HOLD_TIME: "Total Hold Time",
    TOTAL_TIMES_IN_HOLD: "Total Times in Hold",
    PLATFORM_TYPE: "Platform Type",
    INTERACTION_CONTROL_STATE: "Interaction Control State",
    TASK_PANE_STATE: "Task Pane State",
    ERROR_DETAILS_DOWNLOADED: "Error Details Downloaded",
    LOGS_UPLOADED_TO_WEBEX: "Logs uploaded to Webex",
    SIGN_OUT_METHOD: "Sign Out Method",
    INTERACTION_ID: "InteractionId",
    TOTAL_RECORDING_PAUSE_TIME: "Total Recording Pause Time",
    TOTAL_TIMES_IN_RECORDING_PAUSE: "Total Times In Recording Pause",
    SIGN_IN_FAILURE_REASON: "Sign In Failure Reason",
    TOTAL_TIME_SPENT: "Total Time Spent",
    SHORTCUT_KEY_ACTION: "Shortcut Key Action",
    SHORTCUT_KEY_COMBINATION: "Shortcut Key Combination",
    TOTAL_CONNECTION_LOST_DURATION: "Total Connection Lost Duration",
    ENABLE_NOTIFICATION: "Enable Notification",
    ENABLE_SILENT_NOTIFICATION: "Enable Silent Notification",
    MEDIA_TYPE: "Media Type",
    MEDIA_CHANNEL: "Media Channel",
    LAYOUT_SETTINGS_EDIT: "Layout Settings Edit",
    LAYOUT_SETTINGS_RESET: "Layout Settings Reset",
    LAYOUT_SETTINGS_SAVE: "Layout Settings Save",
    AGENT_HISTORY_RESIZE_HEIGHT: "Agent History Resize Height",
    NOTIFICATION_SOUND_SETTINGS_VOLUME: "Notification Sound Volume",
    ENABLE_SOUND_NOTIFICATION: "Enable Sound Notification",
    ENABLE_SOUND_NOTIFICATION_MUTE: "Enable Sound Notification Mute",
    KEYBOARD_SHORTCUT_COMBINATION_PRESSED: "Keyboard Shortcut Key Combination",
    KEYBOARD_SHORTCUT_KEY_VALUE: "Keyboard Shortcut Key Value",
    SCREEN_POP_TARGET: "Screen Pop Target",
    SCREEN_POP_INTERACTION: "Screen Pop Interaction",
    STOP_NAVIGATE_ON_ACCEPT_TASK: "Stop Navigate on Accept Task",
    ADVANCED_HEADER_ENABLED: "ENABLED",
    ADVANCED_HEADER_DISABLED: "DISABLED",
    ADDRESS_BOOK_LIST: "Address Book List",
    ADDRESS_BOOK_LIST_SEARCH: "Address Book List Search",
    PAGE_NAME: "Page Name",
    PI_TIME_FILTER_DURATION_SELECTED: "Post Interaction: Time Filter Selected",
    OUTDIAL_TYPE: "Outdial Type",
    MISSING_TRANSLATION: "Missing Translation",
    CALL_TYPE: "Call Type"
};
const CACHE_KEYS = {
    HOLD_COUNT: "hc",
    HOLD_START_TIME: "hst",
    TOTAL_NUMBER_OF_CONSULT: "cc",
    CONSULT_START_TIME: "cst",
    CUMULATIVE_CONSULT_TIME: "ccst",
    CONSULT_TYPE: "ct",
    CONTACT_ASSIGNED_TIME: "cat",
    CUMULATIVE_HOLD_TIME: "cht",
    CUMULATIVE_REC_PAUSED_TIME: "crpt",
    PAUSE_REC_START_TIME: "prst",
    PAUSE_REC_COUNT: "prc",
    ANALYZER_VIEW_START_TIME: "avst",
    CONTACT_HISTORY_START_TIME: "chst",
    WXM_JOURNEY_START_TIME: "wjst",
    WXM_EXPERIENCE_ANALYTICS_START_TIME: "weast",
    CONNECTION_LOSS_START_TIME: "clst",
    AUXILIARY_PANEL_TAB_NAME: "aptn",
    SEARCHED_ADDRESS_BOOK: "sad",
    CHOSE_ADDRESS_BOOK_ENTRY: "cabe",
    OUTDIAL_TYPE: "ot",
    CALL_TYPE: "callt"
};
const httpConstants = {
    REQUEST: "REQUEST",
    RESPONSE: "RESPONSE",
    Request: "Request",
    Response: "Response"
};
const AGGREGATION_INTERVAL = 1800000; // 30 mins 1000*60*30=1800000


/***/ }),

/***/ "./src/services/telemetry/telemetry-service.ts":
/*!*****************************************************!*\
  !*** ./src/services/telemetry/telemetry-service.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DEFAULT_RATE_LIMITS: () => (/* binding */ DEFAULT_RATE_LIMITS),
/* harmony export */   TelemetryService: () => (/* binding */ TelemetryService),
/* harmony export */   defaultFairUsageBuilder: () => (/* binding */ defaultFairUsageBuilder)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./constants */ "./src/services/telemetry/constants.ts");
/* harmony import */ var _utils_fairUsage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/fairUsage */ "./src/utils/fairUsage.ts");
/* harmony import */ var _telemetry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./telemetry-utils */ "./src/services/telemetry/telemetry-utils.ts");



const SERVICE_PROVIDERS = () => {
    return {
        prometheus: "prometheus",
        webex_behavioral: "webex_behavioral",
        webex_operational: "webex_operational",
        webex_business: "webex_business"
    };
};
const DEFAULT_RATE_LIMITS = [
    { rate: 100, per: 1000 },
    { rate: 1000, per: 3600000 },
    { rate: 10000, per: 86400000 } // 10000 per day
];
const defaultFairUsageBuilder = (rateLimits = DEFAULT_RATE_LIMITS) => {
    return new _utils_fairUsage__WEBPACK_IMPORTED_MODULE_1__.FairUsage(rateLimits);
};
class TelemetryService {
    constructor(webexMetrics, prometheus, fairUsageBuilder = defaultFairUsageBuilder) {
        this.TELEM_EVENT = _constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS;
        this.TELEM_PROPS = _constants__WEBPACK_IMPORTED_MODULE_0__.PROPS_CONSTANTS;
        this.TELEM_CACHE_KEYS = _constants__WEBPACK_IMPORTED_MODULE_0__.CACHE_KEYS;
        this.SERVICE_PROVIDERS = SERVICE_PROVIDERS();
        this.initialized = false;
        this.callbackEventRegister = new Map();
        this.webexMetrics = webexMetrics;
        this.prometheus = prometheus;
        this.fairUsage = fairUsageBuilder();
    }
    startRateLimitChecking() {
        if (this.rateLimitCheckTimer) {
            window.clearInterval(this.rateLimitCheckTimer);
        }
        this.rateLimitCheckTimer = window.setInterval(() => {
            var _a;
            const rateLimitExceededEvent = (0,_telemetry_utils__WEBPACK_IMPORTED_MODULE_2__.generateRateLimitingTelemetryEvent)(this.fairUsage);
            if (!rateLimitExceededEvent.empty()) {
                (_a = this.webexMetrics) === null || _a === void 0 ? void 0 : _a.trackBusinessEvent(this.TELEM_EVENT.RATE_LIMITING, rateLimitExceededEvent.data);
            }
        }, 1800000);
    }
    init() {
        if (!this.initialized) {
            sessionStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_0__.TELEMETRY_CACHE, "{}");
            this.initialized = true;
            this.startRateLimitChecking();
        }
        return this;
    }
    registerCallbackEvent(name, callback) {
        this.callbackEventRegister.set(name, callback);
    }
    track(name, options, services = []) {
        var _a, _b, _c, _d;
        if (!this.fairUsage.isAllowed(name)) {
            this.fairUsage.setStackTrace(name, (_a = new Error().stack) !== null && _a !== void 0 ? _a : "");
            return;
        }
        const webdriver = navigator.webdriver;
        if (options === null || options === undefined) {
            options = {};
        }
        if (typeof options === "object") {
            options = Object.assign(Object.assign({}, options), { webdriver });
        }
        else {
            options = { options, webdriver };
        }
        const callback = this.callbackEventRegister.get(name);
        const trackOptions = callback ? callback(options) : options;
        for (const service of services) {
            switch (service) {
                case this.SERVICE_PROVIDERS.webex_behavioral: {
                    this.trackBehaviouralEvent(name, trackOptions);
                    break;
                }
                case this.SERVICE_PROVIDERS.webex_operational: {
                    (_b = this.webexMetrics) === null || _b === void 0 ? void 0 : _b.trackOperationalEvent(name, trackOptions);
                    break;
                }
                case this.SERVICE_PROVIDERS.webex_business: {
                    (_c = this.webexMetrics) === null || _c === void 0 ? void 0 : _c.trackBusinessEvent(name, trackOptions);
                    break;
                }
                case this.SERVICE_PROVIDERS.prometheus: {
                    (_d = this.prometheus) === null || _d === void 0 ? void 0 : _d.endEvent(name, {
                        timestamp: new Date(),
                        interaction_id: options.interactionId,
                        status: options.Status === this.TELEM_EVENT.STATUS.SUCCESS,
                        old_state: options.PreviousState,
                        state: options.CurrentState,
                        reason_code: options.Reason,
                        media_type: options.media_type,
                        media_channel: options.media_channel,
                        error_code: options.error_code
                    });
                    break;
                }
                default: {
                    this.trackBehaviouralEvent(name, trackOptions);
                }
            }
        }
        if (services.length === 0) {
            this.trackBehaviouralEvent(name, trackOptions);
        }
    }
    timeEvent(name, services = []) {
        var _a, _b, _c, _d;
        for (const service of services) {
            switch (service) {
                case this.SERVICE_PROVIDERS.webex_behavioral:
                case this.SERVICE_PROVIDERS.webex_operational:
                case this.SERVICE_PROVIDERS.webex_business: {
                    (_a = this.webexMetrics) === null || _a === void 0 ? void 0 : _a.timeEvent(name);
                    break;
                }
                case this.SERVICE_PROVIDERS.prometheus: {
                    (_b = this.prometheus) === null || _b === void 0 ? void 0 : _b.startEvent(name, {
                        timestamp: new Date()
                    });
                    break;
                }
                default: {
                    (_c = this.webexMetrics) === null || _c === void 0 ? void 0 : _c.timeEvent(name);
                }
            }
        }
        if (services.length === 0) {
            (_d = this.webexMetrics) === null || _d === void 0 ? void 0 : _d.timeEvent(name);
        }
    }
    register(superProps) {
        var _a;
        (_a = this.webexMetrics) === null || _a === void 0 ? void 0 : _a.register(superProps);
    }
    setValueInCache(key, value) {
        const str = sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__.TELEMETRY_CACHE) || "{}";
        const obj = JSON.parse(str);
        obj[key] = value;
        sessionStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_0__.TELEMETRY_CACHE, JSON.stringify(obj));
    }
    getValueFromCache(key) {
        const str = sessionStorage ? sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__.TELEMETRY_CACHE) : "";
        const obj = JSON.parse(str);
        return obj ? obj[key] : null;
    }
    removeValueFromCache(key) {
        const str = sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__.TELEMETRY_CACHE);
        const obj = JSON.parse(str);
        obj && delete obj[key];
        sessionStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_0__.TELEMETRY_CACHE, JSON.stringify(obj));
    }
    trackBehaviouralEvent(name, options) {
        var _a;
        (_a = this.webexMetrics) === null || _a === void 0 ? void 0 : _a.trackBehavioralEvent(name, options);
    }
}


/***/ }),

/***/ "./src/services/telemetry/telemetry-utils.ts":
/*!***************************************************!*\
  !*** ./src/services/telemetry/telemetry-utils.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   fetchFairUsageSummary: () => (/* binding */ fetchFairUsageSummary),
/* harmony export */   generateRateLimitingTelemetryEvent: () => (/* binding */ generateRateLimitingTelemetryEvent)
/* harmony export */ });
class TelemetryEventNode {
    constructor() {
        this.data = {};
    }
    attachNode(key, node) {
        this.data[key] = node.data;
    }
    attachInteger(key, value) {
        this.data[key] = value;
    }
    attachString(key, value) {
        this.data[key] = value;
    }
    empty() {
        return Object.keys(this.data).length === 0;
    }
}
function createEmptyNode() {
    return new TelemetryEventNode();
}
function generateEventNodes(fairUsage, fairUsageInfos) {
    const excessNode = createEmptyNode();
    for (const [eventName, excesses] of Object.entries(fairUsageInfos)) {
        const eventNode = createEmptyNode();
        for (const excess of excesses) {
            const key = `${excess.rateLimitInfo.rate}/${excess.rateLimitInfo.per}`;
            eventNode.attachInteger(key, excess.numExcess);
        }
        eventNode.attachString("stackTrace", fairUsage.getStackTrace(eventName));
        excessNode.attachNode(eventName, eventNode);
    }
    return excessNode;
}
function fetchFairUsageSummary(fairUsage) {
    var _a;
    const summary = {
        perEvent: {},
        totalEventCount: fairUsage.totalEventCount
    };
    for (const [eventName, excesslimiters] of fairUsage.getExcessLimiters()) {
        const eventExcesses = [];
        for (const limiter of excesslimiters) {
            const excess = limiter.getExcess();
            if (excess > 0) {
                eventExcesses.push({
                    rateLimitInfo: {
                        rate: limiter.getRate(),
                        per: limiter.getPeriod()
                    },
                    numExcess: excess,
                    stackTrace: (_a = fairUsage.getStackTrace(eventName)) !== null && _a !== void 0 ? _a : ""
                });
                limiter.clearEvents();
            }
        }
        if (eventExcesses.length > 0) {
            summary.perEvent[eventName] = eventExcesses;
        }
    }
    fairUsage.totalEventCount = 0;
    return summary;
}
function generateRateLimitingTelemetryEvent(fairUsage) {
    const summary = fetchFairUsageSummary(fairUsage);
    const node = createEmptyNode();
    if (Object.keys(summary.perEvent).length === 0) {
        return node;
    }
    const summaryNode = createEmptyNode();
    const perEvent = generateEventNodes(fairUsage, summary.perEvent);
    if (!perEvent.empty()) {
        summaryNode.attachNode("perEvent", perEvent);
    }
    if (summary.totalEventCount > 0) {
        summaryNode.attachInteger("totalEventCount", summary.totalEventCount);
    }
    node.attachNode("rateLimit", summaryNode);
    fairUsage.clearStackTraces();
    return node;
}


/***/ }),

/***/ "./src/services/telemetry/tracking-utils.ts":
/*!**************************************************!*\
  !*** ./src/services/telemetry/tracking-utils.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   clearCache: () => (/* binding */ clearCache),
/* harmony export */   trackCallEndedEvent: () => (/* binding */ trackCallEndedEvent),
/* harmony export */   trackCallRecordingEvent: () => (/* binding */ trackCallRecordingEvent),
/* harmony export */   trackCallTransferEvent: () => (/* binding */ trackCallTransferEvent),
/* harmony export */   trackConsultEvent: () => (/* binding */ trackConsultEvent),
/* harmony export */   trackHoldEvents: () => (/* binding */ trackHoldEvents),
/* harmony export */   trackInitialCallEvents: () => (/* binding */ trackInitialCallEvents),
/* harmony export */   trackWrapUpAppliedEvent: () => (/* binding */ trackWrapUpAppliedEvent)
/* harmony export */ });
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./constants */ "./src/services/telemetry/constants.ts");


const { CONSULT_START_TIME, CONTACT_ASSIGNED_TIME, CUMULATIVE_REC_PAUSED_TIME, HOLD_START_TIME, PAUSE_REC_COUNT, TOTAL_NUMBER_OF_CONSULT, CUMULATIVE_CONSULT_TIME, CONSULT_TYPE, HOLD_COUNT, CUMULATIVE_HOLD_TIME, PAUSE_REC_START_TIME, OUTDIAL_TYPE, CALL_TYPE } = _constants__WEBPACK_IMPORTED_MODULE_1__.CACHE_KEYS;
const MEDIA_TYPES = {
    VOICE: "telephony"
};
function getCommonProps(telemetryService, evt) {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ InteractionId: evt.interactionId, [telemetryService.TELEM_PROPS.CALL_DIRECTION]: evt.contactDirection, Status: evt.status ? evt.status : telemetryService.TELEM_EVENT.STATUS.SUCCESS, [telemetryService.TELEM_PROPS.MEDIA_TYPE]: evt.mediaType, [telemetryService.TELEM_PROPS.MEDIA_CHANNEL]: evt.mediaChannel }, (evt.reasonForFailure && { Reason: evt.reasonForFailure })), (evt.reasonCode && { Reason_Code: evt.reasonCode })), (evt.ani && { Ani: evt.ani })), (evt.customerDn && { Customer_DN: evt.customerDn })), (evt.ivrConversation && { Ivr_Conversation: evt.ivrConversation })), (evt.outboundType && { Outbound_Type: evt.outboundType })), (evt.deviceType && { DeviceType: evt.deviceType })), (evt.dialNumberType && { [telemetryService.TELEM_PROPS.DIAL_NUMBER_TYPE]: evt.dialNumberType }));
}
function getConsultDuration(telemetryService) {
    let consultStartTime = telemetryService.getValueFromCache(CONSULT_START_TIME);
    let currentConsultTm = 0;
    if (consultStartTime) {
        consultStartTime = consultStartTime ? Number(consultStartTime) : new Date().getTime();
        currentConsultTm = (new Date().getTime() - consultStartTime) / 1000;
        const cumulativeConsultStartTime = telemetryService.getValueFromCache(CUMULATIVE_CONSULT_TIME);
        const totalNumberOfConsult = telemetryService.getValueFromCache(TOTAL_NUMBER_OF_CONSULT);
        if (cumulativeConsultStartTime) {
            telemetryService.setValueInCache(CUMULATIVE_CONSULT_TIME, Number(cumulativeConsultStartTime) + Number(currentConsultTm));
            telemetryService.setValueInCache(TOTAL_NUMBER_OF_CONSULT, Number(totalNumberOfConsult) + 1);
        }
        else {
            telemetryService.setValueInCache(TOTAL_NUMBER_OF_CONSULT, 1);
            telemetryService.setValueInCache(CUMULATIVE_CONSULT_TIME, currentConsultTm);
        }
    }
    return Number(currentConsultTm);
}
function trackCallTransferEvent(telemetryService, evt) {
    try {
        telemetryService.track(evt.eventName, Object.assign(Object.assign({}, getCommonProps(telemetryService, evt)), { [telemetryService.TELEM_PROPS.TRANSFER_TYPE]: telemetryService.getValueFromCache(CONSULT_TYPE) }));
        if (evt.timeEvent) {
            telemetryService.timeEvent(evt.timeEvent);
        }
    }
    catch (e) {
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.warn(_constants__WEBPACK_IMPORTED_MODULE_1__.TELEMETRY_ERR_MSG, evt, e);
    }
}
function trackCallEndedEvent(telemetryService, evt) {
    var _a, _b;
    try {
        const contactAssignedTime = telemetryService.getValueFromCache(CONTACT_ASSIGNED_TIME);
        let totalCallTime = {};
        let totalConsultTime = {};
        let totalConsult = {};
        if (contactAssignedTime) {
            totalCallTime = {
                [telemetryService.TELEM_PROPS.TOTAL_CALL_TIME]: Number(((new Date().getTime() - Number(contactAssignedTime)) / 1000).toFixed(2))
            };
        }
        const cumulativeConsultStartTime = telemetryService.getValueFromCache(CUMULATIVE_CONSULT_TIME);
        if (cumulativeConsultStartTime) {
            totalConsultTime = {
                [telemetryService.TELEM_PROPS.TOTAL_CONSULT_TIME]: Number(parseFloat(cumulativeConsultStartTime).toFixed(2))
            };
        }
        const totalNumberOfConsult = telemetryService.getValueFromCache(TOTAL_NUMBER_OF_CONSULT);
        if (totalNumberOfConsult) {
            totalConsult = {
                [telemetryService.TELEM_PROPS.TOTAL_CONSULT]: Number(totalNumberOfConsult)
            };
        }
        telemetryService.removeValueFromCache(CONTACT_ASSIGNED_TIME);
        const cumulativeHoldTime = telemetryService.getValueFromCache(CUMULATIVE_HOLD_TIME);
        let cumulativeHoldProps = {};
        let totalNumberOfHold = {};
        if (cumulativeHoldTime) {
            cumulativeHoldProps = { [telemetryService.TELEM_PROPS.TOTAL_HOLD_TIME]: Number(cumulativeHoldTime) };
            totalNumberOfHold = {
                [telemetryService.TELEM_PROPS.TOTAL_TIMES_IN_HOLD]: Number(telemetryService.getValueFromCache(HOLD_COUNT))
            };
        }
        const cumulativeRecPausedTime = telemetryService.getValueFromCache(CUMULATIVE_REC_PAUSED_TIME);
        let cumulativePauseReqProps = {};
        let totalNumberOfRecResume = {};
        if (cumulativeRecPausedTime) {
            cumulativePauseReqProps = {
                [telemetryService.TELEM_PROPS.TOTAL_RECORDING_PAUSE_TIME]: Number(cumulativeRecPausedTime)
            };
            totalNumberOfRecResume = {
                [telemetryService.TELEM_PROPS.TOTAL_TIMES_IN_RECORDING_PAUSE]: Number(telemetryService.getValueFromCache(PAUSE_REC_COUNT))
            };
        }
        telemetryService.track(evt.eventName, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, getCommonProps(telemetryService, evt)), totalCallTime), totalConsultTime), totalConsult), cumulativeHoldProps), totalNumberOfHold), cumulativePauseReqProps), totalNumberOfRecResume), [(_a = telemetryService === null || telemetryService === void 0 ? void 0 : telemetryService.SERVICE_PROVIDERS) === null || _a === void 0 ? void 0 : _a.webex_behavioral, (_b = telemetryService === null || telemetryService === void 0 ? void 0 : telemetryService.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_business]);
        if (evt.timeEvent) {
            telemetryService.timeEvent(evt.timeEvent);
        }
    }
    catch (e) {
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.warn(_constants__WEBPACK_IMPORTED_MODULE_1__.TELEMETRY_ERR_MSG, evt, e);
    }
}
function trackCallRecordingEvent(telemetryService, evt) {
    try {
        if (evt.mediaType === MEDIA_TYPES.VOICE) {
            let pauseTime = {};
            let autoResumed = {};
            if (evt.eventName === telemetryService.TELEM_EVENT.CALL_PAUSE_RECORDING_CLICKED) {
                const pauseRecCount = telemetryService.getValueFromCache(PAUSE_REC_COUNT);
                telemetryService.setValueInCache(PAUSE_REC_COUNT, pauseRecCount ? Number(pauseRecCount) + 1 : 1);
            }
            else if (evt.eventName === telemetryService.TELEM_EVENT.CALL_RESUME_RECORDING_ACTIVATED) {
                const startTime = telemetryService.getValueFromCache(PAUSE_REC_START_TIME);
                if (startTime) {
                    const totalPausedTime = ((new Date().getTime() - Number(startTime)) / 1000).toFixed(2);
                    const cumulativeRecPausedTime = telemetryService.getValueFromCache(CUMULATIVE_REC_PAUSED_TIME);
                    if (cumulativeRecPausedTime) {
                        telemetryService.setValueInCache(CUMULATIVE_REC_PAUSED_TIME, Number(cumulativeRecPausedTime) + Number(totalPausedTime));
                    }
                    else {
                        telemetryService.setValueInCache(CUMULATIVE_REC_PAUSED_TIME, totalPausedTime);
                    }
                    pauseTime = {
                        [telemetryService.TELEM_PROPS.PAUSE_RECORDING_TIME]: Number(totalPausedTime)
                    };
                }
                autoResumed = { AutoResumed: evt.autoResumed };
            }
            telemetryService.track(evt.eventName, Object.assign(Object.assign(Object.assign({}, getCommonProps(telemetryService, evt)), pauseTime), autoResumed));
            if (evt.timeEvent) {
                telemetryService.timeEvent(evt.timeEvent);
            }
        }
    }
    catch (e) {
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.warn(_constants__WEBPACK_IMPORTED_MODULE_1__.TELEMETRY_ERR_MSG, evt, e);
    }
}
function trackWrapUpAppliedEvent(telemetryService, evt) {
    var _a, _b;
    try {
        telemetryService.track(evt.eventName, Object.assign({}, getCommonProps(telemetryService, evt)), [(_a = telemetryService === null || telemetryService === void 0 ? void 0 : telemetryService.SERVICE_PROVIDERS) === null || _a === void 0 ? void 0 : _a.webex_behavioral, (_b = telemetryService === null || telemetryService === void 0 ? void 0 : telemetryService.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_business]);
        if (evt.timeEvent) {
            telemetryService.timeEvent(evt.timeEvent);
        }
    }
    catch (e) {
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.warn(_constants__WEBPACK_IMPORTED_MODULE_1__.TELEMETRY_ERR_MSG, evt, e);
    }
}
function trackInitialCallEvents(telemetryService, evt) {
    try {
        telemetryService.track(evt.eventName, Object.assign(Object.assign({}, getCommonProps(telemetryService, evt)), { [telemetryService.TELEM_PROPS.OUTDIAL_TYPE]: telemetryService.getValueFromCache(OUTDIAL_TYPE), [telemetryService.TELEM_PROPS.CALL_TYPE]: telemetryService.getValueFromCache(CALL_TYPE) }));
    }
    catch (e) {
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.warn(_constants__WEBPACK_IMPORTED_MODULE_1__.TELEMETRY_ERR_MSG, evt.eventName, e);
    }
}
function trackHoldEvents(telemetryService, evt) {
    try {
        if (evt.mediaType === MEDIA_TYPES.VOICE) {
            let totalHoldTimeProps = {};
            if (evt.eventName === telemetryService.TELEM_EVENT.CALL_HOLD_CLICKED) {
                telemetryService.setValueInCache(HOLD_START_TIME, new Date().getTime());
                const holdCount = telemetryService.getValueFromCache(HOLD_COUNT);
                telemetryService.setValueInCache(HOLD_COUNT, holdCount ? Number(holdCount) + 1 : 1);
            }
            else if (evt.eventName === telemetryService.TELEM_EVENT.CALL_RESUME_ACTIVATED) {
                const holdStartTime = telemetryService.getValueFromCache(HOLD_START_TIME);
                if (holdStartTime) {
                    const totalHoldTime = ((new Date().getTime() - holdStartTime) / 1000).toFixed(2);
                    totalHoldTimeProps = {
                        [telemetryService.TELEM_PROPS.TOTAL_HOLD_TIME]: Number(totalHoldTime)
                    };
                    const cumulativeHoldTime = telemetryService.getValueFromCache(CUMULATIVE_HOLD_TIME);
                    if (cumulativeHoldTime) {
                        telemetryService.setValueInCache(CUMULATIVE_HOLD_TIME, Number(cumulativeHoldTime) + Number(totalHoldTime));
                    }
                    else {
                        telemetryService.setValueInCache(CUMULATIVE_HOLD_TIME, totalHoldTime);
                    }
                    telemetryService.removeValueFromCache(HOLD_START_TIME);
                }
            }
            telemetryService.track(evt.eventName, Object.assign(Object.assign({}, getCommonProps(telemetryService, evt)), totalHoldTimeProps));
            if (evt.timeEvent) {
                telemetryService.timeEvent(evt.timeEvent);
            }
        }
    }
    catch (e) {
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.warn(_constants__WEBPACK_IMPORTED_MODULE_1__.TELEMETRY_ERR_MSG, evt.eventName, e);
    }
}
function trackConsultEvent(telemetryService, event) {
    try {
        let consultDuration = {};
        if (event.eventName === telemetryService.TELEM_EVENT.CALL_CONSULT_END_ACTIVATED) {
            const consultDur = getConsultDuration(telemetryService);
            if (consultDur > 0) {
                consultDuration = { [telemetryService.TELEM_PROPS.CONSULT_DURATION]: consultDur };
            }
        }
        telemetryService.track(event.eventName, Object.assign(Object.assign(Object.assign({}, getCommonProps(telemetryService, event)), { [telemetryService.TELEM_PROPS.CONSULT_TYPE]: telemetryService.getValueFromCache(CONSULT_TYPE) }), consultDuration));
        if (event.timeEvent) {
            telemetryService.timeEvent(event.timeEvent);
        }
    }
    catch (e) {
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.warn(_constants__WEBPACK_IMPORTED_MODULE_1__.TELEMETRY_ERR_MSG, event, e);
    }
}
function clearCache(telemetryService) {
    telemetryService.removeValueFromCache(CUMULATIVE_CONSULT_TIME);
    telemetryService.removeValueFromCache(TOTAL_NUMBER_OF_CONSULT);
    telemetryService.removeValueFromCache(CONSULT_START_TIME);
    telemetryService.removeValueFromCache(CUMULATIVE_HOLD_TIME);
    telemetryService.removeValueFromCache(CUMULATIVE_REC_PAUSED_TIME);
    telemetryService.removeValueFromCache(HOLD_COUNT);
    telemetryService.removeValueFromCache(CONSULT_TYPE);
    telemetryService.removeValueFromCache(PAUSE_REC_START_TIME);
}


/***/ }),

/***/ "./src/services/userPreferences/user-preferences-service.ts":
/*!******************************************************************!*\
  !*** ./src/services/userPreferences/user-preferences-service.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   userPrefsService: () => (/* binding */ userPrefsService)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");




function userPrefsService() {
    const http = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__.HttpReqs(_config__WEBPACK_IMPORTED_MODULE_0__.CONF.API_GATEWAY);
    return {
        fetchUserPreferences: http.req((p) => ({
            url: `/organization/${p.orgId}/user-preference/${p.userId}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.orgId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_2__.createErrDetailsObject,
            method: "GET",
            errId: "Service.userPrefs.fetchUserPreferences",
            res: {}
        })),
        saveUserPreferences: http.req((p) => ({
            url: `/organization/${p.organizationId}/user-preference/`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.organizationId }),
            data: {
                desktopPreference: JSON.stringify(p.data)
            },
            err: _service_utils__WEBPACK_IMPORTED_MODULE_2__.createErrDetailsObject,
            method: "POST",
            errId: "Service.userPrefs.saveUserPreferences",
            res: {}
        })),
        updateUserPreferences: http.req((p) => ({
            url: `/organization/${p.organizationId}/user-preference/${p.id}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.organizationId }),
            data: {
                desktopPreference: JSON.stringify(p.data)
            },
            err: _service_utils__WEBPACK_IMPORTED_MODULE_2__.createErrDetailsObject,
            method: "PUT",
            errId: "Service.userPrefs.updateUserPreferences",
            res: {}
        })),
        deleteUserPreferences: http.req((p) => ({
            url: `/organization/${p.organizationId}/user-preference/${p.id}`,
            headers: Object.assign(Object.assign({}, _constant__WEBPACK_IMPORTED_MODULE_3__.HTTP_HEADERS), { "X-ORGANIZATION-ID": p.organizationId }),
            data: {},
            err: _service_utils__WEBPACK_IMPORTED_MODULE_2__.createErrDetailsObject,
            method: "DELETE",
            errId: "Service.userPrefs.deleteUserPreferences",
            res: {}
        }))
    };
}


/***/ }),

/***/ "./src/services/webex/web-calling-service.ts":
/*!***************************************************!*\
  !*** ./src/services/webex/web-calling-service.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WebCallingService: () => (/* binding */ WebCallingService)
/* harmony export */ });
/* harmony import */ var _webex_calling__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @webex/calling */ "@webex/calling");
/* harmony import */ var _webex_calling__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_webex_calling__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../.. */ "./src/index.ts");
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




class WebCallingService {
    constructor() {
        this.domainUrl = "";
        this.webCallingRegistered = false;
    }
    registerWebCalling(domainUrl) {
        if (!window.webexService) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("[WebRtc]: event=webexNotFound | webex not available in window, error");
            return;
        }
        if (this.webCallingRegistered) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[WebRtc]: webCalling Already Registered");
            return;
        }
        this.domainUrl = domainUrl;
        this.webex = window.webexService;
        window.CreateClient = (webex, config) => (0,_webex_calling__WEBPACK_IMPORTED_MODULE_0__.createClient)(webex, config);
        if (this.webex.internal.device.registered && this.webex.internal.mercury.connected) {
            this.handleWebRtcDeviceRegister();
        }
        else {
            this.handleWebRtcRegister();
        }
    }
    deregisterWebCalling() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield ((_a = this.line) === null || _a === void 0 ? void 0 : _a.deregister());
                this.webCallingRegistered = false;
                _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[WebRtc]: event=callingClientDeregisterSuccess: webCalling deregistered");
            }
            catch (error) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`[WebRtc] : event=callingClientDeregisterFailed:  Error while deregistering webCalling, ${error}`);
            }
        });
    }
    getMicrophoneStream(audio) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const microphoneStream = yield (0,_webex_calling__WEBPACK_IMPORTED_MODULE_0__.createMicrophoneStream)({ deviceId: audio.ID });
                _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[WebRtc] : event=getMicrophoneStreamSuccess");
                return Promise.resolve(microphoneStream);
            }
            catch (err) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("[WebRtc] : event=getMicrophoneStreamFailed", err);
                return Promise.reject(err);
            }
        });
    }
    answerWebCall(localMicrophoneStream) {
        if (this.webCall) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info(`[WebRtc]: WebCall Answering with localMicrophoneStream, ${localMicrophoneStream}`);
            this.webCall.answer(localMicrophoneStream);
        }
        else {
            this.handleNoWebCall();
        }
    }
    muteWebCall(localMicrophoneStream) {
        if (this.webCall) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[WebRtc]: WebCall mute|unmute requesting!");
            this.webCall.mute(localMicrophoneStream);
        }
        else {
            this.handleNoWebCall();
        }
    }
    isWebCallMuted() {
        if (this.webCall) {
            return this.webCall.isMuted();
        }
        else {
            this.handleNoWebCall();
            return false;
        }
    }
    declineWebCall() {
        if (this.webCall) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[WebRtc]: WebCall end requesting!");
            this.webCall.end();
        }
        else {
            this.handleNoWebCall();
        }
    }
    dispatchWebCallEvent(eventName, detail) {
        window.dispatchEvent(new CustomEvent(eventName, {
            detail: { value: detail },
            bubbles: true,
            composed: true
        }));
    }
    handleNoWebCall() {
        _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[WebRtc]: WebCall not found!");
        this.dispatchWebCallEvent(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.AX_WC_NOT_FOUND);
    }
    handleWebRtcDeviceRegister() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!window.CreateClient) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("[WebRtc]: event=webexCallingNotFound | CreateClient not available in window");
                return;
            }
            const sdkConfig = {
                serviceData: {
                    indicator: _constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.INDICATOR_CONTACT_CENTER,
                    domain: this.domainUrl
                }
            };
            if (___WEBPACK_IMPORTED_MODULE_1__.SERVICE.featureflag.isSDKCallingInfoLevelLogsEnabled()) {
                sdkConfig.logger = {
                    level: "info"
                };
            }
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[WebRtc]: trying to register with webex-calling-sdk with domainUrl", this.domainUrl);
            try {
                this.callingClient = window.callingClient = yield window.CreateClient(this.webex, sdkConfig);
                this.line = Object.values(this.callingClient.getLines())[0];
                this.line.register();
            }
            catch (error) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("[WebRtc]: Error", error, "registering with webex-calling-sdk with domainUrl", this.domainUrl);
                return;
            }
            this.registerCallingEvents();
            this.createUpdateWebCall();
        });
    }
    registerCallingEvents() {
        this.line.on(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.CALLING_REGISTER_EVENT, (deviceInfo) => {
            var _a, _b, _c, _d, _e;
            const deviceRegistered = ((_b = (_a = this.webex.internal) === null || _a === void 0 ? void 0 : _a.device) === null || _b === void 0 ? void 0 : _b.url) !== ""
                ? `Registered, with deviceId: ${(_c = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.device) === null || _c === void 0 ? void 0 : _c.deviceId}, uri : ${(_d = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.device) === null || _d === void 0 ? void 0 : _d.uri} and clientDeviceUri : ${(_e = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.device) === null || _e === void 0 ? void 0 : _e.clientDeviceUri}`
                : "Not Registered";
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info(`[WebRtc]: event=CallingRegistrationSuccess, device Info: ${deviceRegistered}`);
            this.webCallingRegistered = true;
            this.dispatchWebCallEvent(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.AX_WC_DEVICE_REGISTERED, this.webCallingRegistered);
        });
        this.line.on(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.CALLING_UN_REGISTERED, () => {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[WebRtc]: event=CallingClientUnRegistered : Retrying to connect");
            this.webCallingRegistered = false;
            this.dispatchWebCallEvent(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.AX_WC_DEVICE_REGISTERING);
        });
        this.line.on(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.CALLING_ERROR, (err) => {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("[WebRtc]: event=CallingClientRegistrationFailed : Device registration error", err);
            this.webCallingRegistered = false;
            this.dispatchWebCallEvent(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.AX_WC_DEVICE_DISCONNECTED, {
                mode: "client",
                errorDetails: JSON.stringify(err)
            });
        });
    }
    // Create/Update webCall Object.
    createUpdateWebCall() {
        this.line.on(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.CALLING_INCOMING_EVENT, (callObj) => {
            var _a, _b;
            this.webCall = callObj;
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info(`[WebRtc]: event=WebrtcIncomingCall,  MessageType : ${(_a = callObj === null || callObj === void 0 ? void 0 : callObj.remoteRoapMessage) === null || _a === void 0 ? void 0 : _a.messageType}, SDP : ${(_b = callObj === null || callObj === void 0 ? void 0 : callObj.remoteRoapMessage) === null || _b === void 0 ? void 0 : _b.sdp}`);
            this.dispatchWebCallEvent(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.AX_WC_INCOMING);
            // All webCall related Event listners.
            this.webCall.on(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.CALL_DISCONNECT_EVENT, (correlationId) => {
                _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[WebRtc]: Call Disconnected, correlationId:", correlationId);
                this.dispatchWebCallEvent("ax-web-call-disconnected", correlationId);
            });
            this.webCall.on(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.CALL_ESTABLISHED_EVENT, (correlationId) => {
                _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[WebRtc]: Call Established, correlationId:", correlationId);
                this.dispatchWebCallEvent(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.AX_WC_ESTABLISHED, correlationId);
            });
            this.webCall.on(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.CALL_REMOTE_MEDIA_UPDATE_EVENT, (track) => {
                _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[WebRtc]: Call Remote Media Update");
                this.dispatchWebCallEvent(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.AX_WC_REMOTE_MEDIA_UPDATE, track);
            });
            //on sendDTMF call
            this.webCall.on(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.DTMF_TONE_CHANGED_EVENT, (digit) => {
                _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info(`[WebRtc]: Make a DTMF call with digit ${digit}`);
            });
        });
    }
    handleWebRtcRegister() {
        return this.webex.internal.device
            .register()
            .then(() => {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[WebRtc]: event=WebexDeviceRegistrationSuccess : webex.internal.device.register successful");
            return this.webex.internal.mercury
                .connect()
                .then(() => {
                _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[WebRtc]: event=WebexMercuryConnectSuccessFull, webex.internal.mercury.connect successful");
                this.handleWebRtcDeviceRegister();
            })
                .catch((error) => {
                _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("[WebRtc]: event=WebexMercuryConnectionFailed : Error occurred during mercury.connect()", error);
                this.dispatchWebCallEvent(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.AX_WC_DEVICE_DISCONNECTED, {
                    mode: "device",
                    errorDetails: JSON.stringify(error)
                });
            });
        })
            .catch((error) => {
            this.webCallingRegistered = false;
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error("[WebRtc]: event=WebexDeviceRegistrationFailed, Error occurred during webex.internal.device.register()", error);
            this.webCallingRegistered = false;
            this.dispatchWebCallEvent(_constant__WEBPACK_IMPORTED_MODULE_3__.WEB_CALLING.AX_WC_DEVICE_DISCONNECTED, {
                mode: "device",
                errorDetails: JSON.stringify(error)
            });
        });
    }
    sendDTMF(digit) {
        if (this.webCall) {
            this.webCall.sendDigit(digit);
        }
        else {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`[WebRtc]: Call object is not defined`);
        }
    }
    updateCallMedia(micStream) {
        if (this.webCall) {
            this.webCall.updateMedia(micStream);
        }
        else {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info(`[WebRtc]: No current call - no media update required`);
        }
    }
}


/***/ }),

/***/ "./src/services/webex/webex-calling-service.ts":
/*!*****************************************************!*\
  !*** ./src/services/webex/webex-calling-service.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WebexCallingService: () => (/* binding */ WebexCallingService)
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../core/http-reqs */ "./src/core/http-reqs.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");




class WebexCallingService {
    constructor(accessToken) {
        this.accessToken = "";
        this.wxHttp = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__.HttpReqs(`${_config__WEBPACK_IMPORTED_MODULE_0__.CONF.WEBEX_APIS_URL}/telephony/calls`, true);
        this.wxConfigHttp = new _core_http_reqs__WEBPACK_IMPORTED_MODULE_1__.HttpReqs(`${_config__WEBPACK_IMPORTED_MODULE_0__.CONF.WEBEX_APIS_URL}/telephony/config`, true);
        this.httpPost = "POST";
        this.httpGet = "GET";
        this.httpPUT = "PUT";
        this.answerCall = this.wxHttp.req((p) => ({
            url: "/answer",
            headers: this.getRequestHeaders(),
            method: this.httpPost,
            data: { callId: p.callId, endpointId: p.deviceId },
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: _constant__WEBPACK_IMPORTED_MODULE_2__.WEBEX_CALLING.ANSWER_CALL_FAILED,
            res: {}
        }));
        this.rejectCall = this.wxHttp.req((p) => ({
            url: "/reject",
            headers: this.getRequestHeaders(),
            method: this.httpPost,
            data: { callId: p.callId },
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: _constant__WEBPACK_IMPORTED_MODULE_2__.WEBEX_CALLING.REJECT_CALL_FAILED,
            res: {}
        }));
        this.muteCall = this.wxHttp.req((p) => ({
            url: "/mute",
            headers: this.getRequestHeaders(),
            method: this.httpPost,
            data: { callId: p.callId },
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: _constant__WEBPACK_IMPORTED_MODULE_2__.WEBEX_CALLING.MUTE_CALL_FAILED,
            res: {}
        }));
        this.unmuteCall = this.wxHttp.req((p) => ({
            url: "/unmute",
            headers: this.getRequestHeaders(),
            method: this.httpPost,
            data: { callId: p.callId },
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: _constant__WEBPACK_IMPORTED_MODULE_2__.WEBEX_CALLING.MUTE_CALL_FAILED,
            res: {}
        }));
        this.holdCall = this.wxHttp.req((p) => ({
            url: "/hold",
            headers: this.getRequestHeaders(),
            method: this.httpPost,
            data: { callId: p.callId },
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: _constant__WEBPACK_IMPORTED_MODULE_2__.WEBEX_CALLING.HOLD_CALL_FAILED,
            res: {}
        }));
        this.resumeCall = this.wxHttp.req((p) => ({
            url: "/resume",
            headers: this.getRequestHeaders(),
            method: this.httpPost,
            data: { callId: p.callId },
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: _constant__WEBPACK_IMPORTED_MODULE_2__.WEBEX_CALLING.RESUME_CALL_FAILED,
            res: {}
        }));
        this.sendDTMF = this.wxHttp.req((p) => ({
            url: "/transmitDtmf",
            headers: this.getRequestHeaders(),
            method: this.httpPost,
            data: { callId: p.callId, dtmf: p.dtmf },
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: _constant__WEBPACK_IMPORTED_MODULE_2__.WEBEX_CALLING.TRANSMIT_DTMF_FAILED,
            res: {}
        }));
        this.getCallDetails = this.wxHttp.req((p) => ({
            url: `/${p.callId}`,
            headers: this.getRequestHeaders(),
            method: this.httpGet,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: _constant__WEBPACK_IMPORTED_MODULE_2__.WEBEX_CALLING.GET_CALL_DETAILS_FAILED,
            res: {}
        }));
        this.getPreferredAnswerEndpoints = this.wxConfigHttp.req((p) => ({
            url: `/people/${p.personId}/preferredAnswerEndpoint`,
            headers: this.getRequestHeaders(),
            method: this.httpGet,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: _constant__WEBPACK_IMPORTED_MODULE_2__.WEBEX_CALLING.GET_PREFERRED_ANSWER_ENDPOINTS_FAILED,
            res: {}
        }));
        this.setPreferredAnswerEndpoint = this.wxConfigHttp.req((p) => ({
            url: `/people/${p.personId}/preferredAnswerEndpoint`,
            headers: this.getRequestHeaders(),
            method: this.httpPUT,
            data: { preferredAnswerEndpointId: p.preferredAnswerEndpointId },
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: _constant__WEBPACK_IMPORTED_MODULE_2__.WEBEX_CALLING.SET_PREFERRED_ANSWER_ENDPOINT_FAILED,
            res: {}
        }));
        this.getExtensionDetails = this.wxConfigHttp.req(() => ({
            url: "/people/me/settings/contactCenterExtensions",
            headers: this.getRequestHeaders(),
            method: this.httpGet,
            err: _service_utils__WEBPACK_IMPORTED_MODULE_3__.createErrDetailsObject,
            errId: _constant__WEBPACK_IMPORTED_MODULE_2__.WEBEX_CALLING.GET_CONTACT_CENTER_EXTENSIONS_FAILED,
            res: {}
        }));
        this.accessToken = accessToken;
    }
    getRequestHeaders() {
        return {
            Authorization: `Bearer ${this.accessToken}`,
            "Content-Type": "application/json"
        };
    }
}


/***/ }),

/***/ "./src/services/webex/webex-calling-utils.ts":
/*!***************************************************!*\
  !*** ./src/services/webex/webex-calling-utils.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   parseContactCenterExtensions: () => (/* binding */ parseContactCenterExtensions)
/* harmony export */ });
function parseContactCenterExtensions(ccExtensions) {
    const dialNumbers = [];
    const extensions = [];
    const devicesMap = {};
    ccExtensions.ccExtensions.forEach((ccExtension) => {
        var _a;
        if (ccExtension.phoneNumber) {
            dialNumbers.push(ccExtension.phoneNumber);
        }
        if (ccExtension.extension) {
            extensions.push(ccExtension.extension);
            const devices = [];
            (_a = ccExtension.endpoints) === null || _a === void 0 ? void 0 : _a.forEach((endpoint) => {
                var _a;
                const device = (_a = ccExtensions.endpoints) === null || _a === void 0 ? void 0 : _a.find((item) => item.id === endpoint.id);
                if (device && device.status) {
                    devices.push({
                        name: device.name,
                        available: device.status === "CONNECTED"
                    });
                }
            });
            devicesMap[ccExtension.extension] = devices;
        }
    });
    return {
        dialNumbers,
        extensions,
        devicesMap
    };
}


/***/ }),

/***/ "./src/services/webex/webex-service.ts":
/*!*********************************************!*\
  !*** ./src/services/webex/webex-service.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WebexService: () => (/* binding */ WebexService)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _webex_internal_plugin_dss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @webex/internal-plugin-dss */ "@webex/internal-plugin-dss");
/* harmony import */ var _webex_internal_plugin_dss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_webex_internal_plugin_dss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _webex_internal_plugin_metrics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @webex/internal-plugin-metrics */ "@webex/internal-plugin-metrics");
/* harmony import */ var _webex_internal_plugin_metrics__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_webex_internal_plugin_metrics__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! uuid */ "uuid");
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(uuid__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var webex__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! webex */ "webex");
/* harmony import */ var webex__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(webex__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../index */ "./src/index.ts");
/* harmony import */ var _utils_structuredLog__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/structuredLog */ "./src/utils/structuredLog.ts");
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../constant */ "./src/services/constant.ts");
/* harmony import */ var _service_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../service-utils */ "./src/services/service-utils.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};











var CallHoldState;
(function (CallHoldState) {
    CallHoldState["Held"] = "held";
    CallHoldState["Connected"] = "connected";
    CallHoldState["Unknown"] = "unknown";
})(CallHoldState || (CallHoldState = {}));
class WebexService {
    webexInitializedStatus() {
        return this.webexInitialized;
    }
    getFeatureFlag(name) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.webex.internal.feature.getFeature("user", name);
        });
    }
    registerWebex(isProd) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                try {
                    if (this.webexInitialized) {
                        _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[Webex] : Webex already initialized!");
                        resolve();
                        return;
                    }
                    const webexConfig = {
                        config: {
                            meetings: {
                                reconnection: {
                                    enabled: true
                                },
                                enableRtx: true
                            },
                            presence: { initializeWorker: true },
                            mercury: {
                                beforeLogoutOptionsCloseReason: "done (permanent)"
                            }
                        },
                        credentials: {
                            access_token: this.accessToken
                        }
                    };
                    if (!isProd) {
                        _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[Webex]: event=webexConfigForBts | webex configured for bts env");
                        webexConfig.config.services = {
                            discovery: {
                                u2c: _constant__WEBPACK_IMPORTED_MODULE_9__.NON_PROD_WEBEX_URL.U2C,
                                hydra: _constant__WEBPACK_IMPORTED_MODULE_9__.NON_PROD_WEBEX_URL.HYDRA
                            }
                        };
                    }
                    this.webex = window.webexService = webex__WEBPACK_IMPORTED_MODULE_5___default().init(webexConfig);
                    this.mercury = this.webex.internal.mercury;
                    this.device = this.webex.internal.device;
                    this.dss = this.webex.internal.dss;
                    this.presence = this.webex.internal.presence;
                    this.newMetrics = new _webex_internal_plugin_metrics__WEBPACK_IMPORTED_MODULE_2__.NewMetrics({}, { parent: this.webex });
                    this.support = this.webex.internal.support;
                    this.listenForEvents();
                    this.webex.once("ready", () => {
                        this.webexInitialized = true; //To avoid multiple call to webex ready
                        _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[Webex] : event=webexReady | Webex Ready");
                        resolve();
                    });
                }
                catch (error) {
                    this.webexInitialized = false;
                    _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("[Webex] : Error while initializing", error);
                    reject(error);
                }
            });
        });
    }
    registerWebexEvents() {
        _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[Webex] : event=registerWebexEvents | Registering Webex Events");
        this.registerWebexMeeting();
        this.handleWebexMessageEvents();
        this.handleUnreadConversations();
    }
    listenForEvents() {
        this.webex.internal.device.on("registration:success", () => {
            _utils_structuredLog__WEBPACK_IMPORTED_MODULE_8__.StructuredLog.trace("Login/Webex/WDMRegistration/Success");
            //We now should have feature toggles
            //Fire event to initialize logrocket in app.ts
            //We are also ready to submit webex metrics events
            this.wdmRegistrationEvent.send();
        });
    }
    registerWebexMeeting() {
        this.webex.meetings.register().catch((err) => {
            _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error(`event=webexMeetingRegisterError | Webex Meeting Registration error: ${err}`, err);
        });
        this.webex.meetings.on("meetings:registered", () => {
            _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("event=webexMeetingRegisterSuccess | Webex Meeting Registration Success");
            this.listenForIncomingMeetings();
        });
    }
    unregisterWebex() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[Webex] : event=device.unregister called to delete the device registered with webex-js-sdk!");
                this.webexInitialized = false;
                this.mercuryConnectRetry = false;
                yield this.device.unregister();
                yield this.dss.unregister();
                yield this.webex.meetings.unregister();
                yield this.webex.logout({ noRedirect: true });
                yield this.mercury.logout();
            }
            catch (error) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("[Webex] : Error while Logout is initiated, to delete the device registered with webex-js-sdk!", error);
            }
        });
    }
    // polling logic for webex dnd
    poleWebexStatus(data) {
        clearTimeout(this.timeout);
        if (data.status === "dnd" && data.expiresTTL > 0) {
            this.timeout = window.setTimeout(() => {
                var _a, _b;
                this.getUserStatusForWebex((_b = (_a = _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.conf) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.agentId);
            }, data.expiresTTL * 1000);
        }
    }
    webexRequest(method, service, resource, body) {
        var _a;
        return (_a = this.webex) === null || _a === void 0 ? void 0 : _a.request({
            method,
            service,
            resource,
            body
        });
    }
    // get dnd/active status for the webex user
    getUserStatusForWebex(agentId) {
        if (agentId) {
            this.presence
                .get(agentId)
                .then((response) => {
                const eventData = {
                    eventType: _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.constants.WebexConstants.WEBEX_DND,
                    status: response === null || response === void 0 ? void 0 : response.status
                };
                this.newPresenceEventSignal.send(eventData);
                this.poleWebexStatus(response);
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info(`event=webexGetPresenceSuccess | Webex Get Presence Success with status, ${response.status}`);
            })
                .catch((err) => {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error(`event=webexGetPresenceFailed | Webex Get Presence Failed, ${err}`, err);
            });
        }
    }
    getPresenceStatus(agentId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (agentId) {
                try {
                    const response = yield this.presence.get(agentId);
                    _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info(`event=webexGetPresenceSuccess | Webex Get Presence Success with status, ${response.status}`);
                    this.onNewPresenceStateSyncEventSignal.send({
                        data: {
                            eventType: _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.constants.WebexConstants.WEBEX_PRESENCE_UPDATE,
                            subject: response === null || response === void 0 ? void 0 : response.subject,
                            status: response === null || response === void 0 ? void 0 : response.status,
                            category: "status",
                            meetingType: response === null || response === void 0 ? void 0 : response.meetingType
                        }
                    });
                }
                catch (err) {
                    _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error(`event=webexGetPresenceFailed | Webex Get Presence Failed`, err);
                }
            }
        });
    }
    // handle onload/reload
    updateWebexMeeting() {
        var _a, _b;
        if (!this.getCurrentMeeting()) {
            const eventData = {
                id: "",
                timeStamp: 0,
                eventType: _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.constants.WebexConstants.CALL_INACTIVE,
                participantName: "",
                meetingType: _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.constants.WebexConstants.CALL
            };
            this.newMeetingEventSignal.send(eventData);
        }
        this.getUserStatusForWebex((_b = (_a = _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.conf) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.agentId);
    }
    getCurrentMeeting() {
        const meetings = this.webex.meetings.getAllMeetings();
        return meetings[Object.keys(meetings)[0]];
    }
    parseMessage(message, person) {
        return {
            sentBy: message.data.personEmail,
            text: message.data.text,
            html: message.data.html,
            time: message.data.created,
            roomType: message.data.roomType,
            displayName: person.displayName,
            hasAttachments: message.data.files,
            id: message.data.id
        };
    }
    fetchPersonData(personId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.webex.people.get(personId);
        });
    }
    fetchPersonDataByEmail(personEmail) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.webex.people.list({ email: personEmail });
        });
    }
    handleWebexMessageEvents() {
        this.webex.messages
            .listen()
            .then(() => {
            _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("event=webexMessages | listening to message events");
            this.webex.messages.on("created", (message) => __awaiter(this, void 0, void 0, function* () {
                const person = yield this.fetchPersonData(message.data.personId);
                this.newMessageSignal.send(this.parseMessage(message, person));
                this.fetchUnreadConversationCount();
            }));
        })
            .catch((err) => {
            _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error(`event=webexMessagesError | error listening to messages: ${err}`, err);
        });
    }
    listenForIncomingMeetings() {
        this.webex.meetings.on("meeting:added", (addedMeetingEvent) => {
            var _a;
            if (addedMeetingEvent.type === _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.constants.WebexConstants.INCOMING ||
                addedMeetingEvent.type === _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.constants.WebexConstants.JOIN) {
                const addedMeeting = addedMeetingEvent.meeting;
                if (addedMeeting) {
                    const isScheduledMeeting = addedMeeting.locusInfo.scheduledMeeting ? true : false;
                    const timeStamp = (_a = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(addedMeeting.locusInfo.fullState.lastActive)) === null || _a === void 0 ? void 0 : _a.toMillis();
                    const name = addedMeeting.type === _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.constants.WebexConstants.CALL
                        ? addedMeeting.locusInfo.host.name
                        : addedMeeting.locusInfo.info.webExMeetingName;
                    const meetingData = {
                        id: addedMeeting.id,
                        eventType: addedMeetingEvent.type,
                        timeStamp,
                        participantName: name,
                        meetingType: addedMeeting.type,
                        isScheduledMeeting,
                        meetingInMinutes: isScheduledMeeting
                            ? this.getStartTimeInMinute(addedMeetingEvent.meeting.locusInfo.scheduledMeeting.startTime)
                            : 0
                    };
                    this.newMeetingEventSignal.send(meetingData);
                }
            }
        });
        this.webex.meetings.on("meeting:removed", (removeMeetingEvent) => {
            const eventData = {
                id: removeMeetingEvent.meetingId,
                timeStamp: 0,
                eventType: removeMeetingEvent.reason,
                participantName: "",
                meetingType: _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.constants.WebexConstants.CALL
            };
            this.newMeetingEventSignal.send(eventData);
            setTimeout(() => {
                //For missed calls, conversation is updating late so adding delay of 10 seconds
                this.fetchUnreadConversationCount();
            }, 10000);
        });
    }
    fetchUnreadConversationCount() {
        _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("event=webexNotificationCount | Fetching unread conversation count");
        this.webex.rooms
            .listWithReadStatus()
            .then((data) => {
            this.webexNotificationErrorCount = 0; // to reset the count after successful fetch
            let unreadConversationCount = 0;
            data.items.forEach((item) => {
                const lastActivity = new Date(item.lastActivityDate).getTime();
                const lastSeen = new Date(item.lastSeenActivityDate).getTime();
                if (lastSeen < lastActivity) {
                    unreadConversationCount++;
                }
            });
            this.notificationCountUpdateSignal.send(unreadConversationCount);
        })
            .catch((e) => {
            // To remove the spamming of the logs for failing to fetch the unread conversation count
            if (this.webexNotificationErrorCount < this.maxWebexNotificationErrorCount) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error(`event=webexNotificationCountError | Failed to fetch unread conversation count: ${e}`, e);
                this.webexNotificationErrorCount++;
            }
        });
    }
    sendMessage(toPersonEmail, text) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.webex.messages.create({ toPersonEmail, text });
                this.newWebexChatActionDone.send({ status: true });
                return true;
            }
            catch (_a) {
                this.newWebexChatActionDone.send({ status: false });
                return false;
            }
        });
    }
    handleUnreadConversations() {
        this.fetchUnreadConversationCount();
        this.webex.memberships
            .listen()
            .then(() => {
            _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("event=webexNotificationListener | Listening to membership events to update unread conversation count");
            this.webex.memberships.on("seen", () => this.fetchUnreadConversationCount());
            this.webex.memberships.on("deleted", () => this.fetchUnreadConversationCount());
        })
            .catch((e) => _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error(`event=webexNotificationListenerFail | Failed Listening to membership events to update unread conversation count ${e}`, e));
    }
    stopListeningForPresenceUpdates(contactIds) {
        contactIds.forEach((contactId) => {
            this.presence.dequeue(contactId);
        });
    }
    initialisePresencePlugin() {
        _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[Presence]: initialised");
        this.listenForPresenceUpdates();
    }
    subscribeForPresenceUpdates(contactIds) {
        _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[Presence]: subscribeForPresenceUpdates for ", contactIds);
        const updates = [];
        contactIds.forEach((contactId) => {
            if (this.hasPresenceStatus(contactId)) {
                updates.push(this.presences[contactId]);
            }
            else {
                this.presence.enqueue(contactId);
            }
        });
        if (updates.length > 0) {
            this.presenceUpdateSignal.send(updates);
        }
    }
    hasPresenceStatus(contactId) {
        var _a;
        const currentPresence = this.presences[contactId];
        const presenceExpiresTime = (_a = currentPresence === null || currentPresence === void 0 ? void 0 : currentPresence.expiresTime) !== null && _a !== void 0 ? _a : "";
        const now = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.now();
        if (currentPresence === null || currentPresence === void 0 ? void 0 : currentPresence.expiresTime) {
            const expiresTime = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(presenceExpiresTime);
            if ((currentPresence === null || currentPresence === void 0 ? void 0 : currentPresence.expiresTime) && expiresTime < now) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[Presence]: presence is expired removing cached data for: ", contactId);
                delete this.presences[contactId];
            }
            return expiresTime > now;
        }
        return currentPresence !== undefined;
    }
    parsePresenceUpdate(update) {
        return {
            contactId: update.subject,
            status: update.status,
            customStatus: update === null || update === void 0 ? void 0 : update.customStatusMessage,
            lastActiveTime: update.lastActive,
            expiresTime: update === null || update === void 0 ? void 0 : update.expiresTime
        };
    }
    listenForPresenceUpdates() {
        this.presence.on(_index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.constants.WebexConstants.WEBEX_SDK_PRESENCE_UPDATE, (envelope) => {
            _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[Presence] Presence update from webex ", envelope);
            const updates = [];
            if (envelope.type === "presence") {
                envelope.payload.statusList.forEach((update) => {
                    updates.push(this.parsePresenceUpdate(update));
                });
            }
            if (envelope.type === "subscription") {
                updates.push(this.parsePresenceUpdate(envelope.payload));
            }
            updates.forEach((update) => {
                this.presences[update.contactId] = update;
            });
            this.presenceUpdateSignal.send(updates);
        });
    }
    //function to setTimeout
    retryMercuryRegister(agentId, forPresence, forWebexCalling) {
        if (forPresence) {
            this.dispatchMercuryEvent(_constant__WEBPACK_IMPORTED_MODULE_9__.PRESENCE_MERCURY_REG.AX_MERCURY_RETRYING); //dispatch mercury retry event
        }
        setTimeout(() => {
            this.registerToMercury(agentId, forPresence, forWebexCalling);
        }, _constant__WEBPACK_IMPORTED_MODULE_9__.RETRY_TIMEOUT);
    }
    registerToDSS() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.dss.registered) {
                try {
                    yield this.dss.register();
                    _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info(`[Webex] successfully registered to DSS`);
                }
                catch (e) {
                    _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error(`[Webex] failed to register DSS: ${e}`);
                }
            }
        });
    }
    formatTimeDifference(timeDifference) {
        const secondsDifference = Math.floor(timeDifference / 1000);
        const hours = Math.floor(secondsDifference / 3600);
        const remainingSecsAfterHours = secondsDifference % 3600;
        const minutes = Math.floor(remainingSecsAfterHours / 60);
        const seconds = remainingSecsAfterHours % 60;
        return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    }
    canGetServerTime() {
        return this.mercury.mercuryTimeOffset !== undefined && typeof this.mercury.mercuryTimeOffset === "number";
    }
    getServerTime() {
        var _a;
        if (this.canGetServerTime()) {
            if (!this.loggedServerTimeOffset) {
                this.loggedServerTimeOffset = true;
                const absTimeDifference = Math.abs(this.mercury.mercuryTimeOffset);
                if (absTimeDifference > _constant__WEBPACK_IMPORTED_MODULE_9__.MERCURY_TIME_OFFSET_THRESHOLD_MS) {
                    _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.warn(`System time is not in sync with the server. System clock is ${this.formatTimeDifference(absTimeDifference)} (hh::mm::ss) `, `${this.mercury.mercuryTimeOffset > 0 ? "ahead of" : "behind"} server clock.`);
                    _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.track(_index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_EVENT.SERVER_TIME_DIFFERENCE, {
                        offset: this.mercury.mercuryTimeOffset
                    }, [(_a = _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.SERVICE_PROVIDERS) === null || _a === void 0 ? void 0 : _a.webex_business]);
                }
                else {
                    _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("System time is in sync with the server.");
                }
            }
            return new Date(Date.now() - this.mercury.mercuryTimeOffset);
        }
        return new Date();
    }
    registerToMercury(agentId, forPresence = true, forWebexCalling = false) {
        _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[RegisterToMercury]: | Webex : initializing webex.internal.device.register");
        return this.device
            .register()
            .then(() => {
            _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[RegisterToMercury]: event=WebexDeviceRegistrationSuccess | Webex : webex.internal.device.register successful");
            _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[RegisterToMercury]: | Webex : initializing webex.internal.mercury.connect");
            return this.mercury
                .connect()
                .then(() => {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[RegisterToMercury]: | Webex : webex.internal.mercury.connect successful");
                if (forPresence) {
                    this.subscribeStateSync(agentId);
                }
                if (forWebexCalling) {
                    this.subscribeToWebexCallingEvents(agentId);
                }
            })
                .catch((error) => {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("[RegisterToMercury]: event=WebexDeviceRegistrationFailed | Webex : Error occurred during mercury.connect()", error);
                if (this.mercuryConnectRetry) {
                    this.mercuryConnectRetry = false; //after first retry
                    this.retryMercuryRegister(agentId, forPresence, forWebexCalling);
                }
                else if (forPresence) {
                    this.dispatchMercuryEvent(_constant__WEBPACK_IMPORTED_MODULE_9__.PRESENCE_MERCURY_REG.AX_MERCURY_FAILURE, (0,_index__WEBPACK_IMPORTED_MODULE_7__.getTrackingIdFromErrorObject)(error)); //dispatch mercury failure event
                }
            });
        })
            .catch((error) => {
            _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("[RegisterToMercury]: Webex : Error occurred during webex.internal.device.register()", error);
            if (this.deviceRegisterRetry) {
                this.deviceRegisterRetry = false; //after first retry
                this.retryMercuryRegister(agentId, forPresence, forWebexCalling);
            }
            else if (forPresence) {
                this.dispatchMercuryEvent(_constant__WEBPACK_IMPORTED_MODULE_9__.PRESENCE_MERCURY_REG.AX_MERCURY_FAILURE, (0,_index__WEBPACK_IMPORTED_MODULE_7__.getTrackingIdFromErrorObject)(error)); //dispatch mercury failure event
            }
        });
    }
    subscribeStateSync(agentId) {
        this.dispatchMercuryEvent(_constant__WEBPACK_IMPORTED_MODULE_9__.PRESENCE_MERCURY_REG.AX_MERCURY_SUCCESSFUL); //dispatch mercury success event
        this.mercury.on(_index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.constants.WebexConstants.WEBEX_PRESENCE_UPDATE, (status) => {
            if (status.data.subject === agentId) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[PresenceStateSync] : presence sync state updated", status);
                this.onNewPresenceStateSyncEventSignal.send(status);
            }
            else {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info(`[PresenceStateSync] : presence update for ${status.data.subject} is ignored`);
            }
        });
    }
    subscribeToWebexCallingEvents(agentId) {
        this.mercury.on(_index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.constants.WebexConstants.WEBEX_CALL_MUTE_STATE_UPDATE, (updatedMuteState) => {
            this.dispatchWebexCallMuteStateChangedEvent(agentId, updatedMuteState);
        });
        this.mercury.on(_index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.constants.WebexConstants.WEBEX_CALL_UNMUTE_STATE_UPDATE, (updatedMuteState) => {
            this.dispatchWebexCallMuteStateChangedEvent(agentId, updatedMuteState);
        });
        this.mercury.on(_index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.constants.WebexConstants.WEBEX_CALL_HOLD_STATE_UPDATE, (updatedHoldState) => {
            this.dispatchWebexCallHoldStateChangedEvent(agentId, updatedHoldState);
        });
        this.mercury.on(_index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.constants.WebexConstants.WEBEX_CALL_RESUME_STATE_UPDATE, (updatedHoldState) => {
            this.dispatchWebexCallHoldStateChangedEvent(agentId, updatedHoldState);
        });
    }
    dispatchWebexCallMuteStateChangedEvent(agentId, updatedMuteState) {
        const decodedActorId = atob(updatedMuteState.data.actorId);
        const decodedCallId = atob(updatedMuteState.data.callId);
        if (decodedActorId.endsWith(agentId)) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info(`[webex] : Mute state changed. AgentId: ${agentId}. actorId: ${decodedActorId}. callId: ${decodedCallId}. mute state: ${updatedMuteState.data.muted}.`);
            window.dispatchEvent(new CustomEvent(_constant__WEBPACK_IMPORTED_MODULE_9__.WEBEX_CALLING_MERC_SYNC.MUTE_UNMUTE, {
                detail: { callId: decodedCallId, muted: updatedMuteState.data.muted },
                bubbles: true,
                composed: true
            }));
        }
        else {
            // ignore the event
        }
    }
    dispatchWebexCallHoldStateChangedEvent(agentId, updatedHoldState) {
        if (_index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.featureflag.isFeatureFlagEnabled(_index__WEBPACK_IMPORTED_MODULE_7__.FEATURE_FLAGS.WXCC_SYNC_WEBEX_HOLD_RESUME_STATES) === false) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info(`[webex] : WXCC_SYNC_WEBEX_HOLD_RESUME_STATES feature flag is disabled, ignoring hold/resume state event.`);
            return;
        }
        const decodedActorId = atob(updatedHoldState.data.actorId);
        const decodedCallId = atob(updatedHoldState.data.callId);
        let holdState;
        if (updatedHoldState.data.state === CallHoldState.Held) {
            holdState = CallHoldState.Held;
        }
        else if (updatedHoldState.data.state === CallHoldState.Connected) {
            holdState = CallHoldState.Connected;
        }
        else {
            holdState = CallHoldState.Unknown;
        }
        if (holdState !== CallHoldState.Unknown) {
            if (decodedActorId.endsWith(agentId)) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info(`[webex] : Hold state changed. AgentId: ${agentId}. actorId: ${decodedActorId}. callId: ${decodedCallId}. hold state: ${holdState}.`);
                window.dispatchEvent(new CustomEvent(_constant__WEBPACK_IMPORTED_MODULE_9__.WEBEX_CALLING_MERC_SYNC.HOLD_RESUME, {
                    detail: { callId: decodedCallId, held: holdState === CallHoldState.Held },
                    bubbles: true,
                    composed: true
                }));
            }
            else {
                // ignore the event
            }
        }
    }
    registerPresenceSync(agentId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.device.registered && this.mercury.connected) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[PresenceStateSync]: | Webex : Found mercury connection!");
                this.subscribeStateSync(agentId);
            }
            else {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[PresenceStateSync]: | Webex : mercury connection not found retrying ...");
                yield this.registerToMercury(agentId);
            }
        });
    }
    registerWebexCallingEvents(agentId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.device.registered && this.mercury.connected) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[registerWebexCallingEvents]: | Webex : Found mercury connection!");
                this.subscribeToWebexCallingEvents(agentId);
            }
            else {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[registerWebexCallingEvents]: | Webex : mercury connection not found retrying ...");
                yield this.registerToMercury(agentId, false, true);
            }
        });
    }
    setStatus(status, ttl) {
        return __awaiter(this, void 0, void 0, function* () {
            this.presence
                .setStatus(status, ttl)
                .then(() => {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[PresenceStateSync]: webex.internal.presence.setStatus successful");
            })
                .catch((err) => {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("[PresenceStateSync]: Error occurred during webex.internal.presence.setStatus():", err);
                throw err;
            });
        });
    }
    parseUser(user, source) {
        var _a, _b, _c, _d, _e, _f, _g;
        const avatarUrl = (() => {
            if (Array.isArray(user.photos)) {
                for (const photo of user.photos) {
                    if ((photo === null || photo === void 0 ? void 0 : photo.type) === "thumbnail") {
                        return photo === null || photo === void 0 ? void 0 : photo.value;
                    }
                }
            }
            return "";
        })();
        const preferredPhoneNumber = (() => {
            var _a, _b, _c;
            if (Array.isArray(user.phoneNumbers) && user.phoneNumbers.length > 0) {
                const possiblePhoneTypes = ["work_extension", "work", "mobile", "alternate1", "alternate2"];
                for (const type of possiblePhoneTypes) {
                    const primaryNumber = user.phoneNumbers.find((phone) => phone.type === type && phone.primary === true);
                    if (primaryNumber) {
                        return primaryNumber.value;
                    }
                }
            }
            // default to the first phone number, if it exists, if no primary number is found
            return (_c = (_b = (_a = user.phoneNumbers) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : "";
        })();
        return {
            source,
            userId: user.identity,
            displayName: user.displayName,
            email: (_c = (_b = (_a = user.emails) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : "",
            phoneNumber: preferredPhoneNumber,
            department: (_e = (_d = user.additionalInfo) === null || _d === void 0 ? void 0 : _d.department) !== null && _e !== void 0 ? _e : "",
            jobTitle: (_g = (_f = user.additionalInfo) === null || _f === void 0 ? void 0 : _f.jobTitle) !== null && _g !== void 0 ? _g : "",
            avatarUrl
        };
    }
    lookupUsers(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const lookups = ids.map((id) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.dss.lookup({ id });
                return this.parseUser(response, "lookup");
            }));
            return Promise.all(lookups);
        });
    }
    lookupUsersByEmail(emails) {
        return __awaiter(this, void 0, void 0, function* () {
            const lookups = emails.map((email) => __awaiter(this, void 0, void 0, function* () {
                const response = yield this.dss.lookupByEmail({ email });
                return this.parseUser(response, "lookup");
            }));
            return Promise.all(lookups);
        });
    }
    searchUsers(query, resultSize) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.dss.search({
                requestedTypes: ["PERSON"],
                queryString: query.trim(),
                resultSize
            });
            return res.map((user) => this.parseUser(user, "search"));
        });
    }
    updateAnswerCallsSetting(userId, state) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.webex) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("[Webex]: Webex is not initialized");
                return Promise.reject(new Error("Webex is not initialized"));
            }
            if (!userId) {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("[Webex]: userId is empty");
                return Promise.reject(new Error("UserId is empty"));
            }
            return this.updateAnswerCallsCrossClient(userId, state, _constant__WEBPACK_IMPORTED_MODULE_9__.APP_NAME, _constant__WEBPACK_IMPORTED_MODULE_9__.DEFAULT_CROSS_CLIENT_STATE_TTL)
                .then(() => {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("[Webex]: updateAnswerCallsSetting successful");
            })
                .catch((err) => {
                _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("[Webex]: Error occurred during updateAnswerCallsSetting:", err);
                throw err;
            });
        });
    }
    uploadLogs() {
        const feedbackId = (0,uuid__WEBPACK_IMPORTED_MODULE_4__.v4)();
        _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Logger.POOL.flush();
        this.uploadLogsToWebex(feedbackId);
        return feedbackId;
    }
    uploadPendingLogs() {
        const feedbackId = window.sessionStorage.getItem(this.pendingFeedbackIdKey);
        if (!this.isUploadingLogs && feedbackId) {
            _utils_structuredLog__WEBPACK_IMPORTED_MODULE_8__.StructuredLog.debug("LogUpload/UploadPendingLogs", "", { feedbackId });
            this.uploadLogsToWebex(feedbackId);
        }
    }
    updateAnswerCallsCrossClient(userId, enable, appName, ttl) {
        const jsonData = {
            users: [userId],
            compositions: [
                {
                    type: "cross-client-state",
                    ttl,
                    composition: {
                        devices: [
                            {
                                deviceId: this.extractDeviceIdFromUrl(this.webex.internal.device.url),
                                appName,
                                state: {
                                    "answer-calls-on-wxcc": enable
                                }
                            }
                        ]
                    }
                }
            ]
        };
        return this.webex
            .request({
            method: "POST",
            service: "usersub",
            resource: "publish",
            body: jsonData
        })
            .then((response) => {
            this.crossClientState.set(appName, enable);
            this.startRefreshTimer(userId, appName, ttl);
            return response.body;
        })
            .catch((error) => {
            _core_sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error(`[Webex]: updateAnswerCallsCrossClient failed with error: ${error.message}`);
            return Promise.reject(error);
        });
    }
    startRefreshTimer(userId, appName, ttl) {
        const answerCallsState = this.crossClientState.get(appName);
        if (answerCallsState) {
            const refreshTime = ttl * 1000 - _constant__WEBPACK_IMPORTED_MODULE_9__.EXPIRATION_OFFSET;
            setTimeout(() => this.updateAnswerCallsCrossClient(userId, answerCallsState, appName, ttl), refreshTime);
        }
    }
    extractDeviceIdFromUrl(url) {
        if (url) {
            const regex = /\/devices\/([^/?]+)/;
            const match = url.match(regex);
            return match ? match[1] : "";
        }
        return "";
    }
    constructor(accessToken) {
        this.accessToken = "";
        this.newMessageSignal = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.withData();
        this.newMeetingEventSignal = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.withData();
        this.newPresenceEventSignal = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.withData();
        this.newWebexChatActionDone = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.withData();
        this.wdmRegistrationEvent = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.empty();
        this.onNewMessage = this.newMessageSignal.signal;
        this.onNewMeetingEvent = this.newMeetingEventSignal.signal;
        this.onNewPresenceEvent = this.newPresenceEventSignal.signal;
        this.onWebexChatActionDone = this.newWebexChatActionDone.signal;
        this.onWdmRegistrationEvent = this.wdmRegistrationEvent.signal;
        this.notificationCountUpdateSignal = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.withData();
        this.onNotificationCountUpdate = this.notificationCountUpdateSignal.signal;
        this.onNewPresenceStateSyncEventSignal = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.withData();
        this.onNewPresenceStateSyncEvent = this.onNewPresenceStateSyncEventSignal.signal;
        this.presenceUpdateSignal = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Signal.create.withData();
        this.onPresenceUpdateEvent = this.presenceUpdateSignal.signal;
        this.timeout = 0;
        this.webexInitialized = false;
        this.deviceRegisterRetry = true;
        this.mercuryConnectRetry = true;
        this.webexNotificationErrorCount = 0;
        this.loggedServerTimeOffset = false;
        this.presences = {};
        this.crossClientState = new Map();
        this.maxWebexNotificationErrorCount = 3;
        // returns feature ISO date in minutes left
        this.getStartTimeInMinute = (startTime) => {
            var _a;
            if (startTime) {
                return Math.ceil((_a = luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.fromISO(startTime).toLocal().diff(luxon__WEBPACK_IMPORTED_MODULE_3__.DateTime.local(), ["minutes"])) === null || _a === void 0 ? void 0 : _a.minutes);
            }
            return 0;
        };
        this.dispatchMercuryEvent = (eventName, trackingID) => {
            window.dispatchEvent(new CustomEvent(eventName, {
                detail: { trackingId: trackingID },
                bubbles: true,
                composed: true
            }));
        };
        this.pendingFeedbackIdKey = "pendingFeedbackId";
        this.isUploadingLogs = false;
        this.uploadLogsToWebex = (feedbackId) => {
            const logs = window.sessionStorage.getItem(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.Logger.LS_LOGS_KEY);
            if (logs) {
                const options = {
                    feedbackId,
                    logType: "wxcc-client-logs",
                    autoupload: "false",
                    appVersion: sessionStorage.getItem("clientVersion") || "null"
                };
                window.sessionStorage.setItem(this.pendingFeedbackIdKey, feedbackId);
                _utils_structuredLog__WEBPACK_IMPORTED_MODULE_8__.StructuredLog.debug("LogUpload/Start", "", { feedbackId });
                this.isUploadingLogs = true;
                this.support
                    .submitLogs(options, (0,_service_utils__WEBPACK_IMPORTED_MODULE_10__.formatStringsForLogs)(logs))
                    .then(() => {
                    this.isUploadingLogs = false;
                    window.sessionStorage.removeItem(this.pendingFeedbackIdKey);
                    _utils_structuredLog__WEBPACK_IMPORTED_MODULE_8__.StructuredLog.debug("LogUpload/Success", "", { feedbackId });
                    _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.track(_index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_EVENT.LOGS_UPLOADED_TO_WEBEX, {
                        [_index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_PROPS.LOGS_UPLOADED_TO_WEBEX]: true,
                        Status: _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_EVENT.STATUS.SUCCESS,
                        feedbackId
                    });
                })
                    .catch((_error) => {
                    this.isUploadingLogs = false;
                    _utils_structuredLog__WEBPACK_IMPORTED_MODULE_8__.StructuredLog.debug("LogUpload/Failed", "", { feedbackId });
                    _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.track(_index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_EVENT.LOGS_UPLOADED_TO_WEBEX, {
                        [_index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_PROPS.LOGS_UPLOADED_TO_WEBEX]: false,
                        Status: _index__WEBPACK_IMPORTED_MODULE_7__.SERVICE.telemetry.TELEM_EVENT.STATUS.FAILED,
                        feedbackId
                    });
                });
            }
            else {
                _utils_structuredLog__WEBPACK_IMPORTED_MODULE_8__.StructuredLog.warn("LogUpload/Error", "logs not found in local storage", { feedbackId });
            }
        };
        this.accessToken = accessToken;
    }
}


/***/ }),

/***/ "./src/services/webexMetrics/behavioral-events.ts":
/*!********************************************************!*\
  !*** ./src/services/webexMetrics/behavioral-events.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getEventTaxonomy: () => (/* binding */ getEventTaxonomy)
/* harmony export */ });
/* harmony import */ var _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../telemetry/constants */ "./src/services/telemetry/constants.ts");

function getEventTaxonomy(name) {
    const product = "wxcc_desktop";
    switch (name) {
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.STATION_LOGIN:
            return {
                product,
                agent: "user",
                target: "station",
                verb: "login"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_COMPLETED:
            return {
                product,
                agent: "user",
                target: "call",
                verb: "complete"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_CONSULT_CLICKED:
            return {
                product,
                agent: "user",
                target: "call_consult",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_TRANSFER_CLICKED:
            return {
                product,
                agent: "user",
                target: "call_transfer",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_ANSWERED:
            return {
                product,
                agent: "user",
                target: "call",
                verb: "answer"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_CONSULT_ACTIVATED:
            return {
                product,
                agent: "user",
                target: "call_consult",
                verb: "activate"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CONSULT_CALL_TRANSFER:
            return {
                product,
                agent: "user",
                target: "consult_call_transfer",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CONFERENCE_TRANSFER:
            return {
                product,
                agent: "user",
                target: "conference_transfer",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.BARGE_IN_ACTIVATED:
            return {
                product,
                agent: "user",
                target: "barge_in",
                verb: "activate"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_TRANSFER_ACTIVATED:
            return {
                product,
                agent: "user",
                target: "call_transfer",
                verb: "activate"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_CONFERENCE_ACTIVATED:
            return {
                product,
                agent: "user",
                target: "call_conference",
                verb: "activate"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_CONFERENCE_CLICKED:
            return {
                product,
                agent: "user",
                target: "call_conference",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.SIGNOUT_REQUESTED:
            return {
                product,
                agent: "user",
                target: "signout",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.TPW_COLUMN_FILTERED:
            return {
                product,
                agent: "user",
                target: "tpw_column_filter",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.TPW_COLUMN_SORTED:
            return {
                product,
                agent: "user",
                target: "tpw_column_sort",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WC_GRID_COLUMN_BEHAVIOURAL_EVENTS:
            return {
                product,
                agent: "user",
                target: "wc_grid_column",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WC_GRID_HEADER_BEHAVIOURAL_EVENTS:
            return {
                product,
                agent: "user",
                target: "wc_grid_header",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WC_GRID_DATE_SELECTED_BEHAVIOURAL_EVENT:
            return {
                product,
                agent: "user",
                target: "wc_grid_date_range",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WC_GRID_EXPORT_BEHAVIOURAL_EVENT:
            return {
                product,
                agent: "user",
                target: "wc_grid_export",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WC_GRID_ALERT_BEHAVIOURAL_EVENT:
            return {
                product,
                agent: "user",
                target: "wc_grid_alert",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.PI_RECORDING_DETAILS_MODAL_CLOSED:
            return {
                product,
                agent: "user",
                target: "recording_details_modal",
                verb: "view"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.POST_INTERACTION_VISITED:
            return {
                product,
                agent: "user",
                target: "post_interaction_widget",
                verb: "view"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.PI_TIME_FILTER_SELECTED:
            return {
                product,
                agent: "user",
                target: "post_interaction_time_filter",
                verb: "select"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AI_ASSISTANT_OPENED:
            return {
                product,
                agent: "user",
                target: "ai_assistant",
                verb: "open"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AI_ASSISTANT_COPY_CLICKED:
            return {
                product,
                agent: "user",
                target: "ai_assistant_copy",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AI_ASSISTANT_FEEDBACK_CLICKED:
            return {
                product,
                agent: "user",
                target: "ai_assistant_feedback",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AI_ASSISTANT_SUMMARY_GENERATED:
            return {
                product,
                agent: "service",
                target: "ai_assistant_summary",
                verb: "load"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AI_ASSISTANT_SUMMARY_NOTIFICATION_FIRED:
            return {
                product,
                agent: "service",
                target: "ai_assistant_summary_notification",
                verb: "fire"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_STARTED:
            return {
                product,
                agent: "service",
                target: "wellness_break",
                verb: "start"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_ENDED:
            return {
                product,
                agent: "service",
                target: "wellness_break",
                verb: "end"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_CARD_ACCEPTED:
            return {
                product,
                agent: "user",
                target: "wellness_break_card",
                verb: "accept"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_CARD_REJECTED:
            return {
                product,
                agent: "user",
                target: "wellness_break_card",
                verb: "reject"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_CTA_APPROVED:
            return {
                product,
                agent: "service",
                target: "wellness_break_cta",
                verb: "accept"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_CTA_REJECTED:
            return {
                product,
                agent: "service",
                target: "wellness_break_cta",
                verb: "reject"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_CTA_USER_REQUEST:
            return {
                product,
                agent: "user",
                target: "wellness_break_cta",
                verb: "request"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_DISPLAY_CTA:
            return {
                product,
                agent: "user",
                target: "wellness_break_cta",
                verb: "display"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_CHANGE_STATE_ERROR:
            return {
                product,
                agent: "service",
                target: "wellness_break_change_state",
                verb: "fail"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_GENERIC_ERROR:
            return {
                product,
                agent: "service",
                target: "wellness_break",
                verb: "fail"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_NO_RESPONSE:
            return {
                product,
                agent: "user",
                target: "wellness_break",
                verb: "ignore"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_NOTIFICATION_FIRED:
            return {
                product,
                agent: "service",
                target: "wellness_break_notification",
                verb: "fire"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_NOTIFICATION_ACCEPTED:
            return {
                product,
                agent: "user",
                target: "wellness_break_notification",
                verb: "accept"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_NOTIFICATION_DISMISSED:
            return {
                product,
                agent: "user",
                target: "wellness_break_notification",
                verb: "dismiss"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_NOTIFICATION_REJECTED:
            return {
                product,
                agent: "user",
                target: "wellness_break_notification",
                verb: "reject"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_NOTIFICATION_TIMEOUT:
            return {
                product,
                agent: "service",
                target: "wellness_break_notification",
                verb: "expire"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELLNESS_BREAK_PROVIDE_BREAK_EVENT_RECEIVED:
            return {
                product,
                agent: "service",
                target: "wellness_break",
                verb: "load"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DESKTOP_RELOAD:
            return {
                product,
                agent: "user",
                target: "desktop",
                verb: "reload"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AGENTX_JS_API_INIT:
            return {
                product,
                agent: "api",
                target: "agentx_js_api",
                verb: "initialize"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AGENTX_JS_API_REGISTER_CRM_CONNECTOR:
            return {
                product,
                agent: "api",
                target: "agentx_js_api_crm_connector",
                verb: "connect"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.STATION_LOGIN_CLICKED:
            return {
                product,
                agent: "user",
                target: "station_login",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CHANGE_TEAM:
            return {
                product,
                agent: "user",
                target: "team",
                verb: "change"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AGENT_STATE_CHANGE:
            return {
                product,
                agent: "user",
                target: "agent_state",
                verb: "change"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AGENT_HISTORY_RESIZE:
            return {
                product,
                agent: "user",
                target: "agent_history",
                verb: "resize"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DARK_MODE_TOGGLE:
            return {
                product,
                agent: "user",
                target: "dark_mode",
                verb: "toggle"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.HELP_ICON_CLICKED:
            return {
                product,
                agent: "user",
                target: "help_icon",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.SURVEY_ICON_CLICKED:
            return {
                product,
                agent: "user",
                target: "survey_icon",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.TASK_PANE_TOGGLE:
            return {
                product,
                agent: "user",
                target: "task_pane",
                verb: "toggle"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.INTERACTION_CONTROL_PANE_TOGGLE:
            return {
                product,
                agent: "user",
                target: "interaction_control_pane",
                verb: "toggle"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.ERROR_DETAILS_DOWNLOADED:
            return {
                product,
                agent: "user",
                target: "error_details",
                verb: "download"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.SIGN_OUT:
            return {
                product,
                agent: "user",
                target: "station",
                verb: "logout"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CAD_VARIABLE_UPDATED:
            return {
                product,
                agent: "user",
                target: "cad_variable",
                verb: "update"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_INITIATED:
            return {
                product,
                agent: "user",
                target: "call",
                verb: "initiate"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_TOAST_MESSAGE_ACCEPTED:
            return {
                product,
                agent: "user",
                target: "call_toast_message",
                verb: "accept"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AGENT_RONA:
            return {
                product,
                agent: "service",
                target: "agent_rona",
                verb: "set"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_CONFERENCE_ENDED:
            return {
                product,
                agent: "user",
                target: "call_conference",
                verb: "end"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.END_MONITORING_CLICKED:
            return {
                product,
                agent: "user",
                target: "end_monitoring",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_CONSULT_END_CLICKED:
            return {
                product,
                agent: "user",
                target: "call_consult_end",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_CONSULT_END_ACTIVATED:
            return {
                product,
                agent: "user",
                target: "call_conference_end",
                verb: "activate"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.INTERACTION_CONSULT_REQUEST_CLICKED:
            return {
                product,
                agent: "user",
                target: "interaction_consult_request",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.INTERACTION_CONFERENCE_REQUEST_CLICKED:
            return {
                product,
                agent: "user",
                target: "interaction_conference_request",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_HOLD_CLICKED:
            return {
                product,
                agent: "user",
                target: "call_hold",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_HOLD_ACTIVATED:
            return {
                product,
                agent: "user",
                target: "call_hold",
                verb: "activate"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_RESUME_CLICKED:
            return {
                product,
                agent: "user",
                target: "call_resume",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_RESUME_ACTIVATED:
            return {
                product,
                agent: "user",
                target: "call_resume",
                verb: "activate"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_TRANSFER_COMPLETED:
            return {
                product,
                agent: "user",
                target: "call_transfer",
                verb: "complete"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.INTERACTION_TRANSFER_REQUEST_CLICKED:
            return {
                product,
                agent: "user",
                target: "interaction_transfer_request",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_PAUSE_RECORDING_CLICKED:
            return {
                product,
                agent: "user",
                target: "call_pause_recording",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_PAUSE_RECORDING_ACTIVATED:
            return {
                product,
                agent: "user",
                target: "call_pause_recording",
                verb: "activate"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_RESUME_RECORDING_CLICKED:
            return {
                product,
                agent: "user",
                target: "call_resume_recording",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_RESUME_RECORDING_ACTIVATED:
            return {
                product,
                agent: "user",
                target: "call_resume_recording",
                verb: "activate"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CALL_WRAP_UP_APPLIED:
            return {
                product,
                agent: "user",
                target: "call_wrap_up",
                verb: "apply"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.NOTIFICATION_SETTINGS_UPDATE:
            return {
                product,
                agent: "user",
                target: "notification_settings",
                verb: "update"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.IVR_TRANSCRIPT:
            return {
                product,
                agent: "user",
                target: "ivr_transcript",
                verb: "fetch"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AGENT_INVITE_FAILED:
            return {
                product,
                agent: "service",
                target: "agent_invite",
                verb: "fail"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.SCREEN_POP_VIEWED:
            return {
                product,
                agent: "user",
                target: "screen_pop",
                verb: "view"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.KEYBOARD_SHORTCUT_KEY_PRESSED:
            return {
                product,
                agent: "user",
                target: "keyboard_shortcut",
                verb: "press"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CONTACT_HISTORY_VIEWED:
            return {
                product,
                agent: "user",
                target: "contact_history",
                verb: "view"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WXM_JOURNEY_VIEWED:
            return {
                product,
                agent: "user",
                target: "wxm_journey",
                verb: "view"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DESKTOP_CONNECTION_LOSS:
            return {
                product,
                agent: "service",
                target: "desktop_connection",
                verb: "disconnect"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.LAYOUT_SETTINGS_EDIT:
            return {
                product,
                agent: "user",
                target: "layout_settings",
                verb: "edit"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.LAYOUT_SETTINGS_RESET:
            return {
                product,
                agent: "user",
                target: "layout_settings",
                verb: "reset"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.LAYOUT_SETTINGS_SAVE:
            return {
                product,
                agent: "user",
                target: "layout_settings",
                verb: "save"
            };
        /*eslint-disable-next-line @wxcc-desktop/no-blocked-words-plugin/no-blocked-words */
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.LAYOUT_SETTINGS_MASTER_RESET:
            return {
                product,
                agent: "user",
                /*eslint-disable-next-line @wxcc-desktop/no-blocked-words-plugin/no-blocked-words */
                target: "layout_settings_master",
                verb: "reset"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.NOTIFICATION_SOUND_SETTINGS_UPDATE:
            return {
                product,
                agent: "user",
                target: "notification_sound_settings",
                verb: "update"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WEBEX_APP_OPENED:
            return {
                product,
                agent: "user",
                target: "webex_app",
                verb: "open"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WEBEX_APP_CLOSED:
            return {
                product,
                agent: "user",
                target: "webex_app",
                verb: "close"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WEBEX_APP_OPENED_BY_SHORTCUT_KEY:
            return {
                product,
                agent: "user",
                target: "webex_app_shortcut_key",
                verb: "open"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.SCREEN_POP_INSIDE_DESKTOP_REFERRED:
            return {
                product,
                agent: "service",
                target: "screen_pop_inside_desktop",
                verb: "refer"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.SCREEN_POP_DELIVERED:
            return {
                product,
                agent: "service",
                target: "screen_pop",
                verb: "deliver"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AGENT_STATE_SEARCHED:
            return {
                product,
                agent: "user",
                target: "agent_state",
                verb: "search"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AGENT_HISTORY:
            return {
                product,
                agent: "service",
                target: "agent_history",
                verb: "fetch"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AGENT_CONSULT_TRANSFER_SEARCH:
            return {
                product,
                agent: "user",
                target: "agent_consult_transfer",
                verb: "search"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AGENT_INTERACTION_TRANSFERRED:
            return {
                product,
                agent: "user",
                target: "agent_interaction",
                verb: "transfer"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CHANGE_PROFILE_SETTINGS:
            return {
                product,
                agent: "user",
                target: "profile_settings",
                verb: "change"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.SWITCH_USER_ROLE:
            return {
                product,
                agent: "user",
                target: "role",
                verb: "switch"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.LAYOUT_FETCHED_FROM_SERVER:
            return {
                product,
                agent: "service",
                target: "layout",
                verb: "fetch"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WEB_SOCKET_DISCONNECT:
            return {
                product,
                agent: "service",
                target: "websocket",
                verb: "disconnect"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CUSTOM_LAYOUT_LOAD_FAIL:
            return {
                product,
                agent: "service",
                target: "custom_layout_load",
                verb: "fail"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WELCOME_MESSAGE_RECEIVED:
            return {
                product,
                agent: "user",
                target: "welcome_message",
                verb: "receive"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WEBEX_CHAT_TPW_MESSAGE_SEND:
            return {
                product,
                agent: "user",
                target: "tpw_widget_webex_chat_message",
                verb: "send"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.IDLE_INACTIVITY_SIGN_OUT:
            return {
                product,
                agent: "service",
                target: "idle_inactivity",
                verb: "logout"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AID_OPENED:
            return {
                product,
                agent: "user",
                target: "active_interaction_details",
                verb: "open"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.AID_CLOSED:
            return {
                product,
                agent: "user",
                target: "active_interaction_details",
                verb: "close"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.PAUSE_MONITORING_CLICKED:
            return {
                product,
                agent: "user",
                target: "pause_monitoring",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.RESUME_MONITORING_CLICKED:
            return {
                product,
                agent: "user",
                target: "resume_monitoring",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.MIDCALL_MONITORING_STARTED:
            return {
                product,
                agent: "user",
                target: "midcall_monitoring",
                verb: "start"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.MIDCALL_MONITORING_OFFERED:
            return {
                product,
                agent: "user",
                target: "midcall_monitoring",
                verb: "offer"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.MIDCALL_MONITORING_ENDED:
            return {
                product,
                agent: "user",
                target: "midcall_monitoring",
                verb: "end"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.MIDCALL_MONITORING_FAILED:
            return {
                product,
                agent: "user",
                target: "midcall_monitoring",
                verb: "fail"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.BARGE_IN_CLICKED:
            return {
                product,
                agent: "user",
                target: "barge_in",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.ADDRESS_BOOK:
            return {
                product,
                agent: "user",
                target: "address_book",
                verb: "use"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WEBRTC_REGISTRATION:
            return {
                product,
                agent: "service",
                target: "webrtc",
                verb: "register"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WEBRTC_DISCONNECTED:
            return {
                product,
                agent: "service",
                target: "webrtc",
                verb: "disconnect"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WEBRTC_VOICE_CHANNEL_SWITCHED:
            return {
                product,
                agent: "service",
                target: "webrtc_voice_channel",
                verb: "switch"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DESKTOP_VISITED_PAGE:
            return {
                product,
                agent: "user",
                target: "desktop_page",
                verb: "visit"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.STATE_CHANGE_ON_PRESENCE_SYNC:
            return {
                product,
                agent: "service",
                target: "presence_sync_state",
                verb: "change"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WEBRTC_REGISTRATION_FAILURE:
            return {
                product,
                agent: "service",
                target: "webrtc",
                verb: "fail"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.WEBRTC_REGISTRATION_RETRY:
            return {
                product,
                agent: "service",
                target: "webrtc",
                verb: "retry"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CI_TOKEN_REFRESH:
            return {
                product,
                agent: "service",
                target: "ci_token",
                verb: "refresh"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CJDS_WIDGET_LOAD:
            return {
                product,
                agent: "service",
                target: "cjds_widget",
                verb: "load"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CJDS_WIDGET_IS_DEFAULT_TEMPLATE:
            return {
                product,
                agent: "service",
                target: "cjds_widget_default_template",
                verb: "load"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CJDS_WIDGET_PROGRESSIVE_PROFILE_LOADED:
            return {
                product,
                agent: "service",
                target: "cjds_widget_progressive_profile",
                verb: "load"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CJDS_WIDGET_PROGRESSIVE_PROFILE_FAILED:
            return {
                product,
                agent: "service",
                target: "cjds_widget_progressive_profile",
                verb: "fail"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CJDS_WIDGET_HISTORICAL_EVENTS_LOADED:
            return {
                product,
                agent: "service",
                target: "cjds_widget_historical_events",
                verb: "load"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CJDS_WIDGET_HISTORICAL_EVENTS_FAILED:
            return {
                product,
                agent: "service",
                target: "cjds_widget_historical_events",
                verb: "fail"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.CJDS_WIDGET_EVENT_STREAM_FAILED:
            return {
                product,
                agent: "service",
                target: "cjds_widget_event_stream",
                verb: "fail"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_OUTBOUND_TASK_INITIATE:
            return {
                product,
                agent: "user",
                target: "digital_outbound_task",
                verb: "initiate"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_OUTBOUND_MESSAGE:
            return {
                product,
                agent: "user",
                target: "digital_composer_outbound_message",
                verb: "send"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_BLOCKLISTED_WORDS_MASKING:
            return {
                product,
                agent: "user",
                target: "digital_blocklisted_words_masking",
                verb: "toggle"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_RICH_FORMATTING_BOLD:
            return {
                product,
                agent: "user",
                target: "digital_composer_rich_formatting_bold",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_RICH_FORMATTING_ITALICS:
            return {
                product,
                agent: "user",
                target: "digital_composer_rich_formatting_italics",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_RICH_FORMATTING_UNDERLINE:
            return {
                product,
                agent: "user",
                target: "digital_composer_rich_formatting_underline",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_ATTACHMENTS_UPLOAD:
            return {
                product,
                agent: "user",
                target: "digital_composer_attachments",
                verb: "upload"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_ATTACHMENTS_DOWNLOAD:
            return {
                product,
                agent: "user",
                target: "digital_composer_attachments",
                verb: "download"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_EMOJI_MODAL:
            return {
                product,
                agent: "user",
                target: "digital_composer_emoji_modal",
                verb: "open"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_EMOJI:
            return {
                product,
                agent: "user",
                target: "digital_composer_emoji",
                verb: "select"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_TEMPLATES_MODAL:
            return {
                product,
                agent: "user",
                target: "digital_composer_templates_modal",
                verb: "open"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_TEMPLATE_GROUP_TAB:
            return {
                product,
                agent: "user",
                target: "digital_composer_template_group_tab",
                verb: "select"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_TEMPLATE_PREVIEW:
            return {
                product,
                agent: "user",
                target: "digital_composer_template",
                verb: "view"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_TEMPLATE_SELECT:
            return {
                product,
                agent: "user",
                target: "digital_composer_template",
                verb: "select"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_WORKFLOWS_MODAL:
            return {
                product,
                agent: "user",
                target: "digital_composer_workflows_modal",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_WORKFLOWS:
            return {
                product,
                agent: "user",
                target: "digital_composer_workflows",
                verb: "initiate"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_CLEAR_MESSAGE:
            return {
                product,
                agent: "user",
                target: "digital_composer_clear_message",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_WHISPER:
            return {
                product,
                agent: "user",
                target: "digital_composer_whisper",
                verb: "send"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_EMAIL_READ_PANE:
            return {
                product,
                agent: "user",
                target: "digital_email_read_pane",
                verb: "load"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_EMAIL_READ_PANE_ACCORDION:
            return {
                product,
                agent: "user",
                target: "digital_email_read_pane_accordion",
                verb: "view"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_EMAIL_READ_PANE_REPLY:
            return {
                product,
                agent: "user",
                target: "digital_email_read_pane_reply",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_EMAIL_READ_PANE_REPLY_ALL:
            return {
                product,
                agent: "user",
                target: "digital_email_read_pane_reply_all",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_EMAIL_READ_PANE_FORWARD:
            return {
                product,
                agent: "user",
                target: "digital_email_read_pane_forward",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_EMAIL_TO_RECIPIENTS:
            return {
                product,
                agent: "user",
                target: "digital_email_to_recipients",
                verb: "edit"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_EMAIL_CC_RECIPIENTS:
            return {
                product,
                agent: "user",
                target: "digital_email_cc_recipients",
                verb: "edit"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_EMAIL_BCC_RECIPIENTS:
            return {
                product,
                agent: "user",
                target: "digital_email_bcc_recipients",
                verb: "edit"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_WEB_COMPONENT:
            return {
                product,
                agent: "service",
                target: "digital_web_component",
                verb: "initialize"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_ATTACHMENT_ANTIMALWARE_SCAN:
            return {
                product,
                agent: "service",
                target: "digital_attachment_antimalware_scan",
                verb: "request"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_PII_MASKING:
            return {
                product,
                agent: "service",
                target: "digital_pii_masking",
                verb: "request"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_ATTACHMENT_PCI_SCAN:
            return {
                product,
                agent: "service",
                target: " digital_attachment_pci_scan",
                verb: "request"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_ATTACHMENT_UPLOAD_STATUS:
            return {
                product,
                agent: "user",
                target: "digital_attachment_upload_status",
                verb: "upload"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_COMPOSER_DRAFT:
            return {
                product,
                agent: "service",
                target: "digital_composer_draft",
                verb: "save"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_INBOUND_MESSAGE_RECEIVE:
            return {
                product,
                agent: "service",
                target: "digital_inbound_message_receive",
                verb: "receive"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_INBOUND_MESSAGE_READ:
            return {
                product,
                agent: "service",
                target: "digital_inbound_message_read",
                verb: "view"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_ANTIMALWARE_BANNER:
            return {
                product,
                agent: "service",
                target: "digital_antimalware_banner",
                verb: "display"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_PCI_BANNER:
            return {
                product,
                agent: "service",
                target: "digital_pci_banner",
                verb: "display"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_WEAK_CONNECTION_BANNER:
            return {
                product,
                agent: "service",
                target: "digital_weak_connection_banner",
                verb: "display"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.DIGITAL_OUTBOUND_MESSAGE:
            return {
                product,
                agent: "user",
                target: "digital_outbound_message",
                verb: "retry"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.REALTIME_TRANSCRIPTS_LOADED:
            return {
                product,
                agent: "service",
                target: "realtime_transcripts",
                verb: "load"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.REALTIME_TRANSCRIPTS_VISIBLE:
            return {
                product,
                agent: "user",
                target: "realtime_transcripts",
                verb: "view"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.REALTIME_TRANSCRIPTS_AVAILABLE:
            return {
                product,
                agent: "service",
                target: "realtime_transcripts",
                verb: "start"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.REALTIME_TRANSCRIPTS_FEEDBACK_CLICKED:
            return {
                product,
                agent: "user",
                target: "realtime_transcripts_feedback",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.REALTIME_TRANSCRIPTS_JUMP_TO_BOTTOM_CLICKED:
            return {
                product,
                agent: "user",
                target: "realtime_transcripts_jump_to_bottom",
                verb: "click"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.REALTIME_TRANSCRIPTS_DURATION:
            return {
                product,
                agent: "service",
                target: "realtime_transcripts",
                verb: "end"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.ENHANCED_STATION_LOGIN_START:
            return {
                product,
                agent: "user",
                target: "enhanced_station_login",
                verb: "start"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.ENHANCED_STATION_LOGIN_COMPLETE:
            return {
                product,
                agent: "user",
                target: "enhanced_station_login",
                verb: "complete"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.ENHANCED_STATION_LOGIN_SELECTION_CHANGED:
            return {
                product,
                agent: "user",
                target: "enhanced_station_login",
                verb: "select"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.ENHANCED_STATION_LOGIN_INPUT_CHANGED:
            return {
                product,
                agent: "user",
                target: "enhanced_station_login",
                verb: "edit"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.ENHANCED_STATION_LOGIN_SUBMIT_CLICKED:
            return {
                product,
                agent: "user",
                target: "enhanced_station_login",
                verb: "submit"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.ENHANCED_STATION_LOGIN_CANCEL_CLICKED:
            return {
                product,
                agent: "user",
                target: "enhanced_station_login",
                verb: "cancel"
            };
        case _telemetry_constants__WEBPACK_IMPORTED_MODULE_0__.EVENT_CONSTANTS.ENHANCED_STATION_LOGIN_AUTOLOGIN:
            return {
                product,
                agent: "service",
                target: "enhanced_station_login",
                verb: "login"
            };
        // Adding new metrics? Please add them to the wiki: https://confluence-eng-gpk2.cisco.com/conf/display/UC/List+of+wxcc-desktop+behavioral+metric+events
    }
    return undefined;
}


/***/ }),

/***/ "./src/services/webexMetrics/webex-metrics-service.ts":
/*!************************************************************!*\
  !*** ./src/services/webexMetrics/webex-metrics-service.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WebexMetricsService: () => (/* binding */ WebexMetricsService)
/* harmony export */ });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! js-cookie */ "js-cookie");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../config */ "./src/config.ts");
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../core/sdk */ "./src/core/sdk.ts");
/* harmony import */ var _behavioral_events__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./behavioral-events */ "./src/services/webexMetrics/behavioral-events.ts");




class WebexMetricsService {
    constructor(webex) {
        this.runningEvents = new Map();
        this.superProps = {};
        this.pendingBehavioralEvents = [];
        this.pendingOperationalEvents = [];
        this.pendingBusinessEvents = [];
        this.readyToSubmitEvents = false;
        this.webex = webex;
    }
    setReadyToSubmitEvents() {
        this.readyToSubmitEvents = true;
        this.submitPendingEvents();
    }
    submitPendingEvents() {
        this.submitPendingBehavioralEvents();
        this.submitPendingOperationalEvents();
        this.submitPendingBusinessEvents();
    }
    submitPendingBehavioralEvents() {
        if (this.pendingBehavioralEvents.length === 0) {
            return;
        }
        if (this.readyToSubmitEvents) {
            this.pendingBehavioralEvents.forEach((event) => {
                var _a;
                (_a = this.webex.newMetrics) === null || _a === void 0 ? void 0 : _a.submitBehavioralEvent({
                    product: event.taxonomy.product,
                    agent: event.taxonomy.agent,
                    target: event.taxonomy.target,
                    verb: event.taxonomy.verb,
                    payload: event.payload
                });
            });
            this.pendingBehavioralEvents = [];
        }
    }
    submitPendingOperationalEvents() {
        if (this.pendingOperationalEvents.length === 0) {
            return;
        }
        if (this.readyToSubmitEvents) {
            this.pendingOperationalEvents.forEach((event) => {
                var _a;
                (_a = this.webex.newMetrics) === null || _a === void 0 ? void 0 : _a.submitOperationalEvent({ name: event.name, payload: event.payload });
            });
            this.pendingOperationalEvents = [];
        }
    }
    submitPendingBusinessEvents() {
        if (this.pendingBusinessEvents.length === 0) {
            return;
        }
        if (this.readyToSubmitEvents) {
            this.pendingBusinessEvents.forEach((event) => {
                var _a;
                (_a = this.webex.newMetrics) === null || _a === void 0 ? void 0 : _a.submitBusinessEvent({
                    name: event.name,
                    payload: event.payload,
                    table: "business_metrics"
                });
            });
            this.pendingBusinessEvents = [];
        }
    }
    addDurationIfTimed(name, options) {
        const durationKey = "duration_ms";
        const startTime = this.runningEvents.get(name);
        this.runningEvents.delete(name);
        if (startTime && options) {
            options[durationKey] = Date.now() - startTime;
            return options;
        }
        if (startTime) {
            const payload = {};
            payload[durationKey] = Date.now() - startTime;
            return payload;
        }
        if (options) {
            return options;
        }
        return {};
    }
    spacesToUnderscores(str) {
        return str.replace(/ /g, "_");
    }
    addCommonMetadata(payload) {
        var _a, _b;
        const userRole = localStorage.getItem("userRole");
        payload["user_role"] = userRole !== null && userRole !== void 0 ? userRole : "null";
        payload["desktop_build_number"] = (_a = sessionStorage.getItem("clientVersion")) !== null && _a !== void 0 ? _a : "null";
        payload["data_center"] = this.getDataCenterDetails();
        payload["browser_instance_ID"] = (_b = localStorage.getItem("browserInstanceID")) !== null && _b !== void 0 ? _b : "null";
        payload["dark_mode_enabled"] = js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get("darkMode") === "true";
        payload["task_pane_state"] = js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get("taskAreaCollapsed") === "true" ? "Minimized" : "Expanded";
        payload["current_state"] = js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get("agentState") === "Available" ? "Available" : "Idle";
        payload["tabHidden"] = document.hidden;
        if (window.performance && "memory" in window.performance) {
            const memory = window.performance.memory;
            payload["mem_js_heap_size_limit"] = memory.jsHeapSizeLimit;
            payload["mem_total_js_heap_size"] = memory.totalJSHeapSize;
            payload["mem_used_js_heap_size"] = memory.usedJSHeapSize;
        }
    }
    preparePayload(options) {
        const payload = {};
        for (const [key, value] of Object.entries(options)) {
            payload[this.spacesToUnderscores(key)] = value;
        }
        for (const [key, value] of Object.entries(this.superProps)) {
            payload[this.spacesToUnderscores(key)] = value;
        }
        this.addCommonMetadata(payload);
        return payload;
    }
    metricsDisabled() {
        var _a;
        return !((_a = _config__WEBPACK_IMPORTED_MODULE_1__.CONF.CC_DC) === null || _a === void 0 ? void 0 : _a.includes("prod"));
    }
    trackBehavioralEvent(name, options) {
        const taxonomy = (0,_behavioral_events__WEBPACK_IMPORTED_MODULE_3__.getEventTaxonomy)(name);
        if (!taxonomy) {
            _core_sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`[WebexMetricsService] Behavioral event is not in the taxonomy: ${name}`);
            return;
        }
        if (this.metricsDisabled()) {
            return;
        }
        const payload = this.preparePayload(this.addDurationIfTimed(name, options));
        this.pendingBehavioralEvents.push({ taxonomy, payload });
        this.submitPendingBehavioralEvents();
    }
    trackOperationalEvent(name, options) {
        if (this.metricsDisabled()) {
            return;
        }
        const payload = this.addDurationIfTimed(name, options);
        this.pendingOperationalEvents.push({ name, payload: this.preparePayload(payload) });
        this.submitPendingOperationalEvents();
    }
    trackBusinessEvent(name, options) {
        if (this.metricsDisabled()) {
            return;
        }
        const payload = this.addDurationIfTimed(name, options);
        this.pendingBusinessEvents.push({ name, payload: this.preparePayload(payload) });
        this.submitPendingBusinessEvents();
    }
    timeEvent(_name) {
        if (this.metricsDisabled()) {
            return;
        }
        this.runningEvents.set(_name, Date.now());
    }
    register(superProps) {
        this.superProps = Object.assign({}, superProps);
    }
    getDataCenterDetails() {
        var _a;
        return (_a = _config__WEBPACK_IMPORTED_MODULE_1__.CONF.CC_DC) === null || _a === void 0 ? void 0 : _a.replace("prod", "");
    }
}


/***/ }),

/***/ "./src/utils/fairUsage.ts":
/*!********************************!*\
  !*** ./src/utils/fairUsage.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FairUsage: () => (/* binding */ FairUsage),
/* harmony export */   RateLimiter: () => (/* binding */ RateLimiter)
/* harmony export */ });
class RateLimiter {
    constructor(rate, period) {
        this.rate = rate;
        this.period = period;
        this.events = [];
    }
    wouldExceedLimit(now) {
        this.cleanOldEvents(now);
        return this.events.length >= this.rate;
    }
    addEvent(now) {
        this.events.push(now);
    }
    getExcess() {
        return this.events.length;
    }
    clearEvents() {
        this.events = [];
    }
    cleanOldEvents(now) {
        const cutoff = now - this.period;
        this.events = this.events.filter((time) => time > cutoff);
    }
    getRate() {
        return this.rate;
    }
    getPeriod() {
        return this.period;
    }
}
class FairUsage {
    constructor(rateLimitInfo) {
        this.rateLimitInfo = rateLimitInfo;
        this.perEventLimiters = new Map();
        this.eventExcess = new Map();
        this.eventStackTraces = new Map();
        this.totalEventCount = 0;
    }
    isAllowed(eventName) {
        const now = Date.now();
        if (!this.perEventLimiters.has(eventName)) {
            this.perEventLimiters.set(eventName, this.rateLimitInfo.map((info) => new RateLimiter(info.rate, info.per)));
            this.eventExcess.set(eventName, this.rateLimitInfo.map((info) => new RateLimiter(info.rate, info.per)));
        }
        const limiters = this.perEventLimiters.get(eventName);
        const excessLimiters = this.eventExcess.get(eventName);
        let isAllowed = true;
        for (let i = 0; i < limiters.length; i++) {
            if (limiters[i].wouldExceedLimit(now)) {
                excessLimiters[i].addEvent(now);
                this.totalEventCount++;
                isAllowed = false;
                break;
            }
        }
        if (isAllowed) {
            limiters.forEach((limiter) => limiter.addEvent(now));
        }
        return isAllowed;
    }
    getExcessLimiters() {
        return this.eventExcess;
    }
    setStackTrace(eventName, stack) {
        var _a, _b;
        const stackLines = stack.split("\n");
        const callerLine = (_b = (_a = stackLines[2]) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : "";
        if (!this.eventStackTraces.has(eventName)) {
            this.eventStackTraces.set(eventName, []);
        }
        const traces = this.eventStackTraces.get(eventName);
        const existing = traces.find((t) => t.trace === callerLine);
        if (existing) {
            existing.count++;
        }
        else {
            traces.push({ trace: callerLine, count: 1 });
        }
    }
    getStackTrace(eventName) {
        const traces = this.eventStackTraces.get(eventName);
        if (!traces) {
            return "";
        }
        return traces.map((t) => `${t.trace} called ${t.count} times`).join("\n");
    }
    clearStackTraces() {
        this.eventStackTraces.clear();
    }
}


/***/ }),

/***/ "./src/utils/structuredLog.ts":
/*!************************************!*\
  !*** ./src/utils/structuredLog.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   StructuredLog: () => (/* binding */ StructuredLog)
/* harmony export */ });
/* harmony import */ var _core_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../core/sdk */ "./src/core/sdk.ts");

var StructuredLog;
(function (StructuredLog) {
    function buildLogString(id, message, extraFields) {
        if (!message) {
            message = undefined;
        }
        if (typeof (extraFields === null || extraFields === void 0 ? void 0 : extraFields.toJSON) === "function") {
            extraFields = extraFields.toJSON();
        }
        const logObject = Object.assign({ id, logVer: 1, message }, extraFields);
        return JSON.stringify(logObject);
    }
    StructuredLog.buildLogString = buildLogString;
    // Note: Trace (UUIP info level) is local only, debug, warn and error are all sent to kibana
    function trace(id, message, extraFields) {
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(buildLogString(id, message, extraFields));
    }
    StructuredLog.trace = trace;
    function debug(id, message, extraFields) {
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.debug(buildLogString(id, message, extraFields));
    }
    StructuredLog.debug = debug;
    function warn(id, message, extraFields) {
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.warn(buildLogString(id, message, extraFields));
    }
    StructuredLog.warn = warn;
    function error(id, message, extraFields) {
        _core_sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error(buildLogString(id, message, extraFields));
    }
    StructuredLog.error = error;
})(StructuredLog || (StructuredLog = {}));


/***/ }),

/***/ "./src/workers/workerLogs.ts":
/*!***********************************!*\
  !*** ./src/workers/workerLogs.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LevelDebug: () => (/* binding */ LevelDebug),
/* harmony export */   LevelError: () => (/* binding */ LevelError),
/* harmony export */   LevelTrace: () => (/* binding */ LevelTrace),
/* harmony export */   LevelWarning: () => (/* binding */ LevelWarning),
/* harmony export */   LogType: () => (/* binding */ LogType),
/* harmony export */   logDebug: () => (/* binding */ logDebug),
/* harmony export */   logError: () => (/* binding */ logError),
/* harmony export */   logTrace: () => (/* binding */ logTrace),
/* harmony export */   logWarn: () => (/* binding */ logWarn)
/* harmony export */ });
const startDate = Date.now();
const LogType = "log";
const LevelTrace = "trace";
const LevelWarning = "warn";
const LevelError = "error";
const LevelDebug = "debug";
function prependDate(message) {
    const timeStamp = new Date(startDate + performance.now()).toISOString();
    return `${timeStamp} ${message}`;
}
function logTrace(id, message, extraFields = {}) {
    postMessage({ type: LogType, level: LevelTrace, id, message: prependDate(message), extraFields });
}
function logDebug(id, message, extraFields = {}) {
    postMessage({ type: LogType, level: LevelDebug, id, message: prependDate(message), extraFields });
}
function logWarn(id, message, extraFields = {}) {
    postMessage({ type: LogType, level: LevelWarning, id, message: prependDate(message), extraFields });
}
function logError(id, message, extraFields = {}) {
    postMessage({ type: LogType, level: LevelError, id, message: prependDate(message), extraFields });
}


/***/ }),

/***/ "./src/workers/workerTelemetry.ts":
/*!****************************************!*\
  !*** ./src/workers/workerTelemetry.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TelemetryTypeTimeEvent: () => (/* binding */ TelemetryTypeTimeEvent),
/* harmony export */   TelemetryTypeTrack: () => (/* binding */ TelemetryTypeTrack),
/* harmony export */   TypeTelemetry: () => (/* binding */ TypeTelemetry),
/* harmony export */   timeEvent: () => (/* binding */ timeEvent),
/* harmony export */   track: () => (/* binding */ track)
/* harmony export */ });
const TypeTelemetry = "telemetry";
const TelemetryTypeTrack = "track";
const TelemetryTypeTimeEvent = "timeEvent";
function track(name, options, services = []) {
    postMessage({ type: TypeTelemetry, telemetryType: TelemetryTypeTrack, name, options, services });
}
function timeEvent(name, services = []) {
    postMessage({ type: TypeTelemetry, telemetryType: TelemetryTypeTimeEvent, name, services });
}


/***/ }),

/***/ "./src/workers/workerUtil.ts":
/*!***********************************!*\
  !*** ./src/workers/workerUtil.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createWorker: () => (/* binding */ createWorker)
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! .. */ "./src/index.ts");
/* harmony import */ var _services_service_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../services/service-utils */ "./src/services/service-utils.ts");
/* harmony import */ var _utils_structuredLog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/structuredLog */ "./src/utils/structuredLog.ts");
/* harmony import */ var _workerLogs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./workerLogs */ "./src/workers/workerLogs.ts");
/* harmony import */ var _workerTelemetry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./workerTelemetry */ "./src/workers/workerTelemetry.ts");





const startDate = Date.now();
/**
 * Creates a worker with the given filepath and messageHandler. Logs are already configured
 * to be sent to the logger.
 * @short Creates a worker with the given filepath and messageHandler
 * @param filepath
 * @param messageHandler
 */
function createWorker(filepath, messageHandler, errorHandler) {
    const canaryFlag = (0,_services_service_utils__WEBPACK_IMPORTED_MODULE_1__.getCanaryFlagFromSessionStorage)() ? "&canary=true" : "";
    const worker = new Worker(`${filepath}?time=${startDate}${canaryFlag}`, { type: "module" });
    worker.onmessage = function (e) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.type) === _workerLogs__WEBPACK_IMPORTED_MODULE_3__.LogType && ((_b = e === null || e === void 0 ? void 0 : e.data) === null || _b === void 0 ? void 0 : _b.message)) {
            switch ((_c = e === null || e === void 0 ? void 0 : e.data) === null || _c === void 0 ? void 0 : _c.level) {
                case _workerLogs__WEBPACK_IMPORTED_MODULE_3__.LevelTrace:
                    _utils_structuredLog__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.trace(`${filepath}/${e.data.id}`, e.data.message, e.data.extraFields);
                    break;
                case _workerLogs__WEBPACK_IMPORTED_MODULE_3__.LevelError:
                    _utils_structuredLog__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error(`${filepath}/${e.data.id}`, e.data.message, e.data.extraFields);
                    break;
                case _workerLogs__WEBPACK_IMPORTED_MODULE_3__.LevelDebug:
                    _utils_structuredLog__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.debug(`${filepath}/${e.data.id}`, e.data.message, e.data.extraFields);
                    break;
                case _workerLogs__WEBPACK_IMPORTED_MODULE_3__.LevelWarning:
                    _utils_structuredLog__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.warn(`${filepath}/${e.data.id}`, e.data.message, e.data.extraFields);
                    break;
            }
        }
        if (((_d = e === null || e === void 0 ? void 0 : e.data) === null || _d === void 0 ? void 0 : _d.type) === _workerTelemetry__WEBPACK_IMPORTED_MODULE_4__.TypeTelemetry) {
            if ((_e = e === null || e === void 0 ? void 0 : e.data) === null || _e === void 0 ? void 0 : _e.name) {
                if (((_f = e === null || e === void 0 ? void 0 : e.data) === null || _f === void 0 ? void 0 : _f.telemetryType) === _workerTelemetry__WEBPACK_IMPORTED_MODULE_4__.TelemetryTypeTrack) {
                    ___WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(e.data.name, e.data.options, e.data.services);
                }
                else if (((_g = e === null || e === void 0 ? void 0 : e.data) === null || _g === void 0 ? void 0 : _g.telemetryType) === _workerTelemetry__WEBPACK_IMPORTED_MODULE_4__.TelemetryTypeTimeEvent) {
                    ___WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.timeEvent(e.data.name, e.data.services);
                }
                else {
                    _utils_structuredLog__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error(`WorkerUtil/${filepath}`, `Invalid telemetry event type from worker`);
                }
            }
            else {
                _utils_structuredLog__WEBPACK_IMPORTED_MODULE_2__.StructuredLog.error(`WorkerUtil/${filepath}`, `Invalid telemetry event name from worker`);
            }
        }
        messageHandler === null || messageHandler === void 0 ? void 0 : messageHandler(e);
    };
    worker.onerror = function (e) {
        var _a, _b;
        ___WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.track(___WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry.TELEM_EVENT.UNCAUGHT_EXCEPTION, {
            Message: e.message,
            Source: e.filename,
            Lineno: e.lineno,
            Colno: e.colno,
            Error: e.error,
            Threadtype: `WebWorker/${filepath}`
        }, [(_b = (_a = ___WEBPACK_IMPORTED_MODULE_0__.SERVICE.telemetry) === null || _a === void 0 ? void 0 : _a.SERVICE_PROVIDERS) === null || _b === void 0 ? void 0 : _b.webex_business]);
        errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(e);
    };
    return worker;
}


/***/ }),

/***/ "@microsoft/microsoft-graph-client":
/*!****************************************************!*\
  !*** external "@microsoft/microsoft-graph-client" ***!
  \****************************************************/
/***/ ((module) => {

module.exports = require("@microsoft/microsoft-graph-client");

/***/ }),

/***/ "@splitsoftware/splitio":
/*!*****************************************!*\
  !*** external "@splitsoftware/splitio" ***!
  \*****************************************/
/***/ ((module) => {

module.exports = require("@splitsoftware/splitio");

/***/ }),

/***/ "@uuip/unified-ui-platform-sdk":
/*!************************************************!*\
  !*** external "@uuip/unified-ui-platform-sdk" ***!
  \************************************************/
/***/ ((module) => {

module.exports = require("@uuip/unified-ui-platform-sdk");

/***/ }),

/***/ "@webex/calling":
/*!*********************************!*\
  !*** external "@webex/calling" ***!
  \*********************************/
/***/ ((module) => {

module.exports = require("@webex/calling");

/***/ }),

/***/ "@webex/internal-plugin-dss":
/*!*********************************************!*\
  !*** external "@webex/internal-plugin-dss" ***!
  \*********************************************/
/***/ ((module) => {

module.exports = require("@webex/internal-plugin-dss");

/***/ }),

/***/ "@webex/internal-plugin-metrics":
/*!*************************************************!*\
  !*** external "@webex/internal-plugin-metrics" ***!
  \*************************************************/
/***/ ((module) => {

module.exports = require("@webex/internal-plugin-metrics");

/***/ }),

/***/ "axios":
/*!************************!*\
  !*** external "axios" ***!
  \************************/
/***/ ((module) => {

module.exports = require("axios");

/***/ }),

/***/ "event-emitter":
/*!********************************!*\
  !*** external "event-emitter" ***!
  \********************************/
/***/ ((module) => {

module.exports = require("event-emitter");

/***/ }),

/***/ "fflate":
/*!*************************!*\
  !*** external "fflate" ***!
  \*************************/
/***/ ((module) => {

module.exports = require("fflate");

/***/ }),

/***/ "gql-query-builder":
/*!************************************!*\
  !*** external "gql-query-builder" ***!
  \************************************/
/***/ ((module) => {

module.exports = require("gql-query-builder");

/***/ }),

/***/ "graphql":
/*!**************************!*\
  !*** external "graphql" ***!
  \**************************/
/***/ ((module) => {

module.exports = require("graphql");

/***/ }),

/***/ "js-cookie":
/*!****************************!*\
  !*** external "js-cookie" ***!
  \****************************/
/***/ ((module) => {

module.exports = require("js-cookie");

/***/ }),

/***/ "logrocket":
/*!****************************!*\
  !*** external "logrocket" ***!
  \****************************/
/***/ ((module) => {

module.exports = require("logrocket");

/***/ }),

/***/ "logrocket-fuzzy-search-sanitizer":
/*!***************************************************!*\
  !*** external "logrocket-fuzzy-search-sanitizer" ***!
  \***************************************************/
/***/ ((module) => {

module.exports = require("logrocket-fuzzy-search-sanitizer");

/***/ }),

/***/ "luxon":
/*!************************!*\
  !*** external "luxon" ***!
  \************************/
/***/ ((module) => {

module.exports = require("luxon");

/***/ }),

/***/ "set-interval-async/dynamic":
/*!*********************************************!*\
  !*** external "set-interval-async/dynamic" ***!
  \*********************************************/
/***/ ((module) => {

module.exports = require("set-interval-async/dynamic");

/***/ }),

/***/ "uuid":
/*!***********************!*\
  !*** external "uuid" ***!
  \***********************/
/***/ ((module) => {

module.exports = require("uuid");

/***/ }),

/***/ "webex":
/*!************************!*\
  !*** external "webex" ***!
  \************************/
/***/ ((module) => {

module.exports = require("webex");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.ts");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map